import React from 'react';
import { Languages } from '~Types';

// This could be harder typed using generics, but this will work for now
type Translation = any;

type TranslationObject = {
  [key: string]: {
    en: Translation;
    se: Translation;
    no: Translation;
    es: Translation;
    tr: Translation;
    dk: Translation;
  };
};

export const translations: TranslationObject = {
  // General
  'General.GoBack': {
    en: 'Go back',
    es: 'Volver',
    se: 'Tillbaka',
    no: 'Tilbake',
    tr: 'Geri git',
    dk: 'Gå tilbage',
  },
  'General.Retry': {
    en: 'Retry',
    es: 'Reintentar',
    se: 'Försök igen',
    no: 'Prøv igjen',
    tr: 'Yeniden dene',
    dk: 'Prøv igen',
  },
  'General.Yes': {
    en: 'Yes',
    es: 'Sí',
    se: 'Ja',
    no: 'Ja',
    tr: 'Evet',
    dk: 'Ja',
  },
  'General.No': {
    en: 'No',
    es: 'No',
    se: 'Nej',
    no: 'Nei',
    tr: 'Hayır',
    dk: 'Nej',
  },
  'General.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'Bekräfta',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Godkend',
  },
  'General.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Accepter',
  },
  'General.Proceed': {
    en: 'Proceed',
    es: 'Continuar',
    se: 'Fortsätt',
    no: 'Fortsett',
    tr: 'Devam et',
    dk: 'Fortsæt',
  },
  'General.CustomMessage': {
    en: 'Custom message',
    es: 'Mensaje personalizado',
    se: 'Eget meddelande',
    no: 'Egen melding',
    tr: 'Özel mesaj',
    dk: 'Besked fra gæst',
  },
  'General.EmailAdress': {
    en: 'Email adress',
    es: 'Correo electrónico',
    se: 'E-post address',
    no: 'E-postadresse',
    tr: 'E-posta adresi',
    dk: 'Email adresse',
  },
  'General.Quantity': {
    en: 'Quantity',
    es: 'Cantidad',
    se: 'Antal',
    no: 'Antall',
    tr: 'Miktar',
    dk: 'Antal',
  },
  'General.All': {
    en: 'all',
    es: 'todo',
    se: 'alla',
    no: 'Alle',
    tr: 'Tümü',
    dk: 'Alle',
  },
  'General.Sum': {
    en: 'Sum',
    es: 'Suma',
    se: 'Summa',
    no: 'Sum',
    tr: 'Toplam',
    dk: 'I alt',
  },
  'General.Company': {
    en: 'Company',
    es: 'Negocio',
    se: 'Företag',
    no: 'Bedrift',
    tr: 'Şirket',
    dk: 'Firma',
  },
  'General.OrgNr': {
    en: 'Orgnr',
    es: 'CIF/NIF',
    se: 'Orgnr',
    no: 'Org.nr.',
    tr: 'Organizasyon',
    dk: 'Org.nr.',
  },
  'General.Loading': {
    en: 'Loading',
    es: 'Cargando',
    se: 'Laddar',
    no: 'Laster',
    tr: 'Yükleniyor',
    dk: 'Loader',
  },
  'General.LoadingDots': {
    en: 'Loading...',
    es: 'Cargando...',
    se: 'Laddar...',
    no: 'Laster...',
    tr: 'Yükleniyor...',
    dk: 'Loader...',
  },
  'General.Percentage': {
    en: 'Percentage',
    es: 'Porcentaje',
    se: 'Procent',
    no: 'Prosent',
    tr: 'Yüzde',
    dk: 'Procentdel',
  },
  'General.Price': {
    en: 'Price',
    es: 'Precio',
    se: 'Pris',
    no: 'Pris',
    tr: 'Fiyat',
    dk: 'Pris',
  },
  'General.Clear': {
    en: 'Clear',
    es: 'Eliminar',
    se: 'Rensa',
    no: 'Fjern',
    tr: 'Temizle',
    dk: 'Slet',
  },
  'General.Ok': {
    en: 'Ok',
    es: 'De acuerdo',
    se: 'Ok',
    no: 'Ok',
    tr: 'Tamam',
    dk: 'Ok',
  },
  'General.Add': {
    en: 'Add',
    es: 'Agregar',
    se: 'Klar',
    no: 'Klar',
    tr: 'Ekle',
    dk: 'Tilføj',
  },
  'General.MessagePlaceholder': {
    en: 'Write a message here...',
    es: 'Escribe un mensaje aquí...',
    se: 'Skriv in ett meddelande här...',
    no: 'Skriv en beskjed her...',
    tr: 'Buraya bir mesaj yazın...',
    dk: 'Skriv en besked her...',
  },
  'General.ChosenMode': {
    en: 'Chosen Mode',
    es: 'Modo seleccionado',
    se: 'Valt läge',
    no: 'Valgt modus',
    tr: 'Seçilen Mod',
    dk: 'Valgt tilstand',
  },
  'General.ChooseVenue': {
    en: 'Choose venue',
    es: 'Seleccionar establecimiento',
    se: 'Välj butik',
    no: 'Velg avdeling',
    tr: 'Yer seçin',
    dk: 'Vælg lokation',
  },
  'General.ChooseMode': {
    en: 'Choose what mode to enter',
    es: 'Elija el modo de entrada',
    se: 'Välj vilket läge du vill gå in i',
    no: 'Velg hvilken modus du vil gå inn i',
    tr: 'Hangi moda gireceğinizi seçin',
    dk: 'Vælg hvilken tilstand du vil gå ind i',
  },
  'General.MissingPermission': {
    en: "You don't have access",
    es: 'No tienes acceso',
    se: 'Du har inte behörighet',
    no: 'Du har ikke tilgang',
    tr: 'Erişiminiz yok',
    dk: 'Du har ikke adgang',
  },
  'General.Last': {
    en: 'Last',
    es: 'Último',
    se: 'Förra',
    no: 'Forrige',
    tr: 'Son',
    dk: 'Sidste',
  },
  'General.Today': {
    en: 'Today',
    es: 'Hoy',
    se: 'Idag',
    no: 'I dag',
    tr: 'Bugün',
    dk: 'I dag',
  },
  'General.Yesterday': {
    en: 'Yesterday',
    es: 'Ayer',
    se: 'Igår',
    no: 'I går',
    tr: 'Dün',
    dk: 'I går',
  },
  'General.Tomorrow': {
    en: 'Tomorrow',
    es: 'Mañana',
    se: 'Imorgon',
    no: 'I morgen',
    tr: 'Yarın',
    dk: 'I morgen',
  },
  'General.Send': {
    en: 'Send',
    es: 'Enviar',
    se: 'Skicka',
    no: 'Send',
    tr: 'Gönder',
    dk: 'Send',
  },
  'General.Sending': {
    en: 'Sending...',
    es: 'Enviando...',
    se: 'Skickar...',
    no: 'Sender...',
    tr: 'Gönderiliyor...',
    dk: 'Sender',
  },
  'General.Accept': {
    en: 'Accept',
    es: 'Aceptar',
    se: 'Acceptera',
    no: 'Aksepter',
    tr: 'Kabul et',
    dk: 'Accepter',
  },
  'General.Complete': {
    en: 'Complete',
    es: 'Completado',
    se: 'Slutför',
    no: 'Fullfør',
    tr: 'Tamamla',
    dk: 'Færdiggjort',
  },
  'General.Success': {
    en: 'Success',
    es: 'Éxito',
    se: 'Lyckades',
    no: 'Vellykket',
    tr: 'Başarılı',
    dk: 'Godkendt',
  },
  'General.Error': {
    en: 'Something went wrong',
    es: 'Algo salió mal',
    se: 'Någonting gick fel',
    no: 'Noe gikk galt',
    tr: 'Bir şeyler yanlış gitti',
    dk: 'Noget gik galt',
  },
  'General.NoItem': {
    en: 'No item',
    es: 'Sin objeto',
    se: 'Ingen artikel',
    no: 'Ingen artikkel',
    tr: 'Ürün yok',
    dk: 'Ingen vare',
  },
  'General.NoContent': {
    en: 'No content',
    es: 'Sin contenido',
    se: 'Inget att visa',
    no: 'Ingenting å vise',
    tr: 'İçerik yok',
    dk: 'Intet indhold',
  },
  'General.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'General.Logout': {
    en: 'Log out',
    es: 'Cerrar sesión',
    se: 'Logga ut',
    no: 'Logg ut',
    tr: 'Çıkış yap',
    dk: 'Log ud',
  },
  'General.Login': {
    en: 'Log in',
    es: 'Iniciar sesión',
    se: 'Logga in',
    no: 'Logg inn',
    tr: 'Giriş yap',
    dk: 'Log in',
  },
  'General.Items': {
    en: 'Articles',
    es: 'Artículos',
    se: 'Artiklar',
    no: 'Artikler',
    tr: 'Ürünler',
    dk: 'Vare',
  },
  'General.IncorrectStaffcode': {
    en: 'Incorrect staff code',
    es: 'Código incorrecto',
    se: 'Ogiltig inloggning',
    no: 'Ugyldig passord',
    tr: 'Yanlış personel kodu',
    dk: 'Forkert medarbejder kode',
  },
  'General.LoadingMenuItems': {
    en: 'Loading menu articles',
    es: 'Cargando artículos',
    se: 'Laddar menyartiklar',
    no: 'Laster menyartikler',
    tr: 'Menü yükleniyor',
    dk: 'Loader menu',
  },
  'General.LoadingTableData': {
    en: 'Loading table data',
    es: 'Cargando datos',
    se: 'Laddar bordsdata',
    no: 'Laster bordinnhold',
    tr: 'Masa bilgileri yükleniyor',
    dk: 'Loader borddata',
  },
  'General.AmountIn': {
    en: 'Amount in',
    es: 'Importe en',
    se: 'Summa i',
    no: 'Inngående veksel',
    tr: 'Tutar',
    dk: 'Beløb i',
  },
  'General.NoDateSelected': {
    en: 'No date selected',
    es: 'Ninguna fecha seleccionada',
    se: 'Inget datum valt',
    no: 'Ingen dato valgt',
    tr: 'Tarih seçilmedi',
    dk: 'Ingen dato valgt',
  },
  'General.ClearDate': {
    en: 'Clear date',
    es: 'Borrar fecha',
    se: 'Rensa datum',
    no: 'Fjern dato',
    tr: 'Tarihi temizle',
    dk: 'Ryd dato',
  },
  'General.Submit': {
    en: 'Submit',
    es: 'Enviar',
    se: 'Spara',
    no: 'Lagre',
    tr: 'Gönder',
    dk: 'Gem',
  },
  'General.Or': {
    en: 'Or',
    es: 'O',
    se: 'Eller',
    no: 'Eller',
    tr: 'Veya',
    dk: 'Eller',
  },
  'General.Reason': {
    en: 'Reason',
    es: 'Razón',
    se: 'Anledning',
    no: 'Årsak',
    tr: 'Sebep',
    dk: 'Årsag',
  },
  'General.CommentOptional': {
    en: 'Comment (optional)',
    es: 'Comentario (opcional)',
    se: 'Kommentar (valfritt)',
    no: 'Kommentar (valgfritt)',
    tr: 'Yorum (isteğe bağlı)',
    dk: 'Kommentar (valgfri)',
  },
  'General.Search': {
    en: 'Search',
    es: 'Buscar',
    se: 'Sök',
    no: 'Søk',
    tr: 'Ara',
    dk: 'Søg',
  },
  // Staff
  'Staff.Login.Placeholder': {
    en: 'Enter staff code',
    es: 'Código de personal',
    se: 'Ange personalkod',
    no: 'Oppgi ansattkode',
    tr: 'Personel kodunu girin',
    dk: 'Indtast medarbejderkode',
  },
  'Staff.NoPermission.MakePayment': {
    en: 'You don’t have permission to make payments with this staff login.',
    es: 'No tienes permiso para realizar pagos con este inicio de sesión de personal.',
    se: 'Du har inte behörighet att göra betalningar med denna personalinloggning.',
    no: 'Du har ikke tillatelse til å foreta betalinger med denne ansattinnloggingen.',
    tr: 'Bu personel girişi ile ödeme yapma izniniz yok.',
    dk: 'Du har ikke tilladelse til at foretage betalinger med denne medarbejderlogin.',
  },
  // Customer display
  'CustomerDisplay.FollowOrder': {
    en: 'Follow your order here',
    es: 'Sigue tu pedido aquí',
    se: 'Följ din order här',
    no: 'Følg bestillingen din her',
    tr: 'Siparişinizi buradan takip edin',
    dk: 'Følg din bestilling her',
  },
  'CustomerDisplay.Preparing': {
    en: 'Preparing',
    es: 'Preparando',
    se: 'Förbereder',
    no: 'Forbereder',
    tr: 'Hazırlanıyor',
    dk: 'Forbereder',
  },
  'CustomerDisplay.Ready': {
    en: 'Ready',
    es: 'Listo',
    se: 'Redo',
    no: 'Ferdig',
    tr: 'Hazır',
    dk: 'Klar',
  },
  'CustomerDisplay.KeepAnEyeHere': {
    en: 'Keep an eye here while we are preparing your order',
    es: 'Permanece atento aquí mientras preparamos tu pedido.',
    se: 'Håll ett öga här medans vi förbereder din beställning',
    no: 'Følg med her mens vi forbereder bestillingen din',
    tr: 'Biz siparişinizi hazırlarken buraya dikkat edin.',
    dk: 'Vent et øjeblik, mens vi forbereder din bestilling',
  },
  'CustomerDisplay.ReadyMeals': {
    en: 'Ready meals coming up!',
    es: '¡Tus pedido està listo!',
    se: 'Beställningar är påväg!',
    no: 'Bestillinger er på vei!',
    tr: 'Hazır yemekler geliyor!',
    dk: 'Færdige måltider kommer nu!',
  },
  // History
  'History.Title': {
    en: 'History',
    es: 'Historial',
    se: 'Historik',
    no: 'Kvitteringer',
    tr: 'Geçmiş',
    dk: 'Historik',
  },
  'History.Customer': {
    en: 'Customer',
    es: 'Cliente',
    se: 'Kund',
    no: 'Kunde',
    tr: 'Müşteri',
    dk: 'Gæster',
  },
  'History.Order': {
    en: 'Order',
    es: 'Pedido',
    se: 'Order',
    no: 'Ordre',
    tr: 'Sipariş',
    dk: 'Bestilling',
  },
  'History.TableOrderNumber': {
    en: 'Table number / Order number',
    es: 'Número de mesa / Número de ticket',
    se: 'Bordsnummer / Ordernummer',
    no: 'Bordnummer / Ordrenummer',
    tr: 'Masa numarası / Sipariş numarası',
    dk: 'Bordnummer/bestillingsnummer',
  },
  'History.OrderAmount': {
    en: 'Order amount',
    es: 'Importe del pedido',
    se: 'Beställningssumma',
    no: 'Bestillingssum',
    tr: 'Sipariş miktarı',
    dk: 'Bestillings mængde',
  },
  'History.Date': {
    en: 'Date',
    es: 'Fecha',
    se: 'Datum',
    no: 'Dato',
    tr: 'Tarih',
    dk: 'Dato',
  },
  'History.OpenCheques': {
    en: 'Open cheques',
    es: 'Comandas abiertas',
    se: 'Öppna notor',
    no: 'Åpne regninger',
    tr: 'Çekleri aç',
    dk: 'Åbne checks',
  },
  'History.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'History.TipRefundCompleted': {
    en: 'Tip refund completed',
    es: 'Reembolso de propina completado',
    se: 'Dricks har blivit återbetalt',
    no: 'Tips har blitt refundert',
    tr: 'Bahşiş iadesi tamamlandı',
    dk: 'Refundering af drikkepenge gennemført',
  },
  'History.Payment': {
    en: 'Payment',
    es: 'Pago',
    se: 'Betalning',
    no: 'Betaling',
    tr: 'Ödeme',
    dk: 'Betaling',
  },
  'History.TotalAmount': {
    en: 'Total amount',
    es: 'Cantidad total',
    se: 'Total summa',
    no: 'Totalsum',
    tr: 'Toplam tutar',
    dk: 'Total beløb',
  },
  'History.TotalTip': {
    en: 'Total tip',
    es: 'Propina total',
    se: 'Total dricks',
    no: 'Total tips',
    tr: 'Toplam bahşiş',
    dk: 'Total drikkepenge',
  },
  'History.Amount': {
    en: 'Amount',
    es: 'Importe',
    se: 'Summa',
    no: 'Sum',
    tr: 'Miktar',
    dk: 'Beløb',
  },
  'History.Tip': {
    en: 'Tip',
    es: 'Propina',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşiş',
    dk: 'Drikkepenge',
  },
  'History.CorrectTip': {
    en: 'Correct tip',
    es: 'Propina correcta',
    se: 'Korrigera dricks',
    no: 'Korriger tips',
    tr: 'Doğru bahşiş',
    dk: 'Accepteret drikkepenge',
  },
  'History.EnterCorrectTip': {
    en: 'Enter correct tip amount',
    es: 'Introduce el importe correcto de propina',
    se: 'Fyll i rätt dricks',
    no: 'Fyll i korrekt tipsbeløp',
    tr: 'Doğru bahşiş tutarını girin',
    dk: 'Indtast korrekt drikkepenge beløb',
  },
  'History.OrderType': {
    en: 'Order Type',
    es: 'Tipo de orden',
    se: 'Ordertyp',
    no: 'Bestillingstype',
    tr: 'Sipariş türü',
    dk: 'Bestillingstype',
  },
  'History.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Total',
    no: 'Total',
    tr: 'Toplam',
    dk: 'Total',
  },
  'History.VAT': {
    en: 'VAT',
    es: 'IVA',
    se: 'Moms',
    no: 'MVA',
    tr: 'KDV',
    dk: 'Moms',
  },
  'History.ComplianceID': {
    en: 'Compliance ID',
    es: 'Nº cumplimiento',
    se: 'Kontrollenhet ID',
    no: 'Kontrollenhets-ID',
    tr: 'Uyumluluk Kimliği',
    dk: 'Overholdelses-ID',
  },
  'History.Refund': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'Återbetala',
    no: 'Refunder',
    tr: 'Geri öde',
    dk: 'Refundering',
  },
  'History.Refunded': {
    en: 'Refunded',
    es: 'Reembolsado',
    se: 'Återbetalad',
    no: 'Refundert',
    tr: 'Geri ödeme yapıldı',
    dk: 'Refunderet',
  },
  'History.Type': {
    en: 'Type',
    es: 'Tipo',
    se: 'Typ',
    no: 'Type',
    tr: 'Tür',
    dk: 'Type',
  },
  'History.Paid': {
    en: 'Paid',
    es: 'Pagado',
    se: 'Betald',
    no: 'Betalt',
    tr: 'Ödendi',
    dk: 'Betalt',
  },
  'History.Status': {
    en: 'Status',
    es: 'Estado',
    se: 'Status',
    no: 'Status',
    tr: 'Durum',
    dk: 'Status',
  },
  'History.Refunding': {
    en: 'Refunding...',
    es: 'Reembolsando...',
    se: 'Återbetalar...',
    no: 'Refunderer...',
    tr: 'Geri ödeme yapılıyor...',
    dk: 'Refunderer...',
  },
  'History.Void': {
    en: 'Void',
    es: 'Vacío',
    se: 'Void',
    no: 'Kanseller',
    tr: 'İptal',
    dk: 'Fjern',
  },
  'History.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'Bekräfta',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Bekræft',
  },
  'History.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Annuller',
  },
  'History.VoidPayment': {
    en: 'Are you sure you want to void this payment?',
    es: '¿Está seguro de que desea anular este pago?',
    se: 'Är du säker på att du vill ogiltigförklara den här betalningen?',
    no: 'Er du sikker på at du vil kansellere denne betalingen?',
    tr: 'Bu ödemeyi iptal etmek istediğinizden emin misiniz?',
    dk: 'Er du sikker på at du vil annuller denne betaling?',
  },
  'History.VoidExplanation': {
    en:
      'Voiding a payment will permanently remove it from this cheque. If the payment went through it will cause reporting discrepancies.',
    es:
      'Anular un pago lo eliminará permanentemente de esta comanda. Si el pago se realizó, causará discrepancias en los informes.',
    se:
      'Att ogiltigförklara en betalning kommer permanent ta bort den från denna nota. Om betalningen gick igenom kan det orsaka avvikelser i rapporteringen.',
    no:
      'Kansellering av en betaling vil permanent fjerne den fra denne regningen. Hvis betalingen gikk gjennom, kan det føre til avvik i rapporteringen.',
    tr:
      'Bir ödemeyi iptal etmek, bu çekten kalıcı olarak kaldıracaktır. Ödeme gerçekleştiyse, raporlama tutarsızlıklarına neden olacaktır.',
    dk:
      'Annullering af en betaling vil permanent fjerne den fra denne check. Hvis betalingen er gennemført, vil det forårsage uoverensstemmelser i rapporteringen.',
  },
  'History.ActionIrreversible': {
    en: 'This action is irreversible',
    es: 'Esta acción es irreversible.',
    se: 'Denna åtgärd är oåterkallelig',
    no: 'Denne handlingen kan ikke angres',
    tr: 'Bu işlem geri alınamaz',
    dk: 'Denne handling kan ikke fortrydes',
  },
  'History.ChooseRefundTerminal': {
    en: 'Choose terminal to issue refund on',
    es: 'Elija el datáfono para emitir el reembolso en',
    se: 'Välj terminal för återbetalningen',
    no: 'Velg terminal for tilbakebetaling',
    tr: 'Geri ödemenin yapılacağı yeri seçin',
    dk: 'Vælg terminal at udstede refundering til',
  },
  'History.Payments': {
    en: 'Payments',
    es: 'Pagos',
    se: 'Betalningar',
    no: 'Betalinger',
    tr: 'Ödemeler',
    dk: 'Betalinger',
  },
  'History.RefundFailed': {
    en: 'Refund failed',
    es: 'Reembolso fallido',
    se: 'Återbetalning misslyckades',
    no: 'Refusjon mislyktes',
    tr: 'Geri ödeme başarısız oldu',
    dk: 'Refundering mislykkedes',
  },
  'History.RefundFailed.R24': {
    en: 'Refunds for Retain24 is not supported',
    es: 'Los reembolsos para Retain24 no son compatibles',
    se: 'Återbetalningar för Retain24 stöds inte',
    no: 'Refusjoner for Retain24 støttes ikke',
    tr: 'Retain24 için iadeler desteklenmiyor',
    dk: 'Refunderinger for Retain24 understøttes ikke',
  },
  'History.RefundSuccessful': {
    en: 'Refund successful',
    es: 'Reembolso exitoso',
    se: 'Återbetalning lyckades',
    no: 'Refusjon gjennomført',
    tr: 'Geri ödeme başarılı',
    dk: 'Refundering lykkedes',
  },
  'History.Refunds.OpenNewWindow': {
    en: '(Opens a new window)',
    es: '(Abre una nueva ventana)',
    se: '(Öppnar ett nytt fönster)',
    no: '(Åpner et nytt vindu)',
    tr: '(Yeni bir pencere aç)',
    dk: '(Åbner et nyt vindue)',
  },
  'History.Receipt': {
    en: 'Receipt',
    es: 'Ticket',
    se: 'Kvitto',
    no: 'Kvittering',
    tr: 'Fiş',
    dk: 'Opskrift',
  },
  'History.RefundMissingPermission': {
    en:
      'You are missing permissions to refund and/or void payments. Please contact a head waiter for this.',
    es:
      'Le faltan permisos para reembolsar y/o anular pagos. Póngase en contacto con un responsable',
    se:
      'Du saknar behörighet att återbetala och/eller annullera betalningar. Kontakta platschefen för detta.',
    no:
      'Du mangler rettigheter til å refundere og/eller annullere betalinger. Kontakt systemansvarlig for dette.',
    tr:
      'Ödemeleri iade etme ve/veya iptal etme izniniz yok. Bunun için lütfen şef garsonla iletişime geçin.',
    dk: 'Du mangler tilladelser til at refudere/ eller annullere betaling',
  },
  'History.Page': {
    en: 'Page',
    es: 'Página',
    se: 'Sida',
    no: 'Side',
    tr: 'Sayfa',
    dk: 'Side',
  },
  'History.PrintRefundReceiptCopy': {
    en: 'Print refund receipt copy',
    es: 'Imprimir copia del reembolso',
    se: 'Skriv ut återbetalningskopia',
    no: 'Skriv ut kopikvittering for refusjon',
    tr: 'Geri ödeme makbuzunun kopyasını yazdır',
    dk: 'Print kopi af kvittering for refundering',
  },
  'History.PrintReceiptCopy': {
    en: 'Print receipt copy',
    es: 'Imprimir copia del ticket',
    se: 'Skriv ut kvittokopia',
    no: 'Skriv ut kopikvittering',
    tr: 'Makbuz kopyasını yazdır',
    dk: 'Print kopi af kvittering',
  },
  'History.PrintReceiptCopy.OnlyOne': {
    en: 'Only one physical receipt copy is allowed',
    es: 'Solo se permite una copia física del ticket',
    se: 'Endast en fysisk kvittokopia är tillåten',
    no: 'Kun én fysisk kopikvittering er tillatt',
    tr: 'Yalnızca bir makbuz kopyasına izin verilir',
    dk: 'Kun en fysisk kopi af kvittering er tilladt',
  },
  'History.EmailReceiptCopy': {
    en: 'Email receipt copy',
    es: 'Copia de ticket por email',
    se: 'Maila kvittokopia',
    no: 'Send kopikvittering på e-post',
    tr: 'E-posta makbuzu kopyası',
    dk: 'Kopi af kvittering til email',
  },
  'History.CardDetails': {
    en: 'Card details',
    es: 'Detalles de la tarjeta',
    se: 'Kortinformation',
    no: 'Kortinformasjon',
    tr: 'Kart detayları',
    dk: 'Kort detaljer',
  },
  'History.ConfirmRefund': {
    en: 'Confirm refund of order',
    es: 'Confirmar reembolso de pedido',
    se: 'Bekräfta återbetalning av order',
    no: 'Bekreftelse på refusjon',
    tr: 'Siparişin iadesini onaylayın',
    dk: 'Bekræft refundering af bestilling',
  },
  'History.ReceiptFailed': {
    en: 'Receipt generation failed',
    es: 'Error al generar el ticket',
    se: 'Kvittogenerering misslyckades',
    no: 'Kvitteringsgenerering mislyktes',
    tr: 'Makbuz oluşturma başarısız oldu',
    dk: 'Kvitteringsgenerering mislykkedes',
  },
  'History.PrintFromHistory': {
    en: 'Print from History',
    es: 'Imprimir desde Historial',
    se: 'Skriv ut från Historik',
    no: 'Skriv ut fra Historikk',
    tr: 'Geçmişten Yazdır',
    dk: 'Print fra Historik',
  },
  'History.Close': {
    en: 'Close',
    es: 'Cerrar',
    se: 'Stäng',
    no: 'Lukk',
    tr: 'Kapat',
    dk: 'Luk',
  },
  'History.ReceiptRetryNotAvailable': {
    en: 'Please print receipt from order history',
    es: 'Por favor, imprime el ticket desde el historial de pedidos',
    se: 'Vänligen skriv ut kvitto från orderhistorik',
    no: 'Vennligst skriv ut kvittering fra ordrehistorikk',
    tr: 'Lütfen sipariş geçmişinden makbuz yazdırın',
    dk: 'Venligst print kvittering fra ordrehistorik',
  },
  'History.OnlyThisDevice': {
    en: 'This device only',
    es: 'Solo este dispositivo',
    se: 'Endast denna enhet',
    no: 'Kun fra denne enheten',
    tr: 'Yalnızca bu cihaz',
    dk: 'Kun denne enhed',
  },
  'History.OnlyThisDevice.Description': {
    en: 'Only show orders created on this device',
    es: 'Solo mostrar tickets de este dispositivo.',
    se: 'Visa endast ordrar skapade på denna enhet',
    no: 'Vis kun bestillinger gjort fra denne enheten',
    tr: 'Yalnızca bu cihazda oluşturulan siparişleri göster',
    dk: 'Vis kun bestillinger oprettet på denne enhed',
  },
  'History.Welcome': {
    en: 'Welcome to the new and improved history page',
    es: 'Bienvenido a la nueva y mejorada página de historial',
    se: 'Välkommen till den nya och förbättrade historiksidan',
    no: 'Velkommen til den nye og forbedrede historikksiden',
    tr: 'Yeni ve geliştirilmiş geçmiş sayfasına hoş geldiniz',
    dk: 'Velkommen til den nye og forbedrede historikside',
  },
  'History.OldVersion.Description': {
    en:
      'You can still access the old history page, but it has limited functionality compared to the new version and will be removed in a future update.',
    es:
      'Aún puede acceder a la página de historial antigua, pero tiene funcionalidad limitada en comparación con la nueva versión y se eliminará en una actualización futura.',
    se:
      'Du kan fortfarande komma åt den gamla historiksidan, men den har begränsad funktionalitet jämfört med den nya versionen och kommer att tas bort i en framtida uppdatering.',
    no:
      'Du kan fortsatt få tilgang til den gamle historikksiden, men den har begrenset funksjonalitet sammenlignet med den nye versjonen og vil bli fjernet i en fremtidig oppdatering.',
    tr:
      'Eski geçmiş sayfasına hala erişebilirsiniz, ancak yeni sürüme kıyasla sınırlı işlevselliğe sahiptir ve gelecekteki bir güncellemede kaldırılacaktır.',
    dk:
      'Du kan stadig få adgang til den gamle historikside, men den har begrænset funktionalitet sammenlignet med den nye version og vil blive fjernet i en fremtidig opdatering.',
  },
  'History.GoToOldPage': {
    en: 'Go to old history page',
    es: 'Ir a la página de historial antigua',
    se: 'Gå till gamla historiksidan',
    no: 'Gå til gammel historikkside',
    tr: 'Eski geçmiş sayfasına git',
    dk: 'Gå til gammel historikside',
  },
  'History.Discount': {
    en: 'Discount',
    es: 'Descuento',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'History.PaymentDetails': {
    en: 'Payment details',
    es: 'Detalles del pago',
    se: 'Betalningsdetaljer',
    no: 'Betalingsdetaljer',
    tr: 'Ödeme detayları',
    dk: 'Betalingsdetaljer',
  },
  'History.UserDetails': {
    en: 'User details',
    es: 'Detalles del usuario',
    se: 'Användardetaljer',
    no: 'Brukerdetaljer',
    tr: 'Kullanıcı detayları',
    dk: 'Brugerdetaljer',
  },
  'History.OrgNumber': {
    en: 'Org. number',
    es: 'Número de organización',
    se: 'Org. nummer',
    no: 'Org. nummer',
    tr: 'Org. numarası',
    dk: 'Org. nummer',
  },
  'History.OrderStatusHistory': {
    en: 'Order status history',
    es: 'Historial de estado del pedido',
    se: 'Orderstatushistorik',
    no: 'Bestillingsstatushistorikk',
    tr: 'Sipariş durumu geçmişi',
    dk: 'Bestillingsstatushistorik',
  },
  'History.UnknownTimestamp': {
    en: 'Unknown',
    es: 'Desconocido',
    se: 'Okänd',
    no: 'Ukjent',
    tr: 'Bilinmiyor',
    dk: 'Ukendt',
  },
  'History.Email.Placeholder': {
    en: 'Email',
    es: 'Correo electrónico',
    se: 'E-post',
    no: 'E-post',
    tr: 'E-posta',
    dk: 'Email',
  },
  'History.Cheque': {
    en: 'Cheque',
    es: 'Comanda',
    se: 'Nota',
    no: 'Regning',
    tr: 'Çek',
    dk: 'Check',
  },
  'History.ChequeAmount.Paid': {
    en: 'Paid',
    es: 'Pagado',
    se: 'Betalt',
    no: 'Betalt',
    tr: 'Ödendi',
    dk: 'Betalt',
  },
  'History.ChequeAmount.Remaining': {
    en: 'Remaining',
    es: 'Restante',
    se: 'Återstår',
    no: 'Gjenstående',
    tr: 'Kalan',
    dk: 'Resterende',
  },
  'History.TransactionId': {
    en: 'Transaction id',
    es: 'ID de transacción',
    se: 'Transaktions-id',
    no: 'Transaksjons-id',
    tr: 'İşlem kimliği',
    dk: 'Transaktions-id',
  },
  'History.PaymentId': {
    en: 'Payment id',
    es: 'ID de pago',
    se: 'Betalnings-id',
    no: 'Betalings-id',
    tr: 'Ödeme kimliği',
    dk: 'Betalings-id',
  },
  'History.Move': {
    en: 'Move',
    es: 'Mover',
    se: 'Flytta',
    no: 'Flytt',
    tr: 'Taşı',
    dk: 'Flyt',
  },
  'History.VoidSuccess': {
    en: 'Payment voided successfully',
    es: 'Pago anulado exitosamente',
    se: 'Betalning ogiltigförklarad',
    no: 'Betaling kansellert',
    tr: 'Ödeme başarıyla iptal edildi',
    dk: 'Betaling annulleret',
  },
  'History.VoidFailed': {
    en: 'Failed to void payment',
    es: 'Error al anular el pago',
    se: 'Misslyckades med att ogiltigförklara betalning',
    no: 'Kunne ikke kansellere betaling',
    tr: 'Ödeme iptal edilemedi',
    dk: 'Kunne ikke annullere betaling',
  },
  'History.Voiding': {
    en: 'Voiding...',
    es: 'Anulando...',
    se: 'Ogiltigförklarar...',
    no: 'Kansellerer...',
    tr: 'İptal ediliyor...',
    dk: 'Annullerer...',
  },
  // Order types
  'OrderType.TakeAway': {
    en: 'Take away',
    es: 'Para llevar',
    se: 'Ta med',
    no: 'Ta med',
    tr: 'Al-Git',
    dk: 'Take away',
  },
  'OrderType.EatHere': {
    en: 'Eat here',
    es: 'Consumir aquí',
    se: 'Äta här',
    no: 'Spise her',
    tr: 'Burada',
    dk: 'Spis her',
  },
  'OrderType.Delivery': {
    en: 'Delivery',
    es: 'Entrega',
    se: 'Leverans',
    no: 'Levering',
    tr: 'Paket',
    dk: 'Levering',
  },
  'OrderType.InstantBuy': {
    en: 'Instant buy',
    es: 'Compra instantánea',
    se: 'Direktköp',
    no: 'Direktekjøp',
    tr: 'Hemen Satın Al',
    dk: 'Køb nu',
  },
  'OrderType.Purchase': {
    en: 'Purchase',
    es: 'Compra',
    se: 'Köp',
    no: 'Kjøp',
    tr: 'Satın al',
    dk: 'Køb',
  },
  'OrderType.TableService': {
    en: 'Table service',
    es: 'Servicio en mesa',
    se: 'Bords servering',
    no: 'Bordservering',
    tr: 'Masa servisi',
    dk: 'Bord service',
  },
  'OrderType.LocalDelivery': {
    en: 'Local delivery',
    es: 'Entrega local',
    se: 'Lokal leverans',
    no: 'Levering',
    tr: 'Yerel teslimat',
    dk: 'Lokal levering',
  },
  'OrderType.Shipped': {
    en: 'Shipped',
    es: 'Enviado',
    se: 'Skickats',
    no: 'Sendt',
    tr: 'Gönderildi',
    dk: 'Sendt',
  },
  'OrderType.Booking': {
    en: 'Booking',
    es: 'Reserva',
    se: 'Bokning',
    no: 'Booking',
    tr: 'Rezervasyon',
    dk: 'Booking',
  },
  'OrderType.POS': {
    en: 'POS',
    es: 'POS',
    se: 'POS',
    no: 'POS',
    tr: 'POS',
    dk: 'POS',
  },
  // Order statuses
  'OrderStatus.Completed': {
    en: 'Completed',
    es: 'Completado',
    se: 'Genomförd',
    no: 'Fullført',
    tr: 'Tamamlandı',
    dk: 'Afsluttet',
  },
  'OrderStatus.Pending': {
    en: 'Pending',
    es: 'Pendiente',
    se: 'Väntande',
    no: 'Venter',
    tr: 'Beklemede',
    dk: 'Uafgjort',
  },
  'OrderStatus.Failed': {
    en: 'Failed',
    es: 'Fallido',
    se: 'Misslyckad',
    no: 'Mislyktes',
    tr: 'Başarısız',
    dk: 'Mislykkedes',
  },
  'OrderStatus.Refunded': {
    en: 'Refunded',
    es: 'Reembolsado',
    se: 'Återbetald',
    no: 'Refundert',
    tr: 'Geri ödeme yapıldı',
    dk: 'Refunderet',
  },
  'OrderStatus.Rejected': {
    en: 'Rejected',
    es: 'Rechazado',
    se: 'Avvisad',
    no: 'Avvist',
    tr: 'Reddedildi',
    dk: 'Afvist',
  },
  // Payment statuses
  'PaymentStatus.Success': {
    en: 'Success',
    es: 'Éxito',
    se: 'Lyckades',
    no: 'Vellykket',
    tr: 'Başarılı',
    dk: 'Lykkedes',
  },
  'PaymentStatus.Failed': {
    en: 'Failed',
    es: 'Ha fallado',
    se: 'Misslyckades',
    no: 'Mislyktes',
    tr: 'Başarısız',
    dk: 'Mislykkedes',
  },
  'PaymentStatus.Pending': {
    en: 'Pending',
    es: 'Pendiente',
    se: 'Väntande',
    no: 'Venter',
    tr: 'Beklemede',
    dk: 'Uafgjort',
  },
  'PaymentStatus.NeedHelp': {
    en: 'Need help?',
    es: '¿Necesitas ayuda?',
    se: 'Behöver du hjälp?',
    no: 'Trenger du hjelp?',
    tr: 'Yardıma mı ihtiyacınız var?',
    dk: 'Brug for hjælp?',
  },
  'PaymentStatus.NoTerminal': {
    en: 'No terminal has been added',
    es: 'No se ha agregado ningún datáfono',
    se: 'Ingen terminal har lagts till',
    no: 'Ingen terminal lagt til',
    tr: 'Hiçbir terminal eklenmedi',
    dk: 'Ingen terminal er tilføjet',
  },
  'PaymentStatus.NoTerminal.Add': {
    en: 'Add terminal',
    es: 'Agregar datáfono',
    se: 'Lägg till terminal',
    no: 'Legg til terminal',
    tr: 'Terminal ekle',
    dk: 'Tilføj terminal',
  },
  'PaymentStatus.NoTerminal.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal',
    dk: 'Annuller',
  },
  // Menu
  'Menu.Title': {
    en: 'Menu',
    es: 'Menú',
    se: 'Meny',
    no: 'Meny',
    tr: 'Menü',
    dk: 'Menu',
  },
  'Menu.ShowOrders': {
    en: 'Show orders',
    es: 'Mostrar pedidos',
    se: 'Visa order',
    no: 'Vis bestillinger',
    tr: 'Siparişleri göster',
    dk: 'Vis bestillinger',
  },
  'Menu.Home': {
    en: 'Home',
    es: 'Inicio',
    se: 'Hem',
    no: 'Hjem',
    tr: 'Ana Sayfa',
    dk: 'Hjem',
  },
  'Menu.Login': {
    en: 'Login',
    es: 'Iniciar sesión',
    se: 'Logga in',
    no: 'Logg inn',
    tr: 'Giriş ',
    dk: 'Log ind',
  },
  'Menu.History': {
    en: 'History',
    es: 'Historial',
    se: 'Historik',
    no: 'Kvitteringer',
    tr: 'Geçmiş',
    dk: 'Historik',
  },
  'Menu.PaymentsRefunds': {
    en: 'Payments & Refunds',
    se: 'Köp & Återbetalningar',
    es: 'Pagos y reembolsos',
    no: 'Betalinger og refusjoner',
    dk: 'Betalinger og refusioner',
    tr: 'Ödemeler ve İadeler',
  },
  'Menu.GiftCards': {
    en: 'Gift cards',
    es: 'Tarjetas de regalo',
    se: 'Presentkort',
    no: 'Gavekort',
    tr: 'Hediye Kartları',
    dk: 'Gavekort',
  },
  'Menu.Reports': {
    en: 'Reports',
    es: 'Informes',
    se: 'Rapporter',
    no: 'Rapporter',
    tr: 'Raporlar',
    dk: 'Rapporter',
  },
  'Menu.ZReports': {
    en: 'X/Z-Reports',
    es: 'Informes X/Z',
    se: 'X/Z-Rapporter',
    no: 'X- og Z-rapporter',
    tr: 'X/Z Raporları',
    dk: 'X/Z-Rapporter',
  },
  'Menu.Expenses': {
    en: 'Expenses',
    es: 'Gastos',
    se: 'Utlägg',
    no: 'Utgifter',
    tr: 'Masraflar',
    dk: 'Udgifter',
  },
  'Menu.Statistics': {
    en: 'Statistics',
    es: 'Estadísticas',
    se: 'Statistik',
    no: 'Statistikk',
    tr: 'İstatistik',
    dk: 'Statistikker',
  },
  'Menu.Settings': {
    en: 'Settings',
    es: 'Ajustes',
    se: 'Inställningar',
    no: 'Innstillinger',
    tr: 'Ayarlar',
    dk: 'Indstillinger',
  },
  'Menu.Help': {
    en: 'Help & Support',
    es: 'Servicio de asistencia',
    se: 'Hjälp & Support',
    no: 'Support og kundeservice',
    tr: 'Yardım & Destek',
    dk: 'Hjælp og vejledning',
  },
  'Menu.User': {
    en: 'User',
    es: 'Usuario',
    se: 'Användare',
    no: 'Bruker',
    tr: 'Kullanıcı',
    dk: 'Bruger',
  },
  'Menu.Company': {
    en: 'Company',
    es: 'Empresa',
    se: 'Företag',
    no: 'Bedrift',
    tr: 'Şirket',
    dk: 'Firma',
  },
  'Menu.Device': {
    en: 'Device',
    es: 'Dispositivo',
    se: 'Enhet',
    no: 'Enhet',
    tr: 'Cihaz',
    dk: 'Enhed',
  },
  'Menu.Venue': {
    en: 'Venue',
    es: 'Lugar',
    se: 'Butik',
    no: 'Avdeling',
    tr: 'Mekan',
    dk: 'Lokation',
  },
  'Menu.PoweredBy': {
    en: 'Powered by',
    es: 'Desarrollado por',
    se: 'Drivs av',
    no: 'Powered by',
    tr: 'Tarafından desteklenmektedir',
    dk: 'Drevet af',
  },
  'Menu.PoweredBy.ReloadQuestion': {
    en: 'Are you sure you want to reload the app?',
    es: '¿Quieres actualizar la aplicación?',
    se: 'Är du säker på att du vill ladda om appen?',
    no: 'Er du sikker på at du vil laste inn appen på nytt?',
    tr: 'Programı yeniden başlatmak istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil genindlæse appen?',
  },
  'Menu.PoweredBy.Reload.NotAllowed': {
    en: 'You are not allowed to reload the app due to ongoing payments',
    es: 'No se te permite actualizar la aplicación debido a pagos en curso',
    se: 'Du får inte ladda om appen på grund av pågående betalningar',
    no: 'Du kan ikke laste inn appen på nytt på grunn av pågående betalinger',
    tr: 'Devam eden ücretlendirmeler nedeniyle uygulamayı yeniden başlatamazsınız',
    dk: 'Du må ikke genindlæse appen på grund af løbende betalinger',
  },
  'Menu.ChooseAStore': {
    en: 'Change Venue',
    es: 'Cambiar local',
    se: 'Välj butik',
    no: 'Velg avdeling',
    tr: 'Yeri Değiştir',
    dk: 'Skift lokation',
  },
  'Menu.PunchIn': {
    en: 'Punch in',
    es: 'Golpe en',
    se: 'Stämpla in',
    no: 'Stemple inn',
    tr: 'Ekle',
    dk: 'Stempel ind',
  },
  'Menu.EndOfDay': {
    en: 'End of day',
    es: 'Cierra de servicio',
    se: 'Dagsavslut',
    no: 'Dagsavslutning',
    tr: 'Gün sonu',
    dk: 'Afslutning på dagen',
  },
  'Menu.InventoryOrder': {
    en: 'Inventory order',
    es: 'Orden de inventario',
    se: 'Lagerbeställning',
    no: 'Lagerbestilling',
    tr: 'Envanter siparişi',
    dk: 'Lagerordre',
  },
  'Menu.GiftcardDeposit': {
    en: 'Gift card deposit',
    es: 'Depósito de tarjeta de regalo',
    se: 'Ladda Presentkort',
    no: 'Last inn gavekort',
    tr: 'Hediye kartıyla para yatırma',
    dk: 'Gavekort depositum',
  },
  'Menu.Logout': {
    en: 'Log out',
    es: 'Cerrar sesión',
    se: 'Logga ut',
    no: 'Logg ut',
    tr: 'Çıkış ',
    dk: 'Log ud',
  },
  'Menu.IngredientInventory': {
    en: 'Ingredient Inventory',
    es: 'Inventario de modificadores',
    se: 'Ingredienslager',
    no: 'Ingredienslager',
    tr: 'İçerik Envanteri',
    dk: 'Ingredienslager',
  },
  'Menu.InventoryManagment': {
    en: 'Inventory management',
    es: 'Gestión de inventario',
    se: 'Lagerhantering',
    no: 'Lagerstyring',
    tr: 'Envanter yönetimi',
    dk: 'Lagerstyring',
  },
  'Menu.CashManagement': {
    en: 'Cash management',
    es: 'Movimientos de caja',
    se: 'Kontanthantering',
    no: 'Kontanthåndtering',
    tr: 'Nakit yönetimi',
    dk: 'Kontantstyring',
  },
  'Menu.Members': {
    en: 'Members',
    es: 'Miembros',
    se: 'Medlemmar',
    no: 'Medlemmer',
    tr: 'Üyeler',
    dk: 'Medlemmer',
  },
  'Numpad.MaxValueWarning': {
    en: (maxVal: number) => `The sum exceeds the maximum amount (${maxVal})`,
    es: (maxVal: number) => `La suma excede el importe máximo (${maxVal})`,
    se: (maxVal: number) => `Summan överstiger maxbeloppet (${maxVal})`,
    no: (maxVal: number) => `Summen overstiger maksimumsbeløpet (${maxVal})`,
    tr: (maxVal: number) => `Toplam, azami tutarı aşıyor (${maxVal})`,
    dk: (maxVal: number) => `Summen overstiger det maksimale beløb (${maxVal})`,
  },
  // App
  'App.Welcome': {
    en: 'Welcome',
    es: 'Bienvenido',
    se: 'Välkommen',
    no: 'Velkommen',
    tr: 'Hoş geldiniz',
    dk: 'Velkomst',
  },
  'App.Done': {
    en: 'Done',
    es: 'Hecho',
    se: 'Klar',
    no: 'Klar',
    tr: 'Tamamlandı',
    dk: 'Færdig',
  },
  'App.EmailPhoneLabel': {
    en: 'Email / Phone / Username',
    es: 'Correo electrónico / Teléfono / Nombre de usuario',
    se: 'Email / Telefon / Användarnamn',
    no: 'E-post / Telefon / Brukernavn',
    tr: 'E-posta / Telefon / Kullanıcı Adı',
    dk: 'Email / Telefon / Brugernavn',
  },
  'App.Password': {
    en: 'Password',
    es: 'Clave',
    se: 'Lösenord',
    no: 'Passord',
    tr: 'Şifre',
    dk: 'Adgangskode',
  },
  'App.Signin': {
    en: 'Sign in',
    es: 'Iniciar sesión',
    se: 'Logga in',
    no: 'Logg inn',
    tr: 'Kayıt ol',
    dk: 'Log ind',
  },
  'App.Loading': {
    en: 'Loading',
    es: 'Cargando',
    se: 'Laddar',
    no: 'Laster',
    tr: 'Yükleniyor',
    dk: 'Indlæser',
  },
  'App.InvalidCredit': {
    en: 'Invalid login credentials',
    es: 'Credenciales de acceso inválidas',
    se: 'Ogiltiga inloggningsuppgifter',
    no: 'Ugyldige innloggingsdetaljer',
    tr: 'Geçersiz giriş bilgileri',
    dk: 'Ugyldige loginoplysninger',
  },
  'App.InvalidPhone': {
    en: 'Invalid phone number',
    es: 'Número de teléfono inválido',
    se: 'Ogiltigt telefonnummer',
    no: 'Ugyldig telefonnummer',
    tr: 'Geçersiz telefon numarası',
    dk: 'Ugyldigt telefonnummer',
  },
  'App.InternetError': {
    en:
      'Internet connection error. Please double check-your internet connection and try again. If the issue persists, try restarting your device and/or your wifi router.',
    se:
      'Internetanslutningsfel. Kontrollera din internetanslutning och försök igen. Om problemet kvarstår, starta om din enhet och / eller din wifi-router.',
    es:
      'Error de conexión a Internet. Verifique su conexión y vuelva a intentarlo. Si el problema persiste, intente reiniciar su dispositivo y / o su ruter wifi.',
    no:
      'Feil med tilkobling til internett. Vennligst kontroller nettverkstilkoblingen din og prøv igjen. Hvis problemet vedvarer, forsøk å starte',
    tr:
      'İnternet bağlantısı hatası. Lütfen internet bağlantınızı tekrar kontrol edin ve tekrar deneyin. Sorun devam ederse cihazınızı ve/veya kablosuz yönlendiricinizi yeniden başlatmayı deneyin.',
    dk:
      'Internetforbindelsesfejl. Dobbelttjek venligst din internetforbindelse og prøv igen. Hvis problemet fortsætter, kan du prøve at genstarte din enhed og/eller din wifi-router.',
  },
  'App.ServerError': {
    en: 'Internal server error',
    es: 'Error de servidor interno',
    se: 'Internt serverfel',
    no: 'Intern serverfeil',
    tr: 'İç Sunucu Hatası',
    dk: 'Intern serverfejl',
  },
  'App.UnkownError': {
    en: 'Unknown error',
    es: 'Error desconocido',
    se: 'Okänt fel',
    no: 'Ukjent feil',
    tr: 'Bilinmeyen hata',
    dk: 'Ukendt fejl',
  },
  'App.NoPermission': {
    en:
      'You do not have permission to access any venue. Ask your account manager or back-office controller to assign the correct venue to your account.',
    es:
      'No tienes permiso para acceder. Pídale a su responsable que le asigne el acceso correcto a su cuenta.',
    se:
      'Du har inte behörighet att komma åt någon restaurang. Be din kontoansvarige att tilldela rätt restaurang till ditt konto.',
    no:
      'Du har ikke tilgang til noen avdelinger. Ta kontakt med systemansvarlig for å få tildelt riktige tilganger til brukeren din',
    tr:
      'Herhangi bir yere erişim izniniz yok. Hesap yöneticinizden veya ofis denetleyicinizden hesabınıza doğru yeri atamasını isteyin.',
    dk:
      'Du har ikke tilladelse til at få adgang til noget sted. Bed din kontoadministrator eller backoffice-controller om at tildele det korrekte mødested til din konto.',
  },
  'App.RejectReason': {
    en: 'REJECT REASON',
    es: 'MOTIVO DE RECHAZO',
    se: 'AVSLUTA SKÄLLANDE',
    no: 'FEILMELDING',
    tr: 'REDDETME NEDENİ',
    dk: 'AFVIS RÆSON',
  },
  'App.NoLocation': {
    en: 'No location',
    es: 'Sin ubicación',
    se: 'Ingen plats',
    no: 'Ingen avdeling',
    tr: 'Konum yok',
    dk: 'Ingen placering',
  },
  'App.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'Bekräfta',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Bekræft',
  },
  'App.NewIncoming': {
    en: 'New order',
    es: 'Nuevo pedido',
    se: 'Ny order',
    no: 'Ny order',
    tr: 'Yeni',
    dk: 'Ny ordre',
  },
  'App.PendingNew': {
    en: 'orders',
    es: 'pedidos',
    se: 'nya',
    no: 'nye',
    tr: 'yeni',
    dk: 'nye',
  },
  'App.At': {
    en: 'at',
    es: 'en',
    se: 'på',
    no: 'på',
    tr: 'de',
    dk: 'på',
  },
  'App.User': {
    en: 'User',
    es: 'Usuario',
    se: 'Användare',
    no: 'Bruker',
    tr: 'Kullanıcı',
    dk: 'Bruger',
  },
  'App.Username': {
    en: 'Username',
    se: 'Användarnamn',
    es: 'Nombre de usuario',
    no: 'Brukernavn',
    tr: 'Kullanıcı adı',
    dk: 'Brugernavn',
  },
  'App.MarkEnded': {
    en: 'Mark as Ended',
    es: 'Marcar como terminado',
    se: 'Markera som avslutat',
    no: 'Marker som avsluttet',
    tr: 'Sonlandı Olarak İşaretle',
    dk: 'Markér som afsluttet',
  },
  'App.Map': {
    en: 'Map',
    es: 'Mapa',
    se: 'Karta',
    no: 'Kart',
    tr: 'Plan',
    dk: 'Kort',
  },
  'App.ViewOrder': {
    en: 'View order',
    es: 'Ver pedido',
    se: 'Visa order',
    no: 'Vis bestilling',
    tr: 'Siparişi görüntüle',
    dk: 'Se ordre',
  },
  'App.Tomorrow': {
    en: 'tomorrow',
    es: 'mañana',
    se: 'Imorgon',
    no: 'I morgen',
    tr: 'Yarın',
    dk: 'i morgen',
  },
  'App.Today': {
    en: 'today',
    es: 'hoy',
    se: 'Idag',
    no: 'I dag',
    tr: 'Bugün',
    dk: 'i dag',
  },
  'App.View': {
    en: 'View',
    es: 'Vista',
    se: 'Se',
    no: 'Vis',
    tr: 'Görüntüle',
    dk: 'Se',
  },
  'App.TapAwake': {
    en: 'Tap screen to wake...',
    es: 'Toca la pantalla para continuar...',
    se: 'Tryck på skärmen för att vakna...',
    no: 'Trykk på skjermen for å vekke...',
    tr: 'Canlandırmak için ekrana dokunun...',
    dk: 'Tryk på skærmen for at vække...',
  },
  'App.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Total',
    no: 'Total',
    tr: 'Toplam',
    dk: 'Total',
  },
  'App.ChooseLanguage': {
    en: 'Choose Language',
    es: 'Elige idioma',
    se: 'Välj språk',
    no: 'Velg språk',
    tr: 'Dil seçiniz',
    dk: 'Vælg sprog',
  },
  'App.ChooseLanguage.Swedish': {
    en: 'Svenska',
    es: 'sueco',
    se: 'Svenska',
    no: 'Svenska',
    tr: 'Türkçe',
    dk: 'tyrkisk',
  },
  'App.ChooseLanguage.English': {
    en: 'English',
    es: 'inglés',
    se: 'English',
    no: 'English',
    tr: 'İngilizce',
    dk: 'engelsk',
  },
  'App.ChooseLanguage.Norwegian': {
    en: 'Norwegian',
    es: 'Noruego',
    se: 'Norska',
    no: 'Norsk',
    tr: 'Norveççe',
    dk: 'Norsk',
  },
  'App.Next': {
    en: 'Next',
    es: 'Suiguiente',
    se: 'Nästa',
    no: 'Neste',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'App.Select': {
    en: 'Select',
    es: 'Seleccione',
    se: 'Välj',
    no: 'Velg',
    tr: 'Seç',
    dk: 'Vælge',
  },
  'App.NoChanges': {
    en: 'No changes',
    es: 'Sin cambios',
    se: 'Inga ändringar',
    no: 'Ingen endringer',
    tr: 'Değişiklik yok',
    dk: 'Ingen ændringer',
  },
  'App.Quantity': {
    en: 'Quantity',
    es: 'Cantidad',
    se: 'Antal',
    no: 'Antall',
    tr: 'Miktar',
    dk: 'Mængde',
  },
  'App.Adjust': {
    en: 'Adjust',
    es: 'Ajustar',
    se: 'Anpassa',
    no: 'Tilpass',
    tr: 'Ayarla',
    dk: 'Tilpas',
  },
  'App.Ingredients': {
    en: 'Ingredients',
    es: 'Ingredientes',
    se: 'Ingredienser',
    no: 'Ingredienser',
    tr: 'İçindekiler',
    dk: 'Ingredienser',
  },
  'App.Add': {
    en: 'Add',
    es: 'Agregar',
    se: 'Lägg till',
    no: 'Legg til',
    tr: 'Ekle',
    dk: 'Tilføj',
  },
  'App.Continue': {
    en: 'Continue',
    es: 'Continuar',
    se: 'Fortsätt',
    no: 'Fortsett',
    tr: 'Devam et',
    dk: 'Fortsæt',
  },
  'App.Offer': {
    en: 'Offer',
    es: 'Oferta',
    se: 'Erbjudande',
    no: 'Tilbud',
    tr: 'Teklif',
    dk: 'Tilbud',
  },
  'App.AboutOffer': {
    en: 'About the offer',
    es: 'Acerca de la oferta',
    se: 'Om erbjudandet',
    no: 'Om tilbudet',
    tr: 'Teklif hakkında',
    dk: 'Om tilbuddet',
  },
  // Order
  'Order.CustomerComment': {
    en: 'Customer comment:',
    es: 'Comentario del cliente:',
    se: 'Kommentar från kund:',
    no: 'Kommentar fra kunde',
    tr: 'Müşteri yorumu:',
    dk: 'Kommentar fra gæst:',
  },
  'Order.PreOrder': {
    en: 'PRE-ORDER',
    es: 'PREPEDIDO',
    se: 'FÖRBOKA',
    no: 'FORHÅNDSBESTILL',
    tr: 'ÖN SİPARİŞ',
    dk: 'FORUDBESTILLING',
  },
  'Order.PreOrders': {
    en: 'Pre-orders',
    es: 'Prepedidos',
    se: 'Förbeställningar',
    no: 'Forhåndsbestillinger',
    tr: 'Ön Sipariş',
    dk: 'Forudbestillinger',
  },
  'Order.IncomingOrders': {
    en: 'Incoming Orders',
    es: 'Pedidos entrantes',
    se: 'Inkommande beställningar',
    no: 'Innkommende bestillinger',
    tr: 'Gelen Siparişler',
    dk: 'Indgående ordrer',
  },
  'Order.ActiveOrders': {
    en: 'Active orders',
    es: 'Pedidos activos',
    se: 'Aktiva order',
    no: 'Aktive bestillinger',
    tr: 'Aktif siparişler',
    dk: 'Aktive ordrer',
  },
  'Order.TakeAwayReadyPickup': {
    en: 'Take away ready for pickup',
    es: 'Pedido para llevar listo para recoger',
    se: 'Take away redo för upphämtning',
    no: 'Take-away klar for henting',
    tr: 'Al-Git Teslim alınmaya hazır ',
    dk: 'Take away klar til afhentning',
  },
  'Order.OnGoingDelivery': {
    en: 'Ongoing delivery',
    es: 'Entrega en curso',
    se: 'Pågående leverans',
    no: 'Pågående leveranse',
    tr: 'Devam eden teslimat',
    dk: 'Løbende levering',
  },
  'Order.userName': {
    en: 'User Name',
    es: 'Nombre de usuario',
    se: 'Användarnamn',
    no: 'Brukernavn',
    tr: 'Kullanıcı adı',
    dk: 'Brugernavn',
  },
  'Order.productName': {
    en: 'Product Name',
    es: 'Nombre del producto',
    se: 'Produktnamn',
    no: 'Produktnavn',
    tr: 'Ürün adı',
    dk: 'Produktnavn',
  },
  'Order.productPrice': {
    en: 'Product Price',
    es: 'Precio del producto',
    se: 'Produktpris',
    no: 'Produktpris',
    tr: 'Ürün fiyatı',
    dk: 'Produkt Pris',
  },
  'Order.whoPaidForProduct': {
    en: 'Who Paid For Product',
    es: 'Quién pagó el producto',
    se: 'Vem betalat för produkt',
    no: 'Hvem betalte for produktet',
    tr: 'Ürünün Parasını Kim Ödedi',
    dk: 'Hvem betalte for produktet',
  },
  'Order.TableService': {
    en: 'TABLE SERVICE',
    es: 'SERVICIO EN MESA',
    se: 'BORDS SERVERING',
    no: 'BORDSERVERING',
    tr: 'MASA SERVİSİ',
    dk: 'BORDSERVICE',
  },
  'Order.TakeAway': {
    en: 'TAKE AWAY',
    es: 'PARA LLEVAR',
    se: 'HÄMTMAT',
    no: 'HENTET',
    tr: 'AL-GİT',
    dk: 'TAKE AWAY',
  },
  'Order.Delivery': {
    en: 'DELIVERY',
    es: 'REPARTO',
    se: 'LEVERANS',
    no: 'LEVERING',
    tr: 'PAKET',
    dk: 'LEVERING',
  },
  'Order.Eathere': {
    en: 'EAT HERE',
    es: 'CONSUMIR AQUÍ',
    se: 'ÄT HÄR',
    no: 'SPISE HER',
    tr: 'BURADA ',
    dk: 'SPIS HER',
  },
  'Order.FullOrderInfo': {
    en: 'Full order info',
    es: 'Información completa del pedido',
    se: 'Full beställningsinformation',
    no: 'Komplett bestillingsinformasjon',
    tr: 'Tam sipariş bilgisi',
    dk: 'Fuld ordreinformation',
  },
  'Order.Remove': {
    en: 'Remove',
    es: 'Eliminar',
    se: 'Ta bort',
    no: 'Fjern',
    tr: 'Kaldır',
    dk: 'Fjern',
  },
  'Order.Accept': {
    en: 'ACCEPT',
    es: 'ACEPTAR',
    se: 'ACCEPTERA',
    no: 'AKSEPTER',
    tr: 'KABUL ET',
    dk: 'ACCEPTÉR',
  },
  'Order.Ready': {
    en: 'READY',
    es: 'LISTO',
    se: 'REDO',
    no: 'KLAR',
    tr: 'HAZIR',
    dk: 'KLAR',
  },
  'Order.PickUp': {
    en: 'PICK UP',
    es: 'RECOGER',
    se: 'UPPHÄMTAD',
    no: 'HENTET',
    tr: 'AL',
    dk: 'AFHENT',
  },
  'Order.Supplied': {
    en: 'SUPPLIED',
    es: 'ENTREGADO',
    se: 'LEVERERAD',
    no: 'LEVERT',
    tr: 'TEDARİK EDİLDİ',
    dk: 'LEVERET',
  },
  'Order.TimeToPrepare': {
    en: 'TIME TO PREPARE',
    es: 'TIEMPO DE PREPARACIÓN',
    se: 'TID FÖR ATT FÖRBEREDA',
    no: 'TID FOR Å TILBEREDE',
    tr: 'HAZIRLIK ZAMANI',
    dk: 'TID TIL FORBEREDELSE',
  },
  'Order.RemindMe': {
    en: 'Remind me',
    es: 'Recuérdame',
    se: 'Påminn mig',
    no: 'Påminn meg',
    tr: 'Bana hatırlat',
    dk: 'Påmind mig',
  },
  'Order.CloseAndSave': {
    en: 'CLOSE',
    es: 'CERRAR',
    se: 'STÄNG',
    no: 'STENG',
    tr: 'KAPALI',
    dk: 'LUKKET',
  },
  'Order.SkipSchedule': {
    en: 'Right now',
    es: 'Ahora mismo',
    se: 'Omedelbart',
    no: 'Umiddelbart',
    tr: 'Şimdi',
    dk: 'Lige nu',
  },
  'Order.DenyOrder': {
    en: 'DENY ORDER',
    es: 'RECHAZAR PEDIDO',
    se: 'NEKA ORDER',
    no: 'AVVIS ORDRE',
    tr: 'SİPARİŞİ REDDET',
    dk: 'AFVIS ORDRE',
  },
  'Order.CancelOrder': {
    en: 'CANCEL ORDER',
    es: 'CANCELAR PEDIDO',
    se: 'AVBRYT ORDER',
    no: 'AVBRYT ORDRE',
    tr: 'SİPARİŞİ İPTAL ET',
    dk: 'ANNULLER ORDRE',
  },
  'Order.Cancel': {
    en: 'CANCEL',
    es: 'CANCELAR',
    se: 'AVBRYT',
    no: 'AVBRYT',
    tr: 'İPTAL ET',
    dk: 'OPHÆV',
  },
  'Order.Goods': {
    en: 'goods',
    es: 'productos',
    se: 'varor',
    no: 'varer',
    tr: 'Ürünler',
    dk: 'goder',
  },
  'Order.InsertYourCard': {
    en: 'Insert your card',
    es: 'Introduce tu tarjeta',
    se: 'Sätt i ditt kort',
    no: 'Sett inn kort',
    tr: 'Kartınızı takın',
    dk: 'Indsæt dit kort',
  },
  'Order.FollowTheInstructionsInThePaymentTerminal': {
    en: 'Follow the instructions on the payment terminal.',
    es: 'Sigue las instrucciones en el terminal de pago.',
    se: 'Följ instruktionerna i betalterminalen.',
    no: 'Følg instruksjonene på betalingsterminalen',
    tr: 'Ödeme terminalindeki talimatları takip edin.',
    dk: 'Følg instruktionerne på betalingsterminalen.',
  },
  'Order.OneMomentPaymentInProgress': {
    en: 'One moment, payment in progress..',
    es: 'Un momento, pago en curso..',
    se: 'Ett ögonblick, betalning pågår..',
    no: 'Et øyeblikk, betaling pågår..',
    tr: 'Bir dakika, ödeme devam ediyor..',
    dk: 'Et øjeblik, betaling i gang..',
  },
  'Order.EnterPrice': {
    en: 'Enter the price',
    es: 'Introduce el precio',
    se: 'Skriv in pris',
    no: 'Tast inn pris',
    tr: 'Fiyatı girin',
    dk: 'Indtast prisen',
  },
  'Order.Minutes': {
    en: 'min',
    es: 'min',
    se: 'min',
    no: 'min',
    tr: 'dk.',
    dk: 'min',
  },
  'Order.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Tabel',
  },
  'Order.Title': {
    en: 'Order',
    es: 'Pedido',
    se: 'Order',
    no: 'Ordre',
    tr: 'Sipariş',
    dk: 'Bestil',
  },
  'Order.ForTable': {
    en: 'For table',
    es: 'para mesa',
    se: 'Till bord',
    no: 'Til bord',
    tr: 'Masa için',
    dk: 'Til bord',
  },
  'Order.Before': {
    en: 'before',
    es: 'antes de',
    se: 'innan',
    no: 'innen',
    tr: 'Önce',
    dk: 'før',
  },
  'Order.Free': {
    en: 'Free',
    es: 'Gratis',
    se: 'Free',
    no: 'Free',
    tr: 'Ücretsiz',
    dk: 'Gratis',
  },
  'Order.CallWaiter': {
    en: 'Call for waiter',
    es: 'llamar al camarero',
    se: 'Kalla på servitör',
    no: 'Tilkall servitør',
    tr: 'Garson çağır',
    dk: 'Ring efter tjeneren',
  },
  'Order.PaidAndClosed': {
    en: 'Table paid & closed',
    es: 'Mesa pagada y cerrada',
    se: 'Bord betalat och stängt',
    no: 'Bord betalt og stengt',
    tr: 'Masa ödendi ve kapatıldı',
    dk: 'Bord betalt og lukket',
  },
  'Order.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'Bekräfta',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Bekræft',
  },
  'Order.Waiting': {
    en: 'Waiting',
    es: 'Esperando',
    se: 'Väntande',
    no: 'Venter',
    tr: 'Bekliyor',
    dk: 'Venter',
  },
  'Order.NoOrdersForUser': {
    en: 'No orders for this user',
    es: 'No hay pedidos para este usuario',
    se: 'Inga ordrar från den här användaren',
    no: 'Ingen bestillinger fra denne brukeren',
    tr: 'Bu kullanıcı için sipariş yok',
    dk: 'Ingen ordrer til denne bruger',
  },
  'Order.ClosingTable': {
    en: 'Closing table...',
    es: 'Cerrando mesa...',
    se: 'Stänger bord...',
    no: 'Stenger bord...',
    tr: 'Masa kapanıyor...',
    dk: 'Lukker bord...',
  },
  'Order.ForceClose': {
    en: 'Force close table (make everyone pay)',
    es: 'Forzar el cierre de la mesa (hacer que todos paguen)',
    se: 'Tvångsstäng bordet (alla betalar)',
    no: 'Tvangssteng bordet (alle betaler)',
    tr: 'Masayı kapatmaya zorla (herkesten ödeme al)',
    dk: 'Tving til at lukke bordet (få alle til at betale)',
  },
  'ReasonsDecline.WhyDenyOrder': {
    en: 'Why do you deny this order?',
    es: '¿Por qué niegas esta orden?',
    se: 'Varför nekar du denna order?',
    no: 'Hvorfor avviser du denne bestillingen?',
    tr: 'Bu siparişi neden iptal ediyorsunuz?',
    dk: 'Hvorfor nægter du denne ordre?',
  },
  'ReasonsDecline.ToMuchToDoRightNow': {
    en: 'Too much to do right now',
    es: 'Demasiado que hacer ahora',
    se: 'För mycket att göra just nu',
    no: 'For mye å gjøre akkurat nå',
    tr: 'Şu anda yapacak çok şey var',
    dk: 'For meget at lave lige nu',
  },
  'ReasonsDecline.EndOfGoods': {
    en: 'End of goods',
    es: 'Producto agotado',
    se: 'Slut på varor',
    no: 'Tomt for varer',
    tr: 'Ürünlerin sonu',
    dk: 'Udsolgt',
  },
  'ReasonsDecline.DeliverNotAvailable': {
    en: 'Delivery is not available',
    es: 'La entrega no está disponible',
    se: 'Leverans är inte tillgängligt',
    no: 'Levering ikke tilgjengelig',
    tr: 'Paket mevcut değil',
    dk: 'Levering er ikke tilgængelig',
  },
  'ReasonsDecline.WeWillCloseSoon': {
    en: 'We will close soon',
    es: 'cerraremos pronto',
    se: 'Vi stänger snart',
    no: 'Vi stenger snart',
    tr: 'Yakında kapatacağız',
    dk: 'Vi lukker snart',
  },
  // Bill
  'Bill.PaymentMethod': {
    en: 'Payment Method',
    es: 'Método de pago',
    se: 'Betalmetod',
    no: 'Betalingsmetode',
    tr: 'Ödeme yöntemi',
    dk: 'Betalingsmetode',
  },
  'Bill.CreditCard': {
    en: 'Credit Card',
    es: 'Tarjeta de crédito',
    se: 'Kreditkort',
    no: 'Kredittkort',
    tr: 'Kredi kartı',
    dk: 'Kreditkort',
  },
  'Bill.Denied': {
    en: 'DENIED',
    es: 'DENEGADO',
    se: 'NEKAD',
    no: 'AVVIST',
    tr: 'REDDEDİLDİ',
    dk: 'NÆGTET',
  },
  'Bill.Refunded': {
    en: 'Refunded',
    es: 'Reembolsado',
    se: 'ÅTERBETALD',
    no: 'REFUNDERT',
    tr: 'Geri ödeme yapıldı',
    dk: 'Refunderet',
  },
  'Bill.Refund': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'ÅTERBETALNING',
    no: 'REFUSJON',
    tr: 'Geri öde',
    dk: 'Tilbagebetale',
  },
  // Modal
  'Modal.Title': {
    en: 'Are you sure?',
    es: '¿Está seguro?',
    se: 'Är du säker?',
    no: 'Er du sikker?',
    tr: 'Emin misiniz?',
    dk: 'Er du sikker?',
  },
  'Modal.Content': {
    en:
      'When you close the table, all users will pay for their purchases and will be ousted from the table.',
    es:
      'Cuando cierres la mesa, todos los usuarios pagarán por sus compras y serán expulsados ​​de la mesa.',
    se:
      'När du stänger bordet kommer alla användare att betala för sina inköp och kommer att lossas från bordet.',
    no:
      'Når du stenger bordet vil alle brukere måtte betale for sine kjøp og vil bli fjernet fra bordet',
    tr:
      'Masayı kapattığınızda tüm kullanıcılar yaptıkları satışların parasını öder ve masadan çıkarılır.',
    dk: 'Når du lukker bordet, vil alle brugere betale for deres køb og blive fjernet fra bordet.',
  },
  'Modal.Disagree': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Instämmer inte alls',
    no: 'Kanseller',
    tr: 'İptal et',
    dk: 'Ophæv',
  },
  'Modal.Agree': {
    en: 'Continue',
    es: 'Continuar',
    se: 'Hålla med',
    no: 'Fortsett',
    tr: 'Devam et',
    dk: 'Fortsæt',
  },
  'System.NetworkError': {
    en: 'Network error - Please check your connection',
    es: 'Error de red: comprueba tu conexión',
    se: 'Anslutningsproblem',
    no: 'Tilkoblingsfeil',
    tr: 'Ağ hatası - Lütfen bağlantınızı kontrol edin',
    dk: 'Netværksfejl - Kontroller venligst din forbindelse',
  },
  // Express
  'Express.LegalAge.Title': {
    en: '18 years or older?',
    es: '¿18 años o más?',
    se: '18 år eller äldre?',
    no: '18 år eller eldre?',
    tr: '18 yaşında yada daha büyük?',
    dk: '18 år eller ældre?',
  },
  'Express.LegalAge.SubTitle': {
    en:
      'For purchases of alcoholic beverages you need to be 18 years or older. Please show identification at the checkout.',
    es:
      'Para compras de bebidas alcohólicas es necesario tener 18 años o más. Por favor, muestre una identificación en la caja.',
    se:
      'För att handla alkoholhaltiga måste du vara 18 år eller äldre. Visa legitimation vid kassan.',
    no:
      'For å handle alkoholholdig drikke må du være 18 år eller eldre. Vennligst vis legitimasjon ved kassen.',
    tr:
      'Alkollü içecek satın alabilmeniz için 18 yaş ve üzerinde olmanız gerekmektedir. Lütfen ödeme sırasında kimliğinizi gösterin.',
    dk:
      'For køb af alkoholholdige drikkevarer skal du være fyldt 18 år. Vis venligst legitimation ved kassen.',
  },
  'Express.LegalAge.Yes': {
    en: 'Yes',
    es: 'Sí',
    se: 'Ja',
    no: 'Ja',
    tr: 'Evet',
    dk: 'Ja',
  },
  'Express.LegalAge.No': {
    en: 'No',
    es: 'No',
    se: 'Nej',
    no: 'Nei',
    tr: 'Hayır',
    dk: 'Nej',
  },
  'Express.Receipt.GoBack': {
    en: 'Go back',
    es: 'Volver',
    se: 'Gå tillbaka',
    no: 'Gå tilbake',
    tr: 'Geri git',
    dk: 'Gå tilbage',
  },
  'Express.Receipt.Title': {
    en: 'Receipt?',
    es: '¿Ticket?',
    se: 'Kvitto?',
    no: 'Kvittering?',
    tr: 'Fiş?',
    dk: 'Kvittering?',
  },
  'Express.Receipt.SubTitle': {
    en: 'We will print out your order number, but you also want a complete receipt?',
    es: 'Imprimiremos su número de pedido, pero ¿también quiere un ticket completo?',
    se: 'Vi kommer skriva ut ditt ordernummer men vill du även ha ett fullständigt kvitto?',
    no:
      'Vi kommer til å skrive ut ditt ordrenummer, men vil du også ha en fullstendig kvittering?',
    tr:
      'Sipariş numaranızı yazdıracağız, ancak aynı zamanda eksiksiz bir makbuz da mı istiyorsunuz?',
    dk: 'Vi udskriver dit ordrenummer, men ønsker du også en komplet kvittering?',
  },
  'Express.Receipt.Yes': {
    en: 'Yes, Please',
    es: 'Sí por favor',
    se: 'Ja, Tack',
    no: 'Ja, takk',
    tr: 'Evet lütfen',
    dk: 'Ja tak',
  },
  'Express.Receipt.No': {
    en: 'No, Thanks',
    es: 'No, gracias',
    se: 'Nej, Tack',
    no: 'Nei takk',
    tr: 'Hayır, teşekkürler',
    dk: 'Nej, tak',
  },
  'Express.Cart.Pay': {
    en: 'Pay',
    es: 'Pagar',
    se: 'Betala',
    no: 'Betal',
    tr: 'Öde',
    dk: 'Betale',
  },
  'Express.Cart.Title.Expanded': {
    en: 'Your Order',
    es: 'Su pedido',
    se: 'Din Beställning',
    no: 'Din bestilling',
    tr: 'Siparişiniz',
    dk: 'Din bestilling',
  },
  'Express.Cart.Title.YourChoices': {
    en: 'Your choices',
    es: 'Tus elecciones',
    se: 'Dina val',
    no: 'Dine valg',
    tr: 'Seçimleriniz',
    dk: 'Dine valg',
  },
  'Express.Cart.Choose': {
    en: 'Choose',
    es: 'Elegir',
    se: 'Välj',
    no: 'Velg',
    tr: 'Seç',
    dk: 'Vælg',
  },
  'Express.Cart.Chosen': {
    en: 'Chosen',
    es: 'Elegido',
    se: 'Vald',
    no: 'Valgt',
    tr: 'Seçildi',
    dk: 'Valgt',
  },
  'Express.Cart.Title': {
    en: 'To Checkout',
    es: 'Para revisar',
    se: 'Till Betalning',
    no: 'Til betaling',
    tr: 'Kontrol et',
    dk: 'Til kassen',
  },
  'Express.OrderNumber.Title': {
    en: 'Thank you, please take your print out',
    es: 'Gracias, por favor tome su impresión',
    se: 'Tack, ta din utskrift',
    no: 'Takk, vennligst ta utskriften',
    tr: 'Teşekkür ederim, lütfen çıktınızı alın',
    dk: 'Tak, tag venligst dit print ud',
  },
  'Express.OrderNumber.SubTitle': {
    en: ' Follow the instructions on the order display, enjoy your meal.',
    es: 'Siga las instrucciones en la pantalla de pedidos, disfrute de su comida.',
    se: 'Följ din status på utlämningsskärmarna, smaklig måltid.',
    no: 'Følg status på utleveringsskjermen.',
    tr: 'Sipariş ekranındaki talimatları takip edin, yemeğinizin tadını çıkarın.',
    dk: 'Følg instruktionerne på ordredisplayet, nyd dit måltid.',
  },
  'Express.OrderNumber.NewOrder': {
    en: 'Create a new order',
    es: 'Crear un nuevo pedido',
    se: 'Skapa ny beställning',
    no: 'Opprett en ny bestilling',
    tr: 'Yeni bir sipariş oluştur',
    dk: 'Opret en ny bestilling',
  },
  'Express.Home.Title': {
    en: 'Vigårda`s Most Popular',
    es: 'Los más populares de Vigårda',
    se: 'Vigårdas Populära',
    no: 'Mest populære',
    tr: "İstanbul'un En Popülerleri",
    dk: 'Istanbuls mest populære',
  },
  'Express.Home.Offer': {
    en: 'Offers',
    es: 'Ofertas',
    se: 'Erbjudanden',
    no: 'Tilbud',
    tr: 'Teklifler',
    dk: 'Tilbud',
  },
  'Express.Timeout.Subheader': {
    en: 'Tap the screen to return to your order',
    es: 'Toque la pantalla para volver a su pedido',
    se: 'Tryck på skärmen för att återgå till din beställning',
    no: 'Trykk på skjermen for å gå tilbake til din bestilling',
    tr: 'Siparişinize geri dönmek için ekrana dokunun',
    dk: 'Tryk på skærmen for at vende tilbage til din bestilling',
  },
  'Express.Timeout.Header': {
    en: 'Timeout',
    es: 'Se acabó el tiempo',
    se: 'Timeout',
    no: 'Tidsavbrudd',
    tr: 'Zaman aşımı',
    dk: 'Timeout',
  },
  'Express.Item.Unavailable': {
    en: 'Out of stock',
    es: 'Agotado',
    se: 'Slut för dagen',
    no: 'Utsolgt',
    tr: 'Stoklar tükendi',
    dk: 'Udsolgt',
  },
  'Express.Item.AddToCart': {
    en: 'Added!',
    es: '¡Añadido!',
    se: 'Tillagd!',
    no: 'Lagt til!',
    tr: 'Eklendi!',
    dk: 'Føjet til!',
  },
  'Express.Order': {
    en: 'Order',
    es: 'Pedido',
    se: 'Beställ',
    no: 'Bestill',
    tr: 'Sipariş',
    dk: 'Bestil',
  },
  'Express.StartOver': {
    en: 'Start over',
    es: 'Comenzar de nuevo',
    se: 'Börja om',
    no: 'Start på nytt',
    tr: 'Baştan başla',
    dk: 'Start forfra',
  },
  'Express.VenueClosed': {
    en: 'This express checkout is closed. Welcome to order by the counter!',
    es: 'Este pago exprés está cerrado. ¡Bienvenido a ordenar por el mostrador!',
    se: 'Den här kassan är stängd. Välkommen fram till vår kassadisk!',
    no: 'Denne kassen er stengt. Du er velkommen til å bestille i kassen.',
    tr: 'Bu hızlı ödeme kapalı. Tezgahtan sipariş verin!',
    dk: 'Denne hurtigkasse er lukket. Bestil venligst ved disken!',
  },
  'KDS.Order.DesiredTime': {
    en: 'Desired pickup time',
    es: 'Hora de recogida deseada',
    se: 'Önskad hämtningstid',
    no: 'Ønsket hentetidspunkt',
    tr: 'İstenilen alım zamanı',
    dk: 'Ønsket afhentningstid',
  },
  'KDS.Order.Mock.DisplayName': {
    en: 'Cheeseburger',
    es: 'Tacos',
    se: 'Köttbullar',
    no: 'Lapskaus',
    tr: 'Kebap',
    dk: 'Smørrebrød',
  },
  'KDS.OrdersDueTomorrowOnward': {
    en: 'Future orders',
    es: 'Pedidos futuros',
    se: 'Framtida ordrar',
    no: 'Fremtidige bestillinger',
    tr: 'Gelecek siparişler',
    dk: 'Fremtidige ordrer',
  },
  'KDS.OrdersDueTomorrowOnwardExtended': {
    en: 'All orders due from tomorrow onward',
    es: 'Todos los pedidos desde mañana en adelante',
    se: 'Alla ordrar från imorgon och framåt',
    no: 'Alle bestillinger fra i morgen og fremover',
    tr: 'Yarından itibaren teslim edilecek tüm siparişler',
    dk: 'Alle ordrer fra i morgen og fremover',
  },
  'ServiceType.TakeAway': {
    en: 'Take Away',
    es: 'Llevar',
    se: 'Ta med',
    no: 'Ta med',
    tr: 'Al-Git',
    dk: 'Take Away',
  },
  'ServiceType.EatHere': {
    en: 'Eat Here',
    es: 'Comer aquí',
    se: 'Äta här',
    no: 'Spise her',
    tr: 'Burada',
    dk: 'Spis her',
  },
  'ServiceType.Delivery': {
    en: 'Delivery',
    es: 'Entrega',
    se: 'Leverans',
    no: 'Levering',
    tr: 'Teslimat',
    dk: 'Levering',
  },
  'InstantOrder.Title': {
    en: 'Thank you',
    es: 'Gracias',
    se: 'Tack för ditt köp',
    no: 'Takk',
    tr: 'Teşekkür ederim',
    dk: 'Tak',
  },
  'InstantOrder.SubTitle': {
    en: 'You may now pick up your items at the counter',
    es: 'Puede recoger sus artículos en el mostrador.',
    se: 'Du kan hämta din order själv i kylen vid utlämningsdisken',
    no: 'Du kan hente bestillingen ved utleveringsdisken',
    tr: 'Artık ürünlerinizi kasadan alabilirsiniz',
    dk: 'Du kan nu hente dine varer ved skranken',
  },
  // TSR
  'TM.Message': {
    en: 'Message',
    es: 'Reclamar',
    se: 'Meddelande',
    no: 'Bedes',
    tr: 'Mesaj',
    dk: 'Besked',
  },
  'TM.Correction': {
    en: 'Correction',
    es: 'Corrección',
    se: 'Korrigering',
    no: 'Korrigering',
    tr: 'Düzeltme',
    dk: 'Korrigering',
  },
  'TM.ReasonForCorrection': {
    en: 'Reason for correction',
    es: 'Motivo de la corrección',
    se: 'Orsak till korrigering',
    no: 'Årsak til korrigering',
    tr: 'Düzeltme nedeni',
    dk: 'Årsag til korrektion',
  },
  'TM.Waste': {
    en: 'Waste',
    es: 'Desperdicio',
    se: 'Svinn',
    no: 'Svinn',
    tr: 'İsraf', // "Fire" was wrong here; "İsraf" = waste/loss
    dk: 'Spild',
  },
  'TM.ReasonForWaste': {
    en: 'Reason for waste',
    es: 'Motivo del desperdicio',
    se: 'Orsak till svinn',
    no: 'Årsak til svinn',
    tr: 'İsraf nedeni',
    dk: 'Årsag til spild',
  },
  'TM.RemovalType': {
    en: 'Removal type',
    es: 'Tipo de retirada',
    se: 'Borttagningstyp',
    no: 'Fjerningstype',
    tr: 'Çıkarma türü',
    dk: 'Fjernelsestype',
  },
  'TM.Pay': {
    en: 'Pay',
    es: 'Pagar',
    se: 'Betala',
    no: 'Betal',
    tr: 'Öde',
    dk: 'Betale',
  },
  'TM.Rename': {
    en: 'Rename',
    es: 'Renombrar',
    se: 'Byt namn',
    no: 'Bytt navn',
    tr: 'Yeniden isimlendir',
    dk: 'Omdøb',
  },
  'TM.Rename.Placeholder': {
    en: 'Enter new name',
    es: 'Ingrese nuevo nombre',
    se: 'Ange nytt namn',
    no: 'Skriv inn nytt navn',
    tr: 'Yeni isim girin',
    dk: 'Indtast nyt navn',
  },
  'TM.Receipt': {
    en: 'Receipt',
    es: 'Ticket',
    se: 'Kvitto',
    no: 'Kvittering',
    tr: 'Fiş',
    dk: 'Kvittering',
  },
  'TM.Cheques': {
    en: 'Cheques',
    es: 'Comandas',
    se: 'Notor',
    no: 'Regninger',
    tr: 'Çekler',
    dk: 'Checks',
  },
  'TM.Bill': {
    en: 'Bill',
    es: 'Ticket',
    se: 'Nota',
    no: 'Regning',
    tr: 'Fatura',
    dk: 'Regning',
  },
  'TM.Logs': {
    en: 'Logs',
    es: 'Registros',
    se: 'Loggar',
    no: 'Logger',
    tr: 'Kayıtlar',
    dk: 'Logs',
  },
  'TM.People': {
    en: 'People',
    es: 'Comensales',
    se: 'Personer',
    no: 'Personer',
    tr: 'İnsanlar',
    dk: 'Mennesker',
  },
  'TM.Qty': {
    en: 'Qty',
    es: 'Ud.',
    se: 'St',
    no: 'Ant',
    tr: 'Adet',
    dk: 'Ant',
  },
  'TM.Article': {
    en: 'Article',
    es: 'Artículo',
    se: 'Artiklar',
    no: 'Artikler',
    tr: 'Ürün',
    dk: 'Artikel',
  },
  'TM.Payed': {
    en: 'Paid',
    es: 'Pagado',
    se: 'Betalat',
    no: 'Betalt',
    tr: 'Ödendi',
    dk: 'Betalt',
  },
  'TM.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Total',
    no: 'Total',
    tr: 'Toplam',
    dk: 'Total',
  },
  'TM.Time': {
    en: 'Time',
    es: 'Tiempo',
    se: 'Tid',
    no: 'Tid',
    tr: 'Zaman',
    dk: 'Tid',
  },
  'TM.Activity': {
    en: 'Activity',
    es: 'Actividad',
    se: 'Aktivitet',
    no: 'Aktivitet',
    tr: 'Aktivite',
    dk: 'Aktivitet',
  },
  'TM.New': {
    en: 'New',
    es: 'Nueva',
    se: 'Ny',
    no: 'Ny',
    tr: 'Yeni',
    dk: 'Ny',
  },
  'TM.RemoveCheque': {
    en: 'Remove Cheque',
    es: 'Quitar comanda',
    se: 'Radera nota',
    no: 'Slett kvittering',
    tr: 'Çeki Kaldır',
    dk: 'Fjern check',
  },
  'TM.Remove': {
    en: 'Remove',
    es: 'Eliminar',
    se: 'Radera',
    no: 'Slett',
    tr: 'Kaldır',
    dk: 'Fjerne',
  },
  'TM.Removed': {
    en: 'removed',
    es: 'eliminado',
    se: 'raderats',
    no: 'slettet',
    tr: 'Kaldırıldı',
    dk: 'fjernet',
  },
  'TM.CantRemoveChequeWithPayments': {
    en: 'You can not remove a cheque with payments on it',
    se: 'Du kan inte ta bort en nota med betalningar på',
    es: 'No puedes eliminar una comanda con pagos realizados',
    no: 'Du kan ikke slette en regning med betalinger på',
    tr: 'Üzerinde ödeme bulunan çeki kaldıramazsınız',
    dk: 'Du kan ikke fjerne en check med betalinger på',
  },
  'TM.CantRemoveItemsWithPayments': {
    en: 'The selected items total sum exceeds the total sum of payments made.',
    se:
      'Det totala beloppet för de valda artiklarna överstiger det totala beloppet för gjorda betalningar.',
    es:
      'La suma total de los artículos seleccionados excede la suma total de los pagos realizados.',
    no: 'Den valgte varens totalsum overstiger totalsummen av betalinger som er gjort.',
    tr: 'Seçilen öğelerin toplam tutarı, yapılan ödemelerin toplam tutarını aşıyor.',
    dk: 'Det valgte varers totalsum overstiger den samlede sum af foretagne betalinger.',
  },
  'TM.CantApplyDiscountWithPayments': {
    en:
      'You can not apply a discount when payments have been made. Use the history to refund the payments if needed.',
    se:
      'Du kan inte lägga till en rabatt när betalningar har gjorts. Använd historiken för att återbetala betalningarna om det behövs.',
    es:
      'No puedes aplicar un descuento cuando se han realizado pagos. Utilice el historial para reembolsar los pagos si es necesario.',
    no:
      'Du kan ikke legge til en rabatt etter at betalinger har blitt gjort. Bruk kvitteringsoversikten til å refundere betalingene, dersom det trengs.',
    tr:
      'Ödeme yapıldıktan sonra indirim uygulanamaz. Gerekirse ödemeleri iade etmek için geçmişi kullanın.',
    dk:
      'Du kan ikke anvende rabat, når betalinger er foretaget. Brug historikken til at refundere betalingerne, hvis det er nødvendigt.',
  },
  'TM.Discount': {
    en: 'Discount',
    es: 'Descuento',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'TM.BookingDiscount': {
    en: 'Booking discount',
    es: 'Descuento de reserva',
    se: 'Bokningsrabatt',
    no: 'Bookingrabatt',
    tr: 'Rezervasyon indirimi',
    dk: 'Bookningsrabat',
  },
  'TM.ManualDiscount': {
    en: 'Manual discount',
    es: 'Descuento manual',
    se: 'Manuell rabatt',
    no: 'Manuell rabatt',
    tr: 'Manuel indirim',
    dk: 'Manuel rabat',
  },
  'TM.CustomMessage': {
    en: 'Custom message',
    es: 'Mensaje personalizado',
    se: 'Eget meddelande',
    no: 'Egen melding',
    tr: 'Özel mesaj',
    dk: 'Brugerdefineret besked',
  },
  'TM.KitchenMessages': {
    en: 'Kitchen messages',
    es: 'Mensajes a cocina',
    se: 'Köksmeddelanden',
    no: 'Kjøkkenbeskjed',
    tr: 'Mutfak mesajları',
    dk: 'Køkkenbeskeder',
  },
  'TM.SplitPayment': {
    en: 'Split payment',
    es: 'Pago dividido',
    se: 'Delbetalning',
    no: 'Delbetaling',
    tr: 'Bölünmüş ödeme',
    dk: 'Opdel betaling',
  },
  'TM.Clear': {
    en: 'Clear',
    es: 'Eliminar',
    se: 'Rensa',
    no: 'Fjern',
    tr: 'Temizle',
    dk: 'Slet',
  },
  'TM.Save': {
    en: 'Save',
    es: 'Guardar',
    se: 'Spara',
    no: 'Lagre',
    tr: 'Kaydet',
    dk: 'Spar',
  },
  'TM.Send': {
    en: 'Send',
    es: 'Enviar',
    se: 'Skicka',
    no: 'Send',
    tr: 'Gönder',
    dk: 'Send',
  },
  'TM.Split': {
    en: 'Split',
    es: 'Dividir',
    se: 'Dela',
    no: 'Splitt',
    tr: 'Böl',
    dk: 'Del',
  },
  'TM.Skipped': {
    en: 'excluded',
    se: 'uteslöts',
    no: 'utelatt',
    tr: 'hariç tutuldu',
    dk: 'udeladt',
    es: 'excluido',
  },
  'TM.PartialPayment': {
    en: 'partial payment',
    se: 'delbetalning',
    no: 'delbetaling',
    tr: 'kısmi ödeme',
    dk: 'delbetaling',
    es: 'pago parcial',
  },
  'TM.SplitPartialDisabled': {
    en: 'Can not split partially paid cheque.',
    es: 'No se puede dividir una comanda parcialmente pagada',
    se: 'Kan inte dela en delvis betald nota.',
    no: 'Du kan ikke splitte en delbetalt regning',
    tr: 'Kısmen ödenen çek bölünemez.',
    dk: 'Kan ikke opdele delvist betalt check.',
  },
  'TM.SplittedTo': {
    en: 'was split into',
    se: 'delades i',
    no: 'ble delt opp i',
    tr: 'olarak bölündü',
    dk: 'ble delt op i',
    es: 'se dividió en',
  },
  'TM.Coverage': {
    en: 'Coverage',
    es: 'Comensales',
    se: 'Antal personer',
    no: 'Antall personer',
    tr: 'Kapsam',
    dk: 'Dækning',
  },
  'TM.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Tabel',
  },
  'TM.Grid': {
    en: 'Grid',
    es: 'Todas las mesas',
    se: 'Bord',
    no: 'Alle bord',
    tr: 'Sistem',
    dk: 'Gitter',
  },
  'TM.OpenTables': {
    en: 'Open',
    es: 'Abiertas',
    se: 'Öppnade',
    no: 'Åpne bord',
    tr: 'Açık',
    dk: 'Åben',
  },
  'TM.Floorplan': {
    en: 'Floorplan',
    es: 'Plano de mesas',
    se: 'Planlösning',
    no: 'Bordkart',
    tr: 'Kat planı',
    dk: 'Plantegning',
  },
  'TM.LeftoverItems': {
    en: 'Leftover Items',
    es: 'Artículos restantes',
    se: 'Restprodukter',
    no: 'Restprodukter',
    tr: 'Artık Ürünler',
    dk: 'Rester af genstande',
  },
  'TM.Open': {
    en: 'Open',
    es: 'Añadir',
    se: 'Öppna',
    no: 'Åpne',
    tr: 'Açık',
    dk: 'Åben',
  },
  'TM.Created': {
    en: 'was created',
    es: 'fue creado',
    se: 'skapades',
    no: 'ble opprettet',
    tr: 'Oluşturuldu',
    dk: 'blev oprettet',
  },
  'TM.Moved': {
    en: 'was moved to',
    es: 'fue movido a',
    se: 'flyttades till',
    no: 'ble flyttet til',
    tr: 'Taşındı',
    dk: 'blev flyttet til',
  },
  'TM.MovedFrom': {
    en: 'was moved from',
    es: 'fue movido de',
    se: 'flyttades från',
    no: 'ble flyttet fra',
    tr: 'Buradan aşındı',
    dk: 'blev flyttet fra',
  },
  'TM.SplitFrom': {
    en: 'was split from',
    es: 'se dividió de',
    se: 'delades från',
    no: 'ble splittet fra',
    dk: 'blev opdelt fra',
    tr: 'Bölündü',
  },
  'TM.Added': {
    en: 'was added',
    es: 'fue añadido',
    se: 'lades till',
    no: 'ble lagt til',
    tr: 'Eklendi',
    dk: 'blev tilføjet',
  },
  'TM.ItemMoved': {
    en: 'Item was moved',
    es: 'El artículo fue movido',
    se: 'Produkt flyttades',
    no: 'Produkt ble flyttet',
    tr: 'Ürün taşındı',
    dk: 'Varen blev flyttet',
  },
  'TM.RenamedTo': {
    en: 'was renamed to',
    es: 'fue renombrado a',
    se: 'bytte namn till',
    no: 'byttet navn til',
    tr: 'olarak yeniden adlandırıldı',
    dk: 'blev omdøbt til',
  },
  'TM.CoverageChange': {
    en: 'Changed coverage to',
    es: 'Cambió los comensales a',
    se: 'Ändrade antal personer till',
    no: 'Endret antall personer til',
    tr: 'Kapsamı şu şekilde değiştirdi:',
    dk: 'Ændret dækning til',
  },
  'TM.WantToPrint': {
    en: 'Do you wish to print the receipt?',
    es: '¿Desea imprimir el ticket?',
    se: 'Vill du skriva ut kvittot?',
    no: 'Vil du skrive ut kvittering?',
    tr: 'Fişin çıktısını almak istiyor musunuz?',
    dk: 'Ønsker du at udskrive kvitteringen?',
  },
  'TM.MergedInto': {
    en: 'was merged into',
    es: 'se fusionó en',
    se: 'slogs samman till',
    no: 'ble slått sammen med',
    tr: 'Birleştirildi',
    dk: 'blev slået sammen til',
  },
  'TM.DiscountAdded': {
    en: 'discount added on',
    es: 'descuento añadido en',
    se: 'rabatt tillagds till',
    no: 'rabatt ble lagt til',
    tr: 'İndirim eklendi',
    dk: 'rabat tilføjet',
  },
  'TM.DiscountReseted': {
    en: 'Discounts were reset on',
    es: 'Se eliminó el descuento en',
    se: 'Rabatterna återställdes på',
    no: 'Rabattene ble nullstilt den',
    tr: 'İndirimler sıfırlandı',
    dk: 'Rabatter blev nulstillet pr',
  },
  'TM.InitiatePaymnet': {
    en: 'Initiate paymnet for',
    es: 'Iniciar el pago de',
    se: 'Initiera betalning för',
    no: 'Start betaling for',
    tr: 'Şunun için ödeme başlat:',
    dk: 'Start betalingsnet for',
  },
  'TM.AddPayment': {
    en: 'added as a payment for',
    es: 'añadido como pago por',
    se: 'läggs till som betalning för',
    no: 'lagt til som betaling for',
    tr: 'Ödeme olarak eklendi',
    dk: 'tilføjet som betaling for',
  },
  'TM.Printed': {
    en: 'was printed',
    es: 'fue impreso',
    se: 'skrevs ut',
    no: 'ble skrevet ut',
    tr: 'Yazdırıldı',
    dk: 'blev trykt',
  },
  'TM.CreateNote': {
    en: 'Note',
    es: 'Nota',
    se: 'Anteckning',
    no: 'Bordnotat',
    tr: 'Oluştur',
    dk: 'Note',
  },
  'TM.Amount': {
    en: 'Amount',
    es: 'Monto',
    se: 'Belopp',
    no: 'Beløp',
    tr: 'Miktar',
    dk: 'Beløb',
  },
  'TM.Tip': {
    en: 'Tip',
    es: 'Propina',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşiş',
    dk: 'Tip',
  },
  'TM.EditCheque': {
    en: 'Actions',
    es: 'Acciones',
    se: 'Handlingar',
    no: 'Handlinger',
    tr: 'Eylemler',
    dk: 'Handlinger',
  },
  'TM.ChangeOwner': {
    en: 'Owner',
    es: 'Propietario',
    se: 'Ägarbyte',
    no: 'Bytt eier',
    tr: 'Sahibi Değiştir',
    dk: 'Skift ejer',
  },
  'TM.Close': {
    en: 'Close',
    es: 'Cerrar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'Kapalı',
    dk: 'Luk',
  },
  'TM.InvoiceBill': {
    en: 'Invoice bill',
    es: 'Factura editable',
    se: 'Fakturanota',
    no: 'Faktura',
    tr: 'Fiş faturası',
    dk: 'Fakturaregning',
  },
  'TM.DeleteReason': {
    en: 'Write a reason',
    es: 'Escribe una razón',
    se: 'Skriv en anledning',
    no: 'Skriv en grunn',
    tr: 'Bir neden yazın',
    dk: 'Skriv en grund',
  },
  'TM.DeleteOptionalComment': {
    en: 'Comment',
    es: 'Comentario',
    se: 'Kommentar',
    no: 'Kommentar',
    tr: 'Yorum',
    dk: 'Kommentar',
  },
  'TM.SearchForStaff': {
    en: 'Search for staff',
    es: 'Buscar personal',
    se: 'Sök bland personal',
    no: 'Søk blant personal',
    tr: 'Personel ara',
    dk: 'Søg efter personale',
  },
  'TM.MembershipDiscount': {
    en: 'Membership discount',
    es: 'Descuento de membresía',
    se: 'Medlemsrabatt',
    no: 'Medlemsrabatt',
    tr: 'Üyelik indirimi',
    dk: 'Medlemsrabat',
  },
  'TM.ConfirmRemoveMembershipDiscount': {
    en: 'Are you sure you want to remove the membership discount?',
    es: '¿Está seguro de que desea eliminar el descuento de membresía?',
    se: 'Är du säker på att du vill ta bort medlemsrabatten?',
    no: 'Er du sikker på at du vil fjerne medlemsrabatten?',
    tr: 'Üyelik indirimini kaldırmak istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil fjerne medlemsrabatten?',
  },
  'TM.ConfirmRemoveBookingsDiscount': {
    en: 'Are you sure you want to remove the bookings discount?',
    es: '¿Está seguro de que desea eliminar el descuento de reservas?',
    se: 'Är du säker på att du vill ta bort bokningsrabatten?',
    no: 'Er du sikker på at du vil fjerne bookingrabatten?',
    tr: 'Rezervasyon indirimini kaldırmak istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil fjerne bookingrabatten?',
  },
  'TSR.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'TSR.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'Bekräfta',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Bekræfte',
  },
  'TSR.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Ophæve',
  },
  'TSR.RemoveDiscount': {
    en: 'Remove discount',
    es: 'Quitar descuento',
    se: 'Ta bort rabatt',
    no: 'Fjern rabatt',
    tr: 'İndirimi kaldır',
    dk: 'Fjern rabat',
  },
  'TSR.Min': {
    en: 'min',
    es: 'min',
    se: 'min',
    no: 'min',
    tr: 'dk.',
    dk: 'min',
  },
  'TSR.Coverage': {
    en: 'Coverage',
    es: 'Comensales',
    se: 'Antal personer',
    no: 'Antall personer',
    tr: 'Kapsam',
    dk: 'Dækning',
  },
  'TSR.ChooseCourseType': {
    en: 'Choose course type',
    es: 'Orden del pase',
    se: 'Välj rätt',
    no: 'Velg rett',
    tr: 'Kors türünü seçin',
    dk: 'Vælg kursustype',
  },
  'TSR.Warning.OutOfSync': {
    en: 'Warning! Out of sync. Number of missed actions:',
    es: '¡Aviso! Fuera de sincronización. Nº de acciones perdidas:',
    se: 'Varning!. Osynkroniserad. Antal missade händelser:',
    no: 'Advarsel! Usynkronisert. Antall tapte hendelser:',
    tr: 'Uyarı! Senkron dışında. Kaçırılan eylemlerin sayısı:',
    dk: 'Advarsel! Ude af synkronisering. Antal mistede handlinger:',
  },
  'TSR.Warning.LostConnection': {
    en: 'Warning! Lost connection to central server. Check internet connection',
    es: '¡Aviso! Se perdió la conexión con el servidor central. Comprobar la conexión a Internet',
    se: 'Varning!. Förlorad anslutning till central server. Kontrollera internetanslutningen',
    no: 'Advarsel! Mistet kontakt med server. Vennligst kontroller nettverkstilkoblingen',
    tr: 'Uyarı! Merkezi sunucuyla bağlantı kesildi. İnternet bağlantısını kontrol edin',
    dk: 'Advarsel! Mistet forbindelse til central server. Tjek internetforbindelsen',
  },
  'TSR.KitchenMessage': {
    en: 'Kitchen message',
    es: 'Mensaje de cocina',
    se: 'Köksmeddelande',
    no: 'Kjøkkenbeskjed',
    tr: 'Mutfak mesajı',
    dk: 'Køkken besked',
  },
  'TSR.ArticlesBonged': {
    en: 'articles ticket sent',
    es: 'Comanda enviada',
    se: 'artiklar bongade',
    no: 'artikler bonget',
    tr: 'Ürünlerin fişi gönderildi',
    dk: 'artikler billet sendt',
  },
  'TSR.ArticleBonged': {
    en: 'article ticket sent',
    es: 'Comanda enviada',
    se: 'artikel bongad',
    no: 'artikkel bonget',
    tr: 'Ürün fişi gönderildi',
    dk: 'varebillet sendt',
  },
  'TSR.ArticlesTrashed': {
    en: 'articles trashed',
    es: 'artículos desechados',
    se: 'artiklar slängda',
    no: 'artikler kastet',
    tr: 'Ürünler çöpe atıldı',
    dk: 'artikler kasseret',
  },
  'TSR.ArticleTrashed': {
    en: 'article trashed',
    es: 'artículo desechado',
    se: 'artikel slängd',
    no: 'artikkel kastet',
    tr: 'Ürün çöpe atıldı',
    dk: 'artiklen smides ud',
  },
  'TSR.NextCourse': {
    en: 'Next course',
    es: 'Marchar pase',
    se: 'Fram',
    no: 'Kjør neste',
    tr: 'Sonraki kors',
    dk: 'Næste kursus',
  },
  'TSR.NextCourse.Short': {
    en: 'Next',
    es: 'Marchar',
    se: 'Fram',
    no: 'Neste',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'TSR.Logs.Paid': {
    en: 'Paid',
    es: 'Pagado',
    se: 'Betalt',
    no: 'Betalt',
    tr: 'Ödendi',
    dk: 'Betalt',
  },
  // Errors
  'Error.SomethingWrong': {
    en: 'Unfortunately, something went wrong',
    es: 'Desafortunadamente, algo salió mal',
    se: 'Något gick fel',
    no: 'Noe gikk galt',
    tr: 'Maalesef bir şeyler ters gitti',
    dk: 'Desværre gik der noget galt',
  },
  'Error.NoErrorInfo': {
    en: 'No error information',
    es: 'Sin información de error',
    se: 'Inga felmeddelanden',
    no: 'Ingen feilmeldinger',
    tr: 'Hata bilgisi yok',
    dk: 'Ingen fejlinformation',
  },
  'Error.SomethingWrong.User.Title': {
    en: 'Oops!',
    es: '¡Ups!',
    se: 'Något gick fel',
    no: 'Oops!',
    tr: 'Hata!',
    dk: 'Ups!',
  },
  'Error.SomethingWrong.User.SubTitle': {
    en:
      'Something went wrong. Go back and try again. If the problem remains, please contact our staff.',
    es:
      'Algo salió mal. Vuelve y vuelve a intentarlo. Si el problema persiste, póngase en contacto con nuestro personal.',
    se: 'Något gick visst fel. Kontakta vår personal.',
    no: 'Noe gikk visst galt. Prøv igjen, eller kontakt personalet dersom feilen vedvarer.',
    tr:
      'Bir şeyler yanlış gitti. Geri dönüp tekrar deneyin. Sorun devam ederse lütfen personelimizle iletişime geçin.',
    dk:
      'Noget gik galt. Gå tilbage og prøv igen. Hvis problemet fortsætter, bedes du kontakte vores personale.',
  },
  'Error.AskHelp': {
    en: 'Something went wrong. Please contact the staff.',
    es: 'Algo salió mal. Póngase en contacto con el personal.',
    se: 'Något gick visst fel. Kontakta vår personal.',
    no: 'Noe gikk visst galt. Vennligst kontakt personalet.',
    tr: 'Bir şeyler yanlış gitti. Lütfen personelle iletişime geçin.',
    dk: 'Noget gik galt. Kontakt venligst personalet.',
  },
  'Report.NoReport': {
    en: 'There is no report for this date',
    es: 'No hay informe para esta fecha',
    se: 'Det finns ingen rapport för detta datum',
    no: 'Det finnes ingen rapport for denne datoen',
    tr: 'Bu tarihe ait rapor yok',
    dk: 'Der er ingen rapport for denne dato',
  },
  'Report.Loading': {
    en: 'Loading report...',
    es: 'Cargando informe..',
    se: 'Hämtar rapport...',
    no: 'Laster rapport...',
    tr: 'Rapor yükleniyor...',
    dk: 'Indlæser rapport...',
  },
  'Report.CategorySales': {
    en: 'Sales per category',
    es: 'Ventas por categoría',
    se: 'Försäljning per kategori',
    no: 'Salg per kategori',
    tr: 'Kategori başına satış',
    dk: 'Salg pr. kategori',
  },
  'Report.Sales': {
    en: 'Sales',
    es: 'Ventas',
    se: 'Försäljning',
    no: 'Salg',
    tr: 'Satış',
    dk: 'Salg',
  },
  'Report.TotalSales': {
    en: 'Total sales',
    es: 'Ventas totales',
    se: 'Total försäljning',
    no: 'Totalt salg',
    tr: 'Toplam satış',
    dk: 'Samlet salg',
  },
  'Report.Orders': {
    en: 'Orders',
    es: 'Pedidos',
    se: 'Ordrar',
    no: 'Ordrer',
    tr: 'Siparişler',
    dk: 'Ordrer',
  },
  'Report.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Total',
    no: 'Totalt',
    tr: 'Toplam',
    dk: 'Total',
  },
  'Report.Sum': {
    en: 'Sum',
    es: 'Suma',
    se: 'Summa',
    no: 'Sum',
    tr: 'Toplam',
    dk: 'Sum',
  },
  'Report.Discounts': {
    en: 'Discounts',
    es: 'Descuentos',
    se: 'Rabatter',
    no: 'Rabatter',
    tr: 'İndirimler',
    dk: 'Rabatter',
  },
  'Report.Tips': {
    en: 'Tips',
    es: 'Propinas',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşişler',
    dk: 'Drikkepenge',
  },
  'Report.VATSpec': {
    en: 'VAT Specification',
    es: 'Tipos de IVA',
    se: 'Momsspecifikation',
    no: 'MVA-spesifikasjon',
    tr: 'KDV Şartnamesi',
    dk: 'momsspecifikation',
  },
  'Report.VAT': {
    en: 'VAT',
    es: 'IVA',
    se: 'Moms',
    no: 'MVA',
    tr: 'KDV',
    dk: 'moms',
  },
  'Report.SumVATTotal': {
    en: 'Total VAT sum',
    es: 'Suma total del IVA',
    se: 'Summa moms totalt',
    no: 'Total MVA',
    tr: 'Toplam KDV toplamı',
    dk: 'Samlet momssum',
  },
  'Report.NetSales': {
    en: 'Net sales',
    es: 'Ventas netas',
    se: 'Nettoomsättning',
    no: 'Nettoomsetning',
    tr: 'Net satış',
    dk: 'Nettoomsætning',
  },
  'Report.NetIncome': {
    en: 'Net income',
    es: 'Base imponible',
    se: 'Nettoinkomst',
    no: 'Nettoinntekt',
    tr: 'Net gelir',
    dk: 'Nettoindkomst',
  },
  'Report.Receipts': {
    en: 'Receipts',
    es: 'Ingresos',
    se: 'Kvitton',
    no: 'Kvitteringer',
    tr: 'Fişler',
    dk: 'Kvitteringer',
  },
  'Report.RegisterReceipts': {
    en: 'Register receipts',
    es: 'Registrar tickets',
    se: 'Kassakvitton',
    no: 'Salgskvitteringer',
    tr: 'Makbuzları kaydet',
    dk: 'Registrer kvitteringer',
  },
  'Report.ReceiptCopies': {
    en: 'Receipt copies',
    es: 'Copias de ticket',
    se: 'Utlämnade kvittokopior',
    no: 'Kopikvitteringer',
    tr: 'Makbuz kopyaları',
    dk: 'Kvittering kopier',
  },
  'Report.PaymentMethods': {
    en: 'Payment methods',
    es: 'Pagos del servicio',
    se: 'Betalningsmedel',
    no: 'Betalingsmidler',
    tr: 'Ödeme metodları',
    dk: 'Betalingsmetoder',
  },
  'Report.Refunds': {
    en: 'Refunds',
    es: 'Reembolsos',
    se: 'Returer',
    no: 'Returer',
    tr: 'Geri ödemeler',
    dk: 'Tilbagebetalinger',
  },
  'Report.OrderRefunds': {
    en: 'Order refunds',
    es: 'Tickets reembolsados',
    se: 'Orderreturer',
    no: 'Ordre returer',
    tr: 'Sipariş iadeleri',
    dk: 'Ordre tilbagebetalinger',
  },
  'Report.Report': {
    en: 'REPORT',
    es: 'INFORME',
    se: 'RAPPORT',
    no: 'RAPPORT',
    tr: 'Rapor',
    dk: 'RAPPORT',
  },
  'Report.PrintedAt': {
    en: 'Printed at',
    es: 'Impreso en',
    se: 'Utskriven',
    no: 'Skrivet ut',
    tr: 'Yazdırıldı',
    dk: 'Printet',
  },
  'Report.Date': {
    en: 'Date',
    es: 'Fecha',
    se: 'Datum',
    no: 'Dato',
    tr: 'Tarih',
    dk: 'Dato',
  },
  'Report.Refunded': {
    en: 'Refunded',
    es: 'Reembolsado',
    se: 'Återbetalningar',
    no: 'Refusjoner',
    tr: 'Geri ödeme yapıldı',
    dk: 'Refunderet',
  },
  'Report.Net': {
    en: 'Net',
    es: 'BI',
    se: 'Netto',
    no: 'Netto',
    tr: 'Net',
    dk: 'Net',
  },
  'Report.Gross': {
    en: 'Gross',
    es: 'Bruto',
    se: 'Brutto',
    no: 'Brutto',
    tr: 'Brüt',
    dk: 'Brutto',
  },
  'Report.TotalSold': {
    en: 'Total sold',
    es: 'Total vendido',
    se: 'Total försäljning',
    no: 'Totalt salg',
    tr: 'Toplam satılan',
    dk: 'Total salg',
  },
  'Report.TotalPerCategory': {
    en: 'Total sales per category',
    es: 'Ventas totales por categoría',
    se: 'Total försäljning per kategori',
    no: 'Totalt salg per kategori',
    tr: 'Kategori başına toplam satış',
    dk: 'Total salg pr. kategori',
  },
  'Report.DetailedSales': {
    en: 'Detailed sales',
    es: 'Ventas detalladas',
    se: 'Detaljerad försäljning',
    no: 'Detaljert salg',
    tr: 'Detaylı satışlar',
    dk: 'Detaljeret salg',
  },
  'Report.Bills': {
    en: 'Bills',
    es: 'Tickets',
    se: 'Notor',
    no: 'Regninger',
    tr: 'Faturalar',
    dk: 'Regninger',
  },
  'Report.OpenCheques': {
    en: 'Open cheques',
    es: 'Comandas abiertas',
    se: 'Öppna notor',
    no: 'Åpne regninger',
    tr: 'Çekleri aç',
    dk: 'Åbne checks',
  },
  'Report.InvoiceReserved': {
    en: 'Invoice (reserved)',
    es: 'Factura (reservada)',
    se: 'Att fakturera (reserverat)',
    no: 'Å fakturere (reservert)',
    tr: 'Fatura (ayrılmış)',
    dk: 'Faktura (reserveret)',
  },
  'Report.AllTimeSales': {
    en: 'Grand total',
    es: 'Ventas acumuladas',
    se: 'Grand total',
    no: 'Grand total',
    tr: 'Genel Toplam',
    dk: 'Totalt',
  },
  'Report.TotalSalesVat': {
    en: 'Grand total sales',
    es: 'Total ventas acumuladas',
    se: 'Grand total försäljning',
    no: 'Grand total salg',
    tr: 'Genel toplam satışlar',
    dk: 'Det samlede salg',
  },
  'Report.SumRefunds': {
    en: 'Grand total refunds',
    es: 'Total reembolsos acumulados',
    se: 'Grand total retur',
    no: 'Grand total retur',
    tr: 'Genel toplam geri ödemeler',
    dk: 'Samlet refusion',
  },
  'Report.AllTimeNetSales': {
    en: 'Net sales',
    es: 'Base imponible',
    se: 'Försäljning netto',
    no: 'Netto salg',
    tr: 'Net satış',
    dk: 'Nettoomsætning',
  },
  'Report.AllTimeSum': {
    en: 'Grand total net (-tips, incl. VAT)',
    es: 'Total BI acumulado (-propinas, incl. IVA)',
    se: 'Grand total netto (- refunds, inkl. moms)',
    no: 'Grand total netto (-refusjoner, inkl. MVA)',
    tr: 'Genel toplam net (-bahşişler, KDV dahil)',
    dk: 'Total netto (-tips, inkl. moms)',
  },
  'Report.DaySales': {
    en: 'Day sales (incl. VAT)',
    es: 'Ventas diarias (IVA incluido)',
    se: 'Dagsförsäljning (ink. moms)',
    no: 'Salg (inkl. MVA)',
    tr: 'Günlük satışlar (KDV dahil)',
    dk: 'Dagsalg (inkl. moms)',
  },
  'Report.CashRegisterIn': {
    en: 'Cash register in',
    es: 'Efectivo inicial en caja',
    se: 'Växelkassa in',
    no: 'Inngående vekselkasse',
    tr: 'Yazar kasa girişi',
    dk: 'Kasseapparat ind',
  },
  'Report.CashRegister': {
    en: 'Cash register',
    es: 'Caja registradora',
    se: 'Växelkassa',
    no: 'Vekselkasse',
    tr: 'Yazar kasa',
    dk: 'Kasseapparat',
  },
  'Report.CashRegisterOut': {
    en: 'Cash register out',
    es: 'Efectivo final en caja',
    se: 'Växelkassa ut',
    no: 'Utgående vekselkasse',
    tr: 'Yazar kasa çıkışı',
    dk: 'Kasseapparat ud',
  },
  'Report.PrintReport': {
    en: 'Print report',
    es: 'Imprimir informe',
    se: 'Skriv ut rapport',
    no: 'Skriv ut rapport',
    tr: 'Raporu yazdır',
    dk: 'Udskriv rapport',
  },
  'Report.SequenceID': {
    en: 'Sequence ID',
    es: 'Nº de secuencia',
    se: 'Löpnummer',
    no: 'Sekvens-ID',
    tr: 'Sıra Kimliği',
    dk: 'Sekvens ID',
  },
  'Report.RegisterID': {
    en: 'Register ID',
    es: 'Nº de registro',
    se: 'Kassa ID',
    no: 'Kasse-ID',
    tr: 'Kayıt Kimliği',
    dk: 'Registrer ID',
  },
  'Report.ZReports': {
    en: 'X/Z-reports',
    es: 'Informes X/Z',
    se: 'X/Z-rapporter',
    no: 'X- og Z-rapporter',
    tr: 'X/Z raporları',
    dk: 'X/Z-rapporter',
  },
  'Report.ZReport': {
    en: 'Z-report',
    es: 'Informe Z',
    se: 'Z-rapport',
    no: 'Z-rapport',
    tr: 'Z raporu',
    dk: 'Z-rapport',
  },
  'Report.AggregatedCategories.Direct': {
    en: 'Direct',
    es: 'Directo',
    se: 'Direkt',
    no: 'Direkte',
    tr: 'Doğrudan',
    dk: 'Direkte',
  },
  'Report.XReport': {
    en: 'X-day report',
    es: 'Informe X',
    se: 'X-dagrapport',
    no: 'X-rapport',
    tr: 'X-gün raporu',
    dk: 'X-dags rapport',
  },
  'Report.ShowFullVenueReport': {
    en: 'Show full venue report',
    es: 'Mostrar informe completo deL local',
    se: 'Visa rapport för hela butiken',
    no: 'Vis rapport for hele avdelingen',
    tr: 'Mekan raporunun tamamını göster',
    dk: 'Vis hele mødestedsrapporten',
  },
  'Report.NotAvailableInFullVenueReport': {
    en: 'Not available when report is for full venue',
    es: 'No disponible cuando el informe es para todo el local',
    se: 'Inte tillgängligt när rapporten är för hela butiken',
    no: 'Ikke tilgjengelig når rapporten vises for hele avdelingen',
    tr: 'Rapor tüm mekan için olduğunda kullanılamaz',
    dk: 'Ikke tilgængelig, når rapporten er for fuldt mødested',
  },
  'Report.Expenses': {
    en: 'Expenses',
    es: 'Gastos',
    se: 'Utlägg',
    no: 'Utgifter',
    tr: 'Giderler',
    dk: 'Udgifter',
  },
  'Report.NumberOfItems': {
    en: 'Number of items',
    es: 'Nº de artículos',
    se: 'Antal artiklar',
    no: 'Antall artikler',
    tr: 'Ürün sayısı',
    dk: 'Antal varer',
  },
  'Report.NumberOfItemsSold': {
    en: 'Total number of items sold',
    es: 'Nº total de artículos vendidos',
    se: 'Totalt antal sålda artiklar',
    no: 'Totalt antall solgte artikler',
    tr: 'Satılan toplam ürün sayısı',
    dk: 'I alt solgte varer',
  },
  'Report.NumberOfItemsRefunded': {
    en: 'Total number of items refunded',
    es: 'Total de artículos reembolsados',
    se: 'Toalt antal återbetalda artiklar',
    no: 'Totalt antall refunderte artikler',
    tr: 'İade edilen toplam ürün sayısı',
    dk: 'I alt varer refunderet',
  },
  'Report.FullReport': {
    en: 'Full report',
    es: 'Informe completo',
    se: 'Fullständig rapport',
    no: 'Fullstendig rapport',
    tr: 'Tam rapor',
    dk: 'Fuld rapport',
  },
  'Report.NoSales': {
    en: 'There are no sales on the selected date',
    es: 'No hay ventas en la fecha seleccionada',
    se: 'Det finns ingen försäljning på vald dag',
    no: 'Det er ingen salg på valgt dato',
    tr: 'Seçilen tarihte satış yok',
    dk: 'Der er ingen salg på den valgte dato',
  },
  'Report.ViewFullReport': {
    en: 'View full report',
    es: 'Ver informe completo',
    se: 'Visa fullständig rapport',
    no: 'Vis fullstendig rapport',
    tr: 'Tam raporu görüntüle',
    dk: 'Se fuld rapport',
  },
  'Report.StaffReport': {
    en: 'Staff report',
    es: 'Informe del personal',
    se: 'Personalrapport',
    no: 'Ansattrapport',
    tr: 'Personel raporu',
    dk: 'Medarbejderrapport',
  },
  'Report.NoDataToPrint': {
    en: 'There is no data to print',
    es: 'No hay datos para imprimir',
    se: 'Det finns ingen data att skriva ut',
    no: 'Det er ingen data å skrive ut',
    tr: 'Yazdırılacak veri yok',
    dk: 'Der er ingen data at udskrive',
  },
  'Report.StaffReport.TipsByPayment': {
    en: 'Tips per payment method',
    es: 'Propina por método de pago',
    se: 'Dricks per betalningsmedel',
    no: 'Tips per betalingsmetode',
    tr: 'Ödeme yöntemi başına bahşiş',
    dk: 'Drikkepenge pr. betalingsmetode',
  },
  'Report.ViewStaffReport': {
    en: 'Select staff',
    es: 'Seleccionar personal',
    se: 'Välj personal',
    no: 'Velg ansatt',
    tr: 'Personel seç',
    dk: 'Vælg medarbejder',
  },
  'Report.StaffWithActivity': {
    en: 'Staff with activity for the selected day',
    es: 'Personal con actividad para el día seleccionado',
    se: 'Personal med aktivitet för vald dag',
    no: 'Ansatte med aktivitet for valgt dag',
    tr: 'Seçilen gün için faaliyet gösteren personel',
    dk: 'Personale med aktivitet for den valgte dag',
  },
  'Report.NoStaffWithActivity': {
    en: 'There is no staff with activity for the selected day',
    es: 'No hay personal con actividad para el día seleccionado',
    se: 'Det finns ingen personal med aktivitet för vald dag',
    no: 'Det er ingen ansatte med aktivitet for valgt dag',
    tr: 'Seçilen gün için faaliyet gösteren personel yok',
    dk: 'Der er ingen personale med aktivitet for den valgte dag',
  },
  'Report.PrintAllStaffReports': {
    en: 'Print all staff reports',
    es: 'Imprimir todos los informes del personal',
    se: 'Skriv ut alla personalrapporter',
    no: 'Skriv ut alle ansattrapporter',
    tr: 'Tüm personel raporlarını yazdır',
    dk: 'Udskriv alle medarbejderrapporter',
  },
  'Report.StaffReport.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Total',
    no: 'Totalt',
    tr: 'Toplam',
    dk: 'Total',
  },
  'Report.StaffReport.Sales': {
    en: 'Sales',
    es: 'Ventas',
    se: 'Försäljningar',
    no: 'Salg',
    tr: 'Satışlar',
    dk: 'Salg',
  },
  'Report.StaffReport.Refunds': {
    en: 'Refunds',
    es: 'Reembolsos',
    se: 'Returer',
    no: 'Refusjoner',
    tr: 'Geri ödemeler',
    dk: 'Refusioner',
  },
  'Report.StaffReport.Discounts': {
    en: 'Discounts',
    es: 'Descuentos',
    se: 'Rabatter',
    no: 'Rabatter',
    tr: 'Indirimler',
    dk: 'Rabatter',
  },
  'Report.StaffReport.Tips': {
    en: 'Total tips',
    es: 'Propinas totales',
    se: 'Total dricks',
    no: 'Total tips',
    tr: 'Toplam bahşiş',
    dk: 'Total drikkepenge',
  },
  'Report.Qty': {
    en: 'Qty',
    es: 'Cant',
    se: 'Antal',
    no: 'Ant',
    tr: 'Adet',
    dk: 'Antal',
  },
  // Receipts
  'Receipt.Types.Copy': {
    en: 'Copy',
    es: 'Copia',
    se: 'Kopia',
    no: 'KOPI',
    tr: 'Kopyala',
    dk: 'Kopi',
  },
  'Receipt.Types.Refund': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'Retur',
    no: 'Returkvittering',
    tr: 'Geri ödeme',
    dk: 'Tilbagebetale',
  },
  'Receipt.Types.TipRefund': {
    en: 'Tip refund',
    es: 'Reembolso de propina',
    se: 'Dricksretur',
    no: 'Tips Retur',
    tr: 'Bahşiş iadesi',
    dk: 'Tip Retur',
  },
  'Receipt.Types.Sale': {
    en: 'Receipt',
    es: 'Ticket',
    se: 'Kvitto',
    no: 'Salgskvittering',
    tr: 'Fiş',
    dk: 'Kvittering',
  },
  'Receipt.Types.Cheque': {
    en: 'Cheque',
    es: 'Cuenta',
    se: 'Nota',
    no: 'Foreløpig kvittering – IKKE KVITTERING FOR KJØP',
    tr: 'Çek',
    dk: 'Check',
  },
  'Receipt.Types.Invoice': {
    en: 'Invoice',
    es: 'Factura',
    se: 'Faktura',
    no: 'Faktura',
    tr: 'Fatura',
    dk: 'Faktura',
  },
  'Receipt.VATNo': {
    en: 'VAT No',
    es: 'NIF/CIF',
    se: 'Org.Nr',
    no: 'Org.nr.',
    tr: 'KDV No',
    dk: 'moms nr',
  },
  'Receipt.ReceiptNo': {
    en: 'Receipt No',
    es: 'Nº Fra. Simplificada',
    se: 'Kvitto Nr',
    no: 'Kvitteringsnr.',
    tr: 'Fiş No',
    dk: 'Kvittering nr',
  },
  'Receipt.OrderDate': {
    en: 'Order date',
    es: 'Fecha',
    se: 'Beställningsdatum',
    no: 'Bestillingsdato',
    tr: 'Sipariş tarihi',
    dk: 'Bestillingsdato',
  },
  'Receipt.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'Receipt.TipRefunded': {
    en: 'Tip refunded',
    es: 'Propina reembolsada',
    se: 'Dricks återbetald',
    no: 'Tips refusjon',
    tr: 'Bahşiş iade edildi',
    dk: 'Tip refunderet',
  },
  'Receipt.TotalIncTip': {
    en: 'Total inc. tip',
    es: 'Total con propina',
    se: 'Total inkl. dricks',
    no: 'Total inkl. tips',
    tr: 'Toplam bahşiş dahil',
    dk: 'Total inkl. drikkepenge',
  },
  'Receipt.Coverage': {
    en: 'Coverage',
    es: 'Comensales',
    se: 'Gäster',
    no: 'Gjester',
    tr: 'Kapsam',
    dk: 'Dækning',
  },
  'Receipt.Discount': {
    en: 'Discount',
    es: 'Descuentos',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'Receipt.Tip': {
    en: 'Tip',
    es: 'Propina',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşiş',
    dk: 'Drikkepenge',
  },
  'Receipt.VAT': {
    en: 'VAT',
    es: 'IVA',
    se: 'Moms',
    no: 'MVA',
    tr: 'KDV',
    dk: 'moms',
  },
  'Receipt.Net': {
    en: 'Net',
    es: 'B.I.',
    se: 'Netto',
    no: 'Netto',
    tr: 'Net',
    dk: 'Net',
  },
  'Receipt.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Total',
    no: 'Total',
    tr: 'Toplam',
    dk: 'Total',
  },
  'Receipt.InvoiceAmount': {
    en: 'Invoice amount',
    es: 'Importe',
    se: 'Fakturabelopp',
    no: 'Fakturabeløp',
    tr: 'Fatura tutarı',
    dk: 'Fakturabeløb',
  },
  'Receipt.TotalAmount': {
    en: 'Total amount',
    es: 'Importe total',
    se: 'Totalbelopp',
    no: 'Totalbeløp',
    tr: 'Toplam tutar',
    dk: 'Samlet beløb',
  },
  'Receipt.ControlUnit': {
    en: 'Control unit',
    es: 'Nº de control',
    se: 'Kontrollenhet',
    no: 'Kontrollenhet',
    tr: 'Kontrol ünitesi',
    dk: 'Kontrolenhed',
  },
  'Receipt.InvoiceAddress': {
    en: 'Invoice address',
    es: 'Dirección de facturación',
    se: 'Fakturaadress',
    no: 'Fakturaadresse',
    tr: 'Fatura adresi',
    dk: 'Fakturaadresse',
  },
  'Receipt.NameClarification': {
    en: 'Name clarification',
    es: 'Nombre y apellidos',
    se: 'Namnförtydligande',
    no: 'Navn',
    tr: 'İsim açıklaması',
    dk: 'Navneafklaring',
  },
  'Receipt.Signature': {
    en: 'Signature',
    es: 'Firma',
    se: 'Signatur',
    no: 'Signatur',
    tr: 'İmza',
    dk: 'Signatur',
  },
  'Receipt.IDCheck': {
    en: 'ID-check',
    es: 'NIF/CIF',
    se: 'ID-kontroll',
    no: 'ID-kontroll',
    tr: 'Kimlik kontrolü',
    dk: 'ID-tjek',
  },
  'Receipt.CardType': {
    en: 'Card type',
    es: 'Tipo de tarjeta',
    se: 'Korttyp',
    no: 'Korttype',
    tr: 'Kart tipi',
    dk: 'Korttype',
  },
  'Receipt.Card': {
    en: 'CARD',
    es: 'TARJETA',
    se: 'KORT',
    no: 'KORT',
    tr: 'KART',
    dk: 'KORT',
  },
  'Receipt.NewTotal': {
    en: 'New total',
    es: 'Nuevo total',
    se: 'Ny total',
    no: 'Ny total',
    tr: 'Yeni toplam',
    dk: 'Ny total',
  },
  'Waste.Register': {
    en: 'Register waste',
    es: 'Registrar desperdicio',
    se: 'Registrera svinn',
    no: 'Registrer svinn',
    tr: 'Atığı kaydet',
    dk: 'Registrer spild',
  },
  'Waste.NumberOfProducts': {
    en: 'Number to register as waste',
    es: 'Cantidad a registrar como desperdicio',
    se: 'Antal att registrera som svinn',
    no: 'Antall å registrere som svinn',
    tr: 'Kayıt edilecek atık miktarı',
    dk: 'Antal at registrere som svind',
  },
  'Waste.WasteRegisteredSuccessfully': {
    en: 'Waste registered successfully',
    es: 'Desperdicio registrado con éxito',
    se: 'Svinn registrerat',
    no: 'Svinn registrert',
    tr: 'Atık başarıyla kaydedildi',
    dk: 'Spild registreret',
  },
  'Waste.WasteRegisteredFailed': {
    en: 'Failed to register waste, please try again',
    es: 'Error al registrar el desperdicio, por favor intente de nuevo',
    se: 'Misslyckades att registrera svinn, försök igen',
    no: 'Kunne ikke registrere svinn, vennligst prøv igjen',
    tr: 'Atık kaydı başarısız oldu, lütfen tekrar deneyin',
    dk: 'Kunne ikke registrere spild, prøv venligst igen',
  },
  'RemoveItems.ExampleWasteComment': {
    en: 'E.g. "Damaged on delivery"',
    es: 'Ej. "Dañado en la entrega"',
    se: 'T.ex. "Skadat vid leverans"',
    no: 'F.eks. "Skadet ved levering"',
    tr: 'Örn. "Teslimatta hasar gördü"',
    dk: 'F.eks. "Beskadiget ved levering"',
  },
  'RemoveItems.ExampleCorrectionComment': {
    en: 'E.g. “They changed their mind”',
    es: 'Ej. “Cambiaron de opinión”',
    se: 'T.ex. “De ändrade sig”',
    no: 'F.eks. “De ombestemte seg”',
    tr: 'Örn. “Fikirlerini değiştirdiler”',
    dk: 'F.eks. “De ombestemte sig”',
  },
  'RemoveItems.CompetitionWarning': {
    en: (name: string) =>
      `You're about to remove competition products. Score will be deducted from ${name} who is the cheque owner.`,
    es: (name: string) =>
      `Vas a eliminar productos de competencia. Se deducirán puntos de ${name} quien es el dueño de la cuenta.`,
    se: (name: string) =>
      `Du tar bort tävlingsprodukter. Poäng dras från ${name} som är notans ägare.`,
    no: (name: string) =>
      `Du fjerner konkurranseprodukter. Poeng trekkes fra ${name} som er regningens eier.`,
    tr: (name: string) =>
      `Yarışma ürünlerini kaldırıyorsunuz. Hesap sahibi olan ${name} üzerinden puan düşülecektir.`,
    dk: (name: string) =>
      `Du fjerner konkurrenceprodukter. Point trækkes fra ${name} som er regningens ejer.`,
  },

  // Inventory
  'Inventory.Balance': {
    en: 'Balance',
    es: 'Existencias',
    se: 'Saldo',
    no: 'Saldo',
    tr: 'Bakiye',
    dk: 'Balance',
  },
  'Inventory.Override.Short': {
    en: 'Override',
    es: 'Modificar',
    se: 'Överskrid',
    no: 'Overstyr',
    tr: 'Geçersiz kıl',
    dk: 'Tilsidesæt',
  },
  'Inventory.Override': {
    en: 'Override inventory',
    es: 'Modificar inventario',
    se: 'Överskrid lagersaldo',
    no: 'Overstyr lagersaldo',
    tr: 'Envanteri geçersiz kıl',
    dk: 'Tilsidesæt beholdning',
  },
  'Inventory.OutOfStock': {
    en: 'Out of stock',
    es: 'Agotado',
    se: 'Slut i lager',
    no: 'Utsolgt',
    tr: 'Stoklar tükendi',
    dk: 'Udsolgt',
  },
  'Inventory.InStock': {
    en: 'In stock',
    es: 'En stock',
    se: 'I lager',
    no: 'På lager',
    tr: 'Stokta var',
    dk: 'På lager',
  },
  'Inventory.SetOutOfStock': {
    en: 'Set out of stock',
    es: 'Fuera de stock',
    se: 'Sätt slut i lager',
    no: 'Sett som utsolgt',
    tr: 'Stokta yok',
    dk: 'Markér som udsolgt',
  },
  'Inventory.RemoveOutOfStock': {
    en: 'Remove out of stock',
    es: 'Quitar fuera de stock',
    se: 'Ta bort slut i lager',
    no: 'Sett som tilgjengelig',
    tr: 'Stokta olmayanları kaldır',
    dk: 'Fjern udsolgt',
  },
  'Inventory.Clear': {
    en: 'Clear inventory',
    es: 'Eliminar inventario',
    se: 'Rensa lagersaldo',
    no: 'Fjern lagersaldo',
    tr: 'Envanteri temizle',
    dk: 'Ryd beholdning',
  },
  'Inventory.SeeRegional': {
    en: 'See regional inventory',
    es: 'Ver inventario local',
    se: 'Se regionalt lagersaldo',
    no: 'Se lagersaldo på andre avdelinger',
    tr: 'Bölgesel envanteri görün',
    dk: 'Se regional opgørelse',
  },
  'Inventory.Regional': {
    en: 'Regional inventory',
    es: 'Inventario local',
    se: 'Regionalt lagersaldo',
    no: 'Lagersaldo per avdeling',
    tr: 'Bölgesel envanter',
    dk: 'Regional opgørelse',
  },
  'Inventory.MakeTransfer': {
    en: 'Make a transfer',
    es: 'Hacer una transferencia',
    se: 'Gör en överföring',
    no: 'Overfør til annen avdeling',
    tr: 'Transfer yap',
    dk: 'Foretag en overførsel',
  },
  'Inventory.Save': {
    en: 'Save',
    es: 'Guardar',
    se: 'Spara',
    no: 'Lagre',
    tr: 'Kaydet',
    dk: 'Spar',
  },
  'Inventory.Back': {
    en: 'Back',
    es: 'Atrás',
    se: 'Tillbaka',
    no: 'Tilbake',
    tr: 'Geri',
    dk: 'Tilbage',
  },
  'Inventory.Venue': {
    en: 'Venue',
    es: 'Local',
    se: 'Butik',
    no: 'Avdeling',
    tr: 'Yer',
    dk: 'Mødested',
  },
  'Inventory.Quantity': {
    en: 'Quantity',
    es: 'Cantidad',
    se: 'Antal',
    no: 'Antall',
    tr: 'Miktar',
    dk: 'Mængde',
  },
  'Inventory.CurrentStock': {
    en: 'Current stock',
    es: 'Stock actual',
    se: 'Nuvarande lagersaldo',
    no: 'Nåværende lagersaldo',
    tr: 'Mevcut stok',
    dk: 'Nuværende lager',
  },
  'Inventory.Continue': {
    en: 'Continue',
    es: 'Continuar',
    se: 'Fortsätt',
    no: 'Fortsett',
    tr: 'Devam et',
    dk: 'Fortsæt',
  },
  'Inventory.ReasonReduction': {
    en: 'Reason for reduction',
    es: 'Motivo de la reducción',
    se: 'Orsak till minskning',
    no: 'Årsak til reduksjon',
    tr: 'Azaltma nedeni',
    dk: 'Årsag til reduktion',
  },
  'Inventory.ReasonReductionMessage': {
    en: 'You need to enter a comment to reduce the stock',
    es: 'Es necesario introducir un comentario para reducir el stock',
    se: 'Du måste ange en kommentar för att minska lagersaldot',
    no: 'Du må angi en kommentar for å redusere lagersaldoen',
    tr: 'Stokları azaltmak için yorum girmeniz gerekmektedir',
    dk: 'Du skal indtaste en kommentar for at reducere beholdningen',
  },
  'Inventory.ChosenItem': {
    en: 'Chosen item',
    es: 'Elemento elegido',
    se: 'Vald produkt',
    no: 'Valgt artikkel',
    tr: 'Seçilen ürün',
    dk: 'Valgt vare',
  },
  'Inventory.TargetVenue': {
    en: 'Target venue',
    es: 'Lugar de destino',
    se: 'Målbutik',
    no: 'Overføres til',
    tr: 'Hedef mekan',
    dk: 'Målsted',
  },
  'Inventory.QuantityToMove': {
    en: 'Quantity to move',
    es: 'Cantidad a mover',
    se: 'Antal att flytta',
    no: 'Antall som skal flyttes',
    tr: 'Taşınacak miktar',
    dk: 'Mængde at flytte',
  },
  'Inventory.OrderInventory': {
    en: 'Order inventory',
    es: 'Inventario de pedidos',
    se: 'Lagerbeställning',
    no: 'Lagerbestilling',
    tr: 'Envanter siparişi ver',
    dk: 'Bestil inventar',
  },
  'Inventory.Product': {
    en: 'Product',
    es: 'Producto',
    se: 'Produkt',
    no: 'Produkt',
    tr: 'Ürün',
    dk: 'Produkt',
  },
  'Inventory.Order': {
    en: 'Order',
    es: 'Pedido',
    se: 'Beställ',
    no: 'Bestill',
    tr: 'Sipariş',
    dk: 'Bestille',
  },
  'Inventory.OrderCommentPlaceholder': {
    en: 'Write a comment here (optional)',
    es: 'Escribe un comentario aquí (opcional)',
    se: 'Lägg en kommentar här (valfritt)',
    no: 'Legg inn en kommentar her (valgfritt)',
    tr: 'Buraya bir yorum yazın (isteğe bağlı)',
    dk: 'Skriv en kommentar her (valgfrit)',
  },
  'Inventory.OrderComment': {
    en: 'Comment',
    es: 'Comentario',
    se: 'Kommentar',
    no: 'Kommentar',
    tr: 'Yorum',
    dk: 'Kommentar',
  },
  'Inventory.CreateNew': {
    en: 'Create new order',
    es: 'Crear nuevo pedido',
    se: 'Gör en ny beställning',
    no: 'Opprett ny bestilling',
    tr: 'Yeni sipariş oluştur',
    dk: 'Opret ny ordre',
  },
  'Inventory.CreateNewText': {
    en: 'To create a new order click the button below:',
    es: 'Para crear un nuevo pedido, haga clic en el siguiente botón:',
    se: 'För att skapa en ny beställning klicka på knappen nedan:',
    no: 'For å opprette en ny bestilling, klikk på knappen nedenfor:',
    tr: 'Yeni bir sipariş oluşturmak için aşağıdaki düğmeye tıklayın:',
    dk: 'For at oprette en ny ordre, klik på knappen nedenfor:',
  },
  'Inventory.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'OK',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Bekræfte',
  },
  'Inventory.LoadingProducts': {
    en: 'Loading articles...',
    es: 'Cargando artículos...',
    se: 'Laddar artiklar...',
    no: 'Laster artikler...',
    tr: 'Ürünler yükleniyor...',
    dk: 'Indlæser artikler...',
  },
  'Inventory.Description': {
    en: 'Description',
    es: 'Descripción',
    se: 'Beskrivning',
    no: 'Beskrivelse',
    tr: 'Tanım',
    dk: 'Beskrivelse',
  },
  'Inventory.NoIngredientsFound': {
    en: 'No Ingredients found',
    es: 'No se encontraron ingredientes',
    se: 'Inga ingredienser hittades',
    no: 'Ingen ingredienser funnet',
    tr: 'Hiçbir malzeme bulunamadı',
    dk: 'Ingen ingredienser fundet',
  },
  'Inventory.NoIngredientsFoundMatching': {
    en: 'No Ingredients found matching',
    es: 'No se encontraron ingredientes que coincidan con',
    se: 'Inga ingredienser hittades som matchar',
    no: 'Ingen ingredienser funnet som samsvarer med',
    tr: 'Hiçbir malzeme bulunamadı',
    dk: 'Ingen ingredienser fundet der matcher',
  },
  'Inventory.NoCategoriesFound': {
    en: 'No categories found.',
    es: 'No se encontraron categorías',
    se: 'Inga kategorier hittades',
    no: 'Ingen kategorier funnet',
    tr: 'Hiçbir kategori bulunamadı',
    dk: 'Ingen kategorier fundet',
  },
  'Inventory.NoCategoriesFoundMatching': {
    en: 'No categories found matching',
    es: 'No se encontraron categorías que coincidan con',
    se: 'Inga kategorier hittades som matchar',
    no: 'Ingen kategorier funnet som samsvarer med',
    tr: 'Hiçbir kategori bulunamadı',
    dk: 'Ingen kategorier fundet der matcher',
  },
  'Inventory.SearchCategories': {
    en: 'Search categories...',
    se: 'Sök kategorier...',
    no: 'Søk kategorier...',
    es: 'Buscar categorías...',
    tr: 'Kategori ara...',
    dk: 'Søg kategorier...',
  },
  'Inventory.SearchProducts': {
    en: 'Search products...',
    se: 'Sök produkter...',
    no: 'Søk produkter...',
    es: 'Buscar productos...',
    tr: 'Ürün ara...',
    dk: 'Søg produkter...',
  },
  'Inventory.SearchVariations': {
    en: 'Search variations/ingredients...',
    se: 'Sök tillval/ingredienser...',
    no: 'Søk variasjoner/ingredienser...',
    es: 'Buscar variaciones/ingredientes...',
    tr: 'Varyasyon/malzeme ara...',
    dk: 'Søg variationer/ingredienser...',
  },
  'Inventory.UpdateProductsStock': {
    en: 'Update products stock',
    se: 'Uppdatera produktlager',
    no: 'Oppdater produktlager',
    es: 'Actualizar stock de productos',
    tr: 'Ürün stokunu güncelle',
    dk: 'Opdater produktbeholdning',
  },
  'Inventory.Variations': {
    en: 'Variations/ingredients',
    se: 'Tillval/ingredienser',
    no: 'Varianter/ingredienser',
    es: 'Variaciones/ingredientes',
    tr: 'Varyasyonlar/malzemeler',
    dk: 'Variationer/ingredienser',
  },
  'Inventory.BatchUpdateInventory': {
    en: 'Batch update inventory',
    se: 'Massuppdatera lager',
    no: 'Masseoppdater lager',
    es: 'Actualización masiva de inventario',
    tr: 'Toplu envanter güncelleme',
    dk: 'Masseopdater beholdning',
  },
  'Inventory.BatchUpdateDescription': {
    en: 'Select products and specify how much stock to add or subtract.',
    se: 'Välj produkter och ange hur mycket lager som ska läggas till eller dras ifrån.',
    no: 'Velg produkter og angi hvor mye lager som skal legges til eller trekkes fra.',
    es: 'Seleccione productos y especifique cuánto stock agregar o restar.',
    tr: 'Ürünleri seçin ve ne kadar stok ekleneceğini veya çıkarılacağını belirtin.',
    dk: 'Vælg produkter og angiv hvor meget lager der skal tilføjes eller fratrækkes.',
  },
  'Inventory.NoProductsFoundMatching': {
    en: 'No products found matching',
    se: 'Inga produkter hittades som matchar',
    no: 'Ingen produkter funnet som samsvarer med',
    es: 'No se encontraron productos que coincidan con',
    tr: 'Eşleşen ürün bulunamadı',
    dk: 'Ingen produkter fundet der matcher',
  },
  'Inventory.ProductsWillBeUpdated': {
    en: 'product will be updated',
    se: 'produkt kommer att uppdateras',
    no: 'produkt vil bli oppdatert',
    es: 'producto será actualizado',
    tr: 'ürün güncellenecek',
    dk: 'produkt vil blive opdateret',
  },
  'Inventory.ProductsWillBeUpdatedPlural': {
    en: 'products will be updated',
    se: 'produkter kommer att uppdateras',
    no: 'produkter vil bli oppdatert',
    es: 'productos serán actualizados',
    tr: 'ürün güncellenecek',
    dk: 'produkter vil blive opdateret',
  },
  'Inventory.NoProductsSelectedForUpdate': {
    en: 'No products selected for update',
    se: 'Inga produkter valda för uppdatering',
    no: 'Ingen produkter valgt for oppdatering',
    es: 'No se seleccionaron productos para actualizar',
    tr: 'Güncelleme için ürün seçilmedi',
    dk: 'Ingen produkter valgt til opdatering',
  },
  'Inventory.UpdateInventory': {
    en: 'Update inventory',
    se: 'Uppdatera lager',
    no: 'Oppdater lager',
    es: 'Actualizar inventario',
    tr: 'Envanteri güncelle',
    dk: 'Opdater beholdning',
  },
  'Inventory.StockNotSet': {
    en: 'Stock not set',
    se: 'Lager ej satt',
    no: 'Lager ikke satt',
    es: 'Stock no configurado',
    tr: 'Stok ayarlanmadı',
    dk: 'Lager ikke sat',
  },
  'Inventory.CostOfGoods': {
    en: 'Cost of goods',
    se: 'Varukostnad',
    no: 'Varekostnad',
    es: 'Costo de bienes',
    tr: 'Mal maliyeti',
    dk: 'Vareomkostning',
  },
  'Inventory.NotSet': {
    en: 'Not set',
    se: 'Ej satt',
    no: 'Ikke satt',
    es: 'No configurado',
    tr: 'Ayarlanmadı',
    dk: 'Ikke sat',
  },
  'Inventory.Actions': {
    en: 'Actions',
    se: 'Åtgärder',
    no: 'Handlinger',
    es: 'Acciones',
    tr: 'İşlemler',
    dk: 'Handlinger',
  },
  'Inventory.XInStock': {
    en: 'in stock',
    se: 'i lager',
    no: 'på lager',
    es: 'en stock',
    tr: 'stokta',
    dk: 'på lager',
  },
  'Inventory.UsedIn': {
    en: 'Used in',
    se: 'Används i',
    no: 'Brukes i',
    es: 'Usado en',
    tr: 'Kullanılan',
    dk: 'Brugt i',
  },
  'Inventory.AndMore': {
    en: 'more',
    se: 'fler',
    no: 'flere',
    es: 'más',
    tr: 'daha fazla',
    dk: 'flere',
  },
  'Inventory.NotUsedInAnyProducts': {
    en: 'Not used in any products',
    se: 'Används inte i några produkter',
    no: 'Ikke brukt i noen produkter',
    es: 'No se usa en ningún producto',
    tr: 'Hiçbir üründe kullanılmıyor',
    dk: 'Ikke brugt i nogen produkter',
  },
  'Inventory.SetCategoryInStock': {
    en: 'Set category as in stock?',
    se: 'Sätt kategori som i lager?',
    no: 'Sett kategori som på lager?',
    es: '¿Marcar categoría como en stock?',
    tr: 'Kategoriyi stokta olarak ayarla?',
    dk: 'Markér kategori som på lager?',
  },
  'Inventory.SetCategoryOutOfStock': {
    en: 'Set category out of stock?',
    se: 'Sätt kategori som slut i lager?',
    no: 'Sett kategori som utsolgt?',
    es: '¿Marcar categoría como agotada?',
    tr: 'Kategoriyi stokta yok olarak ayarla?',
    dk: 'Markér kategori som udsolgt?',
  },
  'Inventory.ProductSingular': {
    en: 'product',
    se: 'produkt',
    no: 'produkt',
    es: 'producto',
    tr: 'ürün',
    dk: 'produkt',
  },
  'Inventory.ProductPlural': {
    en: 'products',
    se: 'produkter',
    no: 'produkter',
    es: 'productos',
    tr: 'ürün',
    dk: 'produkter',
  },

  // Expenses
  'Expenses.HeaderTitle': {
    en: 'Expenses',
    es: 'Gastos',
    se: 'Utlägg',
    no: 'Utgifter',
    tr: 'Giderler',
    dk: 'Udgifter',
  },
  'Expenses.StartExpenseFlowDescription': {
    en: 'View and register expenses',
    es: 'Ver y registrar gastos',
    se: 'Visa och registrera utlägg',
    no: 'Vis og registrer utgifter',
    tr: 'Giderleri görüntüle ve kaydet',
    dk: 'Se og registrer udgifter',
  },
  'Expenses.StartExpenseFlowCTA': {
    en: 'Start expense flow',
    es: 'Iniciar flujo de gastos',
    se: 'Starta utläggsflöde',
    no: 'Start utgiftsstrøm',
    tr: 'Gider akışını başlat',
    dk: 'Start udgiftsflow',
  },
  'Expenses.ExpenseFlowStarted': {
    en: 'Expense flow started',
    es: 'Flujo de gastos iniciado',
    se: 'Utläggsflödet startat',
    no: 'Utgiftsstrømmen startet',
    tr: 'Gider akışı başladı',
    dk: 'Udgiftsflow startede',
  },
  'Expenses.Date': {
    en: 'Date',
    es: 'Fecha',
    se: 'Datum',
    no: 'Dato',
    tr: 'Tarih',
    dk: 'Dato',
  },
  'Expenses.Sum': {
    en: 'Sum',
    es: 'Suma',
    se: 'Summa',
    no: 'Sum',
    tr: 'Toplam',
    dk: 'Sum',
  },
  'Expenses.Staff': {
    en: 'Staff',
    es: 'Personal',
    se: 'Personal',
    no: 'Personale',
    tr: 'Personel',
    dk: 'Personale',
  },
  'Expenses.Loading': {
    en: 'Loading expenses...',
    es: 'Cargando gastos...',
    se: 'Laddar utlägg...',
    no: 'Laster utgifter...',
    tr: 'Giderler yükleniyor...',
    dk: 'Indlæser udgifter...',
  },
  'Expense.LoadMore': {
    en: 'Load more',
    es: 'Cargar más',
    se: 'Hämta fler',
    no: 'Last mer',
    tr: 'Daha fazla yükle',
    dk: 'Indlæs mere',
  },
  'Expenses.NoExpensesFound': {
    en: 'No expenses found',
    es: 'No se encontraron gastos',
    se: 'Inga utlägg hittades',
    no: 'Ingen utgifter funnet',
    tr: 'Hiçbir masraf bulunamadı',
    dk: 'Ingen udgifter fundet',
  },

  // End of day
  'EOD.EndOfDay': {
    en: 'End of day',
    es: 'Cierre de servicio',
    se: 'Dagsavslut',
    no: 'Dagsavslutning',
    tr: 'Gün sonu',
    dk: 'Slut på dagen',
  },
  'EOD.EndOfDay.Procedure': {
    en: 'Perform end-of-day',
    es: 'Realizar cierre de servicio',
    se: 'Genomför dagsavslut',
    no: 'Gjennomfør dagsoppgjør',
    tr: 'Gün sonu kapanışını gerçekleştir',
    dk: 'Gennemfør dagsafslutning',
  },
  'EOD.EndOfDay.CashEntryType': {
    en: 'Manual or counter?',
    es: '¿Manual o contador?',
    se: 'Manuell eller räknare?',
    no: 'Manuell eller teller?',
    tr: 'Manuel mi, sayıcı mı?',
    dk: 'Manuel eller tæller?',
  },
  'EOD.EndOfDay.Procedure.Subtitle': {
    en: 'To perform an end-of-day closing, you need to follow the procedure below:',
    es: 'Para realizar un cierre de servicio, debes seguir el siguiente procedimiento:',
    se: 'För att göra ett dagsavslut krävs det att du genomgår följande procedur:',
    no: 'For å gjennomføre dagsoppgjøret må du følge denne prosedyren:',
    tr: 'Gün sonu kapanışı yapmak için aşağıdaki prosedürü uygulamalısınız:',
    dk: 'For at gennemføre dagsafslutningen skal du følge denne procedure:',
  },
  'EOD.Loading': {
    en: "Loading today's statistics...",
    es: 'Cargando las estadísticas de hoy...',
    se: 'Laddar dagens statistik...',
    no: 'Laster dagens statistikk...',
    tr: 'Bugünün istatistikleri yükleniyor...',
    dk: 'Indlæser dagens statistik...',
  },
  'EOD.Product': {
    en: 'Product',
    es: 'Producto',
    se: 'Godkänna',
    no: 'Artikkel',
    tr: 'Ürün',
    dk: 'Produkt',
  },
  'EOD.Quantity': {
    en: 'Quantity',
    es: 'Cantidad',
    se: 'Kvantitet',
    no: 'Antall',
    tr: 'Miktar',
    dk: 'Mængde',
  },
  'EOD.Approve': {
    en: 'Approve',
    es: 'Aceptar',
    se: 'Godkänn',
    no: 'Godkjenn',
    tr: 'Onayla',
    dk: 'Godkend',
  },
  'EOD.CashOut': {
    en: 'The cash register is out',
    es: 'La caja registradora está cerrada',
    se: 'Växelkassan ut',
    no: 'Utgående vekselkasse',
    tr: 'Yazar kasa kapandı',
    dk: 'Kasseapparatet er ude',
  },
  'EOD.EnterEODBalance': {
    en: 'Enter end of day balance',
    es: 'Introducir fondo de caja final',
    se: 'Fyll i dagsavslut',
    no: 'Fyll inn utgående vekselkasse',
    tr: 'Gün sonu bakiyesini girin',
    dk: 'Indtast saldo for slutningen af ​​dagen',
  },
  'EOD.PrintZReport': {
    en: 'Print Z report',
    es: 'Imprimir informe Z',
    se: 'Skriv ut Z rapport',
    no: 'Generer Z-rapport',
    tr: 'Z raporunu yazdır',
    dk: 'Udskriv Z-rapport',
  },
  'EOD.GrossSales': {
    en: 'Gross sales',
    es: 'Ventas totales',
    se: 'Brutto försäljning',
    no: 'Brutto salg',
    tr: 'Brüt satış',
    dk: 'Bruttosalg',
  },
  'EOD.NetSales': {
    en: 'Net sales',
    es: 'Base imponible',
    se: 'Netto försäljning',
    no: 'Netto salg',
    tr: 'Net satış',
    dk: 'Nettoomsætning',
  },
  'EOD.Tips': {
    en: 'Tips',
    es: 'Propinas',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşişler',
    dk: 'Drikkepenge',
  },
  'EOD.Discount': {
    en: 'Discount',
    es: 'Descuentos',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'EOD.Payments': {
    en: 'Payments',
    es: 'Pagos',
    se: 'Betalningar',
    no: 'Betalinger',
    tr: 'Ödemeler',
    dk: 'Betalinger',
  },
  'EOD.Activity': {
    en: 'Activity',
    es: 'Actividad',
    se: 'Aktivitet',
    no: 'Aktivitet',
    tr: 'Faaliyet',
    dk: 'Aktivitet',
  },
  'EOD.Cash': {
    en: 'Cash',
    es: 'Efectivo',
    se: 'Kontant',
    no: 'Kontant',
    tr: 'Peşin',
    dk: 'Kontanter',
  },
  'EOD.Card': {
    en: 'Credit Card',
    es: 'Tarjeta',
    se: 'Kort',
    no: 'Kort',
    tr: 'Kredi kartı',
    dk: 'Kreditkort',
  },
  'EOD.Invoice': {
    en: 'Invoice',
    es: 'Factura',
    se: 'Faktura',
    no: 'Faktura',
    tr: 'Fatura',
    dk: 'Faktura',
  },
  'EOD.GiftCard': {
    en: 'Gift card',
    es: 'Tarjeta de regalo',
    se: 'Presentkort',
    no: 'Gavekort',
    tr: 'Hediye kartı',
    dk: 'Gavekort',
  },
  'EOD.Transactions': {
    en: 'Transactions',
    es: 'Transacciones',
    se: 'Transaktioner',
    no: 'Transaksjoner',
    tr: 'İşlemler',
    dk: 'Transaktioner',
  },
  'EOD.Refunds': {
    en: 'Refunds',
    es: 'Reembolsos',
    se: 'Återköp',
    no: 'Returer',
    tr: 'Geri ödemeler',
    dk: 'Tilbagebetalinger',
  },
  'EOD.NOfSoldArticles': {
    en: 'Sold articles',
    es: 'Artículos vendidos',
    se: 'Sålda artiklar',
    no: 'Solgte artikler',
    tr: 'Satılan ürünler',
    dk: 'Solgte artikler',
  },
  'EOD.EnterCashError.DayNotStarted': {
    en: 'You need to start the day before entering the end-of-day balance',
    es: 'Debes iniciar servicio antes de ingresar el fondo final de servicio',
    se: 'Du måste starta dagen innan du kan registrera dagsavslutets saldo',
    no: 'Du må starte dagen før du kan legge inn sluttsaldoen',
    tr: 'Gün sonu bakiyesini girmeden önce günü başlatmalısınız',
    dk: 'Du skal starte dagen, før du kan indtaste dagens slutsaldo',
  },
  'EOD.EnterCashError.OpenTables': {
    en: 'You need to close all open tables before entering the end-of-day balance',
    es: 'Cierra todas las mesas antes de ingresar el fondo final de servicio',
    se: 'Du måste stänga alla öppna bord innan du kan registrera dagsavslutets saldo',
    no: 'Du må lukke alle åpne bord før du kan legge inn sluttsaldoen',
    tr: 'Gün sonu bakiyesini girmeden önce tüm açık masaları kapatmalısınız',
    dk: 'Du skal lukke alle åbne borde, før du kan indtaste dagens slutsaldo',
  },
  'EOD.EnterCashError.DeviceSpecific': {
    en:
      "You can't enter the end-of-day balance because cash handling is disabled for this device in settings",
    es:
      'No puedes ingresar el fondo final de servicio porque la gestión de efectivo está desactivada para este dispositivo en la configuración',
    se:
      'Du kan inte registrera dagsavslutets saldo eftersom kontanthantering är inaktiverad för den här enheten i inställningarna',
    no:
      'Du kan ikke legge inn sluttsaldoen fordi kontanthåndtering er deaktivert for denne enheten i innstillingene',
    tr: 'Gün sonu bakiyesi girilemez çünkü bu cihaz için nakit işlemleri ayarlarda devre dışı',
    dk:
      'Du kan ikke indtaste dagens slutsaldo, da kontanthåndtering er deaktiveret for denne enhed i indstillingerne',
  },
  'EOD.EnterCashError.OrdersNotSynced': {
    en:
      "You can't perform end-of-day closing right now because there are orders that haven't been synced yet, please wait a moment and try again",
    es:
      'No puedes realizar el cierre de fin de día en este momento porque hay pedidos que no se han sincronizado aún, espera un momento y vuelve a intentarlo',
    se:
      'Du kan inte registrera genomföra ett dagsavslut just nu eftersom det finns beställningar som inte har synkroniserats än, vänta en stund och försök igen',
    no:
      'Du kan ikke legge inn sluttsaldoen fordi det er bestillinger som ikke har blitt synkronisert ennå, vennligst vent et øyeblikk og prøv igjen',
    tr:
      'Gün sonu bakiyesini giremezsiniz çünkü henüz senkronize edilmemiş siparişler var, lütfen bir moment bekleyin ve tekrar deneyin',
    dk:
      'Du kan ikke indtaste dagens slutsaldo, da der er ordrer, som ikke er synkroniseret endnu, vent venligst et øjeblik og prøv igen',
  },
  'DNS.confirmCashIn': {
    en: 'Confirm cash in',
    es: 'Confirmar ingreso de efectivo',
    se: 'Bekräfta växelkassa in',
    no: 'Bekreft inngående vekselkasse',
    tr: 'Nakit girişini onaylayın',
    dk: 'Bekræft indbetaling',
  },
  'DNS.openRegister': {
    en: 'Open register',
    es: 'Iniciar servicio',
    se: 'Öppna kassa',
    no: 'Åpne kasseskuff',
    tr: 'Kayıt aç',
    dk: 'Åbn register',
  },
  'DNS.DeviceSpecificEOD.OpenAll': {
    en: 'Opening the register will open it for all devices',
    es: 'Abra el servicio en todos los dispositivos',
    se: 'När kassan öppnas kommer den att öppnas på alla enheter',
    no: 'Når kassen åpnes, vil den åpnes på alle enheter',
    tr: 'Kasa açıldığında, tüm cihazlarda açılacaktır',
    dk: 'Når kassen åbnes, åbnes den på alle enheder',
  },
  'DNS.DeviceSpecificEOD.OpenIndividual': {
    en: 'This device is configured to have an individual start of day',
    es: 'Este dispositivo está configurado para tener un fondo de caja y servicio individual',
    se: 'Denna enhet är konfigurerad för att ha en individuell dagsstart',
    no: 'Denne enheten er konfigurert for å ha en individuell dagsstart',
    tr: 'Bu cihaz, günün başlangıcını ayrı ayrı ayarlayacak şekilde yapılandırılmıştır',
    dk: 'Denne enhed er konfigureret til at have en individuel start på dagen',
  },
  'DNS.Print.Title': {
    en: 'Start of day',
    es: 'Inicio de servicio',
    se: 'Dagsstart',
    no: 'Dagsstart',
    tr: 'Gün başlangıcı',
    dk: 'Start på dagen',
  },
  // Gift card

  'GC.Completed': {
    en: 'completed',
    es: 'terminado',
    se: 'slutförd',
    no: 'fullført',
    tr: 'Tamamlandı',
    dk: 'afsluttet',
  },
  'GC.NoContent.Info': {
    en: 'Contact Baemingo to get started!',
    es: 'Sin contenido',
    se: 'Kontakta Baemingo för att komma igång!',
    no: 'Kontakt kundeservice for å komme i gang',
    tr: 'Başlamak için Baemingo ile iletişime geçin!',
    dk: 'Kontakt Baemingo for at komme i gang!',
  },
  'GC.Canceled': {
    en: 'Payment cancelled',
    es: 'Pago cancelado',
    se: 'Betalning avbruten',
    no: 'Betaling avbrutt',
    tr: 'Ödeme iptal edildi',
    dk: 'Betaling annulleret',
  },
  'GC.InvalidInput': {
    en: 'Invalid input',
    es: 'Entrada inválida',
    se: 'Felaktig input',
    no: 'Ugyldig verdi',
    tr: 'Geçersiz Giriş',
    dk: 'Ugyldigt input',
  },
  'GC.TryAgain': {
    en: 'Try again',
    es: 'Intentar otra vez',
    se: 'Försök igen',
    no: 'Prøv igjen',
    tr: 'Tekrar deneyin',
    dk: 'Prøv igen',
  },
  'GC.InputWas': {
    en: 'Input was:',
    es: 'La entrada fue:',
    se: 'Input var:',
    no: 'Inntastet var:',
    tr: 'Giriş şuydu:',
    dk: 'Input var:',
  },
  'GC.Wrong': {
    en: 'Something went wrong',
    es: 'Algo salió mal',
    se: 'Något gick fel',
    no: 'Noe gikk galt',
    tr: 'Bir şeyler yanlış gitti',
    dk: 'Noget gik galt',
  },
  'GC.CardObtained': {
    en: 'Card obtained',
    es: 'Tarjeta obtenida',
    se: 'Kort inläst',
    no: 'Kort innlest',
    tr: 'Kart alındı',
    dk: 'Kort modtaget',
  },
  'GC.AvailableBalance': {
    en: 'Available balance',
    es: 'Saldo disponible',
    se: 'Tillgängligt Saldo',
    no: 'Tilgjengelig saldo',
    tr: 'Kalan bakiye',
    dk: 'Tilgængelig saldo',
  },
  'GC.Scanning': {
    en: 'Scanning...',
    es: 'Exploración...',
    se: 'Läser in...',
    no: 'Leser...',
    tr: 'Taranıyor...',
    dk: 'Scanner...',
  },
  'GC.SWIPE': {
    en: 'Swipe card',
    es: 'Deslizar tarjeta',
    se: 'Svep kort',
    no: 'Magnetstripe',
    tr: 'Kartı kaydır',
    dk: 'Swipe kort',
  },
  'GC.MANUAL': {
    en: 'Enter manually',
    es: 'Ingresar manualmente',
    se: 'Ange manuellt',
    no: 'Oppgi manuelt',
    tr: 'Manuel olarak giriniz',
    dk: 'Indtast manuelt',
  },
  'GC.QR': {
    en: 'QR Code',
    es: 'Código QR',
    se: 'QR Kod',
    no: 'QR-kode',
    tr: 'QR Kod',
    dk: 'QR-kode',
  },
  'GC.OK': {
    en: 'OK',
    es: 'OK',
    se: 'OK',
    no: 'OK',
    tr: 'TAMAM',
    dk: 'OK',
  },
  'GC.Continue': {
    en: 'Continue',
    es: 'Continuar',
    se: 'Fortsätt',
    no: 'Fortsett',
    tr: 'Devam et',
    dk: 'Fortsæt',
  },
  'GC.Error.MissingItem': {
    en: 'Could not set up the gift card item',
    es: 'No se pudo configurar el elemento de la tarjeta de regalo',
    se: 'Kunde inte hämta presentkort artikeln',
    no: 'Kunne ikke hente gavekort-artikkel',
    tr: 'Hediye kartı öğesi ayarlanamadı',
    dk: 'Kunne ikke konfigurere gavekortvaren',
  },
  'GC.InvalidScan': {
    en: 'Invalid Scan!',
    es: '¡Escaneo no válido!',
    se: 'Ogiltig skanning',
    no: 'Ugyldig skanning',
    tr: 'Geçersiz Tarama!',
    dk: 'Ugyldig scanning!',
  },
  'GC.WaitForInput': {
    en: 'Waiting for card input...',
    es: 'Esperando entrada de tarjeta...',
    se: 'Väntar på kortinmatning...',
    no: 'Venter på kort...',
    tr: 'Kart girişi bekleniyor...',
    dk: 'Venter på kortinput...',
  },
  'GC.Wait': {
    en: 'Waiting for card input...',
    es: 'Esperando entrada de tarjeta...',
    se: 'Väntar på kortinmatning...',
    no: 'Venter på kort...',
    tr: 'Kart girişi bekleniyor...',
    dk: 'Venter på kortinput...',
  },
  'GC.Receiving': {
    en: 'Receiving...',
    es: 'Recepción...',
    se: 'Tar emot...',
    no: 'Mottar data...',
    tr: 'Alınıyor...',
    dk: 'Modtager...',
  },
  'GC.ProceedToPayment': {
    en: 'Proceed to payment',
    es: 'Proceder al pago',
    se: 'Till betalning',
    no: 'Til betaling',
    tr: 'Ödemeye devam et',
    dk: 'Fortsæt til betaling',
  },

  // GC.Loading
  'GC.Loading': {
    en: 'Loading',
    es: 'Cargando',
    se: 'Läser in',
    no: 'Leser inn',
    tr: 'Yükleniyor',
    dk: 'Indlæser',
  },
  'GC.CheckingPayment': {
    en: 'Checking the payment...',
    es: 'Comprobando el pago...',
    se: 'Kontrollerar betalning...',
    no: 'Kontrollerer betaling...',
    tr: 'Ödeme kontrol ediliyor...',
    dk: 'Tjek betalingen...',
  },
  GiftCards: {
    en: 'Gift cards',
    es: 'Tarjetas de regalo',
    se: 'Presentkort',
    no: 'Gavekort',
    tr: 'Hediye Kartları',
    dk: 'Gavekort',
  },
  'GC.Code': {
    en: 'Code',
    es: 'Código',
    se: 'Kod',
    no: 'Kode',
    tr: 'Kod',
    dk: 'Kode',
  },
  'GC.Status': {
    en: 'Status',
    es: 'Estado',
    se: 'Status',
    no: 'Status',
    tr: 'Durum',
    dk: 'Status',
  },
  'GC.Balance': {
    en: 'Balance',
    es: 'Balance',
    se: 'Balans',
    no: 'Saldo',
    tr: 'Bakiye',
    dk: 'Balance',
  },
  'GC.History': {
    en: 'History',
    es: 'Historia',
    se: 'Historik',
    no: 'Historikk',
    tr: 'Geçmiş',
    dk: 'Historik',
  },
  'GC.Button.New': {
    en: 'Add',
    es: 'Agregar',
    se: 'Skapa',
    no: 'Opprett',
    tr: 'Ekle',
    dk: 'Tilføj',
  },
  'GC.Button.Print': {
    en: 'Print',
    es: 'Imprimir',
    se: 'Skriv ut',
    no: 'Skriv ut',
    tr: 'Yazdır',
    dk: 'Udskriv',
  },
  'GC.Button.Email': {
    en: 'Send via email',
    es: 'Enviar por email',
    se: 'Skicka via e-post',
    no: 'Send via e-post',
    tr: 'E-postayla gönder',
    dk: 'Send via e-mail',
  },
  'GC.Button.AddFunds': {
    en: 'Add funds',
    es: 'Añadir fondos',
    se: 'Öka saldo',
    no: 'Last inn saldo',
    tr: 'Ödenek ekle',
    dk: 'Tilføj midler',
  },
  'GC.AddFunds.Title': {
    en: 'Add funds',
    es: 'Añadir fondos',
    se: 'Öka saldo',
    no: 'Last inn saldo',
    tr: 'Ödenek ekle',
    dk: 'Tilføj midler',
  },
  'GC.Search.Placeholder': {
    en: 'Search by code',
    es: 'Buscar por código',
    se: 'Sök med kortkod',
    no: 'Søk med kortkode',
    tr: 'Koda göre ara',
    dk: 'Søg via kode',
  },
  'GC.Create.DeliveryMethod': {
    en: 'How would the customer like to recieve the gift card?',
    es: '¿Cómo le gustaría al cliente recibir la tarjeta de regalo?',
    se: 'Hur vill kunden ha sitt presentkort?',
    no: 'Hvordan ønsker kunden å motta gavekortet?',
    tr: 'Müşteri hediye kartını nasıl almak ister?',
    dk: 'Hvordan vil kunden gerne modtage gavekortet?',
  },
  'GC.Create.EmailRecipient': {
    en: 'Send the gift card to',
    es: 'Envía la tarjeta de regalo a',
    se: 'Skicka presentkortet till',
    no: 'Send gavekortet til',
    tr: 'Hediye kartını şu adrese gönderin:',
    dk: 'Send gavekortet til',
  },
  'GC.Create.Amount': {
    en: 'What amount should be on the card?',
    es: '¿Qué cantidad debe haber en la tarjeta?',
    se: 'Vilken summa ska finnas på kortet?',
    no: 'Hvilket beløp skal være på kortet?',
    tr: 'Kartta ne kadar tutar olmalı?',
    dk: 'Hvilket beløb skal der stå på kortet?',
  },
  'GC.Create.Print': {
    en: 'Print',
    es: 'Imprimir',
    se: 'Skriv ut',
    no: 'Skriv ut',
    tr: 'Yazdır',
    dk: 'Udskriv',
  },
  'GC.Create.Email': {
    en: 'Email',
    es: 'Correo electrónico',
    se: 'E-post',
    no: 'E-post',
    tr: 'E-posta',
    dk: 'E-mail',
  },
  'GC.Create.Email.Invalid': {
    en: 'Invalid email address',
    es: 'Dirección de correo electrónico no válida',
    se: 'Ogiltig e-postadress',
    no: 'Ugyldig e-postadresse',
    tr: 'Geçersiz e-posta adresi',
    dk: 'Ugyldig e-mailadresse',
  },
  'GC.Create.Email.Required': {
    en: 'Please provide an email address',
    es: 'Por favor proporcione una dirección de correo electrónico',
    se: 'Vänligen ange en e-postadress',
    no: 'Vennligst oppgi en e-postadresse',
    tr: 'Lütfen bir e-posta adresi belirtin',
    dk: 'Angiv venligst en e-mailadresse',
  },
  'GC.Create.Amount.Placeholder': {
    en: 'Amount in',
    es: 'Cantidad en',
    se: 'Belopp i',
    no: 'Beløp i',
    tr: 'Miktar',
    dk: 'Beløb i',
  },
  'GC.Create.Amount.Required': {
    en: 'Please provide an amount',
    es: 'Por favor proporcione una cantidad',
    se: 'Vänligen ange ett belopp',
    no: 'Vennligst oppgi et beløp',
    tr: 'Lütfen bir miktar belirtin',
    dk: 'Angiv venligst et beløb',
  },
  'GC.Create.Amount.Minimum': {
    en: 'At least 5',
    es: 'Al menos 5',
    se: 'Minst 5',
    no: 'Minst 5',
    tr: 'En az 5',
    dk: 'Mindst 5',
  },
  'GC.Create.SellNewGC': {
    en: 'Sell new gift card',
    es: 'Vender nueva tarjeta de regalo',
    se: 'Sälj nytt presentkort',
    no: 'Selg nytt gavekort',
    tr: 'Yeni hediye kartı sat',
    dk: 'Sælg nyt gavekort',
  },
  'GC.Create.ExpiryDate': {
    en: 'For how long should the card be active?',
    es: '¿Cuánto tiempo debe estar activa la tarjeta?',
    se: 'Hur länge ska kortet vara aktivt?',
    no: 'Hvor lenge skal kortet være aktivt?',
    tr: 'Kart ne kadar süreyle aktif olmalı?',
    dk: 'Hvor længe skal kortet være aktivt?',
  },
  'GC.Create.ExpiryDate.Years': {
    en: 'years',
    es: 'años',
    se: 'år',
    no: 'år',
    tr: 'yıl',
    dk: 'år',
  },
  'GC.Email.Change': {
    en: 'Change email address',
    es: 'Cambiar dirección de correo electrónico',
    se: 'Ändra e-postadress',
    no: 'Endre e-postadresse',
    tr: 'E-posta adresini değiştir',
    dk: 'Ændre e-mailadresse',
  },
  'GC.Email.Sending': {
    en: 'Sending email...',
    es: 'Enviando correo electrónico...',
    se: 'Skickar e-post...',
    no: 'Sender e-post...',
    tr: 'E-posta gönderiliyor...',
    dk: 'Sender e-mail...',
  },
  'GC.Funds.NewBalance': {
    en: 'New balance',
    es: 'Nuevo saldo',
    se: 'Nytt saldo',
    no: 'Ny saldo',
    tr: 'Yeni bakiye',
    dk: 'Ny saldo',
  },
  'GC.Landing.SearchHeading': {
    en: 'Search for a specific gift card',
    es: 'Buscar una tarjeta de regalo específica',
    se: 'Sök efter ett specifikt presentkort',
    no: 'Søk etter et spesifikt gavekort',
    tr: 'Belirli bir hediye kartı ara',
    dk: 'Søg efter et bestemt gavekort',
  },
  'GC.Landing.SearchText': {
    en: 'Handy if you need to see the history of a gift card or send out a new email',
    es:
      'Útil si necesita ver el historial de una tarjeta de regalo o enviar un nuevo correo electrónico',
    se:
      'Praktiskt om du behöver se historiken för ett presentkort eller skicka ett nytt e-postmeddelande',
    no:
      'Nyttig dersom du trenger å se historikken på et gavekort eller sende det på e-post på nytt',
    tr:
      'Bir hediye kartının geçmişini görmeniz veya yeni bir e-posta göndermeniz gerekiyorsa kullanışlıdır',
    dk:
      'Praktisk, hvis du har brug for at se historikken for et gavekort eller sende en ny e-mail',
  },
  'GC.Landing.Sell': {
    en: 'Sell',
    es: 'Vender',
    se: 'Sälj',
    no: 'Selg',
    tr: 'Sat',
    dk: 'Sælg',
  },
  'GC.Landing.Or': {
    en: 'or',
    es: 'o',
    se: 'eller',
    no: 'eller',
    tr: 'veya',
    dk: 'eller',
  },
  'GC.Landing.TopUp': {
    en: 'top up',
    es: 'Recargar',
    se: 'ladda på',
    no: 'fyll opp',
    tr: 'Tamamla',
    dk: 'fylde op',
  },
  'GC.Landing.AGiftCard': {
    en: 'a gift card',
    es: 'una tarjeta de regalo',
    se: 'ett presentkort',
    no: 'et gavekort',
    tr: 'Hediye kartı',
    dk: 'et gavekort',
  },
  'GC.Landing.PhysicalCard': {
    en: 'Physical card',
    es: 'Tarjeta física',
    se: 'Fysiskt kort',
    no: 'Fysisk kort',
    tr: 'Fiziksel kart',
    dk: 'Fysisk kort',
  },
  'GC.Landing.PhysicalCardText': {
    en:
      'If you want to sell a physical gift card or the customer has a an existing one and wants to increase its balance, scan it to get started.',
    es:
      'Si desea vender una tarjeta de regalo física o el cliente tiene una y desea aumentar su saldo, escanéela para comenzar.',
    se:
      'Om du vill sälja ett fysiskt presentkort eller kunden har ett befintligt kort och vill öka dess saldo, skanna det för att komma igång.',
    no:
      'Dersom du vil selge et fysisk gavekort, eller kunder har et eksisterende kort de vil fylle opp, scan det for å sette i gang.',
    tr:
      'Fiziksel bir hediye kartı satmak istiyorsanız veya müşterinin mevcut bir kartı varsa ve bakiyesini artırmak istiyorsa, başlamak için kartı tarayın.',
    dk:
      'Hvis du ønsker at sælge et fysisk gavekort eller kunden har et eksisterende og ønsker at øge saldoen, så scan det for at komme i gang.',
  },
  'GC.Landing.DigitalCard': {
    en: 'Digital card',
    es: 'Tarjeta digital',
    se: 'Digitalt kort',
    no: 'Digitalt kort',
    tr: 'Dijital kart',
    dk: 'Digitalt kort',
  },
  'GC.Landing.DigitalCardText': {
    en:
      'If you want to sell a digital gift card, click the button below to get started. It can be delivered by email or printed on a receipt.',
    es:
      'Si desea vender una tarjeta de regalo digital, haga clic en el botón de abajo para comenzar. Se puede entregar por correo electrónico o imprimir en un ticket.',
    se:
      'Om du vill sälja ett digitalt presentkort, klicka på knappen nedan för att komma igång. Det kan levereras via e-post eller skrivas ut på ett kvitto.',
    no:
      'Dersom du vil selge et digitalt gavekort, klikk nedenfor for å sette i gang. Gavekortet kan leveres via e-post eller skrives ut på en kvittering.',
    tr:
      'Dijital hediye kartı satmak istiyorsanız başlamak için aşağıdaki düğmeye tıklayın. E-postayla teslim edilebilir veya makbuz üzerine basılabilir.',
    dk:
      'Hvis du vil sælge et digitalt gavekort, skal du klikke på knappen nedenfor for at komme i gang. Det kan leveres via e-mail eller printes på en kvittering.',
  },
  'GC.Landing.SellDigitalCard': {
    en: 'Sell digital card',
    es: 'Vender tarjeta digital',
    se: 'Sälj digitalt kort',
    no: 'Selg digitalt kort',
    tr: 'Dijital kart sat',
    dk: 'Sælg digitalkort',
  },
  'GC.Landing.ScanCard': {
    en: 'Scan card',
    es: 'Escanear tarjeta',
    se: 'Skanna kort',
    no: 'Scan kort',
    tr: 'Kartı tarayın',
    dk: 'Scan kort',
  },
  'GC.OrReload': {
    en: 'Or reload',
    es: 'O recargar',
    se: 'Eller ladda om',
    no: 'Eller last inn',
    tr: 'Veya yeniden yükle',
    dk: 'Eller genindlæs',
  },
  'GC.Pagination.Page': {
    en: 'Page',
    es: 'Página',
    se: 'Sida',
    no: 'Side',
    tr: 'Sayfa',
    dk: 'Side',
  },
  // Not found
  'NF.Title': {
    en: 'Ooops... This page does not exist',
    es: 'Ups... Esta página no existe',
    se: 'Ooops... sidan finns inte ',
    no: 'Oops... Siden eksisterer ikke',
    tr: 'Hata... Bu sayfa mevcut değil',
    dk: 'Ups... Denne side findes ikke',
  },
  'NF.Subtitle': {
    en: 'Back to',
    es: 'Volver a',
    se: 'Tillbaka till',
    no: 'Tilbake til',
    tr: 'Geri dön',
    dk: 'Tilbage til',
  },
  // Toast
  'TOAST.Inventory.Changed': {
    en: 'has been updated!',
    es: '¡Ha sido actualizado!',
    se: 'har uppdaterats!',
    no: 'har blitt oppdatert',
    tr: 'Güncellendi!',
    dk: 'er blevet opdateret!',
  },
  'TOAST.Payment.Progress': {
    en: 'Payment in progress',
    es: 'Pago en curso',
    se: 'Betalning pågår',
    no: 'Betaling pågår',
    tr: 'Ödeme devam ediyor',
    dk: 'Betaling i gang',
  },
  'TOAST.Payment.CantAddItems': {
    en: "Can't add new items while payment is in progress",
    es: 'No se pueden agregar artículos mientras el pago está en curso',
    se: 'Kan inte lägga till nya produkter medan betalning pågår',
    no: 'Kan ikke legge til nye artikler mens betaling pågår',
    tr: 'Ödeme devam ederken yeni öğeler eklenemez',
    dk: 'Kan ikke tilføje nye varer, mens betaling er i gang',
  },
  'TOAST.Payment.Completed': {
    en: 'Payment was completed',
    es: 'El pago fue completado',
    se: 'Betalning slutförd',
    no: 'Betaling gjennomført',
    tr: 'Ödeme tamamlandı',
    dk: 'Betalingen blev gennemført',
  },
  'TOAST.Payment.Canceled': {
    en: 'Payment was canceled',
    es: 'El pago fue cancelado',
    se: 'Betalning avbruten',
    no: 'Betaling avbrutt',
    tr: 'Ödeme iptal edildi',
    dk: 'Betalingen blev annulleret',
  },
  'TOAST.Payment.Failed': {
    en: 'Payment failed',
    es: 'Pago fallido',
    se: 'Betalning misslyckades',
    no: 'Betaling feilet',
    tr: 'Ödeme başarısız',
    dk: 'Betaling mislykkedes',
  },
  'TOAST.Bong.Printed': {
    en: 'Ticket has been sent',
    es: 'La nota ha sido enviada',
    se: 'Bong har skickats',
    no: 'Bong sendt',
    tr: 'Bilet gönderildi',
    dk: 'Billet er sendt',
  },
  'TOAST.Message.Sent': {
    en: 'Message was sent',
    es: 'El mensaje fue enviado',
    se: 'Meddelandet har skickats',
    no: 'Melding sendt',
    tr: 'Mesaj gönderildi',
    dk: 'Beskeden blev sendt',
  },
  'TOAST.Email.Sent': {
    en: 'Email has been sent to',
    es: 'El correo electrónico ha sido enviado a',
    se: 'Email har skickats till',
    no: 'E-post har blitt sendt til',
    tr: 'E-posta şu adrese gönderildi:',
    dk: 'E-mail er blevet sendt til',
  },
  'TOAST.Email.Success.Sent': {
    en: 'Email successfully sent',
    es: 'Correo electrónico enviado con éxito',
    se: 'Email har skickats',
    no: 'E-post sendt',
    tr: 'E-posta başarıyla gönderildi',
    dk: 'E-mail er sendt',
  },
  'TOAST.Email.Not.Sent': {
    en: 'Email could not be sent',
    es: 'El correo electrónico no pudo ser enviado',
    se: 'Email kunde inte skickas',
    no: 'E-post kunne ikke sendes',
    tr: 'E-posta gönderilemedi',
    dk: 'E-mail kunne ikke sendes',
  },
  'TOAST.Printer.Error': {
    en: 'Something is wrong with a printer',
    es: 'Algo anda mal con una impresora',
    se: 'Något är fel med en skrivare',
    no: 'Noe er feil med en printer',
    tr: 'Yazıcıda bir sorun var',
    dk: 'Der er noget galt med en printer',
  },
  'TOAST.Printer.Offline': {
    en: 'Printer is offline or not connected',
    es: 'La impresora está fuera de línea o no está conectada',
    se: 'Skrivare är offline eller inte uppkopplad',
    no: 'Printer er offline eller ikke tilkoblet',
    tr: 'Yazıcı çevrimdışı veya bağlı değil',
    dk: 'Printeren er offline eller ikke tilsluttet',
  },
  'TOAST.Language.Changed': {
    en: 'Language changed',
    es: 'Idioma cambiado',
    se: 'Språk ändrats',
    no: 'Språk endret',
    tr: 'Dil değiştirildi',
    dk: 'Sprog ændret',
  },
  'TOAST.EOD.Done': {
    en: 'The Z-report has been printed and the register closed for the day',
    es: 'El informe Z se imprimió y el registro se cerró por el día.',
    se: 'Z-rapporten är nu utskriven och kassan stängd för dagen',
    no: 'Du har nå avsluttet arbeidsdagen. Z-rapporten skrives ut.',
    tr: 'Z raporu yazdırıldı ve kayıt gün için kapatıldı',
    dk: 'Z-rapporten er udskrevet og registret lukket for dagen',
  },
  'TOAST.EOD.WaitForCashUpdate': {
    en: 'Could not load the cash update, please try again',
    es: 'No se pudo cargar la actualización de efectivo, intente de nuevo',
    se: 'Kunde inte ladda kontantuppdateringen, försök igen',
    no: 'Kunne ikke laste kontantoppdateringen, vennligst prøv igjen',
    tr: 'Nakit güncellemesi yüklenemedi, lütfen tekrar deneyin',
    dk: 'Kunne ikke indlæse kontantopdateringen. Prøv venligst igen',
  },
  'TOAST.Receipt.Sent': {
    en: 'Receipt has been sent to the printer',
    es: 'El ticket ha sido enviado a la impresora.',
    se: 'Kvittot har skickats till skrivaren',
    no: 'Kvittering sendt til skriveren',
    tr: 'Fiş yazıcıya gönderildi',
    dk: 'Kvittering er sendt til printeren',
  },
  'TOAST.Refund.Progress': {
    en: 'Refund in progress',
    es: 'Reembolso en curso',
    se: 'Återbetalning pågående',
    no: 'Refundering pågår',
    tr: 'Geri ödeme işlemi devam ediyor',
    dk: 'Tilbagebetaling i gang',
  },
  'TOAST.Refund.Successful': {
    en: 'Refund successful',
    es: 'Reembolso exitoso',
    se: 'Återbetalning lyckades',
    no: 'Refundering gjennomført',
    tr: 'Geri ödeme başarılı',
    dk: 'Tilbagebetaling lykkedes',
  },
  'TOAST.Refund.Failed': {
    en: 'Refund failed',
    es: 'Reembolso fallido',
    se: 'Återbetalning misslyckades',
    no: 'Refundering feilet',
    tr: 'Geri ödeme başarısız oldu',
    dk: 'Tibagebetalingen mislykkedes',
  },
  'TOAST.Inventory.Order': {
    en: 'Inventory order has been created',
    es: 'Se ha creado el pedido de inventario.',
    se: 'Lagerbeställning har skapats',
    no: 'Lagerbestilling opprettet',
    tr: 'Envanter siparişi oluşturuldu',
    dk: 'Lagerordre er oprettet',
  },
  'TOAST.Layout.Updated': {
    en: 'Layout has been updated',
    es: 'El diseño ha sido actualizado',
    se: 'Layout har uppdaterats',
    no: 'Layout oppdatert',
    tr: 'Plan güncellendi',
    dk: 'Layoutet er blevet opdateret',
  },
  'TOAST.Station.Updated': {
    en: 'Station has been updated',
    es: 'El punto de elaboración ha sido actualizado',
    se: 'Station har uppdaterats',
    no: 'Stasjon oppdatert',
    tr: 'İstasyon güncellendi',
    dk: 'Stationen er blevet opdateret',
  },
  'TOAST.Zone.Updated': {
    en: 'The zone has been updated',
    es: 'La sala ha sido actualizada',
    se: 'Zonen har uppdaterats',
    no: 'Sonen oppdatert',
    tr: 'Bölge güncellendi',
    dk: 'Zonen er blevet opdateret',
  },
  'TOAST.Cheque.Printing': {
    en: 'Cheque is printing',
    es: 'El ticket se está imprimiendo',
    se: 'Nota skrivs ut',
    no: 'Regning skrives ut',
    tr: 'Çek yazdırılıyor',
    dk: 'Check udskrives',
  },
  'TOAST.Cheque.Printed': {
    en: 'Cheque was printed',
    es: 'Se imprimió el ticket',
    se: 'Notan har skrivits ut',
    no: 'Regning skrevet ut',
    tr: 'Çek yazdırıldı',
    dk: 'Checken blev udskrevet',
  },
  'TOAST.Cheque.OwnerChanged': {
    en: 'Cheque owner was changed',
    es: 'Se cambió el propietario de la comanda',
    se: 'Notan bytte ägare',
    no: 'Regningens eier skiftet',
    tr: 'Çekin sahibi değiştirildi',
    dk: 'Checkens ejer blev skiftet',
  },
  'TOAST.Offer.NotFound': {
    en: 'The bundle offer was not found',
    es: 'No se encontró la oferta de paquete',
    se: 'Erbjudandet hittades inte',
    no: 'Tilbudet ble ikke funnet',
    tr: 'Paket teklifi bulunamadı',
    dk: 'Pakketilbuddet blev ikke fundet',
  },
  'TOAST.Items.NotAllowed': {
    en: 'Not allowed to modify due to partial payment',
    es: 'No se permite modificar debido a un pago parcial',
    se: 'Får inte ändras på grund av delbetalning',
    no: 'Ikke tillatt å endre på grunn av delvis betaling',
    tr: 'Kısmi ödeme nedeniyle değiştirilmesine izin verilmiyor',
    dk: 'Ikke tilladt at ændre på grund af delvis betaling',
  },
  'TOAST.DisableOrderingAfterPayment': {
    en: 'Not allowed to add items after a payment has been made',
    es: 'No se permite agregar artículos después de que se haya realizado un pago',
    se: 'Ej tillåtet att lägga till produkter efter att en betalning har gjorts',
    no: 'Ikke tillatt å legge til artikler etter at en betaling er gjort',
    tr: 'Ödeme yapıldıktan sonra öğe eklemeye izin verilmiyor',
    dk: 'Ikke tilladt at tilføje varer efter en betaling er foretaget',
  },
  'TOAST.Discount.CantApplyDiscountWithPayments': {
    en: 'Not allowed to apply discount due to partial payment',
    es: 'No se permite aplicar descuento debido a un pago parcial',
    se: 'Får inte rabatteras på grund av delbetalning',
    no: 'Ikke tillatt å gi rabatt på grunn av delvis betaling',
    tr: 'Kısmi ödeme nedeniyle indirim uygulanmasına izin verilmiyor',
    dk: 'Ikke tilladt at give rabat på grund af delvis betaling',
  },
  'Question.Message.AlreadySent': {
    en: 'This has already been sent, do you want to send it again?',
    es: 'Esto ya ha sido enviado, ¿quieres enviarlo de nuevo?',
    se: 'Detta har redan skickats, vill du skicka det igen?',
    no: 'Dette er allerede sendt, vil du sende det igjen?',
    tr: 'Bu zaten gönderildi, tekrar göndermek ister misiniz?',
    dk: 'Dette er allerede sendt, vil du sende det igen?',
  },
  // SAF-T
  'SafT.Action.EmailSafTFile': {
    en: 'Email SAF-T file',
    es: 'Enviar archivo SAF-T por correo electrónico',
    se: 'Maila SAF-T fil',
    no: 'Send SAF-T fil på e-post',
    tr: 'SAF-T dosyasını e-postayla gönderin',
    dk: 'E-mail SAF-T fil',
  },
  // SSK
  'SSK.LegalAge.Title': {
    en: 'Are you 18 or older?',
    es: '¿Tienes 18 años o más?',
    se: '18 år eller äldre?',
    no: '18 år eller eldre?',
    tr: '18 yaşında veya daha büyük müsünüz?',
    dk: 'Er du 18 år eller ældre?',
  },
  'SSK.LegalAge.SubTitle': {
    en: 'To purchase any alcohol you will have to show your ID at the counter.',
    es:
      'Para comprar cualquier bebida alcohólica, deberá mostrar su identificación en el mostrador.',
    se:
      'För att handla alkoholhaltiga måste du vara 18 år eller äldre. Visa legitimation vid kassan.',
    no:
      'For å handle alkoholholdige drikker må du være 18 år eller eldre. Vis legitimasjon ved kassen.',
    tr: 'Herhangi bir alkol satın almak için kasada kimliğinizi göstermeniz gerekecektir.',
    dk: 'For at købe alkohol skal du vise dit ID ved skranken.',
  },
  'SSK.LegalAge.No': {
    en: 'No',
    es: 'No',
    se: 'Nej',
    no: 'Nei',
    tr: 'Hayır',
    dk: 'Nej',
  },
  'SSK.LegalAge.Yes': {
    en: 'Yes',
    es: 'Sí',
    se: 'Ja',
    no: 'Ja',
    tr: 'Evet',
    dk: 'Ja',
  },
  'SSK.Timeout.Header': {
    en: 'Timeout',
    es: 'Se acabó el tiempo',
    se: 'Timeout',
    no: 'Timeout',
    tr: 'Zaman aşımı',
    dk: 'Timeout',
  },
  'SSK.Timeout.Subheader': {
    en: 'Press the screen to continue with your order.',
    es: 'Pulsa la pantalla para continuar con tu pedido.',
    se: 'Tryck på skärmen för att återgå till din beställning',
    no: 'Trykk på skjermen for å fortsette med bestillingen',
    tr: 'Siparişinize devam etmek için ekrana basın.',
    dk: 'Tryk på skærmen for at fortsætte med din ordre.',
  },
  'SSK.Receipt.Title': {
    en: 'Want your reciept?',
    es: '¿Quieres tu ticket?',
    se: 'Kvitto?',
    no: 'Ønsker du kvittering?',
    tr: 'Fiş ister misiniz?',
    dk: 'Vil du have din kvittering?',
  },
  'SSK.Receipt.Description': {
    en: 'We will of course print your order number, would you like a reciept as well?',
    es: 'Por supuesto, imprimiremos su número de pedido, ¿también desea un ticket?',
    se: 'Såklart skriver vi ut ditt ordernummer, vill du även ha ett fullständigt kvitto?',
    no: 'Vi skriver ut ordrenummeret. Ønsker du også en fullstendig kvittering?',
    tr: 'Elbette sipariş numaranızı yazdıracağız, fiş de ister misiniz?',
    dk: 'Vi udskriver selvfølgelig dit ordrenummer, vil du også have en kvittering?',
  },
  'SSK.Receipt.No': {
    en: 'No thanks',
    es: 'No, gracias',
    se: 'Nej, Tack',
    no: 'Nei, takk',
    tr: 'Hayır, teşekkürler',
    dk: 'Nej tak',
  },
  'SSK.Receipt.Yes': {
    en: 'Yes please',
    es: 'Sí, por favor',
    se: 'Ja, Tack',
    no: 'Ja, takk',
    tr: 'Evet lütfen',
    dk: 'Ja tak',
  },
  'SSK.Order.FollowTheInstructionsInThePaymentTerminal': {
    en: 'Follow the instructions on the terminal.',
    es: 'Siga las instrucciones en la terminal.',
    se: 'Följ instruktionerna i betalterminalen.',
    no: 'Følg instruksene på betalingsterminalen.',
    tr: 'Terminaldeki talimatları takip edin.',
    dk: 'Følg instruktionerne på terminalen.',
  },
  'SSK.Order.InsertYourCard': {
    en: 'Put in your card',
    es: 'Pon tu tarjeta',
    se: 'Sätt i ditt kort',
    no: 'Sett i ditt kort',
    tr: 'Kartınızı takın',
    dk: 'Indsæt dit kort',
  },
  'SSK.OrderNumber.Title': {
    en: 'Here’s your ticket!',
    es: '¡Aquí está tu ticket!',
    se: 'Tack, ta din utskrift',
    no: 'Takk, vennligst ta kvitteringen',
    tr: 'İşte biletiniz!',
    dk: 'Her er din billet!',
  },
  'SSK.OrderNumber.SubTitle.OrderDisplay': {
    en: 'Track your order on the delivery screen. Enjoy your meal and welcome back!',
    es: 'Sigue tu pedido en la pantalla de entrega. ¡Buen provecho y bienvenido de nuevo!',
    se: 'Följ din beställning på utlämningsskärmen. Smaklig måltid och välkommen åter!',
    no: 'Følg bestillingen på utleveringsskjermen. Nyt måltidet og velkommen tilbake!',
    tr: 'Siparişinizi teslimat ekranında takip edebilirsiniz. Afiyet olsun, tekrar hoş geldiniz!',
    dk: 'Følg din bestilling på leveringsskærmen. Velbekomme og velkommen tilbage!',
  },
  'SSK.OrderNumber.Subtitle.Generic': {
    en: 'Your order will be prepared shortly. Enjoy your meal and welcome back!',
    es: 'Su pedido se preparará en breve. ¡Buen provecho y bienvenido de nuevo!',
    se: 'Din beställning kommer att förberedas inom kort. Smaklig måltid och välkommen åter!',
    no: 'Bestillingen din vil bli forberedt snart. Nyt måltidet og velkommen tilbake!',
    tr: 'Siparişiniz kısa süre içinde hazırlanacak. Afiyet olsun, tekrar hoş geldiniz!',
    dk: 'Din bestilling vil blive tilberedt om kort tid. Velbekomme og velkommen tilbage!',
  },
  'SSK.Cart.Description': {
    en: 'Click on the product to change or delete parts of your order.',
    es: 'Haga clic en el producto para cambiar o eliminar partes de su pedido.',
    se: 'Klicka på produkten för att ändra eller ta bort delar av din order.',
    no: 'Klikk på produktet for å endre eller ta bort deler av din bestilling.',
    tr: 'Siparişinizin bazı kısımlarını değiştirmek veya silmek için ürüne tıklayın.',
    dk: 'Klik på produktet for at ændre eller slette dele af din ordre.',
  },
  'SSK.Category.NoMoreTitle': {
    en: 'Our famous last words',
    es: 'Nuestras famosas últimas palabras',
    se: 'Våra berömda sista ord',
    no: 'Våre berømte siste ord',
    tr: 'Meşhur son sözlerimiz',
    dk: 'Vores berømte sidste ord',
  },
  'SSK.Category.NoMoreSubTitle': {
    en: 'No more scrolling',
    es: 'No más desplazamiento',
    se: 'Slut på scroll',
    no: 'Ingen mer scrolling',
    tr: 'Artık kaydırma yok',
    dk: 'Ikke mere scrolling',
  },
  'SSK.ItemDetails.Variations.Single': {
    en: 'Choose an alternative',
    es: 'Elige una alternativa',
    se: 'Välj ett alternativ',
    no: 'Velg et alternativ',
    tr: 'Bir alternatif seçin',
    dk: 'Vælg et alternativ',
  },
  'SSK.ItemDetails.Variations.Multi': {
    en: 'Select one or more options',
    es: 'Seleccione una o más opciones',
    se: 'Välj ett alternativ eller flera alternativ',
    no: 'Velg ett eller flere alternativer',
    tr: 'Bir veya daha fazla seçeneği seçin',
    dk: 'Vælg en eller flere muligheder',
  },
  'SSK.ItemUpsells.Next': {
    en: 'Next',
    es: 'próximo',
    se: 'Gå vidare',
    no: 'Gå videre',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'SSK.ItemUpsells.Complete': {
    en: 'Add to basket',
    es: 'Añadir al carrito',
    se: 'Lägg till i varukorgen',
    no: 'Legg i handlekurv',
    tr: 'Sepete ekle',
    dk: 'Læg i kurv',
  },
  'SSK.ItemUpsells.Added': {
    en: 'Added',
    es: 'Agregado',
    se: 'Tillagd',
    no: 'Lagt til',
    tr: 'Eklendi',
    dk: 'Tilføjet',
  },
  'SSK.EnterTheCode': {
    en: 'Enter the code',
    es: 'introduzca el código',
    se: 'Skriv in koden',
    no: 'Skriv inn koden',
    tr: 'Kodu giriniz',
    dk: 'Indtast koden',
  },
  'SSK.YourOrderNumber': {
    en: 'Your order number',
    es: 'Su número de orden',
    se: 'Ditt ordernummer',
    no: 'Ditt bestillingsnummer',
    tr: 'Sipariş numaranız',
    dk: 'Dit ordrenummer',
  },
  'SSK.LoadingVariations': {
    en: 'Loading Variations',
    es: 'Cargando variaciones',
    se: 'Laddar variationer',
    no: 'Laster variasjoner',
    tr: 'Varyasyonları Yükleme',
    dk: 'Indlæsningsvariationer',
  },
  'SSK.LoadingVariationGroups': {
    en: 'Loading Variation Groups',
    es: 'Cargando grupos de variación',
    se: 'Läser in variations grupper',
    no: 'Laster variasjonsgrupper',
    tr: 'Varyasyon Gruplarını Yükleme',
    dk: 'Indlæser variationsgrupper',
  },
  'SSK.LoadingVenue': {
    en: 'Loading Venue',
    es: 'Lugar de carga',
    se: 'Laddar mötesplats',
    no: 'Laster restaurant',
    tr: 'Yer yükleniyor',
    dk: 'Indlæsningssted',
  },
  'SSK.LoadingExpressPages': {
    en: 'Loading Express pages',
    es: 'Cargando páginas Express',
    se: 'Läser in Express -sidor',
    no: 'Laster ekspress-sider',
    tr: 'Ekspres sayfalar yükleniyor',
    dk: 'Indlæser Express-sider',
  },
  'SSK.LoadingImages': {
    en: 'Loading Images',
    es: 'Cargando Imágenes',
    se: 'Läser in bilder',
    no: 'Laster bilder',
    tr: 'Görseller Yükleniyor',
    dk: 'Indlæser billeder',
  },
  'SSK.LoadingItems': {
    en: 'Loading Items',
    es: 'Cargando artículos',
    se: 'Laddar objekt',
    no: 'Laster artikler',
    tr: 'Ürünler Yükleniyor',
    dk: 'Indlæser varer',
  },
  'SSK.LoadingCategories': {
    en: 'Loading Categories',
    es: 'Cargando Categorías',
    se: 'Laddar kategorier',
    no: 'Laster kategorier',
    tr: 'Kategoriler Yükleniyor',
    dk: 'Indlæser kategorier',
  },
  'SSK.KeepShopping': {
    en: 'Keep shopping',
    es: 'Seguir comprando',
    se: 'Fortsätt handla',
    no: 'Fortsett å handle',
    tr: 'Alışverişe devam edin',
    dk: 'Fortsæt med at shoppe',
  },
  'SSK.OfferOfTheWeek': {
    en: 'Offer of the week',
    es: 'oferta de la semana',
    se: 'Veckans erbjudande',
    no: 'Ukens tilbud',
    tr: 'Haftanın teklifi',
    dk: 'Ugens tilbud',
  },
  'SSK.ProductOfTheWeek': {
    en: 'Product of the week',
    es: 'producto de la semana',
    se: 'Veckans produkt',
    no: 'Ukens produkt',
    tr: 'Haftanın ürünü',
    dk: 'Ugens produkt',
  },
  'SSK.VenueClosed': {
    en: 'This self-service kiosk is closed. Welcome to order at the counter!',
    es: 'Este quiosco de autoservicio está cerrado. ¡Bienvenido a ordenar en el mostrador!',
    se: 'Den här kassan är stängd. Välkommen fram till vår kassadisk!',
    no: 'Denne kassen er dessverre stengt.',
    tr: 'Bu self-servis kiosk kapalı. Tezgahta sipariş verebilirsiniz!',
    dk: 'Denne selvbetjeningskiosk er lukket. Du er velkommen til at bestille ved skranken!',
  },
  'SSK.Return': {
    en: 'Go back',
    es: 'Volver',
    se: 'Gå tillbaka',
    no: 'Gå tilbake',
    tr: 'Geri git',
    dk: 'Gå tilbage',
  },
  'SSK.NoData': {
    en: 'Failed to load data',
    es: 'Error al cargar datos',
    se: 'Kunde inte ladda data',
    no: 'Kunne ikke laste data',
    tr: 'Veriler yüklenemedi',
    dk: 'Kunne ikke indlæse data',
  },
  'SSK.NoData.Desc': {
    en: 'Please restart. If the issue persists, contact support.',
    es: 'Reinicie la aplicación. Si el problema continúa, contacte con soporte.',
    se: 'Starta om. Om problemet kvarstår, kontakta support.',
    no: 'Start på nytt. Hvis problemet vedvarer, kontakt support.',
    tr: 'Lütfen yeniden başlatın. Sorun devam ederse, destekle iletişime geçin.',
    dk: 'Genstart venligst. Hvis problemet fortsætter, kontakt support.',
  },
  'SSK.SelectedVariations': {
    en: 'Selected variations',
    es: 'Variaciones seleccionadas',
    se: 'Alternativ är valt',
    no: 'Valgt variasjon',
    tr: 'Seçilen varyasyonlar',
    dk: 'Udvalgte variationer',
  },
  'SSK.SelectVariation': {
    en: 'Select Variation',
    es: 'Seleccionar variación',
    se: 'Välj ett alternativ',
    no: 'Velg ett alternativ',
    tr: 'Varyasyon Seç',
    dk: 'Vælg Variation',
  },
  'SSK.SelectOneOrMoreVariations': {
    en: 'Select one or more variations',
    es: 'Seleccione una o más variaciones',
    se: 'Välj ett alternativ eller flera alternativ',
    no: 'Velg ett eller flere alternativ',
    tr: 'Bir veya daha fazla varyasyon seçin',
    dk: 'Vælg en eller flere varianter',
  },
  'SSK.Checkout.Status.PENDING': {
    en: 'Payment pending…',
    es: 'Pago pendiente…',
    se: 'Betalningen pågår..',
    no: 'Betaling pågår..',
    tr: 'Ödeme bekleniyor…',
    dk: 'Betaling afventer...',
  },
  'SSK.Checkout.Status.COMPLETED': {
    en: 'Payment successful!',
    es: '¡Pago exitoso!',
    se: 'Betalningen lyckades!',
    no: 'Betaling vellyket',
    tr: 'Ödeme başarılı!',
    dk: 'Betaling lykkedes!',
  },
  'SSK.Checkout.Status.FAILED': {
    en: 'The payment failed',
    es: 'el pago falló',
    se: 'Betalningen misslyckades',
    no: 'Betaling feilet',
    tr: 'Ödeme başarısız oldu',
    dk: 'Betalingen mislykkedes',
  },
  'SSK.Checkout.OutOfStock.Title': {
    en:
      'These items are out of stock and was removed from your cart, please select something else',
    es: 'Este artículo está agotado y eliminado de su carrito, seleccione otra cosa',
    se:
      'Dessa produkter är slut i lager och har tagits bort från din varukorg, vänligen välj något annat',
    no: 'Disse produktene er dessverre utsolgt og har blitt fjernet fra handlekurven.',
    tr: 'Bu ürünler stokta yok ve sepetinizden kaldırıldı, lütfen başka bir ürün seçin',
    dk: 'Disse varer er udsolgt og blev fjernet fra din indkøbskurv, vælg venligst noget andet',
  },
  'SSK.Checkout.TakeAwayBagAlert.Text': {
    en: 'This item can’t be removed as Danish law requires a charge for takeaway bags',
    es:
      'Este artículo no se puede eliminar ya que la ley danesa requiere un cargo por las bolsas para llevar',
    se: 'Denna vara kan inte tas bort eftersom dansk lag kräver en avgift för take away-påsar',
    no: 'Denne varen kan ikke fjernes ettersom dansk lov krever en avgift for takeaway-poser',
    tr:
      'Bu öğe kaldırılamaz çünkü Danimarka yasaları paket servis poşetleri için ücret gerektirir',
    dk: 'Denne vare kan ikke fjernes, da dansk lov kræver et gebyr for take-away-poser',
  },
  'SSK.Piece': {
    en: 'pcs',
    es: 'pzas',
    se: 'st',
    no: 'stk',
    tr: 'Adet',
    dk: 'stk',
  },
  'SSK.More': {
    en: 'More',
    es: 'Más',
    se: 'Mer',
    no: 'Mer',
    tr: 'Daha',
    dk: 'Mere',
  },
  'SSK.Close': {
    en: 'Close',
    es: 'Cerrar',
    se: 'Stäng',
    no: 'Lukk',
    tr: 'Kapat',
    dk: 'Luk',
  },
  'SSK.Allergens': {
    en: 'Allergens',
    es: 'Alérgenos',
    se: 'Allergener',
    no: 'Allergener',
    tr: 'Alerjenler',
    dk: 'Allergener',
  },
  'SSK.OrderNumber.PoweredBy': {
    en: 'Powered by Baemingo',
    es: 'Sistema de pedidos de Baemingo',
    se: 'Ordersystem från Baemingo',
    no: 'Bestillingssystem fra Baemingo',
    tr: 'Baemingo sipariş sistemi',
    dk: 'Ordresystem fra Baemingo',
  },
  //Settings
  'Settings.Title': {
    en: 'Settings',
    es: 'Ajustes',
    se: 'Inställningar',
    no: 'Innstillinger',
    tr: 'Ayarlar',
    dk: 'Indstillinger',
  },
  'Settings.BongSettings': {
    en: 'Kitchen Ticket Settings',
    es: 'Configuración del ticket de cocina',
    se: 'Bong-inställningar',
    no: 'Bong-innstillinger',
    tr: 'Mutfak Fişi Ayarları',
    dk: 'Køkkenbilletindstillinger',
  },
  'Settings.Hardware': {
    en: 'Hardware',
    es: 'Hardware',
    se: 'Hårdvara',
    no: 'Hardware',
    tr: 'Donanım',
    dk: 'Hardware',
  },
  'Settings.Payments': {
    en: 'Payments',
    es: 'Configuración de pagos',
    se: 'Betalningar',
    no: 'Betalinger',
    tr: 'Ödemeler',
    dk: 'Betalinger',
  },
  'Settings.Payments.OpenZettle': {
    en: 'Open Zettle settings',
    es: 'Abrir la configuración de Zettle',
    se: 'Öppna Zettle inställningar',
    no: 'Åpne Zettle-innstillinger',
    tr: 'Zettle ayarlarını aç',
    dk: 'Åbn Zettle-indstillinger',
  },
  'Settings.KitchenTickets': {
    en: 'Printed kitchen tickets',
    es: 'Configurar tickets de cocina',
    se: 'Fysiska bongar',
    no: 'Fysiske bonger',
    tr: 'Basılı mutfak biletleri',
    dk: 'Trykte køkkenbilletter',
  },
  'Settings.Receipts': {
    en: 'Receipts',
    es: 'Recibos',
    se: 'Kvitton',
    no: 'Kvitteringer',
    tr: 'Fişler',
    dk: 'Kvitteringer',
  },
  'Settings.PaymentPreferences': {
    en: 'Payment Preferences',
    es: 'Preferencias de pago',
    se: 'Betalningspreferenser',
    no: 'Betalingsinnstillinger',
    tr: 'Ödeme Tercihleri',
    dk: 'Betalingspræferencer',
  },
  'Settings.EnableTipping': {
    en: 'Enable tipping',
    es: 'Habilitar propinas',
    se: 'Aktivera dricks',
    no: 'Aktiver tips',
    tr: 'Bahşişi etkinleştir',
    dk: 'Aktiver tip',
  },
  'Settings.EnableTipping.Text': {
    en: 'Ask your customers to leave a tip',
    es: 'Pide a tus clientes que dejen propina',
    se: 'Be dina kunder om dricks',
    no: 'Be om tips på betalingsterminal',
    tr: 'Müşterilerinizden bahşiş bırakmalarını isteyin',
    dk: 'Bed dine gæster om at give drikkepenge',
  },
  'Settings.AlwaysPrintReceiptEPOS': {
    en:
      'Express checkout: Do not ask the customer whether they want a receipt or order number. The receipt will always be printed.',
    es:
      'Caja de autoservicio: No pregunte al cliente si desea un recibo o número de pedido. El recibo siempre se imprimirá.',
    se:
      'Expresskassa: Fråga inte kunden om de vill ha ett kvitto eller ordernummer. Kvittot skrivs alltid ut.',
    no:
      'Selvbetjent kasse: Ikke spør kunden om de ønsker kvittering eller bestillingsnummer. Kvitteringen skrives alltid ut.',
    tr:
      'Hızlı ödeme: Müşteriye fiş veya sipariş numarası isteyip istemediğini sormayın. Fiş her zaman yazdırılır.',
    dk:
      'Hurtig udtjekning: Spørg ikke kunden, om de ønsker en kvittering eller et ordrenummer. Kvitteringen udskrives altid.',
  },
  'Settings.Other': {
    en: 'Other',
    es: 'Otro',
    se: 'Övrigt',
    no: 'Øvrig',
    tr: 'Diğer',
    dk: 'Andre',
  },
  'Settings.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord ',
  },
  'Settings.Printers': {
    en: 'Printers',
    es: 'Impresoras',
    se: 'Skrivare',
    no: 'Printere',
    tr: 'Yazıcılar',
    dk: 'Printere',
  },
  'Settings.PosLayout': {
    en: 'POS layout',
    es: 'Diseño punto de venta',
    se: 'POS-layout',
    no: 'POS-layout',
    tr: 'POS düzeni',
    dk: 'POS layout',
  },
  'Settings.PosLayout.Choose': {
    en: 'Choose POS layout for this device',
    es: 'Elija el diseño de punto de venta en este dispositivo',
    se: 'Välj POS-layout för denna enhet',
    no: 'Velg POS-layout for denne enheten',
    tr: 'Bu cihaz için POS düzenini seçin',
    dk: 'Vælg POS-layout for denne enhed',
  },
  'Settings.PosLayout.Settings': {
    en: 'Settings',
    es: 'Ajustes',
    se: 'Inställningar',
    no: 'Innstillinger',
    tr: 'Ayarlar',
    dk: 'Indstillinger',
  },
  'Settings.PosLayout.ShowPrices': {
    en: 'Show prices on buttons',
    es: 'Mostrar precios en los botones',
    se: 'Visa priser på knappar',
    no: 'Vis priser på knapper',
    tr: 'Düğmelerde fiyatları göster',
    dk: 'Vis priser på knapper',
  },
  'Settings.PosLayout.ShowImages': {
    en: 'Show images on buttons',
    es: 'Mostrar imágenes en los botones',
    se: 'Visa bilder på knappar',
    no: 'Vis bilder på knapper',
    tr: 'Düğmelerde görselleri göster',
    dk: 'Vis billeder på knapper',
  },
  'Settings.PosLayout.RequireBeeper': {
    en: 'Require beeper number before payment',
    es: 'Requerir número de beeper antes del pago',
    se: 'Kräv pucknummer före betalning',
    no: 'Krev pucknummer før betaling',
    tr: 'Ödeme öncesi puck numarası zorunlu',
    dk: 'Kræv pucknummer før betaling',
  },
  'Settings.PosLayout.RequireBeeper.Desc': {
    en: 'Shows the puck selector when pressing pay if no puck has been selected',
    es: 'Muestra el selector de puck al presionar pagar si no se ha seleccionado un puck',
    se: 'Visar puckväljaren vid betalning om ingen puck har valts',
    no: 'Viser puckvelgeren ved betaling hvis ingen puck er valgt',
    tr: 'Puck seçilmemişse ödeme butonuna basıldığında puck seçicisini gösterir',
    dk: 'Viser puckvælgeren ved betaling hvis ingen puck er valgt',
  },
  'Settings.KdsLayout': {
    en: 'KDS layout',
    es: 'Diseño de pantalla de cocina',
    se: 'KDS-layout',
    no: 'Kjøkkenskjerm-oppsett',
    tr: 'KDS düzeni',
    dk: 'KDS layout',
  },
  'Settings.KdsSettings': {
    en: 'KDS Settings',
    es: 'Configuración de pantalla de cocina',
    se: 'KDS-inställningar',
    no: 'Kjøkkenskjerm-innstillinger',
    tr: 'KDS Ayarları',
    dk: 'KDS-indstillinger',
  },
  'Settings.Styling': {
    en: 'Styling',
    es: 'Estilo',
    se: 'Design',
    no: 'Design',
    tr: 'Şekillendirme',
    dk: 'Styling',
  },
  'Settings.Station': {
    en: 'Station',
    es: 'Punto de elaboración',
    se: 'Station',
    no: 'Stasjon',
    tr: 'İstasyon',
    dk: 'Station',
  },
  'Settings.Station.DisabledDueToPending': {
    en:
      "This station cannot be selected because it does not include the 'PENDING' order status required for auto-accept functionality.",
    es:
      'Este punto de elaboración no se puede seleccionar porque no incluye el estado de pedido "PENDING" requerido para la funcionalidad de autoaceptación.',
    se:
      'Denna station kan inte väljas eftersom den inte inkluderar statusen "PENDING" som krävs för auto-accept-funktionalitet.',
    no:
      'Denne stasjonen kan ikke velges fordi den ikke inkluderer statusen "PENDING" som kreves for auto-aksept-funksjonalitet.',
    tr:
      'Bu istasyon, otomatik kabul işlevselliği için gereken "BEKLEYEN" sipariş durumunu içermediği için seçilemez.',
    dk:
      'Denne station kan ikke vælges, da den ikke indeholder den "AFVENTENDE" ordrestatus, der kræves for auto-accept-funktionalitet.',
  },
  'Settings.Stations': {
    en: 'Stations',
    es: 'Estaciones',
    se: 'Stationer',
    no: 'Stasjoner',
    tr: 'İstasyonlar',
    dk: 'Stationer',
  },
  'Settings.Zone': {
    en: 'Zone',
    es: 'Asignar sala',
    se: 'Zoner',
    no: 'Soner',
    tr: 'Alan',
    dk: 'Zone',
  },
  'Settings.Zone.Choose': {
    en: 'Choose your zone',
    es: 'Elige tu sala',
    se: 'Välj din zon',
    no: 'Velg din sone',
    tr: 'Alanınızı seçin',
    dk: 'Vælg din zone',
  },
  'Settings.PhysicalKDSPrint': {
    en: 'KDS physical print',
    es: 'Impresión física de KDS',
    se: 'Fysisk KDS-bong',
    no: 'Fysisk KDS-bong',
    tr: 'KDS fiziksel baskısı',
    dk: 'KDS fysisk print',
  },
  'Settings.Device': {
    en: 'Device settings',
    es: 'Configuración del dispositivo',
    se: 'Enhetsinställningar',
    no: 'Enhetinnstillinger',
    tr: 'Cihaz ayarları',
    dk: 'Enhedsindstillinger',
  },
  'Settings.Device.Current': {
    en: 'Current device',
    es: 'Dispositivo actual',
    se: 'Nuvarande enhet',
    no: 'Nåværende enhet',
    tr: 'Şuanki cihaz',
    dk: 'Nuværende enhed',
  },
  'Settings.Device.Change': {
    en: 'Change device',
    es: 'Cambiar dispositivo',
    se: 'Byt enhet',
    no: 'Bytt enhet',
    tr: 'Cihazı değiştir',
    dk: 'Skift enhed',
  },
  'Settings.Device.Loading': {
    en: 'Loading devices',
    es: 'Cargando dispositivos',
    se: 'Läser in enheter',
    no: 'Laster enheter',
    tr: 'Cihazlar yükleniyor',
    dk: 'Indlæser enheder',
  },
  'Settings.Device.ConfirmClaim': {
    en: (deviceName: string) => `Claim "${deviceName}"?`,
    es: (deviceName: string) => `¿Reclamar "${deviceName}"?`,
    se: (deviceName: string) => `Vill du ta över "${deviceName}"?`,
    no: (deviceName: string) => `Vil du overta "${deviceName}"?`,
    tr: (deviceName: string) => `"${deviceName}" cihazını talep et?`,
    dk: (deviceName: string) => `Vil du overtage "${deviceName}"?`,
  },
  'Settings.Device.ConfirmClaim.Desc': {
    en: "After claiming, the device can't be claimed again for 7 days.",
    es: 'Después de reclamar, deben pasar 7 días hasta poder hacerlo de nuevo.',
    se: 'Efter att ha tagit över enheten kan den inte tas över igen på 7 dagar.',
    no: 'Etter å ha tatt over enheten, kan den ikke tas over igjen på 7 dager.',
    tr: 'Cihazı talep ettikten sonra, cihaz 7 gün boyunca tekrar talep edilemez.',
    dk: 'Efter at have overtaget enheden, kan den ikke overtages igen i 7 dage.',
  },
  'Settings.developer': {
    en: 'Developer page',
    es: 'Página de desarrollador',
    se: 'Sida för utvecklare',
    no: 'Utviklerside',
    tr: 'Geliştirici sayfası',
    dk: 'Udvikler side',
  },
  'Settings.LegacyHistory': {
    en: 'Legacy history page',
    es: 'Página de historial heredada',
    se: 'Gamla historiksidan',
    no: 'Gammel historikk side',
    tr: 'Eski geçmiş sayfası',
    dk: 'Gammel historik side',
  },
  'Settings.GoToOldHistory': {
    en: 'Go to old history page',
    es: 'Ir al historial anterior',
    se: 'Gå till gamla historiksidan',
    no: 'Gå til gammel historikk side',
    tr: 'Eski geçmiş sayfasına git',
    dk: 'Gå til gammel historik side',
  },
  'Settings.LogoutTitle': {
    en: 'Log out from Baemingo',
    es: 'Cerrar sesión en Baemingo',
    se: 'Logga ut från Baemingo',
    no: 'Logg ut fra Baemingo',
    tr: 'Baemingo’dan çıkış yap',
    dk: 'Log ud fra Baemingo',
  },
  'Settings.termsConditions': {
    en: 'Terms & Conditions',
    es: 'Términos y condiciones',
    se: 'Allmänna villkor',
    no: 'Vilkår og betingelser',
    tr: 'Şartlar ve koşullar',
    dk: 'Vilkår og betingelser',
  },
  'Settings.Announcements': {
    en: 'Announcements',
    es: 'Anuncios',
    se: 'Meddelanden',
    no: 'Meldinger',
    tr: 'Duyurular',
    dk: 'Meddelelser',
  },
  'Settings.EJournal': {
    en: 'E-Journal',
    es: 'Revista electrónica',
    se: 'E-Journal',
    no: 'Elektronisk journal',
    tr: 'E-Dergi',
    dk: 'E-Journal',
  },
  'Settings.StaffSettings': {
    en: 'Staff',
    es: 'Personal',
    se: 'Personal',
    no: 'Personell',
    tr: 'Personel',
    dk: 'Personale',
  },
  'Settings.AppSettings': {
    en: 'App / Online ordering',
    es: 'App / Pedidos online',
    se: 'App / Online beställning',
    no: 'App / Online bestilling',
    tr: 'Uygulama / Çevrimiçi sipariş',
    dk: 'App / Online bestilling',
  },
  'Settings.SelectLanguage': {
    en: 'Select language',
    es: 'Seleccione el idioma',
    se: 'Välj språk',
    no: 'Velg språk',
    tr: 'Dil Seçin',
    dk: 'Vælg sprog',
  },
  'Settings.PrintKitchenBongSlips': {
    en: 'Print kitchen tickets',
    es: 'Imprimir tickets de cocina',
    se: 'Skriv ut bongar',
    no: 'Skriv ut bonger',
    tr: 'Mutfak fişlerini yazdır',
    dk: 'Udskriv køkkenbilletter',
  },
  'Settings.PrintKitchenBongSlips.Text': {
    en: 'Print a summary of the order after purchase',
    es: 'Imprimir un resumen del pedido después de la compra',
    se: 'Skriv ut en bong efter betalning slutförts',
    no: 'Skriv ut bestillingssammendrag på bonger',
    tr: 'Satın aldıktan sonra siparişin özetini yazdırın',
    dk: 'Udskriv en oversigt over ordren efter køb',
  },
  'Settings.AlwaysPrintReceipt': {
    en: 'Always print receipt',
    es: 'Imprima siempre el ticket',
    se: 'Skriv alltid ut kvitto',
    no: 'Skriv alltid ut kvittering',
    tr: 'Her zaman makbuzu yazdır',
    dk: 'Udskriv altid kvittering',
  },
  'Settings.AlwaysPrintReceipt.Text': {
    en: 'Prints receipt without asking first',
    es: 'Imprime ticket sin preguntar primero',
    se: 'Skriv ut kvitto utan att fråga först',
    no: 'Skriv ut kvittering uten å spørre først',
    tr: 'Sormadan önce makbuzu yazdırır',
    dk: 'Udskriver kvittering uden at spørge først',
  },
  'Settings.DeviceSpecificEOD': {
    en: 'Individual start/end day on this device',
    es: 'Inicio / fin individual del servicio en este dispositivo',
    se: 'Individuell start/avslut av dag på denna enhet',
    no: 'Individuell start/avslut av dag på denne enheten',
    tr: 'Bu cihazda bireysel başlangıç/bitiş günü',
    dk: 'Individuel start/slutdag på denne enhed',
  },
  'Settings.DeviceSpecificEOD.Text': {
    en: 'Turning this on will not start/end the day on other devices',
    es: 'Activar esto no iniciará / finalizará el servicio en otros dispositivos',
    se: 'Att aktivera detta kommer inte att starta/avsluta dagen på andra enheter',
    no: 'Dette vil ikke starte/avslutte dagen på andre enheter',
    tr: 'Bunu açmak diğer cihazlarda günü başlatmaz/sonlandırmaz',
    dk: 'Aktivering af dette starter/slutter ikke dagen på andre enheder',
  },
  'Settings.GroupKitchenBongsStation': {
    en: 'Print separate tickets by course type',
    es: 'Imprimir tickets separados por tipo de plato',
    se: 'Skriv ut separata bongar per rätt',
    no: 'Skriv ut separate bonger etter rett type',
    tr: 'Yemek türüne göre ayrı biletler yazdır',
    dk: 'Udskriv separate billetter efter rettype',
  },
  'Settings.GroupKitchenBongsStation.Text': {
    en:
      'Prints one ticket for each course type and hides courses that are not relevant for the station',
    es:
      'Imprime una comanda para cada tipo de plato y oculta los platos que no son relevantes para el punto de elaboración',
    se: 'Skriver ut en bong för varje rätt och döljer rätter som inte är relevanta för stationen',
    no: 'Skriv ut en billett for hver rett og skjul retter som ikke er relevante for stasjonen',
    tr: 'Her yemek türü için bir bilet yazdırır ve istasyon için ilgili olmayan yemekleri gizler',
    dk: 'Udskriver en billet til hver ret og skjuler retter, der ikke er relevante for stationen',
  },
  'Settings.BongPrintByStation': {
    en: 'Print tickets for each station on the printer',
    es: 'Imprimir tickets para cada punto de elaboración en la impresora',
    se: 'Skriv ut bongar för varje station på skrivaren',
    no: 'Skriv ut bonger for hver stasjon på skriveren',
    tr: 'Yazıcıda her istasyon için bilet yazdır',
    dk: 'Udskriv billetter til hver station på printeren',
  },
  'Settings.BongPrintByStation.Text': {
    en: 'Print a ticket per printer station instead of combining all station articles',
    es:
      'Imprime un ticket por punto de elaboración de impresora en lugar de combinar todos los artículos de lOS punto de elaboración',
    se:
      'Skriv ut en bong per station på skrivaren istället för att kombinera alla stationens artiklar',
    no: 'Skriv ut en bong per skriverstasjon i stedet for å kombinere alle stasjonens artikler',
    tr: 'Tüm istasyon öğelerini birleştirmek yerine yazıcı istasyonu başına bir bilet yazdır',
    dk: 'Udskriv en billet pr. printerstation i stedet for at kombinere alle stationens artikler',
  },
  'Settings.GroupKitchenBongsCategory': {
    en: 'Group kitchen tickets by category',
    es: 'Agrupar tickets de cocina por categoría',
    se: 'Gruppera köksbongar efter kategori',
    no: 'Grupper kjøkkenbonger etter kategori',
    tr: 'Mutfak biletlerini kategoriye göre gruplandır',
    dk: 'Gruppér køkkenbilletter efter kategori',
  },
  'Settings.GroupKitchenBongsCategory.Text': {
    en: 'Articles without a course type are grouped by their category',
    es: 'Para artículos sin un tipo de plato, se agrupan por categoría',
    se: 'Artiklar utan rätttyp grupperas utifrån deras kategori',
    no: 'Varer uten rettstype grupperes etter kategori',
    tr: 'Yemek türü olmayan ürünler kategorilerine göre gruplandırılır',
    dk: 'Varer uden rettype grupperes efter kategori',
  },
  'Settings.DefaultTakeAway': {
    en: 'Default "Take away"',
    es: '"Para llevar" predeterminado',
    se: '"Ta med" är standard',
    no: '"Ta med" er standard',
    tr: 'Varsayılan "Al-Git"',
    dk: 'Standard "Take away"',
  },
  'Settings.DefaultTakeAway.Text': {
    en: 'If active POS defaults to "Take away"',
    es: 'Si el POS activo está predeterminado en "Para llevar"',
    se: 'Om POS är aktiv så är "Ta med" standard',
    no: 'Hvis denne innstillingen er på, står "Ta med" som standardvalg',
    tr: 'Etkin POS varsayılan olarak "Al-Git" olarak ayarlanıyorsa',
    dk: 'Hvis aktiv POS som standard er "Take away"',
  },
  'Settings.PrintChequeQR': {
    en: 'Print QR code on cheque',
    es: 'Imprimir código QR en el ticket',
    se: 'Skriv ut QR-kod på nota',
    no: 'Skriv ut QR-kode på regning',
    tr: 'Çekin üzerine QR kodunu yazdırın',
    dk: 'Udskriv QR-kode på check',
  },
  'Settings.PrintChequeQR.Text': {
    en: 'Used for loyalty points',
    es: 'Usado para puntos de fidelización',
    se: 'Används för lojalitetspoäng',
    no: 'Bruker for lojalitetsprogram',
    tr: 'Sadakat puanları için kullanılır',
    dk: 'Bruges til loyalitetspoint',
  },
  'Settings.HideServiceType': {
    en: 'Hide Eat here / Take away option',
    es: 'Ocultar la opción de "Comer aquí / Para llevar"',
    se: 'Dölj "Ät här / Ta med" alternativet',
    no: 'Skjul "Spis her / Ta med" alternativet',
    tr: 'Yemek burada / Paket servis seçeneğini gizle',
    dk: 'Skjul "Spis her / Takeaway" mulighed',
  },
  'Settings.HideServiceType.Text': {
    en: 'Completely hides the "Eat here / Take away" option, including on the kitchen ticket',
    es:
      'Oculta completamente la opción de "Comer aquí / Para llevar", incluido en el ticket de cocina',
    se: 'Döljer helt "Ät här / Ta med" alternativet, inklusive på bongen',
    no: 'Skjuler helt "Spis her / Ta med" alternativet, inkludert på kjøkkenbilletten',
    tr: 'Mutfak fişinde dahil olmak üzere "Yemek burada / Paket servis" seçeneğini tamamen gizler',
    dk: 'Skjuler helt "Spis her / Takeaway" muligheden, inklusive på køkkenbilletten',
  },
  'Settings.NewRefundFlow': {
    en: 'Use new refund flow',
    se: 'Använd nya refund-flödet',
    es: 'Usar nuevo flujo de reembolso',
    no: 'Bruk ny refusjonsflyt',
    tr: 'Yeni geri ödeme akışını kullan',
    dk: 'Brug nyt refusionsflow',
  },
  'Settings.NewRefundFlow.Text': {
    en: 'Only activate if instructed by support',
    se: 'Aktivera endast om du instrueras av support',
    es: 'Solo activa si es instruido por soporte',
    no: 'Aktiveres kun om du er blitt bedt om det av kundeservice',
    tr: 'Yalnızca destek tarafından talimat verildiğinde etkinleştir',
    dk: 'Aktiver kun, hvis du bliver instrueret af support',
  },
  'Settings.NewQRCode': {
    en: 'Use new QR code for points',
    es: 'Usa el nuevo código QR para obtener puntos',
    se: 'Använd nya QR för poäng',
    no: 'Bruk ny QR-løsning for poeng',
    tr: 'Puanlar için yeni QR kodunu kullanın',
    dk: 'Brug ny QR-kode til point',
  },
  'Settings.NewQRCode.Text': {
    en: 'Enables order history in the app',
    es: 'Habilita el historial de pedidos en la aplicación',
    se: 'Aktiverar order historik i appen',
    no: 'Aktiverer ordrehistorikk i appen',
    tr: 'Uygulamada sipariş geçmişini etkinleştirir',
    dk: 'Aktiverer ordrehistorik i appen',
  },
  'Settings.DisableStaffTimeout': {
    en: 'Disable staff timeout',
    es: 'Deshabilitar el tiempo de espera del personal',
    se: 'Avaktivera timeout för personalen',
    no: 'Stopp automatisk utlogging',
    tr: 'Personel zaman aşımını devre dışı bırak',
    dk: 'Deaktiver timeout for personalet',
  },
  'Settings.DisableStaffTimeout.Text': {
    en: 'If set, staff login will persist until next logout or restart',
    es:
      'Si se establece, el inicio de sesión del personal persistirá hasta el próximo cierre de sesión o reinicio',
    se: 'Personalinloggning kommer att vara kvar tills utloggning eller omstart',
    no:
      'Hvis aktiv, vil personalet være logget inn helt til de aktivt logger ut eller starter appen på nytt',
    tr:
      'Ayarlanırsa, personelin oturum açma işlemi bir sonraki oturum kapatılana veya yeniden başlatılana kadar devam edecektir',
    dk: 'Hvis det er indstillet, vil personalelogin fortsætte indtil næste logout eller genstart',
  },
  'Settings.ShortenChequeItemNames': {
    en: 'Shorten cheque item names',
    es: 'Acortar nombres de artículos',
    se: 'Förkorta produktnamn',
    no: 'Forkort produktnavn',
    tr: 'Kasa ürün adlarını kısalt',
    dk: 'Forkort vare navne',
  },
  'Settings.ShortenChequeItemNames.Text': {
    en: 'Will cut off the item name and add "..." ',
    es: 'Cortará el nombre del artículo y agregará "..."',
    se: 'Kommer att kapa produktnamnet och lägga till "..."',
    no: 'Vil forkorte produktnavnet og legge til "..."',
    tr: 'Ürün adını kesip "..." ekleyecek',
    dk: 'Vil skære varens navn af og tilføje "..."',
  },
  'Settings.ShortenChequeNames.Text': {
    en: 'Makes all cheque items max one line, for example: "Domaine de la Romanée-Con..."',
    es:
      'Hace que todos los elementos de verificación tengan una línea como máximo, por ejemplo: "Domaine de la Romanée-Con..."',
    se: 'Alla produktnamn får plats på en rad, till exempel: "Domaine de la Romanée-Con..."',
    no:
      'Alle produktnavn forkortes så de får plass på én rad, for eksempel: "Domaine de la Romanée-Con..."',
    tr:
      'Tüm kontrol öğelerinin maksimum bir satır olmasını sağlar, örneğin: "Domaine de la Romanée-Con..."',
    dk:
      'Gør alle afkrydsningspunkter maks. én linje, for eksempel: "Domaine de la Romanée-Con..."',
  },
  'Settings.Bong.DisableCapitalLetters': {
    en: 'Disable capital letters',
    es: 'Deshabilitar letras mayúsculas',
    se: 'Använd ej stora bokstäver',
    no: 'Bruk små bokstaver',
    tr: 'Büyük harfleri devre dışı bırak',
    dk: 'Deaktiver store bogstaver',
  },
  'Settings.Bong.DisableCapitalLetters.Text': {
    en: 'Makes all letters in small caps to preserve space on the ticket',
    es: 'Hace que todas las letras sean en mayúsculas para conservar espacio en el ticket',
    se: 'Använd endast små bokstäver för att spara utrymme på bongen',
    no: 'Bruk kun små bokstaver for å spare plass på bongene',
    tr: 'Fişte yer tasarrufu sağlamak için tüm harfleri küçük büyük harf haline getirir',
    dk: 'Gør alle bogstaver små for at bevare plads på billetten',
  },
  'Settings.Bong.ShowPrintId': {
    en: 'Show print ID',
    es: 'Mostrar ID de impresión',
    se: 'Visa print-ID',
    no: 'Vis bong-ID',
    tr: 'Yazdırma kimliğini göster',
    dk: 'Vis print-id',
  },
  'Settings.Bong.ShowPrintId.Text': {
    en: 'Makes it easier to identify duplicates in the kitchen',
    es: 'Facilita la identificación de duplicados en la cocina',
    se:
      'Gör det lättare att identifiera dubbletter i köket via ett unikt bong-nummer som skrivs ut på bongen',
    no:
      'Gjør det lettere å identifisere duplikater på kjøkkenet, ved et unikt bong-nummer som skrives ut på bongen',
    tr: 'Mutfaktaki kopyaları tanımlamayı kolaylaştırır',
    dk: 'Gør det nemmere at identificere dubletter i køkkenet',
  },
  'Settings.Printer.EpsonRetry': {
    en: 'Auto-retry Epson prints',
    se: 'Automatiskt försök igen för Epson-utskrifter',
    no: 'Automatisk nytt forsøk for Epson-utskrifter',
    dk: 'Automatisk genforsøg for Epson-udskrifter',
    es: 'Reintentar automáticamente impresiones Epson',
    tr: 'Epson yazdırmaları otomatik yeniden dene',
  },
  'Settings.Printer.EpsonRetry.Text': {
    en: 'If an Epson print fails, it will automatically try again',
    se: 'Om en Epson-utskrift misslyckas försöker den automatiskt igen',
    no: 'Hvis en Epson-utskrift mislykkes, prøver den automatisk på nytt',
    dk: 'Hvis en Epson-udskrift fejler, prøver den automatisk igen',
    es: 'Si una impresión Epson falla, se reintentará automáticamente',
    tr: 'Bir Epson yazdırma başarısız olursa, otomatik olarak tekrar dener',
  },
  'Settings.Bong.ShowFloorplan': {
    en: 'Show table area',
    es: 'Mostrar área de mesa',
    se: 'Visa bordsområde',
    no: 'Vis bordområde',
    tr: 'Masa alanını göster',
    dk: 'Vis bordområde',
  },
  'Settings.Bong.ShowFloorplan.Text': {
    en: 'Shows the table area(floorplan) on the ticket',
    es: 'Muestra el área de la mesa (plano de planta) en el ticket',
    se: 'Visar bordsområdet (planlösning) på bongen',
    no: 'Viser bordområdet (bordkart) på bongen',
    tr: 'Fişte masa alanını (kat planı) gösterir',
    dk: 'Viser bordområdet (gulvplan) på billetten',
  },
  'Settings.Bong.ShowPrices': {
    en: 'Show prices',
    es: 'Mostrar precios',
    se: 'Visa priser',
    no: 'Vis priser',
    tr: 'Fiyatları göster',
    dk: 'Vis priser',
  },
  'Settings.Bong.ShowPrices.Text': {
    en: 'Can be used to prevent fraud or to differentiate articles',
    es: 'Puede usarse para prevenir fraudes o diferenciar artículos',
    se: 'Kan användas för att förhindra bedrägeri eller för att skilja artiklar åt',
    no: 'Kan brukes for å forhindre svindel eller for å skille artikler',
    tr: 'Sahtekarlığı önlemek veya ürünleri ayırt etmek için kullanılabilir',
    dk: 'Kan bruges til at forhindre svindel eller differentiere artikler',
  },
  'Settings.Bong.SortItemsAlphabetically': {
    en: 'Sort items alphabetically',
    es: 'Ordenar artículos alfabéticamente',
    se: 'Sortera artiklar alfabetiskt',
    no: 'Sorter artikler alfabetisk',
    tr: 'Ürünleri alfabetik olarak sırala',
    dk: 'Sorter artikler alfabetisk',
  },
  'Settings.Bong.SortItemsAlphabetically.Text': {
    en: 'Items on kitchen tickets will be sorted alphabetically by name',
    es: 'Los artículos en los tickets de cocina se ordenarán alfabéticamente por nombre',
    se: 'Artiklar på köksbongar sorteras alfabetiskt efter namn',
    no: 'Artikler på kjøkkenbonger sorteres alfabetisk etter navn',
    tr: 'Mutfak fişlerindeki ürünler ada göre alfabetik olarak sıralanacak',
    dk: 'Artikler på køkkenbilletter sorteres alfabetisk efter navn',
  },
  'Settings.Bong.HideAllExceptDesiredTime': {
    en: 'Only show desired time',
    es: 'Mostrar solo la hora deseada',
    se: 'Visa endast upphämtningstid',
    no: 'Vis kun hentetidspunkt',
    tr: 'Yalnızca istenen zamanı göster',
    dk: 'Vis kun det ønskede tidspunkt',
  },
  'Settings.Bong.HideAllExceptDesiredTime.Text': {
    en: 'Hides all times except the desired time, if set',
    es: 'Oculta todas las horas excepto la hora deseada, si está configurada',
    se: 'Visar endast upphämtningstid, om den är satt. Döljer alla andra tider på bongen',
    no: 'Skjuler alle tidspunkter utenom hentetidspunkt, hvis det er satt.',
    tr: 'Ayarlanmışsa, istenen saat dışındaki tüm saatleri gizler',
    dk: 'Skjuler alle tidspunkter undtagen den ønskede tid, hvis den er indstillet',
  },
  'Settings.BongHideArrow': {
    en: 'Hide arrow on ticket',
    es: 'Ocultar flecha en el ticket',
    se: 'Dölj pil på bong',
    no: 'Skjul pil-ikon på bong',
    tr: 'Fişteki oku gizle',
    dk: 'Skjul pilen på billetten',
  },
  'Settings.BongHideArrow.Text': {
    en:
      'Hides the arrow on printed tickets. Useful for printers which do not support printing the arrow.',
    es:
      'Oculta la flecha en los tickets impresos. Útil para impresoras que no admiten la impresión de la flecha.',
    se: 'Döljer pilen på bongar. Användbart för skrivare som inte stödjer att skriva ut pilen.',
    no: 'Skjuler pilen på bonger. Brukes på printere som ikke støtter utskrift av dette ikonet.',
    tr:
      'Basılı fişlerdeki oku gizler. Okun yazdırılmasını desteklemeyen yazıcılar için kullanışlıdır.',
    dk:
      'Skjuler pilen på udskrevne billetter. Nyttigt til printere, der ikke understøtter udskrivning af pilen.',
  },
  'Settings.NewAppOrderingKDS': {
    en: 'Use new app order handling in KDS',
    es: 'Utilice el nuevo manejo de pedidos de aplicaciones en KDS',
    se: 'Använd nya apphanteringen i KDS',
    no: 'Bruk ny apphåndtering i KDS',
    tr: "KDS'de yeni uygulama siparişi işlemeyi kullanın",
    dk: 'Brug ny app ordrehåndtering i KDS',
  },
  'Settings.NewAppOrderingKDS.Text': {
    en: 'Enables app order items to be handled individually',
    es: 'Permite que los elementos del pedido de la aplicación se manejen individualmente',
    se: 'Gör att apporderartiklar kan hanteras individuellt',
    no: 'Tillater at artikler på app-bestillinger kan håndteres individuelt',
    tr: 'Uygulama siparişi ürünlerinin ayrı ayrı ele alınmasını sağlar',
    dk: 'Gør det muligt at håndtere appordrevarer individuelt',
  },
  'Settings.CompleteAppOrdersInstantly': {
    en: 'All app orders are automatically set to "Completed" when accepted.',
    es:
      'Todos los pedidos de la aplicación se establecen automáticamente como "Completados" cuando se aceptan.',
    se: 'Alla appbeställningar sätts automatiskt till "Avslutad" när de accepteras.',
    no: 'Alle app-bestillinger settes automatisk til "Fullført" når de er akseptert.',
    tr:
      'Tüm uygulama siparişleri kabul edildiğinde otomatik olarak "Tamamlandı" olarak ayarlanır.',
    dk: 'Alle appordrer sættes automatisk til "Fuldført", når de er accepteret.',
  },
  'Settings.OnlinePlayNewOrderSound': {
    en: 'Play sound for incoming online orders',
    es: 'Reproducir sonido para pedidos en línea entrantes',
    se: 'Spela upp ljud för inkommande onlinebeställningar',
    no: 'Spill av lyd for innkommende online-bestillinger',
    tr: 'Gelen çevrimiçi siparişler için ses çal',
    dk: 'Afspil lyd for indkommende online ordrer',
  },
  'Settings.ServiceTypeDelivery': {
    en: 'Set service type to delivery',
    es: 'Establecer el tipo de servicio a la entrega',
    se: 'Ställ in leverans som typ',
    no: 'Velg servicemodus til levering',
    tr: 'Hizmet türünü Paket olarak ayarlayın',
    dk: 'Indstil servicetype til levering',
  },
  'Settings.ServiceTypeDelivery.Text': {
    en: 'All orders will be created with the service type "Delivery"',
    es: 'Todos los pedidos se crearán con el tipo de servicio "Entrega"',
    se: 'Alla ordrar kommer att skapas med typen "Leverans"',
    no: 'Alle ordrer blir satt med typen "Levering"',
    tr: 'Tüm siparişler "Paket" hizmet türüyle oluşturulacaktır.',
    dk: 'Alle ordrer oprettes med servicetypen "Levering"',
  },
  'Settings.Search.Placeholder': {
    en: 'Search...',
    es: 'Búsqueda...',
    se: 'Sök...',
    no: 'Søk...',
    tr: 'Ara',
    dk: 'Søger...',
  },
  'Settings.TerminalIPAddress': {
    en: 'Terminal IP-Address',
    es: 'Dirección IP del terminal',
    se: 'IP-adress för terminal',
    no: 'IP-adresse til terminal',
    tr: 'Terminal IP Adresi',
    dk: 'Terminal IP-adresse',
  },
  'Settings.TerminalID': {
    en: 'Terminal ID',
    es: 'ID de terminal',
    se: 'Terminal ID',
    no: 'Terminal-ID',
    tr: 'Terminal Kimliği',
    dk: 'Terminal ID',
  },
  'Settings.Add': {
    en: 'Add',
    es: 'Agregar',
    se: 'Lägg till',
    no: 'Legg til',
    tr: 'Ekle',
    dk: 'Tilføj',
  },
  'Settings.Terminal.Reconnect': {
    en: 'Reconnect',
    es: 'Reconectar',
    se: 'Återanslut',
    no: 'Koble til på nytt',
    tr: 'Yeniden bağlan',
    dk: 'Tilslut igen',
  },
  'Settings.AddNewTerminal': {
    en: 'Add new terminal',
    es: 'Añadir nueva terminal',
    se: 'Lägg till ny terminal',
    no: 'Legg til ny terminal',
    tr: 'Yeni terminal ekle',
    dk: 'Tilføj ny terminal',
  },
  'Settings.AddNewTerminal.text': {
    en: '( [device model]-[serial number] )',
    es: '([modelo de dispositivo]-[número de serie])',
    se: '( [device model]-[serial number] )',
    no: '( [device model]-[serial number] )',
    tr: '( [cihaz modeli]-[seri numarası] )',
    dk: '([enhedsmodel]-[serienummer])',
  },
  'Settings.AddTerminalScan': {
    en: 'Add terminal automatically',
    es: 'Agregar terminal automáticamente',
    se: 'Lägg till terminal automatiskt',
    no: 'Legg til terminal automatisk',
    tr: 'Terminali otomatik olarak ekle',
    dk: 'Tilføj terminal automatisk',
  },
  'Settings.AddTerminal.Completed': {
    en: 'Terminal was successfully added',
    es: 'La terminal se agregó correctamente',
    se: 'Terminalen har lagts till',
    no: 'Terminal lagt til',
    tr: 'Terminal başarıyla eklendi',
    dk: 'Terminal blev tilføjet',
  },
  'Settings.AddTerminalScan.Info.Title': {
    en: 'Scan your terminal',
    es: 'Escanee su terminal',
    se: 'Skanna din terminal',
    no: 'Scan din terminal',
    tr: 'Terminalinizi tarayın',
    dk: 'Scan din terminal',
  },
  'Settings.Terminal.Name': {
    en: 'Name',
    es: 'Nombre',
    se: 'Namn',
    no: 'Navn',
    tr: 'İsim',
    dk: 'Navn',
  },
  'Settings.AddTerminalScan.Info.Text': {
    en: 'Scan the QR code on your terminal to connect.',
    es: 'Escanee el código QR en su terminal para conectarse.',
    se: 'Skanna QR-koden på din terminal för att ansluta.',
    no: 'Scan QR-koden på terminalen for å koble til',
    tr: 'Bağlanmak için terminalinizdeki QR kodunu tarayın.',
    dk: 'Scan QR-koden på din terminal for at oprette forbindelse.',
  },
  'Settings.AddTerminalScan.Info.ToShow': {
    en: 'To show the QR code on your terminal:',
    es: 'Para mostrar el código QR en su terminal:',
    se: 'För att visa QR-koden på din terminal:',
    no: 'For å vise QR-koden på terminalen:',
    tr: 'QR kodunu terminalinizde göstermek için:',
    dk: 'Sådan viser du QR-koden på din terminal:',
  },
  'Settings.AddTerminalScan.Info.Step1': {
    en: 'Press 5 followed by the green button',
    es: 'Presione 5 seguido del botón verde',
    se: 'Tryck 5 följt av den gröna knappen',
    no: 'Trykk 5 etterfulgt av den grønne knappen',
    tr: "5'e ve ardından yeşil düğmeye basın",
    dk: 'Tryk på 5 efterfulgt af den grønne knap',
  },
  'Settings.AddTerminalScan.Info.Step2': {
    en: 'Press the blue circle',
    es: 'Presione el círculo azul',
    se: 'Tryck på den blå cirkeln',
    no: 'Trykk på den blå sirkelen',
    tr: 'Mavi daireye basın',
    dk: 'Tryk på den blå cirkel',
  },
  'Settings.AddTerminalScan.Info.Button': {
    en: 'Scan QR code',
    es: 'Escanear código QR',
    se: 'Skanna QR-kod',
    no: 'Scan QR-kode',
    tr: 'QR kodu tarayın',
    dk: 'Scan QR-kode',
  },
  'Settings.AddTerminalManually': {
    en: 'Add terminal manually',
    es: 'Agregar terminal manualmente',
    se: 'Lägg till terminal manuellt',
    no: 'Legg til terminal manuelt',
    tr: 'Terminali manuel olarak ekle',
    dk: 'Tilføj terminal manuelt',
  },
  'Settings.HasBuiltInPrinter': {
    en: 'Has built-in printer',
    es: 'Tiene impresora incorporada',
    se: 'Har inbyggd skrivare',
    no: 'Har innebygget printer',
    tr: 'Dahili yazıcıya sahiptir',
    dk: 'Har indbygget printer',
  },
  'Settings.HasBuiltInPrinter.Text': {
    en: 'If this is checked receipt is printed from terminal',
    es: 'Si esto está marcado, el ticket se imprime desde la terminal',
    se: 'Om detta är markerat skrivs kvitto ut från terminalen',
    no: 'Om denne er aktivert skrives kvittering ut fra terminalen',
    tr: 'Bu işaretlenirse terminalden fiş yazdırılır',
    dk: 'Hvis dette er markeret, udskrives kvittering fra terminal',
  },
  'Settings.Terminal.Primary': {
    en: 'Primary',
    es: 'Principal',
    se: 'Primär',
    no: 'Primær',
    tr: 'Birincil',
    dk: 'Primær',
  },
  'Settings.AddedTerminals': {
    en: 'Added terminals',
    es: 'Terminales añadidos',
    se: 'Tillagda terminaler',
    no: 'Aktiverte terminaler',
    tr: 'Terminaller eklendi',
    dk: 'Tilføjede terminaler',
  },
  'Settings.AvailableTerminals': {
    en: 'Available Terminals',
    es: 'Terminales Disponibles',
    se: 'Tillgängliga terminaler',
    no: 'Tilgjengelige terminaler',
    tr: 'Mevcut Terminaller',
    dk: 'Tilgængelige terminaler',
  },
  'Settings.TerminalSetName': {
    en: 'Set name',
    es: 'Establecer nombre',
    se: 'Ange namn',
    no: 'Angi navn',
    tr: 'Adını belirle',
    dk: 'Indstil navn',
  },
  'Settings.TerminalSaveName': {
    en: 'Save',
    es: 'Ahorrar',
    se: 'Spara',
    no: 'Spare',
    tr: 'Kaydetmek',
    dk: 'Spare',
  },
  'Settings.TerminalEnterName': {
    en: 'Enter name for this terminal',
    es: 'Introducir nombre para esta terminal',
    se: 'Ange namn för denna terminal',
    no: 'Skriv inn navn for denne terminalen',
    tr: 'Adınızı girin bu terminal için',
    dk: 'Indtast navn til denne terminal',
  },
  'Settings.Printer': {
    en: 'Printer',
    es: 'Impresora',
    se: 'Skrivare',
    no: 'Printer',
    tr: 'Yazıcı',
    dk: 'Printer',
  },
  'Settings.NewPatflow': {
    en: 'New P@T flow',
    es: 'Nuevo flujo P@T',
    se: 'Nya P@T flöde',
    no: 'Ny P@T-flyt',
    tr: 'Yeni P@T akışı',
    dk: 'Nyt P@T flow',
  },
  'Settings.Cloud': {
    en: 'Cloud',
    es: 'Nube',
    se: 'Cloud',
    no: 'Cloud',
    tr: 'Cloud',
    dk: 'Skyen',
  },
  'Settings.AddCert': {
    en: 'Add certificate',
    es: 'Agregar certificado',
    se: 'Lägg till certifikat',
    no: 'Legg til sertifikat',
    tr: 'Sertifika ekle',
    dk: 'Tilføj certifikat',
  },
  'Settings.Test': {
    en: 'Test',
    es: 'Prueba',
    se: 'Testa',
    no: 'Test',
    tr: 'Deneme',
    dk: 'Prøve',
  },
  'Settings.MismatchedIP': {
    en: 'MISMATCHED IP - CLICK TO RESET',
    es: 'IP NO COINCIDENTE - HAGA CLIC PARA RESTABLECER',
    se: 'OMATCHANDE IP - KLICKA FÖR ATT ÅTERSTÄLLA',
    no: 'IP MATCHER IKKE - KLIKK FOR Å NULLSTILLE',
    tr: 'EŞLEŞMEYEN IP - SIFIRLAMAK İÇİN TIKLAYIN',
    dk: 'MISMATCHED IP - KLIK FOR AT NULSTILLE',
  },
  'Settings.PrinterName.Placeholder': {
    en: 'Write a printer name',
    es: 'Escriba un nombre de impresora',
    se: 'Fyll i ett skrivarnamn',
    no: 'Fyll inn et navn på printeren',
    tr: 'Bir yazıcı adı yazın',
    dk: 'Skriv et printernavn',
  },
  'Settings.NoAccess': {
    en: "You don't have access to this page",
    es: 'No tienes acceso a esta página',
    se: 'Du har inte tillgång till denna sida',
    no: 'Du har ikke tilgang til denne siden',
    tr: 'Bu sayfaya erişiminiz yok',
    dk: 'Du har ikke adgang til denne side',
  },
  'Settings.NoAccess.GoToGateway': {
    en: 'Go to start page',
    es: 'Ir a la página de inicio',
    se: 'Gå till startsidan',
    no: 'Gå til startside',
    tr: 'Başlangıç sayfasına git',
    dk: 'Gå til startside',
  },
  'Settings.NoAccess.GoToPos': {
    en: 'Go to POS',
    es: 'Ir a POS',
    se: 'Gå till POS',
    no: 'Gå til POS',
    tr: 'POS’a git',
    dk: 'Gå til POS',
  },
  'EJournal.TableEvents': {
    en: 'Table events',
    es: 'Eventos de mesa',
    se: 'Bordsevent',
    no: 'Bordhendelser',
    tr: 'Masa etkinlikleri',
    dk: 'Bordbegivenheder',
  },
  'EJournal.ReportEvents': {
    en: 'Report events',
    es: 'Reportar eventos',
    se: 'Rapportevent',
    no: 'Rapporthendelser',
    tr: 'Etkinlikleri raporla',
    dk: 'Rapportér begivenheder',
  },
  'EJournal.NoEventsFound': {
    en: 'No events found',
    es: 'No se encontraron eventos',
    se: 'Inga event hittades',
    no: 'Ingen hendelser funnet',
    tr: 'Hiçbir etkinlik bulunamadı',
    dk: 'Ingen begivenheder fundet',
  },
  'Settings.Name': {
    en: 'Name',
    es: 'Nombre',
    se: 'Namn',
    no: 'Navn',
    tr: 'İsim',
    dk: 'Navn',
  },
  'Settings.Unknown': {
    en: 'Unknown',
    es: 'Desconocido',
    se: 'Okänd',
    no: 'Ukjent',
    tr: 'Bilinmeyen',
    dk: 'Ukendt',
  },
  'Settings.None': {
    en: 'None',
    es: 'Ninguna',
    se: 'Inga',
    no: 'Ingen',
    tr: 'Hiçbiri',
    dk: 'Ingen',
  },
  'Settings.MakePrimary': {
    en: 'Make primary receipt printer',
    es: 'Hacer impresora de tickets principal',
    se: 'Gör denna till den primära kvittoskrivaren',
    no: 'Gjør dette til primær kvitteringsskriver',
    tr: 'Birincil makbuz yazıcısı yapın',
    dk: 'Lav primær kvitteringsprinter',
  },
  'Settings.MakePrimary.Short': {
    en: 'Make primary',
    es: 'Hacer principal',
    se: 'Gör primär',
    no: 'Gjør primær',
    tr: 'Birincil yap',
    dk: 'Lav primær',
  },
  'Settings.UnknownStation': {
    en: 'Unknown station',
    es: 'Punto de elaboración desconocido',
    se: 'Okänd station',
    no: 'Ukjent stasjon',
    tr: 'Bilinmeyen istasyon',
    dk: 'Ukendt station',
  },
  'Settings.NoStations': {
    en: 'No stations',
    es: 'Sin estaciones',
    se: 'Inga stationer',
    no: 'Ingen stasjoner',
    tr: 'İstasyon yok',
    dk: 'Ingen stationer',
  },
  'Settings.TestPrint': {
    en: 'Test print',
    es: 'Impresión de prueba',
    se: 'Testa utskrift',
    no: 'Test print',
    tr: 'Test baskısı',
    dk: 'Prøvetryk',
  },
  'Settings.Rename': {
    en: 'Rename',
    es: 'Renombrar',
    se: 'Ändra namn',
    no: 'Endre navn',
    tr: 'Yeniden isimlendir',
    dk: 'Omdøb',
  },
  'Settings.Rename.Title': {
    en: 'Choose name for this printer',
    es: 'Elija un nombre para esta impresora',
    se: 'Välj ett namn för denna skrivare',
    no: 'Velg et navn for denne printeren',
    tr: 'Bu yazıcı için bir ad seçin',
    dk: 'Vælg et navn til denne printer',
  },
  'Settings.Rename.SubmitAndAdd': {
    en: 'Submit and add',
    es: 'Enviar y agregar',
    se: 'Spara och lägg till',
    no: 'Lagre og legg til',
    tr: 'Gönder ve ekle',
    dk: 'Send og tilføj',
  },
  'Settings.AssignStation': {
    en: 'Assign stations',
    es: 'Asignar punto de elaboración',
    se: 'Tilldela stationer',
    no: 'Tildel stasjoner',
    tr: 'İstasyonları ata',
    dk: 'Tildel stationer',
  },
  'Settings.Remove': {
    en: 'Remove',
    es: 'Eliminar',
    se: 'Radera',
    no: 'Fjern',
    tr: 'Kaldır',
    dk: 'Fjerne',
  },
  'Settings.PrinterName': {
    en: 'Printer name',
    es: 'Nombre de la impresora',
    se: 'Skrivarnamn',
    no: 'Printernavn',
    tr: 'Yazıcı adı',
    dk: 'Printerens navn',
  },
  'Settings.AssignStationsToPrinter': {
    en: 'Assign stations to this printer',
    es: 'Asignar puntos de elaboración a esta impresora',
    se: 'Tilldela stationer till denna skrivare',
    no: 'Tildel stasjoner til denne printeren',
    tr: 'İstasyonları bu yazıcıya atayın',
    dk: 'Tildel stationer til denne printer',
  },
  'Settings.AddedPrinters': {
    en: 'Added printers',
    es: 'Impresoras añadidas',
    se: 'Tillagda skrivare',
    no: 'Aktive printere',
    tr: 'Yazıcılar eklendi',
    dk: 'Tilføjede printere',
  },
  'Settings.AddPrinters': {
    en: 'Add printers',
    es: 'Agregar impresoras',
    se: 'Lägg till skrivare',
    no: 'Legg til printere',
    tr: 'Yazıcı ekle',
    dk: 'Tilføj printere',
  },
  'Settings.AddPrinters.Desc': {
    en: 'Click "add" on a printer to add it to this device',
    es: 'Haga clic en "agregar" en una impresora para agregarla a este dispositivo',
    se: 'Klicka på "lägg till" på en skrivare för att lägga till den på denna enhet',
    no: 'Klikk "legg til" på en printer for å legge den til på denne enheten',
    tr: 'Bir yazıcıyı bu cihaza eklemek için "ekle" yi tıklayın',
    dk: 'Klik på "tilføj" på en printer for at tilføje den til denne enhed',
  },
  'Settings.AddPrinters.ScanInfo': {
    en: 'No printers found, press the scan button to search for printers',
    es: 'No se encontraron impresoras, presione el botón de escaneo para buscar impresoras',
    se: 'Inga skrivare hittades, tryck på skanningsknappen för att söka efter skrivare',
    no: 'Ingen printere funnet, trykk på skann-knappen for å søke etter printere',
    tr: 'Yazıcı bulunamadı, yazıcıları aramak için tarama düğmesine basın',
    dk: 'Ingen printere fundet, tryk på scan-knappen for at søge efter printere',
  },
  'Settings.Printers.TroubleInfo': {
    en: 'Unable to find your printer in the list?',
    es: '¿No encuentras tu impresora en la lista?',
    se: 'Kan du inte hitta din skrivare i listan?',
    no: 'Finner du ikke skriveren din i listen?',
    tr: 'Yazıcınızı listede bulamıyor musunuz?',
    dk: 'Kan du ikke finde din printer på listen?',
  },
  'Settings.Printers.TroubleInfo.Button': {
    en: 'Help me',
    es: 'Ayúdame',
    se: 'Hjälp mig',
    no: 'Hjelp meg',
    tr: 'Yardım edin',
    dk: 'Hjælp mig',
  },
  'Settings.Printers.Stations': {
    en: 'Stations',
    es: 'Puntos de elaboración',
    se: 'Stationer',
    no: 'Stasjoner',
    tr: 'İstasyonlar',
    dk: 'Stationer',
  },
  'Settings.Printers.Stations.Title': {
    en: 'Select stations for this printer',
    es: 'Seleccione punto(s) de elaboración para esta impresora',
    se: 'Välj stationer för denna skrivare',
    no: 'Velg stasjoner for denne printeren',
    tr: 'Bu yazıcı için istasyonları seçin',
    dk: 'Vælg stationer til denne printer',
  },
  'Settings.Printers.Stations.None': {
    en: 'No station selected',
    es: 'Ningún punto de elaboración seleccionado',
    se: 'Ingen station vald',
    no: 'Ingen stasjon valgt',
    tr: 'Hiçbir istasyon seçilmedi',
    dk: 'Ingen station valgt',
  },
  'Settings.Printers.NoStationsExist': {
    en:
      'There are no stations created, go into the backoffice and create the stations you want and then assign them here',
    es:
      'No hay estaciones creadas, vaya al backoffice y cree las estaciones que desee y luego asígnelas aquí',
    se:
      'Det finns inga stationer skapade, gå in i backoffice och skapa de stationer du vill och tilldela dem här',
    no:
      'Det er ingen stasjoner opprettet, gå inn i backoffice og opprett de stasjonene du vil og tildel dem her',
    tr:
      'Oluşturulan istasyon yok, backoffice gidin ve istediğiniz istasyonları oluşturun ve ardından buraya atayın',
    dk:
      'Der er ingen stationer oprettet, gå ind i backoffice og opret de stationer, du vil, og tildel dem her',
  },
  'Settings.Printers.Stations.All': {
    en: 'All stations',
    es: 'Todas los puntos de elaboración',
    se: 'Alla stationer',
    no: 'Alle stasjoner',
    tr: 'Tüm istasyonlar',
    dk: 'Alle stationer',
  },
  'Settings.Printers.Toast.Added': {
    en: 'Printer was added',
    es: 'La impresora fue añadida',
    se: 'Skrivaren har lagts till',
    no: 'Printeren ble lagt til',
    tr: 'Yazıcı eklendi',
    dk: 'Printeren blev tilføjet',
  },
  'Settings.Printers.Toast.StationsUpdated': {
    en: 'Stations was updated',
    es: 'Puntos de elaboración actualizados',
    se: 'Stationer har uppdaterats',
    no: 'Stasjoner ble oppdatert',
    tr: 'İstasyonlar güncellendi',
    dk: 'Stationer blev opdateret',
  },
  'Settings.Printers.Toast.NotSaved': {
    en: 'This printer is not saved on the venue',
    es: 'Esta impresora no está guardada en el local',
    se: 'Denna skrivare är inte sparad',
    no: 'Denne printeren er ikke lagret',
    tr: 'Bu yazıcı mekanda kaydedilmedi',
    dk: 'Denne printer er ikke gemt på stedet',
  },
  'Settings.Printers.Toast.Test': {
    en: 'Sending test print',
    es: 'Enviando impresión de prueba',
    se: 'Skickar testutskrift',
    no: 'Sender testutskrift',
    tr: 'Test baskı gönderiliyor',
    dk: 'Sender test print',
  },
  'Settings.Printers.Toast.NoInternet': {
    en: 'Internet connection issues',
    es: 'Problemas de conexión a internet',
    se: 'Internetanslutningsproblem',
    no: 'Internettforbindelsesproblemer',
    tr: 'İnternet bağlantı sorunları',
    dk: 'Internetforbindelsesproblemer',
  },
  'Settings.Printers.Toast.PrinterUpdated': {
    en: 'Printer updated',
    es: 'Impresora actualizada',
    se: 'Testutskrift skickad',
    no: 'Testutskrift sendt',
    tr: 'Test baskı gönderildi',
    dk: 'Test print sendt',
  },
  'Settings.Printers.Toast.TryingReconnect': {
    en: 'Trying reconnect... try test print again after a few seconds',
    es:
      'Intentando reconectar... intente la impresión de prueba nuevamente después de unos segundos',
    se: 'Försöker ansluta igen... försök testutskrift igen efter några sekunder',
    no: 'Prøver å koble til igjen... prøv testutskrift igjen etter noen sekunder',
    tr: 'Yeniden bağlanmaya çalışılıyor... birkaç saniye sonra tekrar test baskı yapmayı deneyin',
    dk: 'Prøver at genoprette forbindelsen... prøv test print igen efter et par sekunder',
  },
  'Settings.AvailablePrinters': {
    en: 'Available printers',
    es: 'Impresoras disponibles',
    se: 'Tillgängliga skrivare',
    no: 'Tilgjengelige printere',
    tr: 'Mevcut yazıcılar',
    dk: 'Tilgængelige printere',
  },
  'Settings.ScanForPrinters': {
    en: 'Scan for printers',
    es: 'Buscar impresoras',
    se: 'Sök efter skrivare',
    no: 'Søk etter printere',
    tr: 'Yazıcıları tarayın',
    dk: 'Scan efter printere',
  },
  'Settings.Scanning.Dots': {
    en: 'Scanning...',
    es: 'Escaneando...',
    se: 'Skannar...',
    no: 'Scanner...',
    tr: 'Tarama...',
    dk: 'Scanner...',
  },
  'Settings.TestAllPrinters': {
    en: 'Test all printers',
    es: 'Probar todas las impresoras',
    se: 'Testa alla skrivare',
    no: 'Test alle printere',
    tr: 'Tüm yazıcıları test et',
    dk: 'Test alle printere',
  },
  'Settings.Online': {
    en: 'Online',
    es: 'En línea',
    se: 'Online',
    no: 'Online',
    tr: 'Çevrimiçi',
    dk: 'Online',
  },
  'Settings.NotResponding': {
    en: 'Not responding',
    es: 'No responde',
    se: 'Svarar inte',
    no: 'Svarer ikke',
    tr: 'Cevap vermiyor',
    dk: 'Svarer ikke',
  },
  'Settings.Printers.AddedAt': {
    en: 'Added at',
    es: 'Añadido en',
    se: 'Tillagd',
    no: 'Lagt til',
    tr: 'Eklenme tarihi:',
    dk: 'Tilføjet til',
  },
  'Settings.Printers.Model': {
    en: 'Model',
    es: 'Modelo',
    se: 'Model',
    no: 'Modell',
    tr: 'Model',
    dk: 'Model',
  },
  'Settings.Printers.Address': {
    en: 'Address',
    es: 'Dirección',
    se: 'Adress',
    no: 'Adresse',
    tr: 'Adres',
    dk: 'Adresse',
  },
  'Settings.Printers.Name': {
    en: 'Name',
    es: 'Nombre',
    se: 'Namn',
    no: 'Navn',
    tr: 'İsim',
    dk: 'Navn',
  },
  'Settings.Printers.Primary': {
    en: 'Primary receipt printer',
    es: 'Impresora de tickets principal',
    se: 'Primär kvittoskrivare',
    no: 'Primær kvitteringsskriver',
    tr: 'Birincil makbuz yazıcısı',
    dk: 'Primær kvitteringsprinter',
  },
  'Settings.Printers.NoAdded': {
    en: 'No printers added',
    es: 'No se agregaron impresoras',
    se: 'Inga skrivare tillagda',
    no: 'Ingen printere lagt til',
    tr: 'Hiçbir yazıcı eklenmedi',
    dk: 'Ingen printere tilføjet',
  },
  'Settings.Printers.StartScan': {
    en: 'Start scan',
    es: 'Iniciar escaneo',
    se: 'Starta skanning',
    no: 'Søk etter tilgjengelige printere',
    tr: 'Taramayı başlat',
    dk: 'Start scanning',
  },
  'Settings.Printers.NoAvailable': {
    en: 'No printers available',
    es: 'No hay impresoras disponibles',
    se: 'Inga skrivare tillgängliga',
    no: 'Ingen printere tilgjengelig',
    tr: 'Kullanılabilir yazıcı yok',
    dk: 'Ingen printere tilgængelige',
  },
  'Settings.Printers.StoredPrinters': {
    en: 'Stored printers',
    es: 'Impresoras almacenadas',
    se: 'Sparade skrivare',
    no: 'Lagrede printere',
    tr: 'Depolanan yazıcılar',
    dk: 'Gemte printere',
  },
  'Settings.Printers.StoredPrinters.Text': {
    en: 'See all previously saved printers on this venue',
    es: 'Ver todas las impresoras guardadas anteriormente en este local',
    se: 'Se alla tidigare sparade skrivare på denna restaurang',
    no: 'Se alle tidligere lagrede printere på denne restauranten',
    tr: 'Bu mekanda daha önce kaydedilen tüm yazıcıları görün',
    dk: 'Se alle tidligere gemte printere på dette sted',
  },
  'Settings.TestPrinters': {
    en: 'Test printers',
    es: 'Impresoras de prueba',
    se: 'Testa skrivare',
    no: 'Test printere',
    tr: 'Yazıcıları test edin',
    dk: 'Test printere',
  },
  'Settings.TestPrinters.Text': {
    en: 'Prints station categories and articles on all printers',
    es: 'Imprime categorías de estaciones y artículos en todas las impresoras',
    se: 'Skriver ut stationskategorier och artiklar på alla skrivare',
    no: 'Skriver ut stasjonskategorier og artikler på alle printere',
    tr: 'İstasyon kategorilerini ve ürünleri tüm yazıcılarda yazdır',
    dk: 'Udskriver stationskategorier og artikler på alle printere',
  },
  'Settings.ConfigurePrinter': {
    en: 'Configure printer',
    es: 'Configurar impresora',
    se: 'Konfigurera skrivare',
    no: 'Konfigurer printer',
    tr: 'Yazıcıyı yapılandır',
    dk: 'Konfigurer printer',
  },
  'Settings.AddPrinter': {
    en: 'Add',
    es: 'Agregar',
    se: 'Lägg till',
    no: 'Legg til',
    tr: 'Ekle',
    dk: 'Tilføj',
  },
  'Settings.NewPrinter': {
    en: 'NEW',
    es: 'NUEVO',
    se: 'NY',
    no: 'NY',
    tr: 'Yeni',
    dk: 'NY',
  },
  'Settings.Station.NrOfItems': {
    en: (count: number) => (count === 1 ? 'article' : 'articles'),
    es: (count: number) => (count === 1 ? 'artículo' : 'artículos'),
    se: (count: number) => (count === 1 ? 'artikel' : 'artiklar'),
    no: (count: number) => (count === 1 ? 'artikkel' : 'artikler'),
    tr: (count: number) => (count === 1 ? 'makale' : 'makaleler'),
    dk: (count: number) => (count === 1 ? 'artikel' : 'artikler'),
  },
  'Settings.Station.NrOfCategories': {
    en: (count: number) => (count == 1 ? 'category' : 'categories'),
    es: (count: number) => (count == 1 ? 'categoría' : 'categorías'),
    se: (count: number) => (count == 1 ? 'kategori' : 'kategorier'),
    no: (count: number) => (count == 1 ? 'kategori' : 'kategorier'),
    tr: (count: number) => (count == 1 ? 'kategori' : 'kategoriler'),
    dk: (count: number) => (count == 1 ? 'kategori' : 'kategorier'),
  },
  'Settings.NotAllowed': {
    en: 'Not allowed',
    es: 'No permitido',
    se: 'Ej tillåtet',
    no: 'Ikke tillatt',
    tr: 'İzin verilmedi',
    dk: 'Ikke tilladt',
  },
  'Settings.Claimed': {
    en: 'CLAIMED',
    es: 'RECLAMADO',
    se: 'UPPTAGEN',
    no: 'OPPTATT',
    tr: 'Talep edildi',
    dk: 'PÅKRÆVET',
  },
  'Settings.Claim': {
    en: 'Claim',
    es: 'Reclamar',
    se: 'Använd denna',
    no: 'Bruk denne',
    tr: 'Talep',
    dk: 'Påstand',
  },
  'Settings.APP.AutoAccept': {
    en: 'Auto accept app orders',
    es: 'Aceptar automáticamente los pedidos de aplicaciones',
    se: 'Autoacceptera app-ordrar',
    no: 'Auto-aksepter app-bestillinger',
    tr: 'Uygulama siparişlerini otomatik olarak kabul et',
    dk: 'Accepter automatisk app-ordrer',
  },
  'Settings.APP.AutoAccept.Text': {
    en:
      'All incoming app orders will be automatically accepted. Note: You will not be able to deny an order with this setting.',
    es:
      'Todos los pedidos de aplicaciones entrantes se aceptarán automáticamente. Nota: No podrá denegar un pedido con esta configuración',
    se:
      'Alla inkommande app-ordrar kommer att accepteras automatiskt. OBS: Du kommer ej kunna neka en order med denna inställning aktiverad.',
    no:
      'Alle innkommende app-bestillinger blir automatisk akseptert. OBS: Du kan ikke avvise en bestilling når denne innstillingen er aktivert.',
    tr:
      'Gelen tüm uygulama siparişleri otomatik olarak kabul edilecektir. Not: Bu ayarla bir siparişi reddedemezsiniz.',
    dk:
      'Alle indkommende app-ordrer vil automatisk blive accepteret. Bemærk: Du vil ikke være i stand til at afvise en ordre med denne indstilling.',
  },
  'Settings.APP.ShowIncomingAppOrders': {
    en: 'Show incoming online orders',
    es: 'Mostrar pedidos en línea entrantes',
    se: 'Visa inkommande onlinebeställningar',
    no: 'Vis innkommende nettbestillinger',
    tr: 'Gelen çevrimiçi siparişleri göster',
    dk: 'Vis indkommende onlineordrer',
  },
  'Settings.APP.ShowIncomingAppOrders.Text': {
    en: 'Shows a flashing online order indicator',
    es: 'Muestra un indicador de pedido en línea parpadeante',
    se: 'Visar en blinkande onlinebeställningsindikator',
    no: 'Viser en blinkende nettbestillingsindikator',
    tr: 'Parlayan çevrimiçi sipariş göstergesi gösterir',
    dk: 'Viser en blinkende online bestillingsindikator',
  },
  'Settings.APP.AutoShowOnlinePopup': {
    en: 'Show incoming online orders popup instantly',
    es: 'Mostrar instantáneamente la ventana emergente de pedidos en línea entrantes',
    se: 'Visa popup för inkommande onlinebeställningar direkt',
    no: 'Vis popup for innkommende nettbestillinger umiddelbart',
    tr: 'Gelen çevrimiçi siparişler için açılır pencereyi anında göster',
    dk: 'Vis straks popup for indkommende onlineordrer',
  },
  'Settings.APP.AutoShowOnlinePopup.Text': {
    en: 'As soon as there are online orders to handle, automatically show the popup',
    es:
      'Tan pronto como haya pedidos en línea para gestionar, muestra automáticamente la ventana emergente',
    se: 'Så snart det finns onlinebeställningar att hantera, visa popup-fönstret automatiskt',
    no: 'Så snart det er nettbestillinger å håndtere, vis popup automatisk',
    tr: 'İşlenecek çevrimiçi siparişler olduğunda, açılır pencereyi otomatik olarak göster',
    dk: 'Så snart der er onlineordrer at håndtere, vis automatisk popup-vinduet',
  },
  'Settings.KDS.ShowBottomBar': {
    en: 'Show bottom bar',
    es: 'Mostrar barra inferior',
    se: 'Visa nedre raden',
    no: 'Vis informasjonsrad nederst',
    tr: 'Alt çubuğu göster',
    dk: 'Vis nederste bjælke',
  },
  'Settings.KDS.ShowBottomBar.Text': {
    en: 'Note: Disabling this will hide the bottom bar which contains name and order origin',
    es:
      'Nota: Al deshabilitar esto, se ocultará la barra inferior que contiene el nombre y el origen del pedido.',
    se: 'Obs: Om du inaktiverar detta döljs den nedre raden som innehåller namn och orderursprung',
    no: 'Vis informasjonsrad nederst på bestillingene, som viser navn og bestillingskanal',
    tr: 'Not: Bunu devre dışı bırakmak, adı ve sipariş kaynağını içeren alt çubuğu gizleyecektir',
    dk:
      'Bemærk: Deaktivering af dette vil skjule den nederste bjælke, som indeholder navn og ordreoprindelse',
  },
  'KDS.CurrentOrders': {
    en: 'Current',
    es: 'Actual',
    se: 'Aktuella',
    no: 'Nåværende',
    tr: 'Mevcut',
    dk: 'Aktuelle',
  },
  'KDS.NoItems': {
    en: 'No items',
    es: 'Sin artículos',
    se: 'Inga artiklar',
    no: 'Ingen varer',
    tr: 'Öğe yok',
    dk: 'Ingen varer',
  },
  'KDS.Upcoming': {
    en: 'Upcoming',
    es: 'Próximos',
    se: 'Kommande',
    no: 'Kommende',
    tr: 'Yaklaşan',
    dk: 'Kommende',
  },
  'KDS.OtherStations': {
    en: 'Other stations',
    es: 'Otras estaciones',
    se: 'Andra stationer',
    no: 'Andre stasjoner',
    tr: 'Diğer istasyonlar',
    dk: 'Andre stationer',
  },
  'Settings.KDS.ShowETA': {
    en: 'Show countdown timer for orders with a pick-up time',
    es: 'Mostrar temporizador de cuenta regresiva para pedidos con hora de recogida',
    se: 'Visa nedräkningstimer för beställningar med upphämtningstid',
    no: 'Vis nedtellingstimer for bestillinger med hentetid',
    tr: 'Alış saati olan siparişler için geri sayım sayacını göster',
    dk: 'Vis nedtællingstimer for ordrer med afhentningstid',
  },
  'Settings.KDS.ShowETA.Text': {
    en:
      'Note: Disabling this will hide the countdown timer for orders with a pick-up time and replace it with the ETA timer',
    es:
      'Nota: Deshabilitar esto ocultará el temporizador de cuenta regresiva para pedidos con hora de recogida y lo reemplazará con el temporizador ETA',
    se:
      'Obs: Om du inaktiverar detta döljs nedräkningen för beställningar med upphämtningstid och ersätts med ETA-timern',
    no:
      'Obs: Deaktivering av dette vil skjule nedtellingstimeren for bestillinger med hentetid og erstatte den med ETA-timeren',
    tr:
      'Not: Bunu devre dışı bırakmak, alış saati olan siparişler için geri sayım sayacını gizler ve ETA sayacı ile değiştirir',
    dk:
      'Bemærk: Deaktivering af dette vil skjule nedtællingstimeren for ordrer med afhentningstid og erstatte den med ETA-timeren',
  },
  'Settings.KDS.Lite': {
    en: 'Minimal KDS mode',
    es: 'Modo KDS mínimo',
    se: 'Minimalt KDS-läge',
    no: 'Minimal KDS-modus',
    tr: 'Minimal KDS modu',
    dk: 'Minimal KDS-tilstand',
  },
  'Settings.KDS.Lite.Text': {
    en:
      'Orders will be shown in columns; Accepted, Ready. Recommended to use together with printed tickets.',
    es:
      'Los pedidos se mostrarán en columnas; Aceptado, Listo. Se recomienda usarlo junto con los tickets impresos.',
    se:
      'Beställningar visas i kolumner; Accepterad, Redo. Rekommenderas att använda tillsammans med utskrivna bongar.',
    no:
      'Bestillinger vises i kolonner; Akseptert, Klar. Anbefales å bruke sammen med utskrevne bonger.',
    tr:
      'Siparişler sütunlarda gösterilecektir; Kabul edildi, Hazır. Yazdırılmış biletlerle birlikte kullanılması önerilir.',
    dk:
      'Ordrer vises i kolonner; Accepteret, Klar. Anbefales at bruge sammen med udskrevne bonger.',
  },
  'Settings.KDS.ChooseLayout': {
    en: 'Choose layout',
    es: 'Elegir diseño',
    se: 'Välj layout',
    no: 'Velg layout',
    tr: 'Düzeni seç',
    dk: 'Vælg layout',
  },
  'Settings.KDS.ChooseLayout.Text': {
    en:
      'Choose a compact view or a grid view. The grid view will create extra space between orders',
    es:
      'Elija una vista compacta o una vista de cuadrícula. La vista de cuadrícula creará espacio adicional entre los pedidos',
    se: 'Välj en kompakt vy eller en rutnätsvy. Rutnätsvyn skapar extra utrymme mellan order',
    no:
      'Velg en kompakt visning eller et rutenett. Rutenettet vil skape ekstra plass mellom bestillinger',
    tr:
      'Kompakt bir görünüm veya ızgara görünümü seçin. Izgara görünümü siparişler arasında ekstra alan yaratacaktır',
    dk:
      'Vælg en kompakt visning eller et gittervisning. Gittervisningen vil skabe ekstra plads mellem ordrer',
  },
  'Settings.KDS.ChooseLayout.Compact': {
    en: 'Compact',
    es: 'Compacto',
    se: 'Kompakt',
    no: 'Kompakt',
    tr: 'Kompakt',
    dk: 'Kompakt',
  },
  'Settings.KDS.ChooseLayout.Grid': {
    en: 'Grid',
    es: 'Cuadrícula',
    se: 'Rutnät',
    no: 'Rutenett',
    tr: 'Izgara',
    dk: 'Gitter',
  },
  'Settings.KDS.FiveColumns': {
    en: 'Show five columns',
    es: 'Mostrar cinco columnas',
    se: 'Visa fem kolumner',
    no: 'Vis 5 kolonner',
    tr: 'Beş sütun göster',
    dk: 'Vis fem kolonner',
  },
  'Settings.KDS.FiveColumns.Text': {
    en: 'Note: Disabling this will default to four columns',
    es: 'Nota: Al deshabilitar esto, se establecerán cuatro columnas de forma predeterminada.',
    se: 'Obs! Om du inaktiverar detta kommer fyra kolumner som standard att användas',
    no: 'Vis fem kolonner i stedet for standarden på fire',
    tr: 'Not: Bunu devre dışı bırakmak varsayılan olarak dört sütuna dönüşür',
    dk: 'Bemærk: Deaktivering af dette vil som standard have fire kolonner',
  },
  'Settings.KDS.MarkAddedVariationsGreen': {
    en: 'Highlight added variations in green',
    es: 'Resaltar variaciones agregadas en verde',
    se: 'Markera tillagda tillval i grönt',
    no: 'Marker tilleggsvalg i grønt',
    tr: 'Eklenen varyasyonları yeşil renkle vurgulayın',
    dk: 'Fremhæv tilføjede variationer med grønt',
  },
  'Settings.KDS.MarkAddedVariationsGreen.Text': {
    en: 'Variations not preselected will be marked in green with a ‘+’ prefix',
    es: 'Las variaciones no preseleccionadas se marcarán en verde con un prefijo "+"',
    se: 'Tillval som inte är förvalda markeras i grönt med ett "+"-prefix',
    no: 'Tilleggsvalg som ikke er forhåndsvalgt, markeres i grønt med et "+"-prefiks',
    tr: 'Önceden seçilmemiş varyasyonlar, başında "+" öneki ile yeşil renkle işaretlenecektir',
    dk: 'Variationer, der ikke er forudvalgt, markeres med grønt med et "+"-præfiks',
  },
  'Settings.KDS.TripleProgress': {
    en: 'Triple progress',
    es: 'Habilitar progreso triple',
    se: 'Trippel-progress',
    no: 'Hurtigfullføring',
    tr: 'Üçlü ilerleme',
    dk: 'Tredobbelt fremskridt',
  },
  'Settings.KDS.TripleProgress.Text': {
    en:
      'When an order or item is clicked, it will skip straight to completed and disappear from the KDS',
    es:
      'Cuando se hace clic en un pedido o artículo, se saltará directamente a completado y desaparecerá de la KDS',
    se:
      'När en order eller artikel klickas på, hoppar den direkt till färdig och försvinner från KDS:en',
    no:
      'Når en ordre eller artikkel trykkes på, går den direkte til "Ferdig" og forsvinner fra kjøkkenskjermen',
    tr:
      "Bir siparişe veya ürüne tıklandığında, doğrudan tamamlanmış aşamasına atlayacak ve KDS'den kaybolacaktır.",
    dk:
      'Når der klikkes på en ordre eller vare, springer den direkte over til fuldført og forsvinder fra KDS',
  },
  'Settings.KDS.DisableFullOrderProgress': {
    en: 'Order progress',
    es: 'Habilitar progreso de pedido',
    se: 'Order-progress',
    no: 'Ordre-fremgang',
    tr: 'Sipariş ilerlemesi',
    dk: 'Ordreforløb',
  },
  'Settings.KDS.DisableItemProgress': {
    en: 'Item progress',
    es: 'Habilitar progreso de artículo',
    se: 'Artikel-progress',
    no: 'Artikkel-fremgang',
    tr: 'Ürün ilerlemesi',
    dk: 'Varefremskridt',
  },
  'Settings.KDS.DisableItemProgress.Text': {
    en: 'Click on an item to advance that individual item to the next status',
    es: 'Haga clic en un artículo para avanzar ese artículo individual al siguiente estado',
    se: 'Klicka på en artikel för att skicka vidare den individuella artikeln till nästa status',
    no: 'Klikk på én individuell artikkel for å sende den videre til neste status',
    tr: 'Bir ürünü bir sonraki duruma ilerletmek için ürüne tıklayın',
    dk: 'Klik på et element for at flytte det enkelte element til den næste status',
  },
  'Settings.KDS.DisableFullOrderProgress.Text': {
    en: 'Click on an order header to advance the full order',
    es: 'Haga clic en un encabezado de pedido para avanzar el pedido',
    se: 'Klicka på en orderrubrik för att gå vidare med hela ordern',
    no: 'Klikk på en ordreoverskrift for sende hele ordren videre til neste status',
    tr: 'Siparişin tamamını ilerletmek için sipariş başlığına tıklayın',
    dk: 'Klik på en ordreoverskrift for at fremføre hele ordren',
  },
  'Settings.KDS.ShowAllOrderStatuses': {
    en: 'Show all order statuses',
    es: 'Mostrar todos los estados de pedido',
    se: 'Visa alla orderstatusar',
    no: 'Vis alle ordrestatuser',
    tr: 'Tüm sipariş durumlarını göster',
    dk: 'Vis alle ordrestatusser',
  },
  'Settings.KDS.ShowAllOrderStatuses.Text': {
    en:
      'All order statuses will be shown, even if they are not in the station filter, but only the filtered ones can be progressed',
    es:
      'Se mostrarán todos los estados de pedido, incluso si no están en el filtro de punto de elaboración, pero solo se pueden avanzar los filtrados',
    se:
      'Alla order statusar kommer visas oavsett stationsfilter, men enbart de filtrerade kan skickas vidare',
    no:
      'Alle ordrestatuser vises, uansett stasjonsfilter - men kun de filtrerte kan sendes videre',
    tr:
      'İstasyon filtresinde olmasa bile tüm sipariş durumları gösterilecek, ancak yalnızca filtrelenenlere ilerlenebilecek',
    dk:
      'Alle ordrestatusser vil blive vist, selvom de ikke er i stationsfilteret, men kun de filtrerede kan videreføres',
  },
  'Settings.KDS.PlaySound': {
    en: 'Play Sound on new order',
    es: 'Reproducir sonido en nuevo pedido',
    se: 'Spela ljud vid ny order',
    no: 'Spill av lyd ved nye ordre',
    tr: 'Yeni siparişte Ses Gelsin',
    dk: 'Afspil lyd på ny ordre',
  },
  'Settings.KDS.PlaySound.Text': {
    en: 'Make a sound when a new order is received. Note: This will only work if the KDS is open',
    es:
      'Haga un sonido cuando se recibe un nuevo pedido. Nota: esto solo funcionará si el KDS está abierto',
    se:
      'Gör ett ljud när en ny order tas emot. Obs: Detta kommer bara att fungera om KDS:en är öppen',
    no:
      'Spiller av en lyd når ny ordre kommer inn. Obs: Denne funksjonen fungerer kun når kjøkkenskjermen er åpen',
    tr: 'Yeni bir sipariş alındığında ses çıkar. Not: Bu yalnızca KDS açıksa işe yarar',
    dk: 'Giv en lyd, når en ny ordre modtages. Bemærk: Dette virker kun, hvis KDS er åben',
  },
  'Settings.KDS.ProgressOnlyFiltered': {
    en: 'Progress only visible items',
    es: 'Avanzar solo artículos visibles',
    se: 'Progressa endast synliga artiklar',
    no: 'Send kun synlige artikler videre',
    tr: 'Yalnızca görünür ürünlerde ilerleme',
    dk: 'Fremskrid kun synlige elementer',
  },
  'Settings.KDS.ProgressOnlyFiltered.Text': {
    en:
      'Only the items that are visible will be progressed, even if the order has other items that are not visible because of filtering',
    es:
      'Solo se avanzarán los artículos que son visibles, incluso si el pedido tiene otros artículos que no son visibles a través del filtro',
    se:
      'Endast de artiklar som är synliga kommer att skickas vidare, även om ordern har andra artiklar som inte är synliga på grund av filter',
    no:
      'Kun artikler som er synlige kommer til å sendes videre, selv om ordren har andre artikler som ikke er synlige på grunn av filtrering',
    tr:
      'Siparişte filtreleme nedeniyle görünmeyen başka öğeler olsa bile, yalnızca görünür olan öğeler ilerletilecektir',
    dk:
      'Kun de elementer, der er synlige, vil blive videreført, selvom ordren har andre varer, der ikke er synlige på grund af filtrering',
  },
  'Settings.KDS.BongOnProgress': {
    en: 'Print physical ticket when progressing an order',
    es: 'Imprimir ticket físico al avanzar un pedido',
    se: 'Skriv ut fysisk bong varje gång du skickar vidare en order',
    no: 'Skriv ut fysisk bong når du sender videre en ordre',
    tr: 'Bir siparişi ilerletirken fiziksel bilet yazdırın',
    dk: 'Udskriv fysisk billet, når du fortsætter en ordre',
  },
  'Settings.KDS.BongOnProgress.Text': {
    en:
      'Note: This will only work if you have a physical ticket printer connected to the KDS. IMPORTANT! This will also disable regular ticket prints for this device.',
    es:
      'Nota: Esto solo funcionará si tiene una impresora de comandas física conectada al KDS. ¡IMPORTANTE! Esto también deshabilitará las impresiones regulares de comandas para este dispositivo.',
    se:
      'Obs! Detta fungerar endast om du har en fysisk bongskrivare ansluten till KDS:en. VIKTIGT! Detta kommer också att inaktivera vanliga bongutskrifter för den här skärmen.',
    no:
      'Dette fungerer kun når du har en fysisk bongprinter koblet til kjøkkenskjermen. NB: Dette kommer også til å deaktivere vanlige bongutskrifter for denne POS-enheten.',
    tr:
      "Not: Bu yalnızca KDS'ye bağlı fiziksel bir bilet yazıcınız varsa işe yarar. ÖNEMLİ! Bu aynı zamanda bu cihaz için normal bilet yazdırma işlemlerini de devre dışı bırakacaktır.",
    dk:
      'Bemærk: Dette vil kun fungere, hvis du har en fysisk billetprinter tilsluttet til KDS. VIGTIG! Dette vil også deaktivere almindelige billetudskrifter for denne enhed.',
  },
  'Settings.KDS.BongOnReady.Text': {
    en: 'Print physical ticket an order is ready (green)',
    es: 'Imprimir ticket físico cuando un pedido está listo (verde)',
    se: 'Skriv ut fysisk bong när en order är klar (grön)',
    no: 'Skriv ut fysisk bong når en ordre er klar (grønn)',
    tr: 'Fiziksel bileti yazdır, sipariş hazır (yeşil)',
    dk: 'Udskriv fysisk billet, en ordre er klar (grøn)',
  },
  'Settings.KDS.BongOnReady': {
    en: 'Print on ready/green status',
    es: 'Imprimir en listo',
    se: 'Bonga vid grön status',
    no: 'Skriv ut på klar/grønn status',
    tr: 'Hazır/yeşil durumda yazdır',
    dk: 'Udskriv på klar/grøn status',
  },
  'Settings.KDS.BongOnItemProgress': {
    en: 'Print physical ticket when progressing an individual article',
    es: 'Imprimir ticket físico al avanzar un artículo individual',
    se: 'Skriv ut fysisk bong när en enskild artikel skickas vidare',
    no: 'Skriv ut fysisk bong når du sender videre en individuell artikkel',
    tr: 'Bireysel bir ürünü ilerletirken fiziksel bilet yazdırın',
    dk: 'Udskriv fysisk billet, når du fortsætter en individuel artikel',
  },
  'Settings.KDS.BongOnItemProgress.Text': {
    en:
      'When enabled, tapping an individual article to progress it will print a physical ticket with only that article. This setting works independently from the full order bonging settings.',
    es:
      'Cuando está habilitado, al tocar un artículo individual para avanzarlo se imprimirá una comanda física con solo ese artículo. Esta configuración funciona independientemente de la configuración de comanda de pedido completo.',
    se:
      'När denna inställning är aktiverad kommer ett tryck på en enskild artikel för att skicka den vidare att skriva ut en fysisk bong med endast den artikeln. Denna inställning fungerar oberoende av inställningarna för fullständig orderbonging.',
    no:
      'Når dette er aktivert, vil trykk på en individuell artikkel for å sende den videre skrive ut en fysisk bong med bare den artikkelen. Denne innstillingen fungerer uavhengig av innstillingene for full ordrebonging.',
    tr:
      'Etkinleştirildiğinde, ilerlemek için bireysel bir ürüne dokunmak yalnızca o ürünü içeren fiziksel bir bilet yazdıracaktır. Bu ayar, tam sipariş yazdırma ayarlarından bağımsız olarak çalışır.',
    dk:
      'Når aktiveret, vil tryk på en individuel artikel for at fortsætte den udskrive en fysisk billet med kun den artikel. Denne indstilling fungerer uafhængigt af indstillingerne for fuld ordrebonning.',
  },
  'Settings.KDS.ShowOrderStatusInTSR': {
    en: 'Show KDS order status in TSR',
    es: 'Mostrar estado del pedido KDS en TSR',
    se: 'Visa KDS orderstatus i TSR',
    no: 'Vis KDS-ordrestatus på bordkartet',
    tr: "TSR'de KDS sipariş durumunu göster",
    dk: 'Vis KDS ordrestatus i TSR',
  },
  'Settings.KDS.ShowOrderStatusInTSR.Text': {
    en: 'Show an orders KDS status on its corresponding table in the TSR tables view.',
    es:
      'Muestra el estado KDS de los pedidos en su mesa correspondiente en la vista de mesas de TSR.',
    se: 'Visa en orders KDS status på dess motsvarande bord i TSR:ens bordvy.',
    no: 'Viser bestillingens ordrestatus på det grafiske bordkartet i POS',
    tr: 'TSR tabloları görünümündeki ilgili tabloda bir siparişin KDS durumunu gösterin.',
    dk: 'Vis en ordres KDS-status på dens tilsvarende tabel i visningen TSR-tabeller.',
  },
  'Settings.KDS.GroupItemsByCourseType': {
    en: 'Group articles by course type',
    es: 'Agrupar elementos por tipo de curso',
    se: 'Gruppera artiklar efter rätt-typ',
    no: 'Grupper artikler etter rett',
    tr: 'Ürünleri korslara göre gruplandır',
    dk: 'Gruppér artikler efter kursustype',
  },
  'Settings.KDS.GroupItemsByCourseType.Text': {
    en: 'Display KDS order items grouped by course type',
    es: 'Mostrar elementos de pedido de KDS agrupados por tipo de curso',
    se: 'Visa KDS-beställningsartiklar grupperade efter rätt-typ',
    no: 'Vis KDS-bestillingselementer gruppert etter rett',
    tr: 'Kors türüne göre gruplandırılmış KDS sipariş öğelerini görüntüleyin',
    dk: 'Vis KDS-ordreelementer grupperet efter kursustype',
  },
  'Settings.KDS.CourseOrdersMode': {
    en: 'Create one KDS order per course',
    es: 'Crear un pedido KDS por curso',
    se: 'Skapa en KDS-order per rätt',
    no: 'Opprett én KDS-bestilling per rett',
    tr: 'Her kurs için bir KDS siparişi oluştur',
    dk: 'Opret én KDS-ordre pr. ret',
  },
  'Settings.KDS.CourseOrdersMode.Text': {
    en:
      'When enabled, KDS creates separate orders per course and keeps later courses as upcoming until fired.',
    es:
      'Cuando está activado, KDS crea pedidos separados por curso y mantiene los cursos posteriores como próximos hasta que se lancen.',
    se:
      'När detta är aktiverat skapar KDS separata ordrar per rätt och håller senare rätter som kommande tills de fyras av.',
    no:
      'Når dette er aktivert, oppretter KDS separate bestillinger per rett og holder senere retter som kommende til de fyres av.',
    tr:
      'Etkinleştirildiğinde KDS her kurs için ayrı siparişler oluşturur ve sonraki kursları ateşlenene kadar yaklaşan olarak tutar.',
    dk:
      'Når dette er aktiveret, opretter KDS separate ordrer pr. ret og holder senere retter som kommende, indtil de fyres af.',
  },
  'Settings.KDS.HoldFirstCourse': {
    en: 'Hold first course',
    es: 'Retener primer curso',
    se: 'Håll första rätten',
    no: 'Hold første rett',
    tr: 'İlk kursu beklet',
    dk: 'Hold første ret',
  },
  'Settings.KDS.HoldFirstCourse.Text': {
    en:
      'When enabled, the first course is also created as upcoming instead of firing immediately.',
    es:
      'Cuando está activado, el primer curso también se crea como próximo en lugar de lanzarse inmediatamente.',
    se:
      'När detta är aktiverat skapas även första rätten som kommande istället för att fyras av direkt.',
    no:
      'Når dette er aktivert, opprettes også første rett som kommende i stedet for å fyres av med en gang.',
    tr: 'Etkinleştirildiğinde ilk kurs da hemen ateşlenmek yerine yaklaşan olarak oluşturulur.',
    dk:
      'Når dette er aktiveret, oprettes den første ret også som kommende i stedet for at blive fyret af med det samme.',
  },
  'Settings.KDS.HideOrderHeader': {
    en: 'Hide order header',
    es: 'Ocultar cabecera del pedido',
    se: 'Dölj orderhuvud',
    no: 'Skjul ordrehode',
    tr: 'Sipariş başlığını gizle',
    dk: 'Skjul ordrehoved',
  },
  'Settings.KDS.HideOrderHeader.Text': {
    en:
      'Hide the order header and top status bar. Shows the order name/title inline instead of service type.',
    es:
      'Oculta la cabecera del pedido y la barra de estado superior. Muestra el nombre/título del pedido en línea en lugar del tipo de servicio.',
    se:
      'Döljer orderhuvudet och den översta statusraden. Visar ordernamn/titel inline istället för serveringstyp.',
    no:
      'Skjuler ordrehodet og den øverste statuslinjen. Viser ordrenavn/tittel inline i stedet for servicetype.',
    tr:
      'Sipariş başlığını ve üst durum çubuğunu gizler. Servis türü yerine sipariş adını/başlığını satır içinde gösterir.',
    dk:
      'Skjuler ordrehovedet og den øverste statuslinje. Viser ordrenavn/titel inline i stedet for servicetype.',
  },
  'Settings.KDS.SummaryPanel': {
    en: 'Summary panel',
    es: 'Panel de resumen',
    se: 'Sammanfattningspanel',
    no: 'Sammendragspanel',
    tr: 'Özet paneli',
    dk: 'Opsummeringspanel',
  },
  'Settings.KDS.SummaryPanel.Text': {
    en: 'Show a right-side summary panel with current, other-station, and upcoming item totals.',
    es: 'Muestra un panel lateral derecho con totales actuales, de otras estaciones y próximos.',
    se:
      'Visa en sammanfattningspanel till höger med aktuella, andra stationers och kommande artikeltotaler.',
    no:
      'Vis et sammendragsfelt til høyre med totale varer for nåværende, andre stasjoner og kommende.',
    tr:
      'Geçerli, diğer istasyonlar ve yaklaşan ürün toplamlarını gösteren sağ taraflı bir özet paneli göster.',
    dk:
      'Vis et højresidet opsummeringspanel med aktuelle, andre stationers og kommende varetotaler.',
  },
  'Settings.KDS.OrderStatusFilter': {
    en: 'Show items with matching order status',
    es: 'Mostrar artículos con estado de pedido coincidente',
    se: 'Visa artiklar med matchande orderstatus',
    no: 'Vis artikler med matchende ordrestatus',
    tr: 'Eşleşen sipariş durumuna sahip ürünleri göster',
    dk: 'Vis varer med matchende ordrestatus',
  },
  'Settings.KDS.OrderStatusFilter.Text': {
    en:
      'Show items with order status matching the station, even if the order still has other items in an earlier status.',
    es:
      'Mostrar artículos con estado de pedido que coincida con el punto de elaboración, incluso si el pedido todavía tiene otros artículos en un estado anterior.',
    se:
      'Visa artiklar med orderstatus som matchar stationen, även om ordern fortfarande har andra artiklar i en tidigare status.',
    no:
      'Vis artikler med ordrestatus som matcher stasjonen, selv om ordren fremdeles har andre artikler i en tidligere status.',
    tr:
      'Siparişin daha önceki durumdaki başka öğeleri olsa bile, sipariş durumu istasyonla eşleşen öğeleri gösterin.',
    dk:
      'Vis varer med ordrestatus, der matcher stationen, selvom ordren stadig har andre varer i en tidligere status.',
  },
  'Settings.KDS.FontSize': {
    en: 'Set text size',
    es: 'Establecer tamaño de texto',
    se: 'Ställ in textstorlek',
    no: 'Tekststørrelse',
    tr: 'Metin boyutunu ayarla',
    dk: 'Indstil tekststørrelse',
  },
  'Settings.KDS.Smallest': {
    en: 'XXS',
    es: 'Más pequeño',
    se: 'Minst',
    no: 'Minst',
    tr: 'En küçük',
    dk: 'Minste',
  },
  'Settings.KDS.Smaller': {
    en: 'XS',
    es: 'Menor',
    se: 'Mindre',
    no: 'Minst',
    tr: 'Daha küçük',
    dk: 'Mindre',
  },
  'Settings.KDS.Small': {
    en: 'Small',
    es: 'Pequeña',
    se: 'Liten',
    no: 'Liten',
    tr: 'Küçük',
    dk: 'Lille',
  },
  'Settings.KDS.Default': {
    en: 'Medium',
    es: 'Defecto',
    se: 'Standard',
    no: 'Standard',
    tr: 'Varsayılan',
    dk: 'Misligholdelse',
  },
  'Settings.KDS.Big': {
    en: 'Large',
    es: 'Grande',
    se: 'Stor',
    no: 'Stor',
    tr: 'Büyük',
    dk: 'Stor',
  },
  'Settings.KDS.Bigger': {
    en: 'XL',
    es: 'Más grande',
    se: 'Större',
    no: 'Størst',
    tr: 'Daha büyük',
    dk: 'Større',
  },
  'Settings.KDS.MarginSize': {
    en: 'Set margin size',
    es: 'Establecer el tamaño del margen',
    se: 'Välj marginalstorlek',
    no: 'Marginstørrelse',
    tr: 'Kenar boşluğu boyutunu ayarla',
    dk: 'Indstil margenstørrelse',
  },
  'Settings.StationNone': {
    en: 'None',
    es: 'Ninguna',
    se: 'Ingen',
    no: 'Ingen',
    tr: 'Hiçbiri',
    dk: 'Ingen',
  },
  'Settings.Station.Choose': {
    en: 'Choose station for this device',
    es: 'Elija el punto de elaboración para este dispositivo',
    se: 'Välj station för denna enhet',
    no: 'Velg stasjon for denne enheten',
    tr: 'Bu cihaz için istasyon seçin',
    dk: 'Vælg station til denne enhed',
  },
  'Settings.StationDontAssign': {
    en: "(don't assign station)",
    es: '(no asignar punto de elaboración)',
    se: '(Ingen vald station)',
    no: '(Ingen valgt stasjon)',
    tr: '(istasyon atamayın)',
    dk: '(tildel ikke station)',
  },
  'Settings.Update': {
    en: 'Update',
    es: 'Actualizar',
    se: 'Uppdatera',
    no: 'Oppdater',
    tr: 'Güncelleme',
    dk: 'Opdatering',
  },
  'Settings.ZoneNone': {
    en: 'None',
    es: 'Ninguna',
    se: 'Ingen',
    no: 'Ingen',
    tr: 'Hiçbiri',
    dk: 'Ingen',
  },
  'Settings.ZoneDontAssign': {
    en: "(don't assign zone)",
    es: '(no asignar sala)',
    se: '(Ingen zon vald)',
    no: '(Ingen valgt sone)',
    tr: '(bölge atamayın)',
    dk: '(tildel ikke zone)',
  },
  'Settings.LayoutNone': {
    en: 'None',
    es: 'Ninguna',
    se: 'Ingen',
    no: 'Ingen',
    tr: 'Hiçbiri',
    dk: 'Ingen',
  },
  'Settings.LayoutUseCategories': {
    en: '(use basic categories & articles)',
    es: '(usar categorías y artículos básicos)',
    se: '(Använd kategorierna och artiklarna)',
    no: '(Viser alle kategorier og artikler)',
    tr: '(temel kategorileri ve ürünleri kullanın)',
    dk: '(brug grundlæggende kategorier og artikler)',
  },
  'Settings.PrintVoidedItems': {
    en: 'Print voided items and cheques',
    es: 'Imprimir artículos anulados',
    se: 'Skriv ut när artiklar och kvitton tas bort',
    no: 'Skriv ut når artikler og kvitteringer slettes',
    tr: 'İptal edilen ürünleri ve çekleri yazdırın',
    dk: 'Udskriv annullerede varer og checks',
  },
  'Settings.PrintVoidedItems.Desc': {
    en: 'Prints a physical ticket when cheques or items are removed',
    es: 'Imprime un ticket físico cuando se eliminan artículos o comanda',
    se: 'Skriv ut en fysisk bong när en artikel eller nota tas bort',
    no: 'Skriv ut en fysisk bong når en artikkel eller kvittering slettes',
    tr: 'Çekler veya ürünler kaldırıldığında fiziksel bir bilet yazdırır',
    dk: 'Udskriver en fysisk billet, når checks eller varer fjernes',
  },
  'Settings.AskToPrintBong': {
    en: 'Ask before printing kitchen tickets',
    es: 'Preguntar antes de imprimir comandas',
    se: 'Fråga innan du skriver ut köksbongar',
    no: 'Spør før utskrift av kjøkkenbonger',
    tr: 'Mutfak biletleri yazdırılmadan önce sor',
    dk: 'Spørg før udskrivning af køkkenbilletter',
  },
  'Settings.AskToPrintBong.Desc': {
    en:
      'Shows a prompt asking if you want to print a physical kitchen ticket after completing an order or when punching items into a cheque.',
    se:
      'Visar en fråga om du vill skriva ut en fysisk köksbong efter att du slutfört en order eller när du slår in en artikel på en nota.',
    no:
      'Viser en melding som spør om du vil skrive ut en fysisk kjøkkenbong etter at du har fullført en ordre eller når du registrerer en artikkel på en regning.',
    dk:
      'Viser en prompt, der spørger, om du vil udskrive en fysisk køkkenbillet efter du har afsluttet en ordre eller når du slår en artikel ind på en regning.',
    es:
      'Muestra un aviso preguntando si deseas imprimir una comanda física después de completar un pedido o al ingresar un artículo en una cuenta.',
    tr:
      'Bir siparişi tamamladıktan veya bir fişe bir ürün ekledikten sonra fiziksel bir mutfak bileti yazdırmak isteyip istemediğinizi soran bir uyarı gösterir.',
  },
  'Settings.UseNewPrinterFlow': {
    en: '(Experimental) Use new printer flow',
    se: '(Test) Använd nytt skrivarflöde',
    no: '(Eksperimentell) Bruk nytt skriverflyt',
    tr: '(Deneysel) Yeni yazıcı akışını kullan',
    dk: '(Eksperimentel) Brug nyt skriverflow',
    es: '(Experimental) Usar nuevo flujo de impresora',
  },
  'Settings.UseNewPrinterFlow.Desc': {
    en: 'Uses a new flow for printing tickets',
    se: 'Använder det nya skrivarflödet',
    dk: 'Uses a new flow for printing tickets',
    tr: 'Uses a new flow for printing tickets',
    es: 'Uses a new flow for printing tickets',
    no: 'Uses a new flow for printing tickets',
  },
  'Settings.UseImagePrinting': {
    en: '(Experimental) Use image printing',
    se: '(Test) Använd bildutskrift',
    no: '(Eksperimentell) Bruk bildeutskrift',
    tr: '(Deneysel) Görüntü yazdırmayı kullan',
    dk: '(Eksperimentel) Brug billedeudskrivning',
    es: '(Experimental) Usar impresión de imágenes',
  },
  'Settings.UseImagePrinting.Desc': {
    en: 'Gives a better design on tickets',
    se: 'Ger en bättre design på bongar',
    dk: 'Giver et bedre design på billetter',
    tr: 'Biletlerde daha iyi bir tasarım sağlar',
    es: 'Ofrece un mejor diseño en los tickets',
    no: 'Gir et bedre design på bonger',
  },
  'Settings.KDS.PhysicalPrint': {
    en: 'Print ticket when reaching status on order in the KDS',
    es: 'Imprimir ticket cuando se alcanza el estado en el pedido en el KDS',
    se: 'Skriv ut en bong när en order når status i KDS',
    no: 'Skriv ut en bong når en ordre når status i KDS',
    tr: "KDS'de siparişte duruma ulaşıldığında bilet yazdır",
    dk: 'Udskriv billet, når der nås status på ordre i KDS',
  },
  'Settings.KDS.PhysicalPrint.Desc': {
    en:
      'Prints a physical kitchen ticket when an order created on THIS device reaches the selected status',
    es:
      'Imprime un ticket físico de cocina cuando un pedido creado en este dispositivo cambia al estado seleccionado',
    se: 'Skriv ut en fysisk bong när en order skapad på DENNA enhet når den valda statusen',
    no: 'Skriv ut en fysisk bong når en ordre opprettet på DENNE enheten når den valgte statusen',
    tr:
      'Bu cihazda oluşturulan bir sipariş seçilen duruma ulaştığında fiziksel bir mutfak fişi yazdırır',
    dk:
      'Udskriver en fysisk køkkenbillet, når en ordre oprettet på DENNE enhed når den valgte status',
  },
  'Settings.KDS.NoPrint': {
    en: 'No print',
    es: 'Sin impresión',
    se: 'Ingen bong',
    no: 'Ingen bong',
    tr: 'Yazdırma yok',
    dk: 'Ingen udskrivning',
  },
  'Settings.KDS.Accepted': {
    en: 'Accepted (Blue)',
    es: 'Aceptado (Azul)',
    se: 'Accepterad (Blå)',
    no: 'Akseptert (Blå)',
    tr: 'Kabul edildi (Mavi)',
    dk: 'Accepteret (blå)',
  },
  'Settings.KDS.Finalizing': {
    en: 'Finalizing (Orange)',
    es: 'Finalizando (Naranja)',
    se: 'Slutför (Orange)',
    no: 'Fullfør (Oransje)',
    tr: 'Sonlandırılıyor (Turuncu)',
    dk: 'Afslutning (orange)',
  },
  'Settings.KDS.Ready': {
    en: 'Ready (Green)',
    es: 'Listo (Verde)',
    se: 'Redo (Grön)',
    no: 'Klar (Grønn)',
    tr: 'Hazır (Yeşil)',
    dk: 'Klar (grøn)',
  },
  'Settings.FAQ': {
    en: 'Frequency asked questions',
    es: 'Preguntas frecuentes',
    se: 'Vanliga frågor',
    no: 'Ofte stilte spørsmål',
    tr: 'Sıklıkla sorulan sorular',
    dk: 'Hyppige spørgsmål',
  },
  'Settings.ReceiptSettings': {
    en: 'Receipt settings',
    es: 'Configuración de ticket',
    se: 'Kvittoinställningar',
    no: 'Kvitteringsinnstillinger',
    tr: 'Fiş ayarları',
    dk: 'Kvitteringsindstillinger',
  },
  'Settings.ReceiptSettings.Desc': {
    en: 'Choose when to print receipts',
    es: 'Elija cuándo imprimir tickets',
    se: 'Välj när kvitton ska skrivas ut',
    no: 'Velg når kvitteringer skal skrives ut',
    tr: 'Fişlerin ne zaman yazdırılacağını seçin',
    dk: 'Vælg, hvornår kvitteringer skal udskrives',
  },
  'Settings.ReceiptSettings.Always': {
    en: 'Always print',
    es: 'Imprimir siempre',
    se: 'Skriv alltid ut',
    no: 'Skriv alltid ut',
    tr: 'Her zaman yazdır',
    dk: 'Udskriv altid',
  },
  'Settings.ReceiptSettings.Ask': {
    en: 'Always ask',
    es: 'Preguntar siempre',
    se: 'Fråga alltid',
    no: 'Spør alltid',
    tr: 'Her zaman sor',
    dk: 'Spørg altid',
  },
  'Settings.ReceiptSettings.Manual': {
    en: 'Print manually',
    es: 'Imprimir manualmente',
    se: 'Skriv ut manuellt',
    no: 'Skriv ut manuelt',
    tr: 'Manuel yazdır',
    dk: 'Udskriv manuelt',
  },
  'Settings.Legacy.Text': {
    en:
      'You can still access the old settings page, beware that it is missing new features. The old page will be removed soon.',
    es:
      'Todavía puedes acceder a la antigua página de configuración, ten en cuenta que le faltan nuevas funciones. La antigua página se eliminará pronto.',
    se:
      'Du kan fortfarande komma åt den gamla inställningssidan, var medveten om att den saknar nya funktioner. Den gamla sidan kommer snart att tas bort.',
    no:
      'Du kan fortsatt få tilgang til den gamle innstillingssiden, vær oppmerksom på at den mangler nye funksjoner. Den gamle siden vil bli fjernet snart.',
    tr:
      'Eski ayarlar sayfasına hala erişebilirsiniz, ancak yeni özelliklerin eksik olduğunu unutmayın. Eski sayfa yakında kaldırılacak.',
    dk:
      'Du kan stadig få adgang til den gamle indstillingsside, vær opmærksom på at den mangler nye funktioner. Den gamle side vil snart blive fjernet.',
  },
  'Settings.Legacy.Info': {
    en: 'This page is missing features and will soon be removed.',
    es: 'Esta página carece de funciones y pronto se eliminará.',
    se: 'Denna sida saknar funktioner och kommer snart att tas bort.',
    no: 'Denne siden mangler funksjoner og vil snart bli fjernet.',
    tr: 'Bu sayfa özelliklerden yoksundur ve yakında kaldırılacaktır.',
    dk: 'Denne side mangler funktioner og vil snart blive fjernet.',
  },
  'Settings.Legacy.Info.Button': {
    en: 'Go to new settings',
    es: 'Ir a nueva configuración',
    se: 'Till nya inställningar',
    no: 'Gå til nye innstillinger',
    tr: 'Yeni ayarlara git',
    dk: 'Gå til nye indstillinger',
  },
  'Settings.Reports.AllowStaffReport': {
    en: 'Allow staff to see their own report',
    es: 'Permitir al personal ver su propio informe',
    se: 'Tillåt personal att se sin egen rapport',
    no: 'Tillat ansatte å se sin egen rapport',
    tr: 'Personelin kendi raporunu görmesine izin ver',
    dk: 'Tillad medarbejdere at se deres egen rapport',
  },
  'Settings.Reports.AllowStaffReport.SubLabel': {
    en: 'Enables staff to see their own report without report permissions.',
    es: 'Permite al personal ver su propio informe sin permisos de informes.',
    se: 'Aktiverar personal att se sin egen rapport utan rapportbehörigheter.',
    no: 'Aktiverer ansatte å se sin egen rapport uten rapporttillatelser.',
    tr: 'Personelin rapor izinleri olmadan kendi raporunu görmesine izin verir.',
    dk: 'Aktiverer medarbejdere til at se deres egen rapport uden rapporttilladelser.',
  },
  'Settings.Reports.CategoryBreakdown': {
    en: 'Allow staff to see category breakdown in their staff report',
    es: 'Permitir que el personal vea el desglose de categorías en su informe de ventas',
    se: 'Tillåt personal att se kategorifördelning i sin försäljningsrapport',
    no: 'Tillat ansatte å se kategorioversikt i deres salgsrapport',
    tr: 'Personelin satış raporlarında kategori dökümünü görmesine izin ver',
    dk: 'Tillad medarbejdere at se kategorifordeling i deres salgsrapport',
  },
  'Settings.Reports.CategoryBreakdown.SubLabel': {
    en: 'Enables category breakdown for staff without report permissions.',
    es: 'Habilita el desglose de categorías para el personal sin permisos de informes.',
    se: 'Aktiverar kategorifördelning för personal utan rapportbehörigheter.',
    no: 'Aktiverer kategorioversikt for ansatte uten rapporttillatelser.',
    tr: 'Rapor yetkisi olmayan personel için kategori dökümünü etkinleştirir.',
    dk: 'Aktiverer kategorifordeling for medarbejdere uden rapporttilladelser.',
  },
  'Settings.HideCoverageModal.Title': {
    en: 'Do not ask for table coverage',
    es: 'No preguntar los comensales por mesa',
    se: 'Fråga inte om antal personer',
    no: 'Ikke be om borddekning',
    tr: 'Masa örtüsü istemeyin',
    dk: 'Bed ikke om borddækning',
  },
  'Settings.HideCoverageModal.Description': {
    en: 'Do not ask for coverage when opening a table',
    es: 'No preguntar los comensales al abrir una mesa',
    se: 'Fråga inte om antal personer när ett bord öppnas',
    no: 'Ikke be om dekning når du åpner et bord',
    tr: 'Masa açarken kapsam istemeyin',
    dk: 'Bed ikke om dækning, når du åbner et bord',
  },
  'Settings.HideZeroAmountItemsInCustomerPrints.Title': {
    en: 'Do not show items with zero amount on cheques and receipts',
    es: 'No mostrar artículos con cero en comandas y tickets',
    se: 'Visa inte artiklar med noll i belopp på kvitton',
    no: 'Vis ikke artikler med null i beløp på kvitteringer',
    tr: 'Çeklerde ve fişlerde sıfır tutar olan ürünleri gösterme',
    dk: 'Vis ikke varer med nul i beløb på kvitteringer',
  },
  'Settings.ReceiptShowOnlyOfferName.Title': {
    en: 'Show only offer name on receipts',
    es: 'Mostrar solo el nombre de la oferta en los tickets',
    se: 'Visa endast erbjudandets namn på kvitton',
    no: 'Vis kun tilbudets navn på kvitteringer',
    tr: 'Fişlerde yalnızca teklif adını göster',
    dk: 'Vis kun tilbudets navn på kvitteringer',
  },
  'Settings.ReceiptShowOnlyOfferName.Description': {
    en: 'Show the offer name instead of the articles on receipts',
    es: 'Mostrar el nombre de la oferta en lugar de los artículos en los tickets',
    se: 'Visa erbjudandets namn istället för artiklarna på kvitton',
    no: 'Vis tilbudets navn i stedet for artiklene på kvitteringer',
    tr: 'Fişlerde tam ürün adı yerine teklif adını göster',
    dk: 'Vis tilbudets navn i stedet for artiklerne på kvitteringer',
  },
  'Settings.ShowTipSuggestions.Title': {
    en: 'Show tip suggestions on bills',
    es: 'Mostrar sugerencias de propina en las cuentas',
    se: 'Visa dricksförslag på notor',
    no: 'Vis tipsforslag på regninger',
    tr: 'Hesaplarda bahşiş önerilerini göster',
    dk: 'Vis drikkeforslag på regninger',
  },
  'Settings.ShowTipSuggestions.Description': {
    en: 'Display suggested tip amounts (5%, 10%, 15%, 20%) on printed bills',
    es: 'Mostrar montos de propina sugeridos (5%, 10%, 15%, 20%) en las cuentas impresas',
    se: 'Visa föreslagna dricksbelopp (5%, 10%, 15%, 20%) på utskrivna notor',
    no: 'Vis foreslåtte tipsbeløp (5%, 10%, 15%, 20%) på utskrevne regninger',
    tr:
      'Yazdırılmış hesaplarda önerilen bahşiş tutarlarını (yüzde 5, yüzde 10, yüzde 15, yüzde 20) görüntüleyin',
    dk: 'Vis foreslåede drikkebeløb (5%, 10%, 15%, 20%) på udskrevne regninger',
  },
  'Settings.LockedByBaemingo': {
    en: 'Locked by Baemingo',
    es: 'Bloqueado por Baemingo',
    se: 'Låst av Baemingo',
    no: 'Låst av Baemingo',
    tr: 'Baemingo tarafından kilitlendi',
    dk: 'Låst af Baemingo',
  },
  'Settings.LockedByBaemingo.Toast': {
    en: 'This setting is locked by Baemingo',
    es: 'Esta configuración está bloqueada por Baemingo',
    se: 'Denna inställning är låst av Baemingo',
    no: 'Denne innstillingen er låst av Baemingo',
    tr: 'Bu ayar Baemingo tarafından kilitlendi',
    dk: 'Denne indstilling er låst af Baemingo',
  },
  // Onboarding
  'Onboarding.Create': {
    en: 'Create and Use',
    es: 'Crear y reclamar',
    se: 'Skapa och använd',
    no: 'Opprett og aktiver',
    tr: 'Oluştur ve Kullan',
    dk: 'Opret og brug',
  },
  'Onboarding.Select.CreateOrSelect': {
    en: 'Do you want to create a new device or select an existing one?',
    es: '¿Desea crear un nuevo dispositivo o seleccionar uno existente?',
    se: 'Vill du skapa en ny enhet eller välja en befintlig?',
    no: 'Vil du opprette en ny enhet eller velge en eksisterende?',
    tr:
      'Yeni bir cihaz mı oluşturmak istiyorsunuz yoksa mevcut bir cihazı mı seçmek istiyorsunuz?',
    dk: 'Vil du oprette en ny enhed eller vælge en eksisterende?',
  },
  'Onboarding.Select.Create': {
    en: 'Create',
    es: 'Crear',
    se: 'Skapa',
    no: 'Opprett',
    tr: 'Oluştur ve Kullan',
    dk: 'Skab',
  },
  'Onboarding.Select.Select': {
    en: 'Select',
    es: 'Seleccionar',
    se: 'Välj',
    no: 'Velg',
    tr: 'Seç',
    dk: 'Vælg',
  },
  'Onboarding.Select.Select.Desc': {
    en: 'Please select one of the devices below',
    es: 'Por favor, seleccione uno de los dispositivos a continuación',
    se: 'Vänligen välj en av enheterna nedan',
    no: 'Vennligst velg en av enhetene nedenfor',
    tr: 'Lütfen aşağıdaki cihazlardan birini seçin',
    dk: 'Vælg en af ​​enhederne nedenfor',
  },
  'Onboarding.Select.InUse': {
    en: 'in use',
    es: 'en uso',
    se: 'används',
    no: 'i bruk',
    tr: 'Kullanımda',
    dk: 'i brug',
  },
  'Onboarding.Claim': {
    en: 'Use this device',
    es: 'Usar este dispositivo',
    se: 'Använd denna enhet',
    no: 'Aktiver denne enheten',
    tr: 'Bu aygıtı kullan',
    dk: 'Brug denne enhed',
  },
  'Onboarding.SetUpReader': {
    en: 'SET UP READER',
    es: 'CONFIGURAR LECTOR',
    se: 'INSTALLERA TERMINAL',
    no: 'INSTALLER TERMINAL',
    tr: 'OKUYUCUYU AYARLA',
    dk: 'OPSÆT LÆSER',
  },
  'Onboarding.StreetAddress': {
    en: 'Street address',
    es: 'Dirección',
    se: 'Adress',
    no: 'Adresse',
    tr: 'Açık adres',
    dk: 'Gadeadresse',
  },
  'Onboarding.StreetAddress.Required': {
    en: 'Street address is required',
    es: 'La dirección de la calle es obligatoria',
    se: 'Adress är obligatoriskt',
    no: 'Adresse er obligatorisk',
    tr: 'Sokak adresi gerekli',
    dk: 'Gadeadresse er påkrævet',
  },
  'Onboarding.ZipCode': {
    en: 'ZIP code',
    es: 'Código postal',
    se: 'Postnummer',
    no: 'Postnummer',
    tr: 'Posta kodu',
    dk: 'postnummer',
  },
  'Onboarding.ZipCode.Required': {
    en: 'ZIP code is required',
    es: 'Se requiere el código postal',
    se: 'Postnummer är obligatoriskt',
    no: 'Postnummer er obligatorisk',
    tr: 'Posta kodu gerekli',
    dk: 'Postnummer er påkrævet',
  },
  'Onboarding.ZipCode.Incorrect': {
    en: 'Incorrect format for ZIP code',
    es: 'Formato incorrecto para el código postal',
    se: 'Ogiltigt postnummer',
    no: 'Ugyldig postnummer',
    tr: 'Posta kodu için yanlış format',
    dk: 'Forkert format for postnummer',
  },
  'Onboarding.City': {
    en: 'City',
    es: 'Ciudad',
    se: 'Ort',
    no: 'By',
    tr: 'Şehir',
    dk: 'By',
  },
  'Onboarding.City.Required': {
    en: 'City is required',
    es: 'Ciudad es requerida',
    se: 'Ort är obligatoriskt',
    no: 'By er obligatorisk',
    tr: 'Şehir gerekli',
    dk: 'By er påkrævet',
  },
  'Onboarding.Update': {
    en: 'Update',
    es: 'Actualizar',
    se: 'Uppdatera',
    no: 'Oppdater',
    tr: 'Güncelle',
    dk: 'Opdatering',
  },
  'Onboarding.Location.Completed': {
    en: 'Device location configuration has been saved',
    es: 'La configuración de la ubicación del dispositivo se ha guardado',
    se: 'Enhetens platskonfiguration har sparats',
    no: 'Enhetens plassering er lagret',
    tr: 'Cihaz konumu yapılandırması kaydedildi',
    dk: 'Konfiguration af enhedsplacering er blevet gemt',
  },
  'Onboarding.RegisterDevice': {
    en: 'Register device',
    es: 'Registrar dispositivo',
    se: 'Registrera enhet',
    no: 'Registrer enhet',
    tr: 'Cihazı kaydet',
    dk: 'Registrer enhed',
  },
  'Onboarding.RegisterDevice.ClaimText': {
    en: 'Register your device by claiming one of the following',
    es: 'Registre su dispositivo reclamando uno de los siguientes dispositivos',
    se: 'Registrera din enhet genom att välja en av följande enheter',
    no: 'Registrer enheten din ved å velge en av følgende',
    tr: 'Aşağıdakilerden birini talep ederek cihazınızı kaydedin',
    dk: 'Registrer din enhed ved at gøre krav på en af ​​følgende',
  },
  'Onboarding.RegisterDevice.CreateText': {
    en: 'Create your first device by entering a name and press "Create and Use"',
    es: 'Crea tu primer dispositivo ingresando un nombre y presiona "Crear y reclamar"',
    se: 'Skapa din första enhet genom att ange ett namn och tryck på "Skapa och använd"',
    no: 'Opprett din første enhet ved å skrive inn et navn og trykke på "Opprett og aktiver"',
    tr: 'Bir ad girerek ilk cihazınızı oluşturun ve "Oluştur ve Kullan"a basın',
    dk: 'Opret din første enhed ved at indtaste et navn og trykke på "Opret og brug"',
  },
  'Onboarding.RegisterDevice.Error.Taken': {
    en: 'The entered name is already in use, please try another one',
    es: 'El nombre ingresado ya está en uso, por favor intente con otro',
    se: 'Namnet du angav används redan, försök med ett annat',
    no: 'Navnet du skrev inn er allerede i bruk, vennligst prøv et annet',
    tr: 'Girilen ad zaten kullanılıyor, lütfen başka bir ad deneyin',
    dk: 'Det indtastede navn er allerede i brug, prøv venligst et andet',
  },
  'Onboarding.RegisterDevice.Error.Failed': {
    en: 'Failed to create device, please try again',
    es: 'Error al crear el dispositivo, por favor intente de nuevo',
    se: 'Det gick inte att skapa enheten, försök igen',
    no: 'Kunne ikke opprette enheten, vennligst prøv igjen',
    tr: 'Cihaz oluşturulamadı, lütfen tekrar deneyin',
    dk: 'Kunne ikke oprette enheden. Prøv igen',
  },
  'Onboarding.Device.Success': {
    en: 'Selected device has been saved',
    es: 'El dispositivo seleccionado se ha guardado',
    se: 'Vald enhet har sparats',
    no: 'Valgt enhet er lagret',
    tr: 'Seçilen cihaz kaydedildi',
    dk: 'Den valgte enhed er blevet gemt',
  },
  'Onboarding.RegisterDevice.Error.SwedenCompliance': {
    en: 'Device name should and can only contain letters and numbers',
    es: 'El nombre del dispositivo debe y solo puede contener letras y números',
    se: 'Enhetens namn får endast innehålla bokstäver och siffror',
    no: 'Enhetsnavnet kan kun inneholde bokstaver og tall',
    tr: 'Cihaz adı yalnızca harf ve rakam içermelidir ve içerebilir',
    dk: 'Enhedens navn bør og må kun indeholde bogstaver og tal',
  },
  'Onboarding.RegisterDevice.CreateText.SwedishInfo': {
    en: 'Use lowercase (a–z) and numbers (0–9). å, ä, ö not supported.',
    es: 'Usa minúsculas (a–z) y números (0–9). å, ä, ö no compatibles.',
    se: 'Använd små bokstäver (a–z) och siffror (0–9). Å, ä, ö stöds inte.',
    no: 'Bruk små bokstaver (a–z) og tall (0–9). å, ä, ö støttes ikke.',
    tr: 'Küçük harfler (a–z) ve sayılar (0–9) kullanın. å, ä, ö desteklenmez.',
    dk: 'Brug små bogstaver (a–z) og tal (0–9). å, ä, ö understøttes ikke.',
  },
  'Onboarding.RegisterDevice.Loading': {
    en: 'Loading devices...',
    es: 'Cargando dispositivos...',
    se: 'Laddar enheter...',
    no: 'Laster enheter...',
    tr: 'Cihazlar yükleniyor...',
    dk: 'Indlæser enheder...',
  },
  'Onboarding.RegisterDevice.Error.General': {
    en: 'Something went wrong. Please try again',
    es: 'Algo salió mal. Por favor, inténtalo de nuevo',
    se: 'Något gick fel. Försök igen',
    no: 'Noe gikk galt. Vennligst prøv igjen',
    tr: 'Bir şeyler ters gitti. Lütfen tekrar deneyin',
    dk: 'Noget gik galt. Prøv venligst igen',
  },
  'Onboarding.RegisterDevice.Error.NoOrgNumber': {
    en: 'No "VAT No" has been configured in backoffice for this venue',
    es: 'No se ha configurado ningún NIF en la oficina de backoffice para este local',
    se: 'Inget Organisation ID har konfigurerats i backoffice för denna butik',
    no: 'Ingen organisasjonsnummer er konfigurert i backoffice for denne butikken',
    tr: 'Bu mekan için backoffice’te herhangi bir vergi numarası yapılandırılmamış',
    dk: 'Ingen CVR-nummer er konfigureret i backoffice for denne butik',
  },
  'Onboarding.Select.InUseByThisDevice': {
    en: 'in use by this device',
    es: 'en uso por este dispositivo',
    se: 'används av denna enhet',
    no: 'i bruk av denne enheten',
    tr: 'Bu cihaz tarafından kullanılıyor',
    dk: 'i brug af denne enhed',
  },
  'Onboarding.ZettleConfig': {
    en: 'iZettle configuration',
    es: 'Configuración iZettle',
    se: 'iZettle konfiguration',
    no: 'Zettle-konfigurasjon',
    tr: 'iZettle yapılandırması',
    dk: 'iZettle-konfiguration',
  },
  'Onboarding.ZettleConfig.Text': {
    en:
      'If you have your iZettle reader nearby, press the button below to open the iZettle settings which will guide you through the setup process. You can do this later by pressing the "PAY" button.',
    es:
      'Si tiene su lector iZettle cerca, presione el botón a continuación para abrir la configuración de iZettle que lo guiará a través del proceso de configuración. Puede hacerlo más tarde presionando el botón "PAGAR".',
    se:
      'Om du har din iZettle-läsare i närheten, tryck på knappen nedan för att öppna iZettle-inställningarna som guidar dig genom installationsprocessen. Du kan göra detta senare genom att trycka på "BETALA"-knappen.',
    no:
      'Dersom du har din Zettle-kortleser i nærheten, trykk på knappen nedenfor for å åpne Zettle-innstillingene. Du vil bli tatt gjennom installasjonsstegene. Du kan også gjøre dette senere ved å bruke "BETAL"-knappen.',
    tr:
      'Yakınınızda iZettle okuyucunuz varsa kurulum sürecinde size yol gösterecek iZettle ayarlarını açmak için aşağıdaki düğmeye basın. Bunu daha sonra "ÖDE" butonuna basarak yapabilirsiniz.',
    dk:
      'Hvis du har din iZettle-læser i nærheden, skal du trykke på knappen nedenfor for at åbne iZettle-indstillingerne, som vil guide dig gennem opsætningsprocessen. Du kan gøre dette senere ved at trykke på knappen "BETAL".',
  },
  'Onboarding.SkipContinue': {
    en: 'Skip / Continue',
    es: 'Saltar/Continuar',
    se: 'Skippa / Fortsätt',
    no: 'Hopp over / Fortsett',
    tr: 'Atla / Devam Et',
    dk: 'Spring over / fortsæt',
  },
  'Onboarding.PrinterConfig': {
    en: 'Printer configuration',
    es: 'Configuración de la impresora',
    se: 'Skrivarkonfiguration',
    no: 'Printerkonfigurering',
    tr: 'Yazıcı yapılandırması',
    dk: 'Udskriver konfiguration',
  },
  'Onboarding.PrinterConfig.Text': {
    en:
      'Any available printers will appear below. It is searching for Bluetooth, LAN/Wifi and USB printers. If a printer does not appear, make sure it is not already connected to another nearby POS, is one the same network and is turned on.',
    es:
      'Cualquier impresora disponible aparecerá debajo. Está buscando impresoras Bluetooth, LAN/Wifi y USB. Si no aparece una impresora, asegúrese de que no esté ya conectada a otro POS cercano, sea de la misma red y esté encendida.',
    se:
      'Alla tillgängliga skrivare visas nedan. Den söker efter Bluetooth, LAN/Wifi och USB-skrivare. Om en skrivare inte visas, se till att den inte redan är ansluten till en annan närliggande POS, är i samma nätverk och är påslagen.',
    no:
      'Alle tilgjengelige printere vises nedenfor. Vi søker etter Bluetooth, LAN, Wi-Fi og USB-printere. Dersom printeren din ikke vises, kontroller at den ikke er tilkoblet en annen POS, at den er på samme nettverk, og er slått på.',
    tr:
      "Mevcut yazıcılar aşağıda görünecektir. Bluetooth, LAN/Wifi ve USB yazıcıları arıyor. Yazıcı görüntülenmezse yakındaki başka bir POS'a bağlı olmadığından, aynı ağda olduğundan ve açık olduğundan emin olun.",
    dk:
      'Alle tilgængelige printere vises nedenfor. Den søger efter Bluetooth-, LAN/Wifi- og USB-printere. Hvis en printer ikke vises, skal du sørge for, at den ikke allerede er forbundet til en anden nærliggende POS, er på samme netværk og er tændt.',
  },
  'Onboarding.LayoutConfig': {
    en: 'Layout configuration',
    es: 'Configuración de diseño',
    se: 'Layout konfiguration',
    no: 'Layout-konfigurasjon',
    tr: 'Plan yapılandırması',
    dk: 'Layout konfiguration',
  },
  'Onboarding.LayoutConfig.Text': {
    en: 'Choose which layout this device should have in POS',
    es: 'Elija qué diseño debe tener este dispositivo en POS',
    se: 'Välj vilken layout den här enheten ska ha i POS',
    no: 'Velg hvilken layout denne enheten skal ha i POS',
    tr: "Bu cihazın POS'ta hangi plana sahip olması gerektiğini seçin",
    dk: 'Vælg hvilket layout denne enhed skal have i POS',
  },
  'Onboarding.DeviceLocationConfig': {
    en: 'Device location configuration',
    es: 'Configuración de la ubicación del dispositivo',
    se: 'Platskonfiguration av enheten',
    no: 'Lokasjonskonfigurasjon',
    tr: 'Cihaz konumu yapılandırması',
    dk: 'Konfiguration af enhedsplacering',
  },
  'Onboarding.DeviceLocationConfig.Text': {
    en: 'Please ensure the location settings are correct for this device.',
    es: 'Asegúrese de que la configuración de ubicación sea correcta para este dispositivo.',
    se: 'Se till att platsinställningarna är korrekta för den här enheten.',
    no: 'Sjekk at lokasjonsinnstillingene er riktige for denne enheten.',
    tr: 'Lütfen bu cihaz için konum ayarlarının doğru olduğundan emin olun.',
    dk: 'Sørg for, at placeringsindstillingerne er korrekte for denne enhed.',
  },
  'Onboarding.SetupComplete': {
    en: 'Setup completed!',
    es: '¡Configuración completada!',
    se: 'Installationen slutförd!',
    no: 'Installasjon fullført!',
    tr: 'Kurulum tamamlandı!',
    dk: 'Opsætning afsluttet!',
  },
  'Onboarding.SetupComplete.Text': {
    en: 'You will be redirected to the previous screen in a moment...',
    es: 'Será redirigido a la pantalla anterior en un momento...',
    se: 'Du kommer att omdirigeras till föregående skärm om ett ögonblick...',
    no: 'Du blir straks videresendt...',
    tr: 'Birazdan önceki ekrana yönlendirileceksiniz...',
    dk: 'Du vil om et øjeblik blive omdirigeret til den forrige skærm...',
  },
  // Simple Pay at table
  'SimplePAT.TableCode': {
    en: 'Table code',
    es: 'Código de mesa',
    se: 'Bordskod',
    no: 'Bordkode',
    tr: 'Masa kodu',
    dk: 'Bord kode',
  },
  'SimplePAT.PayTable': {
    en: 'Pay Table',
    es: 'Pagar en mesa',
    se: 'Betala bord',
    no: 'Betal bord',
    tr: 'Ödeme masası',
    dk: 'Betal bord',
  },
  // Reset password
  'ResetPassword.Title': {
    en: 'Change your password',
    es: 'Cambia tu contraseña',
    se: 'Byt ditt lösenord',
    no: 'Bytt passordet ditt',
    tr: 'Şifrenizi değiştirin',
    dk: 'Skift din adgangskode',
  },
  'ResetPassword.Description': {
    en: 'You need to set a new password before you can continue.',
    es: 'Debes establecer una nueva contraseña antes de continuar.',
    se: 'Du behöver sätta ett nytt lösenord innan du kan fortsätta.',
    no: 'Du må sette et nytt passord før du kan fortsette.',
    tr: 'Devam etmeden önce yeni bir şifre belirlemeniz gerekiyor.',
    dk: 'Du skal vælge en ny adgangskode, før du kan fortsætte.',
  },
  'ResetPassword.Error.NoSpaces': {
    en: 'There should be no spaces at the beginning and end of the password.',
    es: 'La contraseña no debe tener espacios al principio ni al final.',
    se: 'Det ska inte finnas några mellanslag i början och slutet av lösenordet.',
    no: 'Det kan ikke være mellomrom i begynnelsen eller slutten av passordet.',
    tr: 'Şifrenin başında ve sonunda boşluk olmamalıdır.',
    dk: 'Der må ikke være mellemrum i begyndelsen og slutningen af ​​adgangskoden.',
  },
  'ResetPassword.Error.TooShort': {
    en: 'Password is too short.',
    es: 'La contraseña es demasiado corta.',
    se: 'Lösenordet är för kort',
    no: 'Passordet er for kort',
    tr: 'Şifre çok kısa.',
    dk: 'Adgangskoden er for kort.',
  },
  'ResetPassword.Error.OnlyLetters': {
    en: 'Only letters (a-z and A-Z), numbers (0-9), and allowed special characters can be used.',
    es:
      'Solo se pueden usar letras (a-z y A-Z), números (0-9) y los caracteres especiales permitidos.',
    se: 'Endast bokstäver (a-z och A-Z), siffror (0-9) och tillåtna specialtecken kan användas.',
    no: 'Kun bokstaver (a-z og A-Z), tall (0-9) og enkelte spesialtegn kan brukes.',
    tr:
      'Yalnızca harfler (a-z ve A-Z), sayılar (0-9) ve izin verilen özel karakterler kullanılabilir.',
    dk: 'Kun bogstaver (a-z og A-Z), tal (0-9) og tilladte specialtegn kan bruges.',
  },
  'ResetPassword.Error.NotStrong': {
    en: 'Password is not strong enough. Try a combination of letters, numbers, and symbols.',
    es:
      'La contraseña no es suficientemente segura. Prueba una combinación de letras, números y símbolos.',
    se:
      'Lösenordet är inte tillräckligt starkt. Prova en kombination av bokstäver, siffror och symboler.',
    no:
      'Passordet du har valgt er ikke sterkt nok. Prøv en kombinasjon av bokstaver, tall og symboler.',
    tr: 'Şifre yeterince güçlü değil. Harf, sayı ve simgelerin birleşimini deneyin.',
    dk: 'Adgangskoden er ikke stærk nok. Prøv en kombination af bogstaver, tal og symboler.',
  },
  'ResetPassword.Error.Mismatch': {
    en: 'Passwords do not match.',
    es: 'Las contraseñas no coinciden.',
    se: 'Lösenorden matchar inte',
    no: 'Passordene er ikke like',
    tr: 'Parolalar uyuşmuyor.',
    dk: 'Adgangskoder stemmer ikke overens.',
  },
  'ResetPassword.Error.Short': {
    en: 'Too short',
    es: 'Demasiado corta',
    se: 'För kort',
    no: 'For kort',
    tr: 'Çok kısa',
    dk: 'For kort',
  },
  'ResetPassword.VeryWeak': {
    en: 'Very weak',
    es: 'Muy débil',
    se: 'Mycket svagt',
    no: 'Veldig svakt',
    tr: 'Çok zayıf',
    dk: 'Meget svag',
  },
  'ResetPassword.Weak': {
    en: 'Weak',
    es: 'Débil',
    se: 'Svagt',
    no: 'Svakt',
    tr: 'Zayıf',
    dk: 'Svag',
  },
  'ResetPassword.Average': {
    en: 'Average',
    es: 'Media',
    se: 'Medel',
    no: 'Middels',
    tr: 'Orta',
    dk: 'Gennemsnitlig',
  },
  'ResetPassword.Strong': {
    en: 'Strong',
    es: 'Fuerte',
    se: 'Starkt',
    no: 'Sterkt',
    tr: 'Güçlü',
    dk: 'Stærk',
  },
  'ResetPassword.VeryStrong': {
    en: 'Very strong',
    es: 'Muy fuerte',
    se: 'Mycket starkt',
    no: 'Veldig sterkt',
    tr: 'Çok güçlü',
    dk: 'Meget stærk',
  },
  'ResetPassword.NewPassword': {
    en: 'New password',
    es: 'Nueva contraseña',
    se: 'Nytt lösenord',
    no: 'Nytt passord',
    tr: 'Yeni Şifre',
    dk: 'Ny adgangskode',
  },
  'ResetPassword.ConfirmPassword': {
    en: 'Confirm new password',
    es: 'Confirmar nueva contraseña',
    se: 'Bekräfta nytt lösenord',
    no: 'Bekreft det nye passordet',
    tr: 'Yeni şifreyi onayla',
    dk: 'Bekræft ny adgangskode',
  },
  'ResetPassword.PasswordStrength': {
    en: 'Password Strength: ',
    es: 'Fortaleza de la contraseña:',
    se: 'Lösenord styrka: ',
    no: 'Passordstyrke',
    tr: 'Şifre güvenlik seviyesi:',
    dk: 'Adgangskodestyrke:',
  },
  'ResetPassword.Info': {
    en:
      'The minimum password length is 8 characters. Use combination of lowercase, uppercase, numbers and special characters to increase password strength.',
    es:
      'La longitud mínima de la contraseña es de 8 caracteres. Utiliza una combinación de minúsculas, mayúsculas, números y caracteres especiales para aumentar la fortaleza.',
    se:
      'Minsta lösenordslängd är 8 tecken. Använd en kombination av gemener, versaler, siffror och specialtecken för att öka lösenordets styrka.',
    no:
      'Minste passordlengde er 8 tegn. Bruk en kombinasjon av små og store bokstaver, siffer og spesialtegn for å øke passordstyrken.',
    tr:
      'Minimum şifre uzunluğu 8 karakterdir. Şifre gücünü artırmak için küçük harf, büyük harf, sayı ve özel karakterlerin birleşimini kullanın.',
    dk:
      'Den mindste adgangskodelængde er 8 tegn. Brug en kombination af små bogstaver, store bogstaver, tal og specialtegn for at øge adgangskodens styrke.',
  },
  'ResetPassword.ChangePassword': {
    en: 'Change password',
    es: 'Cambiar contraseña',
    se: 'Byt lösenord',
    no: 'Bytt passord',
    tr: 'Şifre değiştir',
    dk: 'Skift adgangskode',
  },
  // Parked orders
  'ParkedOrders.Title': {
    en: 'Parked orders',
    es: 'Comandas aparcadas',
    se: 'Parkerade ordrar',
    no: 'Parkerte ordre',
    tr: 'Alınmış siparişler',
    dk: 'Parkerede ordrer',
  },
  'ParkedOrders.Name': {
    en: 'Name',
    es: 'Nombre',
    se: 'Namn',
    no: 'Navn',
    tr: 'Ad',
    dk: 'Navn',
  },
  'ParkedOrders.Device': {
    en: 'Device',
    es: 'Dispositivo',
    se: 'Enhet',
    no: 'Enhet',
    tr: 'Cihaz',
    dk: 'Enhed',
  },
  'ParkedOrders.DeviceParkedOn': {
    en: 'Parked on',
    es: 'Aparcado en',
    se: 'Parkerad på',
    no: 'Parkert på',
    tr: 'Park edildi',
    dk: 'Parkeret på',
  },
  'ParkedOrders.ParkedBy': {
    en: 'Parked by',
    es: 'Aparcado por',
    se: 'Parkerad av',
    no: 'Parkert av',
    tr: 'Park eden',
    dk: 'Parkeret af',
  },
  'ParkedOrders.ParkedAt': {
    en: 'Parked at',
    es: 'Aparcado a las',
    se: 'Parkerad kl.',
    no: 'Parkert kl.',
    tr: 'Park saati',
    dk: 'Parkeret kl.',
  },
  'ParkedOrders.Parked': {
    en: 'Parked',
    es: 'Aparcado',
    se: 'Parkerad',
    no: 'Parkert',
    tr: 'Park edilmiş',
    dk: 'Parkeret',
  },
  'ParkedOrders.Staff': {
    en: 'Staff',
    es: 'Personal',
    se: 'Personal',
    no: 'Personal',
    tr: 'Personel',
    dk: 'Personale',
  },
  'ParkedOrders.NoStaff': {
    en: 'No staff',
    es: 'Sin personal',
    se: 'Ingen personal',
    no: 'Ingen personal',
    tr: 'Personel yok',
    dk: 'Intet personale',
  },
  'ParkedOrders.Order': {
    en: 'Order',
    es: 'Comanda',
    se: 'Order',
    no: 'Ordre',
    tr: 'Sipariş',
    dk: 'Bestil',
  },
  'ParkedOrders.TotalAmount': {
    en: 'Total amount',
    es: 'Importe total',
    se: 'Totalsumma',
    no: 'Totalsum',
    tr: 'Toplam tutar',
    dk: 'Samlet beløb',
  },
  'ParkedOrders.MoveToTable': {
    en: 'Move to table',
    es: 'Mover a la mesa',
    se: 'Flytta till bord',
    no: 'Flytt til bord',
    tr: 'Masa taşı',
    dk: 'Flyt til bord',
  },
  'ParkedOrders.Name.Placeholder': {
    en: 'Enter a name for the parked order',
    es: 'Introduce un nombre para la comanda aparcada',
    se: 'Ange ett namn för den parkerade ordern',
    no: 'Skriv inn et navn for den parkerte ordren',
    tr: 'Park edilen sipariş için bir ad girin',
    dk: 'Indtast et navn for den parkerede ordre',
  },
  'ParkedOrders.Untitled': {
    en: 'Untitled',
    es: 'Sin título',
    se: 'Namnlös',
    no: 'Navnløs',
    tr: 'Başlıksız',
    dk: 'Unavngivet',
  },
  'ParkedOrders.Proceed': {
    en: 'To checkout',
    es: 'Ir a cobro',
    se: 'Till betalning',
    no: 'Til betaling',
    tr: 'Ödeme yapmak için',
    dk: 'Til betaling',
  },
  'ParkedOrders.NoParkedOrders': {
    en: 'No parked orders',
    es: 'No hay comandas aparcadas',
    se: 'Inga parkerade ordrar',
    no: 'Ingen parkerte ordre',
    tr: 'Park edilmiş sipariş yok',
    dk: 'Ingen parkerede ordrer',
  },
  'ParkedOrders.NoParkedOrders.Desc': {
    en: 'Once an order has been parked, it will appear here',
    es: 'Cuando aparques una comanda, aparecerá aquí',
    se: 'När en order har parkerats visas den här',
    no: 'Når en ordre er parkert, vil den vises her',
    tr: 'Bir sipariş park edildiğinde burada görünecektir',
    dk: 'Når en ordre er parkeret, vil den vises her',
  },
  'ParkedOrders.DeletedItems.Title': {
    en: 'These products are no longer available',
    es: 'Estos artículos ya no están disponibles',
    se: 'Dessa produkter är inte längre tillgängliga',
    no: 'Disse produktene er ikke lenger tilgjengelige',
    tr: 'Bu ürünler artık mevcut değil',
    dk: 'Disse produkter er ikke længere tilgængelige',
  },
  'ParkedOrders.DeletedItems.Desc': {
    en:
      'This can be due to the item being deleted in backoffice or not available in the current menu',
    es:
      'Esto puede deberse a que el artículo se eliminó en el backoffice o no está disponible en el menú actual',
    se:
      'Detta kan bero på att artikeln har tagits bort i backoffice eller inte är tillgänglig i den aktuella menyn',
    no:
      'Dette kan skyldes at varen er slettet i backoffice eller ikke er tilgjengelig i den nåværende menyen',
    tr:
      'Bu, ürünün backoffice üzerinden silinmiş veya mevcut menüde bulunmamasından kaynaklanabilir',
    dk:
      'Dette kan skyldes, at varen er blevet slettet i backoffice eller ikke er tilgængelig i den aktuelle menu',
  },
  'ParkedOrders.DeletedItems.Description': {
    en: 'Do you want to proceed to payment without these items?',
    es: '¿Quieres continuar con el cobro sin estos artículos?',
    se: 'Vill du gå vidare till betalning utan dessa artiklar?',
    no: 'Vil du fortsette til betaling uten disse varene?',
    tr: 'Bu ürünler olmadan ödemeye devam etmek istiyor musunuz?',
    dk: 'Vil du fortsætte til betaling uden disse varer?',
  },
  'ParkOrder.BongPrompt': {
    en: 'Send ticket?',
    es: '¿Enviar ticket?',
    se: 'Skicka bong?',
    no: 'Sende bong?',
    tr: 'Fiş gönderilsin mi?',
    dk: 'Sende billet?',
  },
  'ParkedOrders.BongOrChequePrompt': {
    en: 'Print kitchen ticket and/or bill?',
    es: '¿Imprimir ticket de cocina y/o factura?',
    se: 'Skriv ut bong och/eller nota?',
    no: 'Skriv ut bong og/eller regning?',
    tr: 'Mutfak fişi ve/veya faturayı yazdır?',
    dk: 'Udskriv bong og/eller regning?',
  },
  'ParkedOrder.PrintBill': {
    en: 'Do you want to print bill?',
    es: '¿Quieres imprimir la factura?',
    se: 'Vill du skriva ut notan?',
    no: 'Vil du skrive ut regningen?',
    tr: 'Faturayı yazdırmak istiyor musunuz?',
    dk: 'Vil du udskrive regningen?',
  },
  'MembershipPoints.UserId': {
    en: 'User ID',
    es: 'ID de usuario',
    se: 'Användar-ID',
    no: 'Bruker-ID',
    tr: 'Kullanıcı kimliği',
    dk: 'Bruger-id',
  },
  'MembershipPoints.Amount': {
    en: 'Amount',
    es: 'Importe',
    se: 'Antal',
    no: 'Antall',
    tr: 'Miktar',
    dk: 'Beløb',
  },
  'MembershipPoints.PointsAdded': {
    en: 'Points added',
    es: 'Puntos añadidos',
    se: 'Poäng tillagda',
    no: 'Poeng opptjent',
    tr: 'Puan eklendi',
    dk: 'Point tilføjet',
  },
  'MembershipPoints.Submit': {
    en: 'Submit',
    es: 'Enviar',
    se: 'Skicka',
    no: 'Send',
    tr: 'Gönder',
    dk: 'Indsend',
  },
  'MembershipPoints.Add': {
    en: 'Add points',
    es: 'Añadir puntos',
    se: 'Lägg till poäng',
    no: 'Legg til poeng',
    tr: 'Puan ekle',
    dk: 'Tilføj point',
  },
  'MembershipPoints.Add.Placeholder': {
    en: 'Enter points to add',
    es: 'Ingrese los puntos a añadir',
    se: 'Ange poäng att lägga till',
    no: 'Skriv inn poeng å legge til',
    tr: 'Eklemek istediğiniz puanları girin',
    dk: 'Indtast point at tilføje',
  },
  'MembershipPoints.Loading': {
    en: 'Loading members',
    es: 'Cargando miembros',
    se: 'Laddar medlemmar',
    no: 'Laster medlemmer',
    tr: 'Üyeler yükleniyor',
    dk: 'Indlæser medlemmer',
  },
  'MembershipPoints.Add.PermissionDenied': {
    en: 'You do not have permission to add points. This action requires "Refund" permission.',
    es: 'No tienes permiso para añadir puntos. Esta acción requiere permiso de "Reembolso".',
    se:
      'Du har inte behörighet att lägga till poäng. Denna åtgärd kräver "Återbetalning" behörighet.',
    no:
      'Du har ikke tillatelse til å legge til poeng. Denne handlingen krever "Refundering" tillatelse.',
    tr: 'Puan ekleme izniniz yok. Bu işlem "İade" izni gerektirir.',
    dk:
      'Du har ikke tilladelse til at tilføje point. Denne handling kræver "Refundering" tilladelse.',
  },
  // System status
  'SystemStatus.Errors': {
    en: 'errors',
    es: 'errores',
    se: 'fel',
    no: 'feil',
    tr: 'Hatalar',
    dk: 'fejl',
  },
  'SystemStatus.NoErrors': {
    en: 'No errors',
    es: 'Sin errores',
    se: 'Inga fel',
    no: 'Ingen feil',
    tr: 'Hata yok',
    dk: 'Ingen fejl',
  },
  'SystemStatus.Operational': {
    en: 'System is operational',
    es: 'El sistema está operativo',
    se: 'Systemet är i drift',
    no: 'Systemet er i drift',
    tr: 'Sistem çalışıyor',
    dk: 'Systemet er i drift',
  },
  'SystemStatus.Operational.Desc': {
    en: 'Any issues will be displayed here if they occur',
    es: 'Cualquier incidencia aparecerá aquí si ocurre',
    se: 'Eventuella problem visas här om de uppstår',
    no: 'Eventuelle problemer vises her hvis de oppstår',
    tr: 'Herhangi bir sorun oluşursa burada görünecektir',
    dk: 'Eventuelle problemer vises her, hvis de opstår',
  },
  'SystemStatus.ExperiencingIssues': {
    en: 'System is experiencing issues',
    es: 'El sistema está experimentando incidencias',
    se: 'Systemet har problem',
    no: 'Systemet har problemer',
    tr: 'Sistem sorun yaşıyor',
    dk: 'Systemet har problemer',
  },
  'SystemStatus.Warning.CTA': {
    en: 'Warning',
    es: 'Aviso',
    se: 'Varning',
    no: 'Advarsel',
    tr: 'Uyarı',
    dk: 'Advarsel',
  },
  'SystemStatus.Warning': {
    en: 'System is under high load',
    es: 'El sistema está bajo alta carga',
    se: 'Systemet är under hög belastning',
    no: 'Systemet er under høy belastning',
    tr: 'Sistem yüksek yük altında',
    dk: 'Systemet er under høj belastning',
  },
  'SystemStatus.Warning.OrderStatus': {
    en: 'High load on order data',
    es: 'Alta carga en los datos de comandas',
    se: 'Hög belastning på orderdata',
    no: 'Høy belastning på ordredata',
    tr: 'Sipariş verilerinde yüksek yük',
    dk: 'Høj belastning på ordredata',
  },
  'SystemStatus.Warning.TableStatus': {
    en: 'High load on table data',
    es: 'Alta carga en los datos de mesas',
    se: 'Hög belastning på bordsdata',
    no: 'Høy belastning på borddata',
    tr: 'Masa verilerinde yüksek yük',
    dk: 'Høj belastning på borddata',
  },
  'SystemStatus.Warning.Heading': {
    en: 'This may affect system performance',
    es: 'Esto puede afectar el rendimiento del sistema',
    se: 'Detta kan påverka systemets prestanda',
    no: 'Dette kan påvirke systemytelsen',
    tr: 'Bu, sistem performansını etkileyebilir',
    dk: 'Dette kan påvirke systemets ydeevne',
  },
  'SystemStatus.Warning.Desc': {
    en:
      'We recommend restarting the device at a suitable time. Please ensure there are no ongoing payments before doing so.',
    es:
      'Recomendamos reiniciar el dispositivo en un momento adecuado. Asegúrate de que no haya pagos en curso antes de hacerlo.',
    se:
      'Vi rekommenderar att du startar om enheten vid ett lämpligt tillfälle. Se till att det inte finns några pågående betalningar innan du gör det.',
    no:
      'Vi anbefaler at du starter enheten på nytt på et passende tidspunkt. Sørg for at det ikke er noen pågående betalinger før du gjør det.',
    tr:
      'Cihazı uygun bir zamanda yeniden başlatmanızı öneririz. Bunu yapmadan önce devam eden bir ödeme olmadığından emin olun.',
    dk:
      'Vi anbefaler, at du genstarter enheden på et passende tidspunkt. Sørg for, at der ikke er igangværende betalinger, før du gør det.',
  },
  'SystemStatus.Warning.NrOfEvents': {
    en: 'Number of events',
    es: 'Número de eventos',
    se: 'Antal events',
    no: 'Antall hendelser',
    tr: 'Olay sayısı',
    dk: 'Antal hændelser',
  },
  // Support modal
  'SupportModal.Button': {
    en: 'Support',
    es: 'Apoyo',
    se: 'Support',
    no: 'Support',
    tr: 'Destek',
    dk: 'Støtte',
  },
  'SupportModal.Description': {
    en:
      "Describe what happened and what the user tried to do. Enter the time when the event occurred. In the case of the app or a customer, enter the customer's mobile number and / or full name",
    es:
      'Describa qué sucedió y qué intentó hacer el usuario. Ingrese la hora en que ocurrió el evento. En el caso de la aplicación o un cliente, ingrese el número de teléfono móvil y/o el nombre completo del cliente',
    se:
      'Beskriv vad som har hänt samt vad användaren försökte utföra. Ange tidpunkt när händelsen inträffade. Om det gäller appen eller en kund, ange kundens mobilnummer och/eller fullt namn',
    no:
      'Beskriv hva som har skjedd, og hvilken bruker du har forsøkt med. Angi tidspunkt for når hendelsen skjedde. Om det gjelder app-bestilling, angi kundens mobilnummer og/eller fullt navn',
    tr:
      'Ne olduğunu ve kullanıcının ne yapmaya çalıştığını açıklayın. Olayın gerçekleştiği zamanı girin. Uygulama veya müşteri söz konusu olduğunda müşterinin cep telefonu numarasını ve/veya tam adını girin',
    dk:
      'Beskriv, hvad der skete, og hvad brugeren forsøgte at gøre. Indtast det tidspunkt, hvor hændelsen fandt sted. I tilfælde af appen eller en kunde, indtaste kundens mobilnummer og/eller fulde navn',
  },
  'SupportModal.CreatedMessage': {
    en: 'Support ticket created. We will get back to you as soon as possible.',
    es: 'Ticket de soporte creado. Nos pondremos en contacto con usted lo antes posible.',
    se: 'Supportärendet har skapats. Vi återkommer till dig så snart som möjligt.',
    no: 'Supportsaken er opprettet. Vi kommer tilbake til deg så snart som mulig.',
    tr: 'Destek fişi oluşturuldu. En kısa sürede size geri döneceğiz.',
    dk: 'Supportbillet oprettet. Vi vil vende tilbage til dig hurtigst muligt.',
  },
  // Refunds
  'Refunds.UnableToRefund': {
    en: 'Unable to refund order',
    es: 'No se puede reembolsar el pedido',
    se: 'Det gick inte att göra en refund på',
    no: 'Det var ikke mulig å gjennomføre refusjon',
    tr: 'Sipariş iadesi yapılamıyor',
    dk: 'Ordren kunne ikke refunderes',
  },
  'Refunds.ChooseTerminal': {
    en: 'Choose terminal to issue refund on',
    es: 'Elija el datáfono para emitir el reembolso en',
    se: 'Välj terminal att göra återbetalning på',
    no: 'Velg terminal for refundering',
    tr: 'Geri ödemenin yapılacağı terminali seçin',
    dk: 'Vælg terminal at udstede refundering på',
  },
  'Refunds.Refund.Button': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'Återbetala',
    no: 'Refunder',
    tr: 'Geri ödeme',
    dk: 'Tilbagebetale',
  },
  'Refunds.Refunded': {
    en: 'Refunded',
    es: 'Reembolsado',
    se: 'Återbetald',
    no: 'Refundert',
    tr: 'Geri ödeme yapıldı',
    dk: 'Refunderet',
  },
  'Refunds.RefundFullOrder.Button': {
    en: 'Refund the whole order',
    es: 'Reembolsar todo el ticket',
    se: 'Återbetala hela beställningen',
    no: 'Refunder hele bestillingen',
    tr: 'Siparişin tamamını iade edin',
    dk: 'Refunder hele ordren',
  },
  'Refunds.Disabled.MultiPayment.Partial': {
    en: 'Order was paid with multiple payment methods, contact support to make a partial refund',
    es:
      'El pedido se pagó con varios métodos de pago, contacte con soporte para realizar un reembolso parcial',
    se:
      'Beställningen betalades med flera betalningsmetoder, kontakta support för att göra en delåterbetalning',
    no:
      'Bestillingen ble betalt med flere betalingsmetoder, kontakt support for å gjøre en delvis refusjon',
    tr:
      'Sipariş birden fazla ödeme yöntemiyle ödendi, kısmi iade yapmak için destek ile iletişime geçin',
    dk:
      'Ordren blev betalt med flere betalingsmetoder, kontakt support for at lave en delvis refundering',
  },
  'Refunds.SelectItems.Button': {
    en: 'Select articles to refund',
    es: 'Seleccione artículos para reembolsar',
    se: 'Välj artiklar för återbetalning',
    no: 'Velg artikler for refusjon',
    tr: 'Geri ödeme yapılacak ürünleri seçin',
    dk: 'Vælg artikler, der skal refunderes',
  },
  'Refunds.CorrectTip.Button': {
    en: 'Tip correction',
    es: 'Corrección de propina',
    se: 'Korrrigera dricks',
    no: 'Korriger tips',
    tr: 'Bahşiş düzeltme',
    dk: 'Tip korrektion',
  },
  'Refunds.Cancel.Button': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Ophæve',
  },
  'Refunds.GoBack.Button': {
    en: 'Go back',
    es: 'Volver',
    se: 'Tillbaka',
    no: 'Tilbake',
    tr: 'Geri git',
    dk: 'Gå tilbage',
  },
  'Refunds.SelectItems.Title': {
    en: 'Select articles to refund',
    es: 'Seleccione artículos para reembolsar',
    se: 'Välj artiklar för återbetalning',
    no: 'Velg artikler for refusjon',
    tr: 'Geri ödeme yapılacak ürünleri seçin',
    dk: 'Vælg artikler, der skal refunderes',
  },
  'Refunds.ViewSummary.Button': {
    en: 'View summary',
    es: 'Ver resumen',
    se: 'Visa sammanfattning',
    no: 'Vis sammendrag',
    tr: 'Özet görüntüle',
    dk: 'Se oversigt',
  },
  'Refunds.FullRefund.Title': {
    en: 'Full-order refund',
    es: 'Reembolso de ticket completo',
    se: 'Återbetalning av hela beställningen',
    no: 'Refusjon av hele bestillingen',
    tr: 'Tam sipariş iadesi',
    dk: 'Refusion af fuld ordre',
  },
  'Refunds.PartRefund.Title': {
    en: 'Article refund',
    es: 'Reembolso de artículo',
    se: 'Återbetalning av artiklar',
    no: 'Refusjon av artikler',
    tr: 'Ürün iadesi',
    dk: 'Artikel tilbagebetaling',
  },
  'Refunds.TipRefund.Title': {
    en: 'Tip refund',
    es: 'Reembolso de propina',
    se: 'Återbetalning av dricks',
    no: 'Refusjon av tips',
    tr: 'Bahşiş iadesi',
    dk: 'Refusion af tip',
  },
  'Refunds.Summary.TipToRefund': {
    en: 'Tip to be refunded',
    es: 'Propina a reembolsar',
    se: 'Dricks att återbetala',
    no: 'Tips som skal refunderes',
    tr: 'İade edilecek bahşiş',
    dk: 'Drikkepenge der skal refunderes',
  },
  'Refunds.Summary.ArticlesToRefund': {
    en: 'Articles to be refunded',
    es: 'Artículos a reembolsar',
    se: 'Artiklar att återbetala',
    no: 'Artikler som skal refunderes',
    tr: 'İade edilecek ürünler',
    dk: 'Artikler der skal refunderes',
  },
  'Refunds.CurrentTip': {
    en: 'Current tip',
    es: 'Propina actual',
    se: 'Nuvarande dricks',
    no: 'Nåværende tips',
    tr: 'Şu anki bahşiş',
    dk: 'Nuværende tip',
  },
  'Refunds.NewTip': {
    en: 'New tip',
    es: 'Nueva propina',
    se: 'Ny dricks',
    no: 'Ny tips',
    tr: 'Yeni bahşiş',
    dk: 'Nyt tip',
  },
  'Refunds.Tip.AmountToRefund': {
    en: 'Amount to refund',
    es: 'Cantidad a reembolsar',
    se: 'Summa att återbetala',
    no: 'Sum å tilbakebetale',
    tr: 'İade edilecek tutar',
    dk: 'Beløb til tilbagebetaling',
  },
  'Refunds.Tip.SetNewAmount': {
    en: 'Set new amount',
    es: 'Establecer nueva cantidad',
    se: 'Ange ny summa',
    no: 'Oppgi ny sum',
    tr: 'Yeni tutarı ayarla',
    dk: 'Indstil nyt beløb',
  },
  'Refunds.Disabled.MultiPayment': {
    en: 'Order was paid with multiple payment methods, contact support to make a refund',
    es:
      'El pedido se pagó con varios métodos de pago, contacte con soporte para realizar un reembolso',
    se:
      'Beställningen betalades med flera betalningsmetoder, kontakta support för att göra en återbetalning',
    no:
      'Bestillingen ble betalt med flere betalingsmetoder, kontakt support for å gjøre en refusjon',
    tr:
      'Sipariş birden fazla ödeme yöntemiyle ödendi, geri ödeme yapmak için destek ile iletişime geçin',
    dk:
      'Ordren blev betalt med flere betalingsmetoder, kontakt support for at foretage en refundering',
  },
  'Refunds.Disabled.AlreadyRefunded': {
    en: 'Order has already been refunded',
    es: 'El ticket ya ha sido reembolsado',
    se: 'Beställningen har redan återbetalats',
    no: 'Bestillingen har allerede blitt refundert',
    tr: 'Sipariş zaten geri ödendi',
    dk: 'Ordren er allerede blevet refunderet',
  },
  'Refunds.Disabled.OrderNotCompleted': {
    en: 'Order has not been completed',
    es: 'El ticket no se ha completado',
    se: 'Beställningen har inte genomförts',
    no: 'Bestillingen har ikke blitt fullført',
    tr: 'Sipariş tamamlanmadı',
    dk: 'Ordren er ikke gennemført',
  },
  'Refunds.Disabled.StaffNotAllowed': {
    en: "You don't have the required access level for refunds",
    es: 'No tiene el nivel de acceso requerido para los reembolsos',
    se: 'Du har inte rätt åtkomstnivå för återbetalningar',
    no: 'Du har ikke nødvendig tilgangsnivå for å gjøre refusjoner',
    tr: 'Geri ödemeler için gerekli erişim düzeyine sahip değilsiniz',
    dk: 'Du har ikke det nødvendige adgangsniveau til refusion',
  },
  // Printer status
  'PrinterStatus.PrintReceipt': {
    en: 'Print latest receipt',
    es: 'Imprimir último ticket',
    se: 'Skriv ut senaste kvitto',
    no: 'Skriv ut siste kvittering',
    tr: 'Son makbuzu yazdır',
    dk: 'Udskriv seneste kvittering',
  },
  'PrinterStatus.Online': {
    en: 'Online',
    es: 'En línea',
    se: 'Online',
    no: 'Online',
    tr: 'Çevrimiçi',
    dk: 'Online',
  },
  'PrinterStatus.Offline': {
    en: 'Offline',
    es: 'Desconectado',
    se: 'Offline',
    no: 'Offline',
    tr: 'Çevrimdışı',
    dk: 'Offline',
  },
  'PrinterStatus.Title': {
    en: 'Printers',
    es: 'Impresora',
    se: 'Skrivare',
    no: 'Printer',
    tr: 'Yazıcı',
    dk: 'Printer',
  },
  'PrinterStatus.Operational': {
    en: 'No failed prints',
    es: 'Sin impresiones fallidas',
    se: 'Inga misslyckade utskrifter',
    no: 'Ingen mislykkede utskrifter',
    tr: 'Başarısız yazdırma yok',
    dk: 'Ingen mislykkede udskrifter',
  },
  'PrinterStatus.NotConnected': {
    en: 'No printer connected',
    es: 'Sin impresora conectada',
    se: 'Ingen skrivare ansluten',
    no: 'Ingen skriver tilkoblet',
    tr: 'Yazıcı bağlı değil',
    dk: 'Ingen printer tilsluttet',
  },
  'PrinterStatus.Warning': {
    en: 'Some printers seem to be offline',
    es: 'Algunas impresoras parecen estar desconectadas',
    se: 'Några skrivare verkar vara offline',
    no: 'Noen skrivere ser ut til å være offline',
    tr: 'Bazı yazıcılar çevrimdışı görünüyor',
    dk: 'Nogle printere ser ud til at være offline',
  },
  'PrinterStatus.Warning.Desc': {
    en: 'Check internet connection and printer status below',
    es: 'Verifica la conexión a internet y el estado de las impresoras a continuación',
    se: 'Se över internetuppkoppling och skrivarstatus nedan',
    no: 'Sjekk internettforbindelsen og skriverstatus nedenfor',
    tr: 'Aşağıdan internet bağlantınızı ve yazıcı durumunu kontrol edin',
    dk: 'Tjek internetforbindelsen og printerstatus nedenfor',
  },
  'PrinterStatus.Error': {
    en: 'Failed to print',
    es: 'Error al imprimir',
    se: 'Kunde inte skriva ut',
    no: 'Kunne ikke skrive ut',
    tr: 'Yazdırma başarısız',
    dk: 'Udskrivning mislykkedes',
  },
  'PrinterStatus.Error.Desc': {
    en: 'Please review the printer errors below',
    es: 'Revise los errores de la impresora a continuación',
    se: 'Granska skrivarfelen nedan',
    no: 'Se gjennom skriverfeilene nedenfor',
    tr: 'Lütfen aşağıdaki yazıcı hatalarını kontrol edin',
    dk: 'Gennemgå printerfejlene nedenfor',
  },
  'PrinterStatus.SendBong': {
    en: 'Send / Print tickets',
    es: 'Enviar / Imprimir ticket',
    se: 'Skicka / Skriv ut bong',
    no: 'Send / Skriv ut bong',
    tr: 'Fiş gönder / yazdır',
    dk: 'Send / Print billet',
  },
  'PrinterStatus.Sent': {
    en: 'Sending...',
    es: 'Enviando...',
    se: 'Skickar...',
    no: 'Sender...',
    tr: 'Gönderiliyor...',
    dk: 'Sender...',
  },
  'PrinterStatus.Scanning': {
    en: 'Scanning...',
    es: 'Escaneando...',
    se: 'Söker...',
    no: 'Søker...',
    tr: 'Taranıyor...',
    dk: 'Søger...',
  },
  'PrinterStatus.Reconnect': {
    en: 'Reconnect printers',
    es: 'Reconectar impresoras',
    se: 'Återanslut skrivare',
    no: 'Koble til skrivere på nytt',
    tr: 'Yazıcıları yeniden bağla',
    dk: 'Genforbind printere',
  },
  'PrinterStatus.PrinterConnection': {
    en: 'Printer connection',
    es: 'Conexión de impresora',
    se: 'Skrivaranslutning',
    no: 'Printerforbindelse',
    tr: 'Yazıcı bağlantısı',
    dk: 'Printerforbindelse',
  },
  'PrinterStatus.InternetConnection': {
    en: 'Internet connection',
    es: 'Conexión a internet',
    se: 'Internetanslutning',
    no: 'Internettforbindelse',
    tr: 'İnternet bağlantısı',
    dk: 'Internetforbindelse',
  },
  'PrinterStatus.Errors': {
    en: 'Print errors',
    es: 'Errores de impresión',
    se: 'Skrivarfel',
    no: 'Utskriftsfeil',
    tr: 'Yazdırma hataları',
    dk: 'Udskriftsfejl',
  },
  'PrinterStatus.Errors.Retry': {
    en: 'Retry',
    es: 'Reintentar',
    se: 'Försök igen',
    no: 'Prøv igjen',
    tr: 'Tekrar dene',
    dk: 'Prøv igen',
  },
  'PrinterStatus.Errors.RetryWith': {
    en: 'Retry with...',
    es: 'Reintentar con...',
    se: 'Försök igen med...',
    no: 'Prøv igjen med...',
    tr: 'Şununla tekrar dene...',
    dk: 'Prøv igen med...',
  },
  'PrinterStatus.Errors.Dismiss': {
    en: 'Dismiss',
    es: 'Descartar',
    se: 'Avfärda',
    no: 'Avvis',
    tr: 'Reddet',
    dk: 'Afvis',
  },
  'PrinterStatus.Errors.ForOrder': {
    en: 'for order:',
    es: 'para orden:',
    se: 'gällande order:',
    no: 'for ordre:',
    tr: 'için sipariş:',
    dk: 'for ordre:',
  },
  'PrinterStatus.NoPrintersAdded': {
    en: 'No printers have been added, go to printer settings to add.',
    es: 'No se han agregado impresoras, vaya a la configuración de impresoras para agregar.',
    se: 'Inga skrivare har lagts till, gå till skrivarinställningar för att lägga till.',
    no: 'Ingen skrivere er lagt til, gå til skriverinnstillinger for å legge til.',
    tr: 'Yazıcı eklenmedi, eklemek için yazıcı ayarlarına gidin.',
    dk: 'Ingen printere er tilføjet, gå til printerindstillinger for at tilføje.',
  },
  'PrinterStatus.PrinterSettings': {
    en: 'Printer settings',
    es: 'Configuración de impresora',
    se: 'Skrivarinställningar',
    no: 'Skriveinnstillinger',
    tr: 'Yazıcı ayarları',
    dk: 'Printerindstillinger',
  },
  'PrinterStatus.OrderId': {
    en: 'Order ID',
    es: 'Nº de pedido',
    se: 'Order-ID',
    no: 'Ordre-ID',
    tr: 'Sipariş ID',
    dk: 'Ordre-ID',
  },
  'PrinterStatus.Loading': {
    en: 'Loading...',
    es: 'Cargando...',
    se: 'Laddar...',
    no: 'Laster...',
    tr: 'Yükleniyor...',
    dk: 'Indlæser...',
  },
  'PrintType.BONG': {
    en: 'Kitchen ticket',
    es: 'Comanda de cocina',
    se: 'Köksbong',
    no: 'Bong',
    tr: 'Mutfak fişi',
    dk: 'Køkkenbillet',
  },
  'PrintType.RECEIPT': {
    en: 'Receipt',
    es: 'Ticket',
    se: 'Kvitto',
    no: 'Kvittering',
    tr: 'Fiş',
    dk: 'Kvittering',
  },
  'PrintType.SESSION_RECEIPT': {
    en: 'Session receipt',
    es: 'Ticket de sesión',
    se: 'Sessionkvitto',
    no: 'Øktkvittering',
    tr: 'Oturum fişi',
    dk: 'Session kvittering',
  },
  'PrintType.COMPETITION_SCORE': {
    en: 'Competition score',
    es: 'Puntuación de la competencia',
    se: 'Tävlingsresultat',
    no: 'Konkurransepoeng',
    tr: 'Yarışma puanı',
    dk: 'Konkurrence score',
  },
  'PrintType.TEST_PRINT': {
    en: 'Test print',
    es: 'Impresión de prueba',
    se: 'Testutskrift',
    no: 'Testutskrift',
    tr: 'Test baskısı',
    dk: 'Test print',
  },
  'PrintType.Z_REPORT': {
    en: 'Z-report',
    es: 'Informe Z',
    se: 'Z-rapport',
    no: 'Z-rapport',
    tr: 'Z-raporu',
    dk: 'Z-rapport',
  },
  'PrintType.EPOS_ORDER_NUMBER': {
    en: 'EPOS order number',
    es: 'Nº EPOS',
    se: 'EPOS ordernummer',
    no: 'EPOS ordrenummer',
    tr: 'EPOS sipariş numarası',
    dk: 'EPOS ordrenummer',
  },
  'PrintType.REPORT': {
    en: 'Report',
    es: 'Informe',
    se: 'Rapport',
    no: 'Rapport',
    tr: 'Rapor',
    dk: 'Rapport',
  },
  'PrintType.START_DAY': {
    en: 'Start day ticket',
    es: 'Ticket de inicio de servicio',
    se: 'Startdagsbong',
    no: 'Startdag billett',
    tr: 'Günü başlat fişi',
    dk: 'Start dag billet',
  },
  'PrintType.INVENTORY': {
    en: 'Inventory',
    es: 'Inventario',
    se: 'Inventering',
    no: 'Inventar',
    tr: 'Envanter',
    dk: 'Inventar',
  },
  'PrintType.GIFT_CARD': {
    en: 'Gift card',
    es: 'Tarjeta de regalo',
    se: 'Presentkort',
    no: 'Gavekort',
    tr: 'Hediye kartı',
    dk: 'Gavekort',
  },
  'PrintType.SWISH': {
    en: 'Swish',
    es: 'Swish',
    se: 'Swish',
    no: 'Swish',
    tr: 'Swish',
    dk: 'Swish',
  },
  'PrintType.PAYMENT_SCAN': {
    en: 'Payment scan',
    es: 'Escaneo de pago',
    se: 'Betalningsskanning',
    no: 'Betalings skanning',
    tr: 'Ödeme taraması',
    dk: 'Betalings scan',
  },
  'Printer.BackupBong': {
    en: 'Backup kitchen ticket was successfully printed on the primary printer',
    es: 'La comanda de cocina de respaldo se imprimió correctamente en la impresora principal',
    se: 'Backup köksbong skrevs ut på den primära skrivare',
    no: 'Backup kjøkkenbillet ble skrevet ut på primær skriver',
    tr: 'Yedek mutfak fişi başarılı bir şekilde birincil yazıcıda yazdırıldı',
    dk: 'Backup køkkenbillet blev succesfuldt udskrevet på primær printer',
  },
  'Printer.BackupBong.Failed': {
    en: 'Failed to print backup kitchen ticket on the primary printer',
    es: 'Error al imprimir la comanda de cocina de respaldo en la impresora principal',
    se: 'Det gick inte att skriva ut backup köksbong på den primära skrivaren',
    no: 'Klarte ikke å skrive ut backup kjøkkenbillet på primær skriver',
    tr: 'Yedek mutfak fişi birincil yazıcıda yazdırılamadı',
    dk: 'Kunne ikke udskrive backup køkkenbillet på primær printer',
  },
  'Printer.Error.Connection': {
    en: 'Could not connect to the printer, please check the connection',
    es: 'No se pudo conectar a la impresora, por favor verifique la conexión',
    se: 'Kunde inte ansluta till skrivaren, vänligen kontrollera anslutningen',
    no: 'Kunne ikke koble til skriveren, vennligst sjekk tilkoblingen',
    tr: 'Yazıcıya bağlanılamadı, lütfen bağlantıyı kontrol edin',
    dk: 'Kunne ikke forbinde til printeren, tjek venligst forbindelsen',
  },
  'Printer.Error.BadPort': {
    en: 'Bad port, please check the printer settings',
    es: 'Puerto incorrecto, por favor verifique la configuración de la impresora',
    se: 'Felaktig port, vänligen kontrollera skrivarens inställningar',
    no: 'Feil port, vennligst sjekk skriverinnstillingene',
    tr: 'Kötü port, lütfen yazıcı ayarlarını kontrol edin',
    dk: 'Dårlig port, tjek venligst printerindstillingerne',
  },
  'Printer.Error.OpenFailed': {
    en: 'Could not connect to the printer, check the printer',
    es: 'No se pudo conectar a la impresora, verifique la impresora',
    se: 'Kunde inte ansluta till skrivaren, kontrollera skrivaren',
    no: 'Kunne ikke koble til skriveren, sjekk skriveren',
    tr: 'Yazıcıya bağlanılamadı, yazıcıyı kontrol',
    dk: 'Kunne ikke forbinde til printeren, tjek printeren',
  },
  'Printer.Error.NoPaper': {
    en: 'No paper in the printer',
    es: 'No hay papel en la impresora',
    se: 'Inget papper i skrivaren',
    no: 'Ingen papir i skriveren',
    tr: 'Yazıcıda kağıt yok',
    dk: 'Ingen papir i printeren',
  },
  'Printer.Error.CoverOpen': {
    en: 'The printer cover is open, please close it',
    es: 'La cubierta de la impresora está abierta, por favor ciérrela',
    se: 'Skrivarlocket är öppet, vänligen stäng det',
    no: 'Skriverdekselet er åpent, vennligst lukk det',
    tr: 'Yazıcı kapağı açık, lütfen kapatın',
    dk: 'Printerdækslet er åbent, luk venligst',
  },
  'Printer.Error.Cutter': {
    en: 'The printer cutter is jammed',
    es: 'El cortador de la impresora está atascado',
    se: 'Skrivarens papper-skärare har fastnat',
    no: 'Skriverens kuttekniv er fast',
    tr: 'Yazıcı kesici sıkıştı',
    dk: 'Printerskæreren er fast',
  },
  'Printer.Error.Mechanical': {
    en: 'Mechanical error, please check the printer',
    es: 'Error mecánico, por favor verifique la impresora',
    se: 'Mekaniskt fel, vänligen kontrollera skrivaren',
    no: 'Mekanisk feil, vennligst sjekk skriveren',
    tr: 'Mekanik hata, lütfen yazıcıyı kontrol edin',
    dk: 'Mekanisk fejl, tjek venligst printeren',
  },
  'Printer.Error.Unknown': {
    en: 'Unknown printer error, check cables and connection.',
    es: 'Error desconocido de la impresora, verifique los cables y la conexión.',
    se: 'Okänt skrivarfel, kontrollera kablar och anslutning.',
    no: 'Ukjent skriverfeil, sjekk kabler og tilkobling.',
    tr: 'Bilinmeyen yazıcı hatası, kabloları ve bağlantıyı kontrol edin.',
    dk: 'Ukendt printerfejl, tjek kabler og forbindelse.',
  },
  'Printer.Error.Receipt': {
    en: 'Receipt print failed',
    es: 'Error al imprimir el ticket',
    se: 'Kvitto utskrift misslyckades',
    no: 'Kvittering utskrift feilet',
    tr: 'Fiş yazdırma başarısız',
    dk: 'Kvittering udskrivning mislykkedes',
  },
  'Printer.Status.CoverOpen': {
    en: 'The cover is open',
    es: 'La cubierta está abierta',
    se: 'Luckan är öppen',
    no: 'Dekselet er åpent',
    tr: 'Kapak açık',
    dk: 'Dækslet er åbent',
  },
  'Printer.Status.DrawerOpen': {
    en: 'Cash drawer is open',
    es: 'La caja registradora está abierta',
    se: 'Kassalådan är öppen',
    no: 'Kontantskuffen er åpen',
    tr: 'Çekmece açık',
    dk: 'Kontantskuffen er åben',
  },
  'Printer.Status.Online': {
    en: 'Printer is online',
    es: 'La impresora está en línea',
    se: 'Skrivaren är online',
    no: 'Skriveren er online',
    tr: 'Yazıcı çevrimiçi',
    dk: 'Printeren er online',
  },
  'Printer.Status.InternetOnline': {
    en: 'No internet issues detected',
    es: 'No se detectaron problemas de internet',
    se: 'Inga internetproblem upptäckta',
    no: 'Ingen internettproblemer oppdaget',
    tr: 'İnternet sorunu tespit edilmedi',
    dk: 'Ingen internetproblemer fundet',
  },
  'Printer.Status.InternetOffline': {
    en: 'Internet seems to be offline',
    es: 'Parece que el internet está desconectado',
    se: 'Internet verkar vara offline',
    no: 'Internett ser ut til å være offline',
    tr: 'İnternet çevrimdışı görünüyor',
    dk: 'Internettet ser ud til at være offline',
  },
  'Printer.Status.AddedPrinters': {
    en: 'Added printers',
    es: 'Impresoras añadidas',
    se: 'Tillagda skrivare',
    no: 'Tilførte skrivere',
    tr: 'Eklenen yazıcılar',
    dk: 'Tilføjede printere',
  },
  'Printer.Status.FailedPrints': {
    en: 'Failed prints',
    es: 'Impresiones fallidas',
    se: 'Misslyckade utskrifter',
    no: 'Mislykkede utskrifter',
    tr: 'Başarısız yazdırmalar',
    dk: 'Mislykkede udskrifter',
  },
  'Printer.Status.Offline': {
    en: 'Printer is not responding',
    es: 'La impresora no responde',
    se: 'Skrivaren svarar inte',
    no: 'Skriveren svarer ikke',
    tr: 'Yazıcı yanıt vermiyor',
    dk: 'Printeren svarer ikke',
  },
  'Printer.Status.NoStation': {
    en: 'No station selected',
    es: 'Sin punto de elaboración',
    se: 'Ingen station vald',
    no: 'Ingen stasjon valgt',
    tr: 'Seçilen istasyon yok',
    dk: 'Ingen station valgt',
  },
  'Printer.Status.Primary': {
    en: 'Primary',
    es: 'Primario',
    se: 'Primär',
    no: 'Primær',
    tr: 'Birincil',
    dk: 'Primær',
  },
  'Printer.Status.Stations': {
    en: 'Stations',
    es: 'Estaciones',
    se: 'Stationer',
    no: 'Stasjoner',
    tr: 'İstasyonlar',
    dk: 'Stationer',
  },
  'Printer.Status.NoPaper': {
    en: 'No paper',
    es: 'Sin papel',
    se: 'Slut på papper',
    no: 'Ingen papir',
    tr: 'Kağıt yok',
    dk: 'Ingen papir',
  },
  'Printer.Status.PaperNearEmpty': {
    en: 'Paper almost empty',
    es: 'Papel casi agotado',
    se: 'Pappret är nästan slut',
    no: 'Papir nesten tomt',
    tr: 'Kağıt neredeyse bitmiş',
    dk: 'Papir næsten tomt',
  },
  'Printer.Status.DismissAll': {
    en: 'Dismiss all',
    es: 'Descartar todo',
    se: 'Avvisa alla',
    no: 'Avvis alle',
    tr: 'Hepsini Kapat',
    dk: 'Afvis alle',
  },
  'Printer.Status.TryAllAgain': {
    en: 'Try all again',
    es: 'Intentar todo de nuevo',
    se: 'Försök igen',
    no: 'Prøv igjen',
    tr: 'Tekrar dene',
    dk: 'Prøv igen',
  },

  // Payment status
  'PaymentStatus.PlacingOrder': {
    en: 'Placing order',
    es: 'Realización de pedido',
    se: 'Lägger beställning',
    no: 'Oppretter bestilling',
    tr: 'Sipariş verme',
    dk: 'Placerer ordre',
  },
  'PaymentStatus.Cancelled': {
    en: 'Cancelled',
    es: 'Cancelado',
    se: 'Avbruten',
    no: 'Avbrutt',
    tr: 'İptal edildi',
    dk: 'Annulleret',
  },
  'PaymentStatus.Refund': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'Återbetalning',
    no: 'Refusjon',
    tr: 'Geri öde',
    dk: 'Tilbagebetale',
  },
  'PaymentStatus.Payment': {
    en: 'Payment',
    es: 'Pago',
    se: 'Betalning',
    no: 'Betaling',
    tr: 'Ödeme',
    dk: 'Betaling',
  },
  'PaymentStatus.InProgress': {
    en: 'in progress',
    es: 'en curso',
    se: 'pågår',
    no: 'pågår',
    tr: 'Devam etmekte',
    dk: 'i gang',
  },
  'PaymentStatus.RetryRefund': {
    en: 'Retry refund',
    es: 'Reintentar reembolso',
    se: 'Prova återbetalning igen',
    no: 'Prøv refusjon på nytt',
    tr: 'Geri ödemeyi yeniden dene',
    dk: 'Prøv refusion igen',
  },
  'PaymentStatus.Completed': {
    en: 'Completed!',
    es: 'Terminado!',
    se: 'Genomförd!',
    no: 'Fullført!',
    tr: 'Tamamlandı!',
    dk: 'Fuldført!',
  },
  'PaymentStatus.ReadyForNext': {
    en: 'Ready to accept next',
    es: 'Listo para aceptar el siguiente',
    se: 'Redo för nästa',
    no: 'Klar for neste',
    tr: 'Sonrakini kabul etmeye hazır',
    dk: 'Klar til at acceptere næste',
  },
  // KDS (Kitchen display)
  'KDS.Warning.OutOfSync': {
    en: 'Warning! Out of sync. Number of missed actions:',
    es: '¡Advertencia! Fuera de sincronización. Número de acciones perdidas:',
    se: 'Varning!. Osynkroniserad. Antal missade händelser:',
    no: 'Advarsel! Ikke synkronisert. Antall tapte hendelser:',
    tr: 'Uyarı! Senkron dışında. Kaçırılan eylemlerin sayısı:',
    dk: 'Advarsel! Ude af synkronisering. Antal mistede handlinger:',
  },
  'KDS.Warning.LostConnection': {
    en: 'Warning! Lost connection to central server. Check internet connection',
    es:
      '¡Advertencia! Se perdió la conexión con el servidor central. Comprobar la conexión a Internet',
    se: 'Varning!. Förlorad anslutning till central server. Kontrollera internetanslutningen',
    no: 'Advarsel! Mangler kontakt med server. Vennligst kontroller nettverkstilkoblingen',
    tr: 'Uyarı! Merkezi sunucuyla bağlantı kesildi. İnternet bağlantısını kontrol edin',
    dk: 'Advarsel! Mistet forbindelse til central server. Tjek internetforbindelsen',
  },
  'KDS.Orders': {
    en: 'orders',
    es: 'pedidos',
    se: 'ordrar',
    no: 'ordre',
    tr: 'Emirler',
    dk: 'ordrer',
  },
  'KDS.Accept': {
    en: 'Accept',
    es: 'Aceptar',
    se: 'Acceptera',
    no: 'Aksepter',
    tr: 'Kabul et',
    dk: 'Accepter',
  },
  'KDS.Reject': {
    en: 'Reject',
    es: 'Rechazar',
    se: 'Neka',
    no: 'Avvis',
    tr: 'Reddet',
    dk: 'Afvis',
  },
  'KDS.IncomingOrders': {
    en: 'Incoming orders',
    es: 'Pedidos entrantes',
    se: 'Inkommande ordrar',
    no: 'Innkommende ordre',
    tr: 'Gelen siparişler',
    dk: 'Indgående ordrer',
  },
  'KDS.IncomingOrders.FailedAccept': {
    en: 'Failed to accept order, please try again',
    es: 'Error al aceptar el pedido, por favor intente de nuevo',
    se: 'Misslyckades med att acceptera beställning, försök igen',
    no: 'Kunne ikke akseptere bestilling, vennligst prøv igjen',
    tr: 'Siparişi kabul edemedim, lütfen tekrar deneyin',
    dk: 'Kunne ikke acceptere ordren, prøv igen',
  },
  'KDS.IncomingOrders.Pickup': {
    en: 'Pickup',
    es: 'Recoger',
    se: 'Hämtning',
    no: 'Henting',
    tr: 'Alma',
    dk: 'Afhentning',
  },
  'KDS.Warning.ProblemRequest': {
    en: 'There was a problem handling your request.',
    es: 'Hubo un problema con la realización de su encargo.',
    se: 'Det uppstod ett problem med att hantera din förfrågan.',
    no: 'Det oppstod et problem med å håndtere forespørselen.',
    tr: 'İsteğiniz işleme alınırken bir sorun oluştu.',
    dk: 'Der opstod et problem med at håndtere din anmodning.',
  },
  'KDS.Delayed': {
    en: 'Delayed',
    es: 'Demorado',
    se: 'Försenad',
    no: 'Forsinket',
    tr: 'Gecikti',
    dk: 'Forsinket',
  },
  'KDS.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'KDS.PickupTime': {
    en: 'Pickup time',
    es: 'Hora de recogida',
    se: 'Upphämtningstid',
    no: 'Hentetidspunkt',
    tr: 'Alma vakti',
    dk: 'Afhentningstid',
  },
  'KDS.Min': {
    en: 'min',
    es: 'min',
    se: 'min',
    no: 'min',
    tr: 'dk.',
    dk: 'min',
  },
  'KDS.TimeNotSet': {
    en: 'Time not set',
    es: 'Hora no establecida',
    se: 'Ingen tid vald',
    no: 'Ingen tid valgt',
    tr: 'Zaman ayarlanmadı',
    dk: 'Tid ikke indstillet',
  },
  'KDS.AssignStation': {
    en: 'Assign a station to this Kitchen Display',
    es: 'Asigne un punto de elaboración a esta pantalla de cocina',
    se: 'Tilldela en station till denna KDS',
    no: 'Tildel en stasjon til denne kjøkkenskjermen',
    tr: 'Bu Mutfağa bir istasyon atayın',
    dk: 'Tildel en station til denne Kitchen Display',
  },
  'KDS.AssignStation.Subtitle': {
    en: 'Determines which articles and orders will appear on this Kitchen Display',
    es: 'Determina qué artículos y pedidos aparecerán en esta pantalla de cocina',
    se: 'Avgör vilka artiklar och beställningar som visas i denna KDS',
    no: 'Bestemmer hvilke artikler og bestillinger som vises på denne kjøkkenskjermen',
    tr: 'Bu, Mutfak Ekranında hangi ürünlerin ve siparişlerin görüneceğini belirler',
    dk: 'Bestemmer hvilke artikler og ordrer der vises på denne Kitchen Display',
  },
  'KDS.Loading': {
    en: 'Loading',
    es: 'Cargando',
    se: 'Laddar',
    no: 'Laster',
    tr: 'Yükleniyor',
    dk: 'Indlæser',
  },
  'KDS.ERROR': {
    en: 'ERROR',
    es: 'ERROR',
    se: 'FEL',
    no: 'FEIL',
    tr: 'HATA',
    dk: 'FEJL',
  },
  'KDS.Station': {
    en: 'Station',
    es: 'Punto de elaboración',
    se: 'Station',
    no: 'Stasjon',
    tr: 'İstasyon',
    dk: 'Station',
  },
  'KDS.ACCEPTED': {
    en: 'Accepted',
    es: 'Aceptado',
    se: 'Accepterad',
    no: 'Akseptert',
    tr: 'Kabul edildi',
    dk: 'Accepteret',
  },
  'KDS.FINALIZING': {
    en: 'Finalizing',
    es: 'Finalizando',
    se: 'Slutför',
    no: 'Fullfør',
    tr: 'Sonlandırılıyor',
    dk: 'Afslutter',
  },
  'KDS.READY': {
    en: 'Ready',
    es: 'Listo',
    se: 'Redo',
    no: 'Klar',
    tr: 'Hazır',
    dk: 'Klar',
  },
  'KDS.Accepted': {
    en: 'Accepted',
    es: 'Aceptado',
    se: 'Accepterad',
    no: 'Akseptert',
    tr: 'Kabul edildi',
    dk: 'Accepteret',
  },
  'KDS.Finalizing': {
    en: 'Finalizing',
    es: 'Finalizando',
    se: 'Slutför',
    no: 'Fullfør',
    tr: 'Sonlandırılıyor',
    dk: 'Afslutter',
  },
  'KDS.Ready': {
    en: 'Ready',
    es: 'Listo',
    se: 'Redo',
    no: 'Klar',
    tr: 'Hazır',
    dk: 'Klar',
  },
  'KDS.Overdue': {
    en: 'Overdue',
    es: 'Atrasado',
    se: 'Försenad',
    no: 'Forsinket',
    tr: 'Vadesi geçmiş',
    dk: 'Forsinket',
  },
  'KDS.Reload': {
    en: 'Reload',
    es: 'Recargar',
    se: 'Ladda om',
    no: 'Oppdater',
    tr: 'Tekrar yükle',
    dk: 'Genindlæs',
  },
  'KDS.ClearOrders': {
    en: 'Clear orders',
    es: 'Limpiar pedidos',
    se: 'Rensa ordrar',
    no: 'Fjern ordre',
    tr: 'Siparişleri temizle',
    dk: 'Rens ordrer',
  },
  'KDS.ClearOrders.ConfirmForStation': {
    en: 'Are you sure you want to clear all orders for this station?',
    es: '¿Está seguro de que desea limpiar todos los pedidos para esta estación?',
    se: 'Är du säker på att du vill rensa alla ordrar för denna station?',
    no: 'Er du sikker på at du vil fjerne alle ordre for denne stasjonen?',
    tr: 'Bu istasyon için tüm siparişleri temizlemek istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil rense alle ordrer for denne station?',
  },
  'KDS.ClearOrders.Confirm': {
    en: 'Are you sure you want to clear all orders?',
    es: '¿Está seguro de que desea limpiar todos los pedidos?',
    se: 'Är du säker på att du vill rensa alla ordrar?',
    no: 'Er du sikker på at du vil fjerne alle ordre?',
    tr: 'Tüm siparişleri temizlemek istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil rense alle ordrer?',
  },
  'KDS.Undo': {
    en: 'Undo',
    es: 'Deshacer',
    se: 'Ångra',
    no: 'Angre',
    tr: 'Geri al',
    dk: 'Fortryd',
  },
  'KDS.NoCourseType': {
    en: 'No course type',
    es: 'Sin tipo de curso',
    se: 'Övrigt',
    no: 'Annet',
    tr: 'Kors türü yok',
    dk: 'Ingen kursustype',
  },
  'KDS.LaterThan30Minutes': {
    en: 'Due in more than 30 minutes',
    es: 'Más de 30 minutos restantes',
    se: 'Längre än 30 minuter kvar',
    no: 'Mer enn 30 minutter igjen',
    tr: '30 dakikadan fazla süre kaldı',
    dk: 'Mere end 30 minutter tilbage',
  },
  // POS
  'POS.Park': {
    en: 'Park',
    es: 'Aparcar',
    se: 'Parkera',
    no: 'Parker',
    tr: 'Park',
    dk: 'Parker',
  },
  'POS.Parked': {
    en: 'Parked',
    es: 'Aparcados',
    se: 'Parkerade',
    no: 'Parkerte',
    tr: 'Park edildi',
    dk: 'Parkeret',
  },
  'POS.Collecting': {
    en: 'Collecting',
    es: 'Unificados',
    se: 'Samlade',
    no: 'Samler',
    tr: 'Toplama',
    dk: 'Indsamler',
  },
  'POS.Collect': {
    en: 'Collect',
    es: 'Unificar',
    se: 'Samla',
    no: 'Samlebong',
    tr: 'Topla',
    dk: 'Samle',
  },
  'POS.Undo': {
    en: 'Undo',
    es: 'Deshacer',
    se: 'Ångra',
    no: 'Angre',
    tr: 'Geri al',
    dk: 'Fortryd',
  },
  'POS.Change': {
    en: 'Change',
    es: 'Modificadores',
    se: 'Ändra',
    no: 'Endre',
    tr: 'Değiştir',
    dk: 'Ændre',
  },
  'POS.Message': {
    en: 'Message',
    es: 'Mensaje',
    se: 'Meddelande',
    no: 'Melding',
    tr: 'İleti',
    dk: 'Besked',
  },
  'POS.Duplicate': {
    en: 'Duplicate',
    es: 'Duplicar',
    se: 'Duplicera',
    no: 'Dupliser',
    tr: 'Kopyala',
    dk: 'Duplikere',
  },
  'POS.Remove': {
    en: 'Remove',
    es: 'Elimina',
    se: 'Radera',
    no: 'Fjern',
    tr: 'Kaldır',
    dk: 'Fjerne',
  },
  'POS.Messages': {
    en: 'Messages',
    es: 'Mensajes',
    se: 'Meddelanden',
    no: 'Meldinger',
    tr: 'Mesajlar',
    dk: 'Beskeder',
  },
  'POS.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Ophæve',
  },
  'POS.Split': {
    en: 'Split',
    es: 'Dividir',
    se: 'Dela',
    no: 'Splitt',
    tr: 'Böl',
    dk: 'Del',
  },
  'POS.Pay': {
    en: 'Pay',
    es: 'Pagar',
    se: 'Betala',
    no: 'Betal',
    tr: 'Öde',
    dk: 'Betal',
  },
  'POS.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'POS.Clear': {
    en: 'Clear',
    es: 'Eliminar',
    se: 'Rensa',
    no: 'Fjern',
    tr: 'Temizle',
    dk: 'Slet',
  },
  'POS.Qty': {
    en: 'Qty',
    es: 'Ud',
    se: 'Qty',
    no: 'Ant',
    tr: 'Adet',
    dk: 'Antal',
  },
  'POS.Article': {
    en: 'Article',
    es: 'Artículo',
    se: 'Artikel',
    no: 'Artikkel',
    tr: 'Ürün',
    dk: 'Artikel',
  },
  'POS.Discount': {
    en: 'Discount',
    es: 'Descuento',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'POS.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Totalt',
    no: 'Total',
    tr: 'Toplam',
    dk: 'Total',
  },
  'POS.MembershipDiscount': {
    en: 'Membership discount',
    es: 'Descuento por membresía',
    se: 'Medlemsrabatt',
    no: 'Medlemsrabatt',
    tr: 'Üyelik indirimi',
    dk: 'Medlemsrabat',
  },
  'POS.ManualDiscount': {
    en: 'Manual discount',
    es: 'Descuento manual',
    se: 'Manuell rabatt',
    no: 'Manuell rabatt',
    tr: 'Manuel indirim',
    dk: 'Manuel rabat',
  },
  'POS.Percentage': {
    en: 'Percentage',
    es: 'Porcentaje',
    se: 'Procent',
    no: 'Prosent',
    tr: 'Yüzde',
    dk: 'Procent',
  },
  'POS.Amount': {
    en: 'Amount',
    es: 'Cantidad',
    se: 'Belopp',
    no: 'Beløp',
    tr: 'Miktar',
    dk: 'Beløb',
  },
  'POS.PayWith': {
    en: 'Pay with...',
    es: 'Pagar con...',
    se: 'Betala med...',
    no: 'Betal med...',
    tr: 'ile öde...',
    dk: 'Betal med...',
  },
  'POS.SplitPayment': {
    en: 'Split payment',
    es: 'Pago dividido',
    se: 'Delbetalning',
    no: 'Delbetaling',
    tr: 'Bölünmüş ödeme',
    dk: 'Delbetaling',
  },
  'POS.TakeAway': {
    en: 'Take away',
    es: 'Llevar',
    se: 'Ta med',
    no: 'Ta med',
    tr: 'Al-Git',
    dk: 'Take away',
  },
  'POS.Eathere': {
    en: 'Eat here',
    es: 'Coma aqui',
    se: 'Äta här',
    no: 'Spise her',
    tr: 'Burada ',
    dk: 'Spis her',
  },
  'POS.RegisterClosed': {
    en: 'Register closed',
    es: 'Servicio cerrado',
    se: 'Kassan är stängd',
    no: 'Kassen er stengt',
    tr: 'Kayıt kapatıldı',
    dk: 'Kassen er lukket',
  },
  'POS.OutOfStock': {
    en: 'Out of stock',
    es: 'Agotado',
    se: 'Slut för dagen',
    no: 'Utsolgt',
    tr: 'Stoklar tükendi',
    dk: 'Udsolgt',
  },
  'POS.EnterPrice': {
    en: 'Enter the price',
    es: 'Introduce el precio',
    se: 'Skriv in pris',
    no: 'Skriv inn pris',
    tr: 'Fiyatı gir',
    dk: 'Indtast prisen',
  },
  'POS.HowMany': {
    en: 'How many',
    es: 'Cuanto',
    se: 'Hur många',
    no: 'Hvor mange',
    tr: 'Kaç tane',
    dk: 'Hvor mange',
  },
  'POS.Loading': {
    en: 'Loading',
    es: 'Cargando',
    se: 'Laddar',
    no: 'Laster',
    tr: 'Yükleniyor',
    dk: 'Indlæser',
  },
  'POS.Add': {
    en: 'Add',
    es: 'Agregar',
    se: 'Lägg till',
    no: 'Legg til',
    tr: 'Ekle',
    dk: 'Tilføj',
  },
  'POS.TSR': {
    en: 'Tables',
    es: 'Mesas',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masalar',
    dk: 'Borde',
  },
  'POS.Loading.Variations': {
    en: 'Loading variations...',
    es: 'Variaciones de carga...',
    se: 'Laddar variationer...',
    no: 'Laster varianter...',
    tr: 'Varyasyonlar yükleniyor...',
    dk: 'Indlæser variationer...',
  },
  'POS.Loading.ModificationGroups': {
    en: 'Loading modification groups...',
    es: 'Cargando grupos de modificación...',
    se: 'Laddar tillvalsgrupper...',
    no: 'Laster tilleggsgrupper...',
    tr: 'Değişiklik grupları yükleniyor...',
    dk: 'Indlæser tilpasningsgrupper...',
  },
  'POS.Loading.Upsales': {
    en: 'Loading upsales...',
    es: 'Cargando ventas adicionales...',
    se: 'Laddar merförsäljning...',
    no: 'Laster tilvalgsgrupper...',
    tr: 'İndirimler yükleniyor...',
    dk: 'Indlæser mersalg...',
  },
  'POS.Loading.Images': {
    en: 'Loading images...',
    es: 'Cargando imágenes...',
    se: 'Laddar bilder...',
    no: 'Laster bilder...',
    tr: 'Resimler yükleniyor...',
    dk: 'Indlæser billeder...',
  },
  'POS.Loading.Venue': {
    en: 'Loading venue...',
    es: 'Cargando lugar...',
    se: 'Laddar restaurang...',
    no: 'Laster restaurant...',
    tr: 'Mekan yükleniyor...',
    dk: 'Indlæser loaktion...',
  },
  'POS.Loading.Articles': {
    en: 'Loading articles...',
    es: 'Cargando artículos...',
    se: 'Laddar artiklar...',
    no: 'Laster artikler...',
    tr: 'Ürünler yükleniyor...',
    dk: 'Indlæser artikler...',
  },
  'POS.Loading.Metadata': {
    en: 'Loading articles metadata...',
    es: 'Cargando metadatos de artículos...',
    se: 'Laddar artiklars metadata...',
    no: 'Laster artiklers metadata...',
    tr: 'Ürün meta verileri yükleniyor...',
    dk: 'Indlæser metadata for artikler...',
  },
  'POS.Loading.Categories': {
    en: 'Loading categories...',
    es: 'Cargando categorías...',
    se: 'Laddar kategorier...',
    no: 'Laster kategorier...',
    tr: 'Kategoriler yükleniyor...',
    dk: 'Indlæser kategorier...',
  },
  'POS.CollectQuestion': {
    en: 'Do you want to stay in collect mode?',
    es: '¿Quieres permanecer en el modo de recogida?',
    se: 'Vill du fortsätta samla bongar?',
    no: 'Vil du fortsette å samle bonger?',
    tr: 'Toplama modunda kalmak istiyor musunuz?',
    dk: 'Vil du forblive i indsamlingstilstand?',
  },
  'POS.Search': {
    en: 'Search product',
    es: 'Buscar producto',
    se: 'Sök produkt',
    no: 'Søk produkt',
    tr: 'Ürün ara',
    dk: 'Søg efter produkt',
  },
  'POS.Rest': {
    en: 'Rest',
    es: 'Resto',
    se: 'Resterande',
    no: 'Rest',
    tr: 'Kalan',
    dk: 'Rest',
  },
  'POS.Wait': {
    en: 'Wait',
    es: 'Esperar',
    se: 'Vänta',
    no: 'Vent',
    tr: 'Bekle',
    dk: 'Vent',
  },
  'POS.Finish': {
    en: 'Finish',
    es: 'Terminar',
    se: 'Klar',
    no: 'Fullfør',
    tr: 'Bitir',
    dk: 'Færdig',
  },
  'POS.NextStage': {
    en: 'Next',
    es: 'Siguiente',
    se: 'Nästa',
    no: 'Neste',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'POS.Stage': {
    en: 'Stage',
    es: 'Etapa',
    se: 'Steg',
    no: 'Steg',
    tr: 'Aşama',
    dk: 'Trin',
  },
  'BONG.Failed.BackupPrint': {
    en: 'Ticket print failed. Printed backup ticket on primary printer.',
    es: 'Falló la impresión del ticket. Ticket de respaldo impreso en la impresora principal.',
    se: 'Bong misslyckades att skriva ut, skrevs ut på den primära skrivaren',
    no: 'Feil under utskrift av bongen. Backup har blitt skrevet ut på kvitteringsskriver.',
    tr: 'Fiş basımı başarısız oldu. Birincil yazıcıda yedekleme fişi yazdırıldı.',
    dk: 'Billetudskrivning mislykkedes. Udskrevet backup-billet på primær printer.',
  },
  'BONG.Failed.TryingPrimary': {
    en: 'Ticket print failed. Trying to print ticket on primary printer.',
    es: 'Falló la impresión del ticket. Intentando imprimir el ticket en la impresora principal.',
    se: 'Bong utskrift misslyckades. Försöker skriva ut på den primära skrivaren',
    no: 'Feil under utskrift av bongen. Forsøker å skrive ut backup på kvitteringsskriver.',
    tr: 'Bilet basımı başarısız oldu. Birincil yazıcıda fiş basılmaya çalışılıyor.',
    dk: 'Billetudskrivning mislykkedes. Forsøger at udskrive billet på primær printer.',
  },
  'BONG.Failed.Everywhere': {
    en: 'Ticket print failed. Also failed to print backup ticket on primary printer.',
    es:
      'Falló la impresión del ticket. Tampoco se pudo imprimir el ticket de respaldo en la impresora principal.',
    se: 'Bong utskrift misslyckade. Utskriften misslyckades även på den primära skrivaren',
    no: 'Feil under utskrift av bongen. Utskriften feilet også på backup-skriveren.',
    tr: 'Fiş basımı başarısız oldu. Ayrıca birincil yazıcıda yedek bilet yazdırılamadı.',
    dk:
      'Billetudskrivning mislykkedes. Det lykkedes heller ikke at udskrive backupbillet på den primære printer.',
  },
  'BONG.sent': {
    en: 'Ticket sent',
    es: 'Comanda enviada',
    se: 'Bong utskriven',
    no: 'Bong sendt',
    tr: 'Fiş gönderildi',
    dk: 'Billet sendt',
  },
  'BONG.UnknownStation': {
    en: 'Unknown station',
    es: 'Punto de elaboración desconocido',
    se: 'Okänd station',
    no: 'Ukjent stasjon',
    tr: 'Bilinmeyen istasyon',
    dk: 'Ukendt station',
  },
  'BONG.NoStations': {
    en: 'No stations',
    es: 'Sin estaciones',
    se: 'Inga stationer',
    no: 'Ingen stasjoner',
    tr: 'İstasyon yok',
    dk: 'Ingen stationer',
  },
  'BONG.Reprint': {
    en: 'This is a reprint of failed print',
    es: 'Esta es una impresión de la impresión que fallo',
    se: 'Detta är en kopia av en mysslyckad bongutskrift',
    no: 'Dette er en kopi av en feilet bongutskrift',
    tr: 'Bu başarısız yazdırmanın yeniden basımıdır',
    dk: 'Dette er et genoptryk af mislykket udskrivning',
  },
  'BONG.PrintStations': {
    en: 'Print stations',
    es: 'Estaciones de impresión',
    se: 'Bongstationer',
    no: 'Bongstasjoner',
    tr: 'Baskı istasyonları',
    dk: 'Print stationer',
  },
  'BONG.Error': {
    en: 'PRINT ERROR',
    es: 'ERROR',
    se: 'SKRIVARFEL',
    no: 'UTSKRIFTSFEIL',
    tr: 'YAZDIRMA HATASI',
    dk: 'UDSKRIFTSFEJL',
  },
  'BONG.Print.Failed': {
    en: 'Ticket print failed',
    es: 'Falló la impresión del ticket',
    se: 'Bongutskrift misslyckades',
    no: 'Bongutskrift feilet',
    tr: ' ',
    dk: 'Billetudskrivning mislykkedes',
  },
  'BONG.Print.Retry': {
    en: 'Click to retry print',
    es: 'Haga clic para reintentar la impresión',
    se: 'Klicka för att försöka skriva ut igen',
    no: 'Klikk her for å prøve igjen',
    tr: 'Yazdırmayı yeniden denemek için tıklayın',
    dk: 'Klik for at prøve at udskrive igen',
  },
  'Bong.Correction': {
    en: 'Correction',
    es: 'Corrección',
    se: 'Korrigering',
    no: 'Korreksjon',
    tr: 'Düzeltme',
    dk: 'Korrektion',
  },
  'Bong.Correction.SpecificItems': {
    en: 'Specific articles',
    es: 'Artículos específicos',
    se: 'Specifika artiklar',
    no: 'Spesifikke artikler',
    tr: 'Belirli ürünler',
    dk: 'Specifikke artikler',
  },
  'Bong.Correction.FullCheque': {
    en: 'Full cheque',
    es: 'Cheque completo',
    se: 'Hela notan',
    no: 'Full kvittering',
    tr: 'Tam fiş',
    dk: 'Fuld kvittering',
  },
  'Bong.Correction.Removed': {
    en: 'Removed',
    es: 'Eliminado',
    se: 'Borttagna',
    no: 'Fjernet',
    tr: 'Kaldırıldı',
    dk: 'Fjernet',
  },
  'Bong.Correction.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'Bong.Correction.ParkedOrder': {
    en: 'Parked order',
    es: 'Orden estacionada',
    se: 'Parkerad order',
    no: 'Parkert ordre',
    tr: 'Park edilmiş sipariş',
    dk: 'Parkeret ordre',
  },
  'Bong.Correction.FullParkedOrder': {
    en: 'Full parked order',
    es: 'Orden estacionada completa',
    se: 'Hela parkerade ordern',
    no: 'Full parkert ordre',
    tr: 'Tam park edilmiş sipariş',
    dk: 'Fuld parkeret ordre',
  },
  'Bong.Correction.Staff': {
    en: 'Staff',
    es: 'Personal',
    se: 'Personal',
    no: 'Personale',
    tr: 'Personel',
    dk: 'Personale',
  },
  'Bong.Correction.Comment': {
    en: 'Comment',
    es: 'Comentario',
    se: 'Kommentar',
    no: 'Kommentar',
    tr: 'Yorum',
    dk: 'Kommentar',
  },
  'Bong.Correction.TotalRemoved': {
    en: 'Articles removed',
    es: 'Artículos eliminados',
    se: 'Antal borttagna artiklar',
    no: 'Antall fjernede artikler',
    tr: 'Kaldırılan ürünler',
    dk: 'Antal fjernede artikler',
  },
  'Adyen.TerminalStatus.ACCOUNT_TYPE_SELECTED': {
    en: 'Account type selected',
    es: 'Tipo de cuenta seleccionado',
    se: 'Kontotyp vald',
    no: 'Kontotype valgt',
    tr: 'Hesap türü seçildi',
    dk: 'Kontotype valgt',
  },
  'Adyen.TerminalStatus.ACKNOWLEDGED': {
    en: 'Acknowledged',
    es: 'Confirmado',
    se: 'Bekräftad',
    no: 'Bekreftet',
    tr: 'Onaylandı',
    dk: 'Bekræftet',
  },
  'Adyen.TerminalStatus.ADDITIONAL_DATA_AVAILABLE': {
    en: 'Additional data available',
    es: 'Datos adicionales disponibles',
    se: 'Ytterligare data tillgänglig',
    no: 'Ytterligere data tilgjengelig',
    tr: 'Ek veri mevcut',
    dk: 'Yderligere data tilgængelig',
  },
  'Adyen.TerminalStatus.APPLICATION_SELECTED': {
    en: 'App selected',
    es: 'App seleccionada',
    se: 'App vald',
    no: 'App valgt',
    tr: 'Uygulama seçildi',
    dk: 'App valgt',
  },
  'Adyen.TerminalStatus.ASK_CHARITY': {
    en: 'Waiting for donation',
    es: 'Esperando donación',
    se: 'Väntar på donation',
    no: 'Venter på donasjon',
    tr: 'Bağış bekleniyor',
    dk: 'Venter på donation',
  },
  'Adyen.TerminalStatus.ASK_DCC': {
    en: 'Checking currency conversion',
    es: 'Verificando conversión de moneda',
    se: 'Kontrollerar valutaväxling',
    no: 'Sjekker valutakonvertering',
    tr: 'Döviz dönüşümü kontrol ediliyor',
    dk: 'Tjekker valutakonvertering',
  },
  'Adyen.TerminalStatus.ASK_GRATUITY': {
    en: 'Waiting for tip',
    es: 'Esperando propina',
    se: 'Väntar på dricks',
    no: 'Venter på tips',
    tr: 'Bahşiş bekleniyor',
    dk: 'Venter på drikkepenge',
  },
  'Adyen.TerminalStatus.ASK_SIGNATURE': {
    en: 'Waiting for signature',
    es: 'Esperando firma',
    se: 'Väntar på signatur',
    no: 'Venter på signatur',
    tr: 'İmza bekleniyor',
    dk: 'Venter på underskrift',
  },
  'Adyen.TerminalStatus.BALANCE_QUERY_ACQUIRED': {
    en: 'Balance acquired',
    es: 'Saldo obtenido',
    se: 'Saldo hämtat',
    no: 'Saldo hentet',
    tr: 'Bakiye alındı',
    dk: 'Saldo hentet',
  },
  'Adyen.TerminalStatus.BALANCE_QUERY_COMPLETED': {
    en: 'Balance check completed',
    es: 'Consulta de saldo completada',
    se: 'Saldokontroll klar',
    no: 'Saldosjekk fullført',
    tr: 'Bakiye sorgusu tamamlandı',
    dk: 'Saldotjek gennemført',
  },
  'Adyen.TerminalStatus.BALANCE_QUERY_STARTED': {
    en: 'Checking balance',
    es: 'Consultando saldo',
    se: 'Kontrollerar saldo',
    no: 'Sjekker saldo',
    tr: 'Bakiye kontrol ediliyor',
    dk: 'Tjekker saldo',
  },
  'Adyen.TerminalStatus.CANCEL_OR_REFUND_COMPLETED': {
    en: 'Refund completed',
    es: 'Reembolso completado',
    se: 'Återbetalning klar',
    no: 'Refusjon fullført',
    tr: 'İade tamamlandı',
    dk: 'Refusion gennemført',
  },
  'Adyen.TerminalStatus.CARD_ACQ_COMPLETED': {
    en: 'Card details acquired',
    es: 'Datos de tarjeta obtenidos',
    se: 'Kortuppgifter hämtade',
    no: 'Kortdetaljer hentet',
    tr: 'Kart bilgileri alındı',
    dk: 'Kortoplysninger hentet',
  },
  'Adyen.TerminalStatus.CARD_DETAILS_PROVIDED': {
    en: 'Card details entered',
    es: 'Datos de tarjeta ingresados',
    se: 'Kortuppgifter angivna',
    no: 'Kortdetaljer angitt',
    tr: 'Kart bilgileri girildi',
    dk: 'Kortoplysninger indtastet',
  },
  'Adyen.TerminalStatus.CARD_INSERTED': {
    en: 'Card inserted',
    es: 'Tarjeta insertada',
    se: 'Kort insatt',
    no: 'Kort satt inn',
    tr: 'Kart takıldı',
    dk: 'Kort indsat',
  },
  'Adyen.TerminalStatus.CARD_METHOD_SELECTED': {
    en: 'Card method selected',
    es: 'Método de tarjeta seleccionado',
    se: 'Kortmetod vald',
    no: 'Kortmetode valgt',
    tr: 'Kart yöntemi seçildi',
    dk: 'Kortmetode valgt',
  },
  'Adyen.TerminalStatus.CARD_MKE': {
    en: 'Waiting for manual card entry',
    es: 'Esperando entrada manual de tarjeta',
    se: 'Väntar på manuell kortinmatning',
    no: 'Venter på manuell kortinntasting',
    tr: 'Manuel kart girişi bekleniyor',
    dk: 'Venter på manuel kortindtastning',
  },
  'Adyen.TerminalStatus.CARD_PRESENTED': {
    en: 'Processing...',
    es: 'Procesando...',
    se: 'Bearbetar...',
    no: 'Behandler...',
    tr: 'İşleniyor...',
    dk: 'Behandler...',
  },
  'Adyen.TerminalStatus.CARD_REMOVED': {
    en: 'Card removed',
    es: 'Tarjeta retirada',
    se: 'Kort borttaget',
    no: 'Kort fjernet',
    tr: 'Kart çıkarıldı',
    dk: 'Kort fjernet',
  },
  'Adyen.TerminalStatus.CARD_SWIPED': {
    en: 'Card swiped',
    es: 'Tarjeta deslizada',
    se: 'Kort draget',
    no: 'Kort dratt',
    tr: 'Kart kaydırıldı',
    dk: 'Kort swipet',
  },
  'Adyen.TerminalStatus.CHARITY_ENTERED': {
    en: 'Donation entered',
    es: 'Donación ingresada',
    se: 'Donation angiven',
    no: 'Donasjon angitt',
    tr: 'Bağış girildi',
    dk: 'Donation indtastet',
  },
  'Adyen.TerminalStatus.CHECK_SIGNATURE': {
    en: 'Verify signature',
    es: 'Verificar firma',
    se: 'Verifiera signatur',
    no: 'Bekreft signatur',
    tr: 'İmzayı doğrulayın',
    dk: 'Bekræft underskrift',
  },
  'Adyen.TerminalStatus.DCC_ACCEPTED': {
    en: 'Currency conversion accepted',
    es: 'Conversión de moneda aceptada',
    se: 'Valutaväxling accepterad',
    no: 'Valutakonvertering godtatt',
    tr: 'Döviz dönüşümü kabul edildi',
    dk: 'Valutakonvertering accepteret',
  },
  'Adyen.TerminalStatus.DCC_REJECTED': {
    en: 'Currency conversion rejected',
    es: 'Conversión de moneda rechazada',
    se: 'Valutaväxling avvisad',
    no: 'Valutakonvertering avvist',
    tr: 'Döviz dönüşümü reddedildi',
    dk: 'Valutakonvertering afvist',
  },
  'Adyen.TerminalStatus.GRATUITY_ENTERED': {
    en: 'Tip entered',
    es: 'Propina ingresada',
    se: 'Dricks angiven',
    no: 'Tips angitt',
    tr: 'Bahşiş girildi',
    dk: 'Drikkepenge indtastet',
  },
  'Adyen.TerminalStatus.INITIAL': {
    en: 'Initiated',
    es: 'Iniciado',
    se: 'Startad',
    no: 'Startet',
    tr: 'Başlatıldı',
    dk: 'Startet',
  },
  'Adyen.TerminalStatus.LOAD_COMPLETED': {
    en: 'Card load completed',
    es: 'Carga de tarjeta completada',
    se: 'Kortladdning klar',
    no: 'Kortlading fullført',
    tr: 'Kart yüklemesi tamamlandı',
    dk: 'Kortopladning gennemført',
  },
  'Adyen.TerminalStatus.LOAD_STARTED': {
    en: 'Loading card',
    es: 'Cargando tarjeta',
    se: 'Laddar kort',
    no: 'Lader kort',
    tr: 'Kart yükleniyor',
    dk: 'Oplader kort',
  },
  'Adyen.TerminalStatus.PIN_ENTERED': {
    en: 'PIN entered',
    es: 'PIN ingresado',
    se: 'PIN angiven',
    no: 'PIN angitt',
    tr: 'PIN girildi',
    dk: 'PIN indtastet',
  },
  'Adyen.TerminalStatus.PRINT_RECEIPT': {
    en: 'Printing receipt',
    es: 'Imprimiendo recibo',
    se: 'Skriver ut kvitto',
    no: 'Skriver ut kvittering',
    tr: 'Fiş yazdırılıyor',
    dk: 'Udskriver kvittering',
  },
  'Adyen.TerminalStatus.PROCESSING_TENDER': {
    en: 'Processing payment',
    es: 'Procesando pago',
    se: 'Bearbetar betalning',
    no: 'Behandler betaling',
    tr: 'Ödeme işleniyor',
    dk: 'Behandler betaling',
  },
  'Adyen.TerminalStatus.PROVIDE_CARD_DETAILS': {
    en: 'Waiting for card',
    es: 'Esperando tarjeta',
    se: 'Väntar på kort',
    no: 'Venter på kort',
    tr: 'Kart bekleniyor',
    dk: 'Venter på kort',
  },
  'Adyen.TerminalStatus.RECEIPT_PRINTED': {
    en: 'Receipt printed',
    es: 'Recibo impreso',
    se: 'Kvitto utskrivet',
    no: 'Kvittering skrevet ut',
    tr: 'Fiş yazdırıldı',
    dk: 'Kvittering udskrevet',
  },
  'Adyen.TerminalStatus.REFERRAL': {
    en: 'Referral required',
    es: 'Referencia requerida',
    se: 'Hänvisning krävs',
    no: 'Henvisning kreves',
    tr: 'Yönlendirme gerekli',
    dk: 'Henvisning påkrævet',
  },
  'Adyen.TerminalStatus.REFERRAL_CHECKED': {
    en: 'Referral checked',
    es: 'Referencia verificada',
    se: 'Hänvisning kontrollerad',
    no: 'Henvisning sjekket',
    tr: 'Yönlendirme kontrol edildi',
    dk: 'Henvisning tjekket',
  },
  'Adyen.TerminalStatus.SIGNATURE_CHECKED': {
    en: 'Signature confirmed',
    es: 'Firma confirmada',
    se: 'Signatur bekräftad',
    no: 'Signatur bekreftet',
    tr: 'İmza onaylandı',
    dk: 'Underskrift bekræftet',
  },
  'Adyen.TerminalStatus.TENDER_CREATED': {
    en: 'Waiting for card tap',
    es: 'Esperando toque de tarjeta',
    se: 'Väntar på kortblipp',
    no: 'Venter på kortberøring',
    tr: 'Kart dokunuşu bekleniyor',
    dk: 'Venter på kort-tap',
  },
  'Adyen.TerminalStatus.TENDER_FINAL': {
    en: 'Completed',
    es: 'Completado',
    se: 'Slutförd',
    no: 'Fullført',
    tr: 'Tamamlandı',
    dk: 'Gennemført',
  },
  'Adyen.TerminalStatus.WAIT_FOR_ACCOUNT_TYPE_SELECTION': {
    en: 'Select account type',
    es: 'Seleccionar tipo de cuenta',
    se: 'Välj kontotyp',
    no: 'Velg kontotype',
    tr: 'Hesap türü seçin',
    dk: 'Vælg kontotype',
  },
  'Adyen.TerminalStatus.WAIT_FOR_AMOUNT_ADJUSTMENT': {
    en: 'Adjusting amount',
    es: 'Ajustando monto',
    se: 'Justerar belopp',
    no: 'Justerer beløp',
    tr: 'Tutar ayarlanıyor',
    dk: 'Justerer beløb',
  },
  'Adyen.TerminalStatus.WAIT_FOR_APP_SELECTION': {
    en: 'Select card type',
    es: 'Seleccionar tipo de tarjeta',
    se: 'Välj korttyp',
    no: 'Velg korttype',
    tr: 'Kart türünü seçin',
    dk: 'Vælg korttype',
  },
  'Adyen.TerminalStatus.WAIT_FOR_PIN': {
    en: 'Waiting for PIN',
    es: 'Esperando PIN',
    se: 'Väntar på PIN',
    no: 'Venter på PIN',
    tr: 'PIN bekleniyor',
    dk: 'Venter på PIN',
  },

  //Adyen expense
  'Adyen.Expense.Error.Generic': {
    en:
      'There was an error trying to create the expense. Did the expense go through on the terminal?',
    es: 'Error al crear el gasto. ¿Se realizó el gasto en la terminal?',
    se: 'Det uppstod ett fel när utgiften skulle skapas. Gick utgiften igenom på terminalen?',
    no: 'Det oppstod en feil når transaksjonen skulle opprettes. Gikk det gjennom på terminalen?',
    tr: 'Gider oluşturulurken bir hata oluştu. Gider terminalde gerçekleşti mi?',
    dk:
      'Der opstod en fejl under forsøget på at oprette udgiften. Gik udgiften igennem på terminalen?',
  },
  'Adyen.Expense.Error.LostConnection': {
    en: 'We lost connection to the terminal. Did the expense go through on the terminal?',
    es: 'Conexión perdida con la terminal. ¿Se realizó el gasto en la terminal?',
    se: 'Vi tappade anslutningen till terminalen. Gick utgiften igenom på terminalen?',
    no: 'Vi mistet kontakt med terminal. Gikk transaksjonen gjennom på terminalen?',
    tr: 'Terminalle bağlantımız kesildi. Gider terminalde gerçekleşti mi?',
    dk: 'Vi mistede forbindelsen til terminalen. Gik udgiften igennem på terminalen?',
  },
  'Adyen.Expense.ReportAdded': {
    en: 'Expense report added',
    es: 'Informe de gasto añadido',
    se: 'Kostnadsrapport har lagts till',
    no: 'Utgiftsrapport opprettet.',
    tr: 'Gider raporu eklendi',
    dk: 'Udgiftsrapport tilføjet',
  },
  'Adyen.Loading': {
    en: 'Loading',
    es: 'Cargando',
    se: 'Laddar',
    no: 'Laster',
    tr: 'Yükleniyor',
    dk: 'Indlæser',
  },
  'Adyen.PleaseWait': {
    en: 'Please wait',
    es: 'Espere por favor',
    se: 'Vänligen Vänta',
    no: 'Vennligst vent',
    tr: 'Lütfen bekleyin',
    dk: 'Vent venligst',
  },
  'Adyen.InsertCard': {
    en: 'Insert card into adyen terminal',
    es: 'Inserta la tarjeta en la terminal Adyen',
    se: 'Sätt i kortet i adyen-terminalen',
    no: 'Sett inn kortet',
    tr: 'Kartı adyen terminaline takın',
    dk: 'Indsæt kortet i adyen-terminalen',
  },
  'Adyen.Waiting': {
    en: 'Waiting...',
    es: 'Esperando...',
    se: 'Väntar...',
    no: 'Venter...',
    tr: 'Bekliyor...',
    dk: 'Venter...',
  },
  'Adyen.PickTerminal': {
    en: 'Pick a terminal',
    es: 'Elige una terminal',
    se: 'Välj en terminal',
    no: 'Velg terminal',
    tr: 'Bir terminal seç',
    dk: 'Vælg en terminal',
  },
  'Adyen.Close': {
    en: 'Close',
    es: 'Cerrar',
    se: 'Stäng',
    no: 'Steng',
    tr: 'Kapalı',
    dk: 'Luk',
  },
  //Payments
  'SKV.UnableContact.Srv4pos.Title': {
    en: 'Order sync with Skatteverket failed',
    es: 'La sincronización de comandas con Skatteverket falló',
    se: 'Order synkronisering med Skatteverket misslyckades',
    no: 'Ordresynkronisering med Skatteverket mislyktes',
    tr: 'Sipariş senkronizasyonu Skatteverket ile başarısız oldu',
    dk: 'Ordresynkronisering med Skatteverket mislykkedes',
  },
  'SKV.UnableContactSrv4pos': {
    en: 'Unable to contact Srv4pos server for order',
    es: 'No se puede contactar con el servidor Srv4pos para la comanda',
    se: 'Det gick inte att kontakta Srv4pos-servern för order',
    no: 'Fikk ikke kontakt med Srv4pos-serveren',
    tr: 'Sipariş için Srv4pos sunucusuyla bağlantı kurulamıyor',
    dk: 'Kan ikke kontakte Srv4pos server for ordre',
  },
  'SKV.UnableContactSrv4pos.Description': {
    en: 'This may be due to an incorrectly configured Skatteverket integration for this company.',
    es:
      'Esto puede deberse a que la integración con Skatteverket para este negocio no esté configurada correctamente.',
    se:
      'Detta kan bero på att Skatteverket-integrationen för detta företag är felaktigt konfigurerad.',
    no: 'Dette kan skyldes at Skatteverket-integrasjonen for dette selskapet er feilkonfigurert.',
    tr:
      'Bu durum, bu şirkete ait Skatteverket entegrasyonunun yanlış yapılandırılmış olmasından kaynaklanıyor olabilir.',
    dk:
      'Dette kan skyldes, at Skatteverket-integrationen for denne virksomhed er forkert konfigureret.',
  },
  'Adyen.TerminalOffline': {
    en: 'Terminal is offline. Check the network connection on the terminal',
    se: 'Terminalen är offline. Kontrollera nätverksanslutningen på terminalen',
    no: 'Terminalen er offline. Sjekk nettverksforbindelsen på terminalen',
    tr: 'Terminal çevrimdışı. Terminaldeki ağ bağlantısını kontrol edin',
    dk: 'Terminalen er offline. Tjek netværksforbindelsen på terminalen',
    es: 'Terminal sin conexión. Revisa la conexión de red en la terminal',
  },
  'Adyen.WrongTerminalId': {
    en: 'Invalid Terminal ID. Please double-check and try again',
    se: 'Ogiltigt terminal-ID. Dubbelkolla och försök igen',
    no: 'Ugyldig terminal-ID. Vennligst dobbeltsjekk og prøv igjen',
    tr: 'Geçersiz Terminal Kimliği. Lütfen tekrar kontrol edin ve tekrar deneyin',
    dk: 'Ugyldig terminal-ID. Venligst dobbelttjek og prøv igen',
    es: 'ID de terminal no válido. Por favor, revisa y vuelve a intentarlo',
  },
  'Adyen.MissingTerminalId': {
    en: 'Missing terminal ID',
    es: 'Falta ID de terminal',
    se: 'Saknar terminal ID',
    no: 'Savner terminal-ID',
    tr: 'Eksik terminal kimliği',
    dk: 'Manglende terminal-id',
  },
  'Adyen.CanceledPayment': {
    en: 'Canceled payment',
    es: 'Pago cancelado',
    se: 'Avbruten betalning',
    no: 'Avbrutt betaling',
    tr: 'Ödeme iptal edildi',
    dk: 'Annulleret betaling',
  },
  'Adyen.UnknownError': {
    en: 'Unknown error',
    es: 'Error desconocido',
    se: 'Okänt fel',
    no: 'Ukjent feil',
    tr: 'Bilinmeyen hata',
    dk: 'Ukendt fejl',
  },
  'Cash.Payment': {
    en: 'Remaining cash',
    es: 'Efectivo pendiente',
    se: 'Återstående kontanter',
    no: 'Gjenværende kontanter',
    tr: 'Kalan nakit',
    dk: 'Resterende kontanter',
  },
  'Cash.ChangeBack': {
    en: 'Change back',
    es: 'Cambio entregado',
    se: 'Växel tillbaka',
    no: 'Vekslepenger tilbake',
    tr: 'Para üstü',
    dk: 'Byttepenge tilbage',
  },
  'Cash.Manualtips': {
    en: (remainingAmount: string) => `How much of ${remainingAmount} is tips?`,
    es: (remainingAmount: string) => `¿Cuánto de ${remainingAmount} corresponde a propina?`,
    se: (remainingAmount: string) => `Hur mycket av ${remainingAmount} är dricks?`,
    no: (remainingAmount: string) => `Hvor mye av ${remainingAmount} er tips?`,
    tr: (remainingAmount: string) => `${remainingAmount} miktarının ne kadarı bahşiş?`,
    dk: (remainingAmount: string) => `Hvor meget af ${remainingAmount} er drikkepenge?`,
  },
  'Cash.RemainingAmount': {
    en: "Is what's left after payment, how would you like to proceed with the rest?",
    es: 'Es lo que queda tras el pago, ¿cómo desea proceder con el resto?',
    se: 'Är det som återstår efter betalning, hur vill du gå vidare med resten?',
    no: 'Er det som gjenstår etter betaling, hvordan vil du fortsette med resten?',
    tr: 'Ödeme sonrası kalan miktar, kalan tutarı nasıl işlem yapmak istersiniz?',
    dk: 'Er det, hvad der er tilbage efter betaling, hvordan vil du fortsætte med resten?',
  },
  'Cash.LogAllAsTips': {
    en: 'Log all as tips',
    es: 'Registrar todo como propinas',
    se: 'Logga allt som dricks',
    no: 'Logg alt som tips',
    tr: 'Tümünü bahşiş olarak kaydet',
    dk: 'Log alt som drikkepenge',
  },
  'Cash.LogManualTips': {
    en: 'Log manual tips',
    es: 'Registrar propinas manualmente',
    se: 'Logga manuell dricks',
    no: 'Logg manuelle tips',
    tr: 'Manuel bahşiş kaydet',
    dk: 'Log manuel drikkepenge',
  },
  'Cash.GiveAsChange': {
    en: 'Give as change',
    es: 'Entregar como cambio',
    se: 'Ge som växel',
    no: 'Gi som vekslepenger',
    tr: 'Para üstü olarak ver',
    dk: 'Giv som byttepenge',
  },

  'Cash.CompletePayment': {
    en: 'Complete payment',
    es: 'Completar el pago',
    se: 'Slutför betalning',
    no: 'Fullfør betaling',
    tr: 'Ödemeyi tamamla',
    dk: 'Fuldfør betaling',
  },
  'Cash.Canceled': {
    en: 'Canceled',
    es: 'Cancelado',
    se: 'Avbruten',
    no: 'Avbrutt',
    tr: 'İptal edildi',
    dk: 'Annulleret',
  },
  'Cash.NotAllowed': {
    en: 'Not allowed because the drawer is open',
    es: 'No permitido porque el cajón está abierto',
    se: 'Inte tillåtet eftersom kassalådan är öppen',
    no: 'Ikke tillatt fordi skuffen er åpen',
    tr: 'Çekmece açık olduğundan izin verilmiyor',
    dk: 'Ikke tilladt, fordi skuffen er åben',
  },
  'Cashdrawer.BlockedPayments': {
    en: 'The cash drawer is open, close it to continue',
    es: 'El cajón de efectivo está abierto, ciérralo para continuar',
    se: 'Kassalådan är öppen, stäng den för att fortsätta',
    no: 'Kasseskuffen er åpen, lukk den for å fortsette',
    tr: 'Çekmece açık, devam etmek için kapatın',
    dk: 'Kontantskuffen er åben, luk den for at fortsætte',
  },
  'Cash.DrawerOpened': {
    en: 'Drawer opened',
    es: 'Cajón de efectivo abierto',
    se: 'Kassalådan öppnades',
    no: 'Skuffen er åpnet',
    tr: 'Çekmece açıldı',
    dk: 'Skuffe åbnet',
  },
  'Cash.DrawerOpen.PermissionDenied': {
    en:
      'You do not have permission to open the cash drawer. This action requires "Close day" permission.',
    es:
      'No tienes permiso para abrir el cajón de efectivo. Esta acción requiere permiso de "Cerrar día".',
    se:
      'Du har inte behörighet att öppna kassalådan. Denna åtgärd kräver behörighet "Dagsavslut".',
    no:
      'Du har ikke tillatelse til å åpne kasseskuffen. Denne handlingen krever tillatelse "Lukk dag".',
    tr: 'Nakit çekmecesini açma izniniz yok. Bu işlem "Günü kapat" izni gerektirir.',
    dk:
      'Du har ikke tilladelse til at åbne kontantskuffen. Denne handling kræver tilladelse "Luk dag".',
  },
  'Cash.Discount': {
    en: 'Discount',
    es: 'Descuento',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'Cash.Tips': {
    en: 'Tips',
    es: 'Propina',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşiş',
    dk: 'Tips',
  },
  'Cash.TotalCashReceived': {
    en: 'Enter total cash received',
    es: 'Introduce el total de efectivo recibido',
    se: 'Ange totalt mottaget kontantbelopp',
    no: 'Angi totalt mottatt kontantbeløp',
    tr: 'Toplam alınan nakit miktarı girin',
    dk: 'Indtast samlede kontanter modtaget',
  },
  'Cash.OfWhichTips': {
    en: 'How much of the cash is tips?',
    es: '¿Cuánto del efectivo corresponde a propinas?',
    se: 'Hur mycket av kontanterna är dricks?',
    no: 'Hvor mye av kontantene er tips?',
    tr: 'Nakit paranın ne kadarı bahşiş?',
    dk: 'Hvor meget af pengene er drikkepenge?',
  },
  'Cash.ReceivedLessThanTotal': {
    en: "Cash received can't be less than the total amount",
    es: 'El efectivo recibido no puede ser menor que el monto total',
    se: 'Mottagna kontanter kan inte vara mindre än totalbeloppet',
    no: 'Mottatte kontanter kan ikke være mindre enn totalbeløpet',
    tr: 'Alınan nakit miktar toplam tutardan az olamaz',
    dk: 'Kontanter modtaget kan ikke være mindre end det samlede beløb',
  },
  'Cash.Sum': {
    en: 'Sum',
    es: 'Suma',
    se: 'Summa',
    no: 'Sum',
    tr: 'Toplam',
    dk: 'Sum',
  },
  'Cash.Text': {
    en: 'Cash',
    es: 'Efectivo',
    se: 'Kontant',
    no: 'Kontant',
    tr: 'Peşin',
    dk: 'Kontanter',
  },
  'Cash.Regain': {
    en: 'Regain',
    es: 'Recuperar',
    se: 'Åter',
    no: 'Veksel',
    tr: 'Geri al',
    dk: 'Genvinde',
  },
  'Cash.GoBack': {
    en: 'Go back',
    es: 'Volver',
    se: 'Tillbaka',
    no: 'Tilbake',
    tr: 'Geri git',
    dk: 'Gå tilbage',
  },
  'Cash.Complete': {
    en: 'Complete',
    es: 'Completo',
    se: 'Slutför',
    no: 'Fullfør',
    tr: 'Tamamla',
    dk: 'Fuldført!',
  },
  'CashManagement.Title': {
    en: 'Cash management',
    es: 'Gestión de caja',
    se: 'Kontanthantering',
    no: 'Kontanthåndtering',
    tr: 'Nakit yönetimi',
    dk: 'Kontantstyring',
  },
  'CashManagement.Change.EnterReason': {
    en: 'Provide a reason for the cash change',
    es: 'Proporciona un motivo para el cambio de efectivo',
    se: 'Ange en anledning för kontantändringen',
    no: 'Oppgi en grunn for kontantendringen',
    tr: 'Nakit değişikliği için bir neden belirtin',
    dk: 'Angiv en årsag til kontantændringen',
  },
  'CashManagement.Change.Reason': {
    en: 'Reason',
    es: 'Motivo',
    se: 'Anledning',
    no: 'Årsak',
    tr: 'Sebep',
    dk: 'Årsag',
  },
  'CashManagement.ManuallyOpenCashDrawer': {
    en: 'Manually open cash drawer',
    es: 'Abrir el cajón de efectivo manualmente',
    se: 'Öppna kassalådan manuellt',
    no: 'Åpne kasseskuffen manuelt',
    tr: 'Para çekmecesini manuel olarak açın',
    dk: 'Åbn kasseskuffen manuelt',
  },
  'CashManagement.OpenCashDrawer': {
    en: 'Open cash drawer',
    es: 'Abrir el cajón de efectivo',
    se: 'Öppna kassalådan',
    no: 'Åpne kasseskuffen',
    tr: 'Para çekmecesini aç',
    dk: 'Åbn pengeskuffen',
  },
  'CashManagement.InitialCashInRegister': {
    en: 'Initial cash in register',
    es: 'Fondo inicial servicio',
    se: 'Startbelopp i kassan',
    no: 'Startbeløp i kassen',
    tr: 'Kasadaki başlangıç nakit',
    dk: 'Indledende kontanter i register',
  },
  'CashManagement.AvailableForPayout': {
    en: 'Available for payout',
    es: 'Excedente de caja',
    se: 'Tillgängligt för utbetalning',
    no: 'Tilgjengelig for utbetaling',
    tr: 'Ödeme için kullanılabilir',
    dk: 'Tilgængeligt for udbetaling',
  },
  'CashManagement.InitialCash': {
    en: 'Initial cash',
    es: 'Fondo inicial servicio',
    se: 'Inledande kontanter',
    no: 'Innledende kontanter',
    tr: 'Başlangıç nakit',
    dk: 'Indledende kontanter',
  },
  'CashManagement.Deposited': {
    en: 'Deposited',
    es: 'Entradas de efectivo',
    se: 'Insatt',
    no: 'Innsatt',
    tr: 'Eklendi',
    dk: 'Deponeret',
  },
  'CashManagement.Withdrawn': {
    en: 'Withdrawn',
    es: 'Salidas de efectivo',
    se: 'Uttaget',
    no: 'Tatt ut',
    tr: 'Çekildi',
    dk: 'Trukket tilbage',
  },
  'CashManagement.CashDeposit': {
    en: 'Cash Deposit',
    es: 'Entrada de efectivo',
    se: 'Kontantinsättning',
    no: 'Kontantinnskudd',
    tr: 'Nakit Yatırma',
    dk: 'Kontantindbetaling',
  },
  'CashManagement.CashWithdrawal': {
    en: 'Cash Withdrawal',
    es: 'Salida de efectivo',
    se: 'Kontantuttag',
    no: 'Kontantuttak',
    tr: 'Nakit Çekim',
    dk: 'Kontanthævning',
  },
  'CashManagement.Float': {
    en: 'Float',
    es: 'Fondo de caja',
    se: 'Kassaväxel',
    no: 'Kassebeholdning',
    tr: 'Para üstü',
    dk: 'Svæve',
  },
  'CashManagement.Tenders': {
    en: 'Tenders',
    es: 'Cajón de efectivo',
    se: 'Kontantbetalningsmetoder',
    no: 'Betalingsmetoder',
    tr: 'Ödeme türleri',
    dk: 'Udbud',
  },
  'CashManagement.DepositToTender': {
    en: 'Deposit to tender',
    es: 'Entrada en cajón de efectivo',
    se: 'Sätt in till betalningsmetod',
    no: 'Innskudd til betalingsmetode',
    tr: 'Ödeme yöntemine para yatırma',
    dk: 'Depositum til udbud',
  },
  'CashManagement.WithdrawFromTender': {
    en: 'Withdraw from tender',
    es: 'Salida de cajón de efectivo',
    se: 'Ta ut från betalningsmetod',
    no: 'Ta ut fra betalingsmetode',
    tr: 'Ödeme yönteminden para çekme',
    dk: 'Træk ud af udbud',
  },
  'CashManagement.CashDrawer': {
    en: 'Cash drawer',
    es: 'Cajón de efectivo',
    se: 'Kassalåda',
    no: 'Kasseskuff',
    tr: 'Para çekmecesi',
    dk: 'Kasseskuffe',
  },
  'CashManagement.CashRegister': {
    en: 'Cash register',
    es: 'Cajón de efectivo',
    se: 'Kassa',
    no: 'Kasse',
    tr: 'Kasa',
    dk: 'Kasseapparat',
  },
  'CashManagement.Payouts': {
    en: 'Cash withdrawals',
    es: 'Salida de efectivo',
    se: 'Utbetalningar',
    no: 'Utbetalinger',
    tr: 'Ödemeler',
    dk: 'Udbetalinger',
  },
  'CashManagement.PayoutCTA': {
    en: 'Withdraw cash',
    es: 'Retirar efectivo',
    se: 'Gör en utbetalning',
    no: 'Gjør en utbetaling',
    tr: 'Ödeme yap',
    dk: 'Lav en udbetaling',
  },
  'CashManagement.PayoutCTA.CashWithdrawn': {
    en: 'Cash withdrawn',
    es: 'Efectivo retirado',
    se: 'Kontanter uttagna',
    no: 'Kontanter tatt ut',
    tr: 'Nakit çekildi',
    dk: 'Kontanter trukket tilbage',
  },
  'CashManagement.PayoutCTA.CashDeposited': {
    en: 'Cash deposited',
    es: 'Efectivo ingresado',
    se: 'Kontanter insatta',
    no: 'Kontanter satt inn',
    tr: 'Nakit yatırıldı',
    dk: 'Kontanter deponeret',
  },
  'CashManagement.Payouts.SelectSource': {
    en: 'Select cash withdrawal source',
    es: 'Seleccionar cajón de efectivo',
    se: 'Välj utbetalningskälla',
    no: 'Velg utbetalingskilde',
    tr: 'Ödeme kaynağını seçin',
    dk: 'Vælg udbetalingskilde',
  },
  'CashManagement.PayoutHistory': {
    en: 'Cash withdrawal history',
    es: 'Historial de movimientos',
    se: 'Utbetalningshistorik',
    no: 'Utbetalingshistorikk',
    tr: 'Ödeme geçmişi',
    dk: 'Udbetalingshistorik',
  },
  'CashManagement.PayoutHistory.NoPayouts': {
    en: 'There are no cash withdrawals for this date',
    es: 'No hay movimientos para esta fecha',
    se: 'Det finns inga utbetalningar för detta datum',
    no: 'Det er ingen utbetalinger for denne datoen',
    tr: 'Bu tarihe ait ödeme yok',
    dk: 'Der er ingen udbetalinger for denne dato',
  },
  'CashManagement.PayoutHistory.Deposited': {
    en: 'Deposited to',
    es: 'Ingresado a',
    se: 'Insatt till',
    no: 'Innsatt til',
    tr: 'Şuraya yatırıldı',
    dk: 'Deponeret til',
  },
  'CashManagement.PayoutHistory.From': {
    en: 'Withdrawn from',
    es: 'Retirado de',
    se: 'Uttaget från',
    no: 'Tatt ut fra',
    tr: 'Şuradan çekildi',
    dk: 'Trukket fra',
  },
  'GiftCard.Payment': {
    en: 'Gift card (Baemingo)',
    es: 'Tarjeta de regaloo',
    se: 'Presentkort (Baemingo)',
    no: 'Gavekort (Baemingo)',
    tr: 'Hediye kartı (Baemingo)',
    dk: 'Gavekort (Baemingo)',
  },
  'GiftCard.ExpiresAt': {
    en: 'Expires at',
    es: 'Expira en',
    se: 'Går ut',
    no: 'Utløper',
    tr: 'Süresi doluyor',
    dk: 'Udløber',
  },
  'GiftCard.Event.ADD_BALANCE': {
    en: 'Balance increased',
    es: 'Balance aumentado',
    se: 'Saldo ökat',
    no: 'Saldo økt',
    tr: 'Bakiye artırıldı',
    dk: 'Balance steget',
  },
  'GiftCard.Event.CREATE_CARD': {
    en: 'Created',
    es: 'Creado',
    se: 'Skapades',
    no: 'Opprettet',
    tr: 'Oluşturuldu',
    dk: 'Oprettet',
  },
  'GiftCard.Event.ACTIVATE': {
    en: 'Activated',
    es: 'Activado',
    se: 'Aktiverat',
    no: 'Aktivert',
    tr: 'Aktif',
    dk: 'Aktiveret',
  },
  'GiftCard.Event.PAYMENT': {
    en: 'Payment',
    es: 'Pago',
    se: 'Betalning',
    no: 'Betaling',
    tr: 'Ödeme',
    dk: 'Betaling',
  },
  'GiftCard.Event.REFUND': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'Återköp',
    no: 'Refusjon',
    tr: 'Geri ödeme',
    dk: 'Tilbagebetale',
  },
  'GiftCard.SelectPaymentMethod': {
    en: 'Select payment method',
    es: 'Selecciona método de pago',
    se: 'Välj betalningsmetod',
    no: 'Velg betalingsmiddel',
    tr: 'Ödeme türünü seçin',
    dk: 'Vælg betalingsmetode',
  },
  'Invoice.OrderRegistered': {
    en: 'Order registered for customer',
    es: 'Pedido registrado para el cliente',
    se: 'Order registrerad på kunden',
    no: 'Ordre registrert på kunden',
    tr: 'Müşteri için kayıtlı sipariş',
    dk: 'Ordre registreret for kunde',
  },
  'Invoice.Undo': {
    en: 'Undo',
    es: 'Deshacer',
    se: 'Ångra',
    no: 'Angre',
    tr: 'Geri al',
    dk: 'Fortryd',
  },
  'Invoice.Name': {
    en: 'Name',
    es: 'Nombre',
    se: 'Namn',
    no: 'Navn',
    tr: 'İsim',
    dk: 'Navn',
  },
  'Invoice.Company': {
    en: 'Company',
    es: 'Negocio',
    se: 'Företag',
    no: 'Bedrift',
    tr: 'Şirket',
    dk: 'Selskab',
  },
  'Invoice.CompanyName': {
    en: 'Company name',
    es: 'Nombre de empresa',
    se: 'Företagsnamn',
    no: 'Firmanavn',
    tr: 'Firma Adı',
    dk: 'Firmanavn',
  },
  'Invoice.Phone': {
    en: 'Phone',
    es: 'Teléfono',
    se: 'Telefon',
    no: 'Telefon',
    tr: 'Telefon',
    dk: 'Telefon',
  },
  'Invoice.Phone.Optional': {
    en: 'Phone (optional)',
    es: 'Teléfono (opcional)',
    se: 'Telefon (valfritt)',
    no: 'Telefon (valgfritt)',
    tr: 'Telefon (isteğe bağlı)',
    dk: 'Telefon (valgfrit)',
  },
  'Invoice.Email': {
    en: 'Email',
    es: 'Correo',
    se: 'Email',
    no: 'E-post',
    tr: 'E-posta',
    dk: 'E-mail',
  },
  'Invoice.Email.Optional': {
    en: 'Email (optional)',
    es: 'Correo (opcional)',
    se: 'Email (valfritt)',
    no: 'E-post (valgfritt)',
    tr: 'E-posta (isteğe bağlı)',
    dk: 'E-mail (valgfrit)',
  },
  'Invoice.Adress': {
    en: 'Adress',
    es: 'Dirección',
    se: 'Address',
    no: 'Adresse',
    tr: 'Adres',
    dk: 'Adresse',
  },
  'Invoice.Adress.Optional': {
    en: 'Adress (optional)',
    es: 'Dirección (opcional)',
    se: 'Address (valfritt)',
    no: 'Adresse (valgfritt)',
    tr: 'Adres (isteğe bağlı)',
    dk: 'Adresse (valgfrit)',
  },
  'Invoice.Reference': {
    en: 'Reference',
    es: 'Referencia',
    se: 'Er referens',
    no: 'Referanse',
    tr: 'Referans',
    dk: 'Reference',
  },
  'Invoice.Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    se: 'Bekräfta',
    no: 'Bekreft',
    tr: 'Onayla',
    dk: 'Bekræfte',
  },
  'Invoice.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Ophæve',
  },
  'Invoice.OrgNo': {
    en: 'Org. number',
    es: 'CIF/NIF',
    se: 'Org. nummer',
    no: 'Org. nummer',
    tr: 'Organizasyon sayısı',
    dk: 'Org. antal',
  },
  'Invoice.PersonalNumber': {
    en: 'Personal number',
    es: 'Número personal',
    se: 'Personnummer',
    no: 'Personnummer',
    tr: 'Kişisel numara',
    dk: 'Personnummer',
  },
  'Invoice.Creating': {
    en: 'Creating',
    es: 'Creando',
    se: 'Skapar',
    no: 'Oppretter',
    tr: 'Oluşturuluyor',
    dk: 'Opretter',
  },
  'Invoice.ZipCode': {
    en: 'ZIP code',
    es: 'Código postal',
    se: 'Postnummer',
    no: 'Postnummer',
    tr: 'Posta kodu',
    dk: 'postnummer',
  },
  'Invoice.City': {
    en: 'City',
    es: 'Ciudad',
    se: 'Ort',
    no: 'By',
    tr: 'Şehir',
    dk: 'By',
  },
  'Invoice.City.Optional': {
    en: 'City (optional)',
    es: 'Ciudad (opcional)',
    se: 'Ort (valfritt)',
    no: 'By (valgfritt)',
    tr: 'Şehir (isteğe bağlı)',
    dk: 'By',
  },
  'Invoice.Save': {
    en: 'Save',
    es: 'Guardar',
    se: 'Spara',
    no: 'Lagre',
    tr: 'Kaydet',
    dk: 'Gem  ',
  },
  'Invoice.SearchUser': {
    en: 'Search for a user',
    es: 'Buscar un usuario',
    se: 'Sök användare',
    no: 'Søk etter en bruker',
    tr: 'Kullanıcı ara',
    dk: 'Søg efter en bruger',
  },
  'Invoice.CreateNewCustomer': {
    en: 'Create new customer',
    es: 'Crear nuevo cliente',
    se: 'Skapa ny kund',
    no: 'Opprett ny kunde',
    tr: 'Yeni müşteri oluştur',
    dk: 'Opret ny kunde',
  },
  'Payment.Canceled': {
    en: 'Canceled payment',
    es: 'Pago cancelado',
    se: 'Betalning avbruten',
    no: 'Betaling avbrutt',
    tr: 'Ödeme iptal edildi',
    dk: 'Annulleret betaling',
  },
  'Payment.SelectTip': {
    en: 'Select Tip',
    es: 'Seleccionar Propina',
    se: 'Välj Dricks',
    no: 'Velg tips',
    tr: 'Bahşiş Seçin',
    dk: 'Vælg Tip',
  },
  'Scan.ToPay': {
    en: 'To pay',
    es: 'Pagar',
    se: 'Att betala',
    no: 'Å betale',
    tr: 'Ödemek',
    dk: 'At betale',
  },
  'Scan.Pay': {
    en: 'pay',
    es: 'pagar',
    se: 'betala',
    no: 'betal',
    tr: 'Öde',
    dk: 'betal',
  },
  'Swish.PaymentFailed': {
    en: 'Swish payment failed',
    es: 'Swish pago fallido',
    se: 'Swishbetalning misslyckades',
    no: 'Betaling feilet',
    tr: 'Swish ödemesi başarısız oldu',
    dk: 'Swish-betaling mislykkedes',
  },
  'Swish.ScanCode': {
    en: 'Scan QR-code in the app',
    es: 'Escanea el código QR en la aplicación',
    se: 'Skanna QR-kod i appen',
    no: 'Scan QR-kode i appen',
    tr: 'Uygulamada QR kodunu tarayın',
    dk: 'Scan QR-koden i appen',
  },
  'Swish.ToPay': {
    en: 'To pay',
    es: 'Pagar',
    se: 'Att betala',
    no: 'Å betale',
    tr: 'Ödemek',
    dk: 'At betale',
  },
  'Timeout.Failure': {
    en: 'Timeout Failure',
    es: 'Fallo de tiempo de espera',
    se: 'Timeout misslyckades',
    no: 'Feilet på grunnav tidsavbrudd',
    tr: 'Zaman Aşımı Hatası',
    dk: 'Timeout-fejl',
  },
  'Ordersyncer.NetworkError': {
    en: 'A network error prevented the order from being saved',
    es: 'Un error de red impidió que se guardara el pedido',
    se: 'Ordern kunde inte spara på grund av ett nätverksfel',
    no: 'Ordren kunne ikke lagres på grunn av en nettverksfeil',
    tr: 'Bir ağ hatası siparişin kaydedilmesini engelledi',
    dk: 'En netværksfejl forhindrede ordren i at blive gemt',
  },
  'Ordersyncer.Title': {
    en: 'Order sync failed',
    es: 'Error al sincronizar el pedido',
    se: 'Ordersynk misslyckades',
    no: 'Ordresynkronisering feilet',
    tr: 'Sipariş senkronizasyonu başarısız oldu',
    dk: 'Ordresynkronisering mislykkedes',
  },
  'Ordersyncer.PleaseSaveBackup': {
    en:
      'This order will sync automatically when the internet connection is restored. Please save the receipt as a backup.',
    es:
      'Este pedido se sincronizará automáticamente cuando se restablezca la conexión a internet. Por favor, guarde el ticket como copia de seguridad.',
    se:
      'Denna beställning synkas automatiskt när internetanslutningen återställs. Spara kvittot som en backup.',
    no:
      'Denne bestillingen vil bli synkronisert automatisk når internettforbindelsen er tilbake. Vennligst ta vare på kvitteringen som backup.',
    tr:
      'Bu sipariş, internet bağlantısı yeniden kurulduğunda otomatik olarak senkronize edilecektir. Lütfen fişi yedek olarak saklayın.',
    dk:
      'Denne ordre synkroniseres automatisk, når internetforbindelsen er gendannet. Gem venligst kvitteringen som backup.',
  },
  'Ordersyncer.AffectedOrderId': {
    en: 'Affected order ID',
    es: 'ID del pedido afectado',
    se: 'Påverkad order',
    no: 'Berørt ordre',
    tr: 'Etkilenen sipariş',
    dk: 'Berørt ordre',
  },
  'Ordersyncer.Order': {
    en: 'Order',
    es: 'Pedido',
    se: 'Order',
    no: 'Ordre',
    tr: 'Sipariş',
    dk: 'Bestille',
  },
  // Gateway
  'Gateway.TableManagement': {
    en: 'Table management',
    es: 'Gestión de mesas',
    se: 'Bordshantering',
    no: 'Bordservering',
    tr: 'Masa yönetimi',
    dk: 'Bordstyring',
  },
  'Gateway.PointOfSale': {
    en: 'Point of sale',
    es: 'Punto de venta',
    se: 'Kassa',
    no: 'Direktesalg',
    tr: 'Satış noktası',
    dk: 'Salgssted',
  },
  'Gateway.PointOfSaleMulti': {
    en: 'Point of sale (multi)',
    es: 'Punto de venta (multi)',
    se: 'Kassa (multi)',
    no: 'Direktesalg (multipay)',
    tr: 'Satış noktası (çoklu)',
    dk: 'Salgssted (multi)',
  },
  'Gateway.KitchenDisplay': {
    en: 'Kitchen display',
    es: 'Pantalla de cocina',
    se: 'Köksdisplay',
    no: 'Kjøkkenskjerm',
    tr: 'Mutfak ekranı',
    dk: 'Køkken display',
  },
  'Gateway.KitchenDisplayNew': {
    en: 'Kitchen display (new)',
    es: 'Pantalla de cocina (nuevo)',
    se: 'Köksdisplay (ny)',
    no: 'Kjøkkenskjerm (ny)',
    tr: 'Mutfak ekranı (yeni)',
    dk: 'Køkkenudstilling (nyt)',
  },
  'Gateway.CustomerDisplay': {
    en: 'Customer display',
    es: 'Visor para cliente',
    se: 'Nummerredoskärm',
    no: 'Utleveringsskjerm',
    tr: 'Müşteri ekranı',
    dk: 'Kunde display',
  },
  'Gateway.CustomerDisplayLarge': {
    en: 'Customer display (large screen)',
    es: 'Visor para cliente (grande)',
    se: 'Nummerredoskärm (Stor skärm)',
    no: 'Utleveringsskjerm (Stor)',
    tr: 'Müşteri ekranı (geniş ekran)',
    dk: 'Kundedisplay (stor skærm)',
  },
  'Gateway.ExpressCheckout': {
    en: 'Express checkout',
    es: 'Caja de autoservicio',
    se: 'Expresskassa',
    no: 'Selvbetjent kasse',
    tr: 'Hızlı ödeme',
    dk: 'Hurtig udtjekning',
  },
  'Gateway.SelfServiceKiosk': {
    en: 'Self service kiosk',
    es: 'Caja de autoservicio',
    se: 'Expresskassa',
    no: 'Selvbetjent kasse',
    tr: 'Self servis kiosk',
    dk: 'Selvbetjenings kiosk',
  },
  'Gateway.Points': {
    en: 'Points',
    es: 'Puntos',
    se: 'Poäng',
    no: 'Poeng',
    tr: 'Puanlar',
    dk: 'Points',
  },
  'Gateway.Inventory': {
    en: 'Inventory',
    es: 'Inventario',
    se: 'Lagerhantering',
    no: 'Lagerstyring',
    tr: 'Envanter',
    dk: 'Inventar',
  },
  'Gateway.PayAtTable': {
    en: 'Pay at table',
    es: 'Pagar en la mesa',
    se: 'Betala vid bord',
    no: 'Betaling ved bord',
    tr: 'Masada ödeme',
    dk: 'Betal ved bordet',
  },
  'Gateway.NoLicensesAvailable': {
    en: 'No available licenses',
    es: 'No hay licencias disponibles',
    se: 'Inga tillgängliga licenser',
    no: 'Ingen tilgjengelige lisenser',
    tr: 'Kullanılabilir lisans yok',
    dk: 'Ingen tilgængelige licenser',
  },
  'Gateway.NoLicensesAvailable.Desc': {
    en:
      "This device has no licenses and the venue has no available licenses to claim. Check if you're on the correct device or contact your administrator.",
    es:
      'Este dispositivo no tiene licencias y el lugar no tiene licencias disponibles para reclamar. Verifique si está en el dispositivo correcto o contacte a su administrador.',
    se:
      'Denna enhet har inga licenser och lokalen har inga tillgängliga licenser att aktivera. Kontrollera om du är på rätt enhet eller kontakta din administratör.',
    no:
      'Denne enheten har ingen lisenser, og lokalet har ingen tilgjengelige lisenser å aktivere. Sjekk om du er på riktig enhet eller kontakt administratoren',
    tr:
      'Bu cihazda lisans yok ve mekanın talep edilecek kullanılabilir lisansı yok. Doğru cihazda olup olmadığınızı kontrol edin veya yöneticinizle iletişime geçin.',
    dk:
      'Denne enhed har ingen licenser, og stedet har ingen tilgængelige licenser at aktivere. Kontroller, om du er på den rigtige enhed, eller kontakt din administrator.',
  },
  'Handy.Title': {
    en: 'Handy',
    es: 'Handy',
    se: 'Handy',
    no: 'Handy',
    tr: 'Kullanışlı',
    dk: 'Praktisk',
  },
  'Handy.Settings.GeneralTitle': {
    en: 'Other',
    es: 'Otros',
    se: 'Övrigt',
    no: 'Annet',
    tr: 'Diğer',
    dk: 'Andet',
  },
  'Handy.Settings.PrintersTitle': {
    en: 'Printers',
    es: 'Impresoras',
    se: 'Skrivare',
    no: 'Printere',
    tr: 'Yazıcılar',
    dk: 'Printere',
  },
  'Handy.Settings.KitchenTickets': {
    en: 'Printed kitchen tickets',
    es: 'Configurar tickets de cocina',
    se: 'Fysiska bongar',
    no: 'Fysiske bonger',
    tr: 'Basılı mutfak biletleri',
    dk: 'Trykte køkkenbilletter',
  },
  'Handy.Settings.PaymentsTitle': {
    en: 'Payments',
    es: 'Configuración de pagos',
    se: 'Betalningar',
    no: 'Betalinger',
    tr: 'Ödemeler',
    dk: 'Betalinger',
  },
  'Handy.Settings.ReceiptsTitle': {
    en: 'Receipts',
    es: 'Recibos',
    se: 'Kvitton',
    no: 'Kvitteringer',
    tr: 'Makbuzlar',
    dk: 'Kvitteringer',
  },
  'Handy.Settings.StaffTitle': {
    en: 'Staff',
    es: 'Personal',
    se: 'Personal',
    no: 'Ansatte',
    tr: 'Personel',
    dk: 'Personal',
  },
  'Handy.Settings.PosLayoutTitle': {
    en: 'POS layout',
    es: 'Diseño de POS',
    se: 'POS layout',
    no: 'POS-layout',
    tr: 'POS düzeni',
    dk: 'POS layout',
  },
  'Handy.Settings.AskToPrint': {
    en: 'Ask to print receipts',
    es: 'Preguntar para imprimir tickets',
    se: 'Fråga för att skriva ut kvitto',
    no: 'Spør om kvittering',
    tr: 'Fişlerin yazdırılmasını isteyin',
    dk: 'Bed om at udskrive kvitteringer',
  },
  'Handy.Settings.PrintVoidedItems': {
    en: 'Print when items and checks are voided',
    es: 'Imprimir cuando se anulan artículos y comandas',
    se: 'Skriv ut när artiklar och notor tas bort',
    no: 'Skriv ut når artikler og sjekker slettes',
    tr: 'Ürünler ve çekler geçersiz kılındığında yazdırın',
    dk: 'Udskriv, når varer og checks er annulleret',
  },
  'Handy.Settings.UseHandheldPrinter': {
    en: 'Use dock as printer',
    es: 'Usar dispositivo portátil como impresora',
    se: 'Använd denna enhet som skrivare',
    no: 'Bruk denne enheten som skriver',
    tr: 'Bağlantı birimini yazıcı olarak kullan',
    dk: 'Brug dock som printer',
  },
  'Handy.Settings.UseHandheldBongPrinter': {
    en: 'Use dock as kitchen ticket printer',
    es: 'Usar dispositivo portátil como impresora de cocina',
    se: 'Använd denna enhet som köksbongskrivare',
    no: 'Bruk denne enheten som kjøkkenbongskriver',
    tr: 'Bağlantı birimini mutfak bilet yazıcısı olarak kullan',
    dk: 'Brug dock som køkkenbilletprinter',
  },
  'Handy.EnableTipping': {
    en: 'Enable tipping',
    es: 'Habilitar propinas',
    se: 'Aktivera dricks',
    no: 'Aktiver tips',
    tr: 'Bahşişi etkinleştir',
    dk: 'Aktiver tip',
  },
  'Handy.Language': {
    en: 'Language',
    es: 'Idioma',
    se: 'Språk',
    no: 'Språk',
    tr: 'Dil',
    dk: 'Sprog',
  },
  'Handy.General': {
    en: 'General',
    es: 'General',
    se: 'Allmänt',
    no: 'Generelt',
    tr: 'Genel',
    dk: 'Generel',
  },
  'Handy.Settings': {
    en: 'Settings',
    es: 'Configuración',
    se: 'Inställningar',
    no: 'Innstillinger',
    tr: 'Ayarlar',
    dk: 'Indstillinger',
  },
  'Handy.EndOfDay': {
    en: 'End of day',
    es: 'Cierre de servicio',
    se: 'Dagsavslut',
    no: 'Dagsavslutning',
    tr: 'Gün sonu',
    dk: 'Slut på dagen',
  },
  'Handy.Home': {
    en: 'Home',
    es: 'Inicio',
    se: 'Hem',
    no: 'Hjem',
    tr: 'Ana Ekran',
    dk: 'Hjem',
  },
  'Handy.Settings.Developer': {
    en: 'Developer',
    es: 'Desarollador',
    se: 'Developer',
    no: 'Developer',
    tr: 'Geliştirici',
    dk: 'Udvikler',
  },
  'Handy.Settings.DeviceTitle': {
    en: 'Device',
    es: 'Dispositivo',
    se: 'Enhet',
    no: 'Enhet',
    tr: 'Cihaz',
    dk: 'Enhed',
  },
  'Handy.Active': {
    en: 'Active',
    es: 'Activo',
    se: 'Aktiv',
    no: 'Aktiv',
    tr: 'Aktif',
    dk: 'Aktiv',
  },
  'Handy.Tables': {
    en: 'Tables',
    es: 'Mesas',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masalar',
    dk: 'Borde',
  },
  'Handy.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'Handy.Table.Open': {
    en: 'Open table',
    es: 'Mesa abierta',
    se: 'Öppna bord',
    no: 'Åpne bord',
    tr: 'Masayı aç',
    dk: 'Åben bord',
  },
  'Handy.ConfigureTaxDeviceMessage': {
    en: 'Configure tax device.',
    es: 'Configure el dispositivo de impuestos.',
    se: 'Konfigurera skatteenhet.',
    no: 'Konfigurer kontrollenhet',
    tr: 'Vergi cihazını yapılandırın.',
    dk: 'Konfigurer skatteenhed.',
  },
  'Handy.ConfigureTaxDeviceLinkText': {
    en: 'Configure device.',
    es: 'Configure el dispositivo.',
    se: 'Konfigurera enhet.',
    no: 'Konfigurer enhet',
    tr: 'Cihazı yapılandırın.',
    dk: 'Konfigurer enhed.',
  },
  'Handy.Onboarding.WelcomeTitle': {
    en: 'Welcome to Baemingo',
    es: 'Bienvenido a Baemingo',
    se: 'Välkommen till Baemingo',
    no: 'Velkommen til Baemingo',
    tr: "Baemingo'ya hoş geldiniz",
    dk: 'Velkommen til Baemingo',
  },
  'Handy.Onboarding.WelcomeText': {
    en: 'The following actions are required to start using this device.',
    es: 'Las siguientes acciones son necesarias para comenzar a usar este dispositivo.',
    se: 'Följande åtgärder krävs för att börja använda denna enhet.',
    no: 'Følgende steg må gjennomføres før du kan bruke denne enheten.',
    tr: 'Bu cihazı kullanmaya başlamak için aşağıdaki eylemler gereklidir.',
    dk: 'Følgende handlinger er nødvendige for at begynde at bruge denne enhed.',
  },
  'Handy.Onboarding.CTA': {
    en: 'Get started!',
    es: 'Empezar!',
    se: 'Kom igång!',
    no: 'Kom i gang!',
    tr: 'Başla!',
    dk: 'Kom i gang!',
  },
  'Handy.Tables.GoToTable': {
    en: 'Go to table',
    es: 'Ir a la mesa',
    se: 'Gå till bord',
    no: 'Gå til bord',
    tr: 'Masaya git',
    dk: 'Gå til bord',
  },
  'Handy.Tables.StaffTables': {
    en: 'Your Tables',
    es: 'Sus mesas',
    se: 'Dina bord',
    no: 'Dine bord',
    tr: 'Masalarınız',
    dk: 'Dine borde',
  },
  'Handy.Tables.Recent': {
    en: 'Recent',
    es: 'Reciente',
    se: 'Senaste',
    no: 'Nylige',
    tr: 'Güncel',
    dk: 'Nylig',
  },
  'Handy.Tables.NoRecent': {
    en: 'No recent tables',
    es: 'No hay mesas recientes',
    se: 'Inga senaste bord',
    no: 'Ingen nylige bord',
    tr: 'Yeni masa yok',
    dk: 'Ingen seneste tabeller',
  },
  'Handy.Tables.All': {
    en: 'All Tables',
    es: 'Todas las mesas',
    se: 'Alla bord',
    no: 'Alle bord',
    tr: 'Tüm Masalar',
    dk: 'Alle borde',
  },
  'Handy.Tables.SwitchToMap': {
    en: 'Map view',
    es: 'Mapa',
    se: 'Kartvy',
    no: 'Kartvisning',
    tr: 'Harita',
    dk: 'Kortvisning',
  },
  'Handy.Tables.SwitchToList': {
    en: 'List view',
    es: 'Lista',
    se: 'Listvy',
    no: 'Listevisning',
    tr: 'Liste',
    dk: 'Listevisning',
  },
  'Handy.Floorplans': {
    en: 'Areas',
    es: 'Áreas',
    se: 'Områden',
    no: 'Bordkart',
    tr: 'Alanlar',
    dk: 'Områder',
  },
  'Handy.Select.Floorplan': {
    en: 'Select floorplan',
    es: 'Seleccionar sala',
    se: 'Välj planlösning',
    no: 'Velg bordkart',
    tr: 'Kat planını seçin',
    dk: 'Vælg gulvplan',
  },
  'Handy.Tables.ChequePanel.Seated': {
    en: 'Seated',
    es: 'Sentado',
    se: 'Sittande',
    no: 'Sittende',
    tr: 'Oturan',
    dk: 'Siddende',
  },
  'Handy.Tables.ChequePanel.Total': {
    en: 'Total',
    es: 'Total',
    se: 'Totalt',
    no: 'Total',
    tr: 'Toplam',
    dk: 'Total',
  },
  'Handy.Tables.ChequePanel.Items': {
    en: 'Articles',
    es: 'Artículos',
    se: 'Artiklar',
    no: 'Artikler',
    tr: 'Ürünler',
    dk: 'genstande',
  },
  'Handy.Tables.ChequePanel.Coverage': {
    en: 'Coverage',
    es: 'Comensales',
    se: 'Personer',
    no: 'Personer',
    tr: 'Kapsam',
    dk: 'Dækning',
  },
  'Handy.Cheque.Article': {
    en: 'Article',
    es: 'Artículo',
    se: 'Artikel',
    no: 'Artikkel',
    tr: 'Ürünler',
    dk: 'Artikel',
  },
  'Handy.Cheque.Price': {
    en: 'Price',
    es: 'Precio',
    se: 'Pris',
    no: 'Pris',
    tr: 'Fiyat',
    dk: 'Pris',
  },
  'Handy.Cheque.Discount': {
    en: 'Discount',
    es: 'Descuento',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'Handy.Cheque.Discount.Clear': {
    en: 'Clear Discount',
    es: 'Eliminar descuento',
    se: 'Rensa Rabatt',
    no: 'Fjern rabatt',
    tr: 'İndirimi Çıkar',
    dk: 'Slet rabat',
  },
  'Handy.Cheque.Paid': {
    en: 'Paid',
    es: 'Pagado',
    se: 'Betalt',
    no: 'Betalt',
    tr: 'Ödendi',
    dk: 'Betalt',
  },
  'Handy.Cheque.Service': {
    en: 'Service',
    es: 'Servicio',
    se: 'Service',
    no: 'Service',
    tr: 'Servis',
    dk: 'Service',
  },
  'Handy.Cheque.Split': {
    en: 'Split cheque',
    es: 'Dividir comanda',
    se: 'Dela upp notan',
    no: 'Splitt regning',
    tr: 'Bölünmüş çek',
    dk: 'Split check',
  },
  'Handy.Cheque.Deleted': {
    en: 'Cheque was deleted',
    es: 'La comanda fue eliminada',
    se: 'Notan togs bort',
    no: 'Regningen ble slettet',
    tr: 'Çek silindi',
    dk: 'Check blev slettet',
  },
  'Handy.Payment.SelectTip': {
    en: 'Select Tip',
    es: 'Seleccionar Propina',
    se: 'Välj Dricks',
    no: 'Velg tips',
    tr: 'Bahşiş Seçin',
    dk: 'Vælg Tip',
  },
  'Handy.Payment.NoTip': {
    en: 'No Tip',
    es: 'Sin Propina',
    se: 'Ingen Dricks',
    no: 'Ingen tips',
    tr: 'Bahşiş yok',
    dk: 'Ingen tip',
  },
  'Handy.Payment.OutOfSync': {
    en: 'Cheque might be out of sync',
    es: 'La comanda podría estar fuera de sincronización',
    se: 'Notan kan vara ur synk',
    no: 'Regningen kan være ute av synk',
    tr: 'Çek senkronizasyon dışında olabilir',
    dk: 'Check kan være ude af synk',
  },
  'Handy.Payment.OutOfSync.Desc': {
    en: 'The cheque might be out of sync with the latest data. Please resync before proceeding.',
    es:
      'La comanda podría estar fuera de sincronización con los últimos datos. Por favor, resincronice antes de continuar.',
    se: 'Notan kan vara ur synk med den senaste datan. Vänligen synka innan du fortsätter.',
    no:
      'Regningen kan være ute av synk med de siste dataene. Vennligst synkroniser før du fortsetter.',
    tr:
      'Çek, en son verilerle senkronize dışında olabilir. Lütfen devam etmeden önce yeniden senkronize edin.',
    dk: 'Check kan være ude af synk med de seneste data. Venligst synkroniser før du fortsætter.',
  },
  'Handy.Payment.OutOfSync.Resync': {
    en: 'Resync',
    es: 'Resincronizar',
    se: 'Synka igen',
    no: 'Synkroniser på nytt',
    tr: 'Yeniden senkronize et',
    dk: 'Synkroniser igen',
  },
  'Handy.Discount.NotApplicable': {
    en: 'Discount not applicable to this cart',
    es: 'Descuento no aplicable a este carrito',
    se: 'Rabatten går inte att applicera på denna nota',
    no: 'Rabatten kan ikke legges på denne regningen',
    tr: 'İndirim bu sepete uygulanamaz',
    dk: 'Rabat gælder ikke for denne vogn',
  },
  'Handy.Discount.AppliedTo': {
    en: (numItems: number) => `Discount applied to ${numItems} items`,
    es: (numItems: number) => `Descuento aplicado a ${numItems} artículos`,
    se: (numItems: number) => `Rabatten applicerad på ${numItems} artiklar`,
    no: (numItems: number) => `Rabatten aktivert på ${numItems} artikler`,
    tr: (numItems: number) => `${numItems} ürüne indirim uygulandı`,
    dk: (numItems: number) => `Rabat anvendes på ${numItems} varer`,
  },
  'Handy.Page.settings': {
    en: 'Settings',
    es: 'Configuración',
    se: 'Inställningar',
    no: 'Innstillinger',
    tr: 'Ayarlar',
    dk: 'Indstillinger',
  },
  'Handy.Page.history': {
    en: 'History',
    es: 'Historial',
    se: 'Historik',
    no: 'Kvitteringer',
    tr: 'Geçmiş',
    dk: 'Historie',
  },
  'Handy.Page.XZ': {
    en: 'X/Z report',
    es: 'X/Z inform',
    se: 'X/Z rapport',
    no: 'X/Z rapport',
    tr: 'X/Z raporu',
    dk: 'X/Z rapport',
  },
  'Handy.Page.Reports': {
    en: 'Reports',
    es: 'Informes',
    se: 'Rapporter',
    no: 'Rapporter',
    tr: 'Raporlar',
    dk: 'Rapporter',
  },
  'Handy.Page.languages': {
    en: 'Languages',
    es: 'Idiomaa',
    se: 'Språk',
    no: 'Språk',
    tr: 'Diller',
    dk: 'Sprog',
  },
  'Handy.Page.home': {
    en: 'Home',
    es: 'Inicio',
    se: 'Hem',
    no: 'Hjem',
    tr: 'Ana Sayfa',
    dk: 'Hjem',
  },
  'Handy.Page.general': {
    en: 'General',
    es: 'General',
    se: 'Allmänt',
    no: 'Generelt',
    tr: 'Genel',
    dk: 'Generel',
  },
  'Handy.Page.tables': {
    en: 'Tables',
    es: 'Mesas',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masalar',
    dk: 'Borde',
  },
  'Handy.Page.printerSettings': {
    en: 'Printer settings',
    es: 'Configuración de impresora',
    se: 'Skrivarinställningar',
    no: 'Printerinnstillinger',
    tr: 'Yazıcı ayarları',
    dk: 'Printerindstillinger',
  },
  'Handy.History.Search.Placeholder': {
    en: 'Search order ID',
    es: 'Nº de ticket',
    se: 'Sök ordernummer',
    no: 'Søk ordrenummer',
    tr: 'Sipariş kimliğini ara',
    dk: 'Søg ordre-id',
  },
  'Handy.History.Search.Sum.Placeholder': {
    en: 'Search sum',
    es: 'Suma de búsqueda',
    se: 'Sök summa',
    no: 'Søk beløp',
    tr: 'Arama toplamı',
    dk: 'Søg sum',
  },
  'Handy.History.Order.Info': {
    en: 'Information',
    es: 'Información',
    se: 'Information',
    no: 'Informasjon',
    tr: 'Bilgi',
    dk: 'Information',
  },
  'Handy.History.Articles': {
    en: 'Articles',
    es: 'Artículos',
    se: 'Artiklar',
    no: 'Artikler',
    tr: 'Ürün',
    dk: 'Artikler',
  },
  'Handy.History.LoadMore': {
    en: 'Load more',
    es: 'Cargar más',
    se: 'Hämta fler',
    no: 'Last inn flere',
    tr: 'Daha fazla yükle',
    dk: 'Indlæs flere',
  },
  'Handy.Order': {
    en: 'Order',
    es: 'Pedido',
    se: 'Bonga',
    no: 'Ordre',
    tr: 'Sipariş',
    dk: 'Ordre',
  },
  'Handy.Settings.SelectLayout': {
    en: 'Select POS layout',
    es: 'Seleccionar diseño de POS',
    se: 'Välj POS layout',
    no: 'Velg POS-layout',
    tr: 'POS düzenini seçin',
    dk: 'Vælg POS-layout',
  },
  'Handy.Ordering.Undo': {
    en: 'Undo',
    es: 'Deshacer',
    se: 'Ångra',
    no: 'Angre',
    tr: 'Geri al',
    dk: 'Fortryd',
  },
  'Handy.Ordering.Send': {
    en: 'Send',
    es: 'Enviar',
    se: 'Skicka',
    no: 'Send',
    tr: 'Gönder',
    dk: 'Send',
  },
  'Handy.Ordering.Continue': {
    en: 'Continue',
    es: 'Seguir',
    se: 'Fortsätt',
    no: 'Fortsett',
    tr: 'Devam et',
    dk: 'Fortsæt',
  },
  'Handy.Ordering.Pay': {
    en: 'Pay',
    es: 'Pagar',
    se: 'Betala',
    no: 'Betal',
    tr: 'Öde',
    dk: 'Betal',
  },
  'Handy.Ordering.Cancel': {
    en: 'Cancel',
    es: 'Cancelar',
    se: 'Avbryt',
    no: 'Avbryt',
    tr: 'İptal et',
    dk: 'Ophæve',
  },
  'Handy.Ordering.Message': {
    en: 'Message',
    es: 'Mensaje',
    se: 'Meddelande',
    no: 'Melding',
    tr: 'İleti',
    dk: 'Besked',
  },
  'Handy.Ordering.ChangeCourse': {
    en: 'Course',
    es: 'Pase',
    se: 'Rätt',
    no: 'Rett',
    tr: 'Kors',
    dk: 'Kursus',
  },
  'Handy.Ordering.Copy': {
    en: 'Copy',
    es: 'Duplicar',
    se: 'Kopiera',
    no: 'Kopier',
    tr: 'Kopyala',
    dk: 'Kopi',
  },
  'Handy.Ordering.Clear.Confirm': {
    en: 'Confirm clearing cart',
    es: 'Confirmar carro de compensación',
    se: 'Bekräfta rensning av varukorgen',
    no: 'Bekreft sletting av handlekurven',
    tr: 'Sepeti temizlemeyi onayla',
    dk: 'Bekræft rydning af vogn',
  },
  'Handy.Ordering.Compress': {
    en: 'Compress articles',
    es: 'Comprimir artículos',
    se: 'Slå ihop artiklar',
    no: 'Slå sammen artikler',
    tr: 'Ürünleri kapat',
    dk: 'Komprimer artikler',
  },
  'Handy.Ordering.UnCompress': {
    en: 'Uncompress articles',
    se: 'Visa alla artiklar',
    es: 'Descomprimir artículos',
    no: 'Vis alle artikler',
    tr: 'Kapatılmış ürünleri aç',
    dk: 'Udkomprimer artikler',
  },
  'Handy.NrOfItems': {
    en: (count: number) => (count === 1 ? 'article' : 'articles'),
    es: (count: number) => (count === 1 ? 'artículo' : 'artículos'),
    se: (count: number) => (count === 1 ? 'artikel' : 'artiklar'),
    no: (count: number) => (count === 1 ? 'artikkel' : 'artikler'),
    tr: (count: number) => (count === 1 ? 'ürün' : 'ürünler'),
    dk: (count: number) => (count === 1 ? 'artikel' : 'artikler'),
  },
  'Handy.Next.Course': {
    en: 'Next',
    es: 'Recl.',
    se: 'Fram',
    no: 'Bedes',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'Handy.Tables.Messages': {
    en: 'Kitchen messages',
    es: 'Mensajes cocina',
    se: 'Köksmeddelanden',
    no: 'Kjøkkenbeskjed',
    tr: 'Mutfak mesajları',
    dk: 'Køkkenbeskeder',
  },
  'Handy.Tables.Logs': {
    en: 'History',
    es: 'Historial',
    se: 'Historik',
    no: 'Historikk',
    tr: 'Geçmiş',
    dk: 'Historie',
  },
  'Handy.Tables.LoadingEvents': {
    en: 'Just a moment, loading the latest table events…',
    es: 'Un momento, cargando los últimos eventos de las mesas…',
    se: 'Ett ögonblick, laddar de senaste händelserna från borden…',
    no: 'Et øyeblikk, laster de siste hendelsene fra bordene…',
    tr: 'Biraz bekleyin, masalardaki en son olaylar yükleniyor…',
    dk: 'Et øjeblik, indlæser de seneste hændelser fra bordene…',
  },
  'Handy.Payment.ReadyForNext': {
    en: 'Ready for next payment',
    es: 'Listo para el próximo pago',
    se: 'Redo för nästa betalning',
    no: 'Klar for neste betaling',
    tr: 'Sonraki ödeme için hazır',
    dk: 'Klar til næste betaling',
  },
  'ZReport.Title': {
    en: 'Z-Report',
    es: 'Cierre de caja - Informe Z',
    se: 'Z-Rapport',
    no: 'Z-rapport',
    tr: 'Z Raporu',
    dk: 'Z-rapport',
  },
  'ZReport.Created': {
    en: 'Created',
    es: 'Creado',
    se: 'Skapad',
    no: 'Opprettet',
    tr: 'Oluşturuldu',
    dk: 'Oprettet',
  },
  'ZReport.SequenceId': {
    en: 'Sequence ID',
    es: 'Nº de secuencia',
    se: 'Sekvens ID',
    no: 'Sekvens-ID',
    tr: 'Sıra Kimliği',
    dk: 'Sekvens ID',
  },
  'ZReport.RegisterId': {
    en: 'Register ID',
    es: 'Nº de registro',
    se: 'Kassa ID',
    no: 'Kasse-ID',
    tr: 'Kayıt Kimliği',
    dk: 'Registrer ID',
  },
  'ZReport.SalesPerCategory': {
    en: 'Sales per category',
    es: 'Ventas por categoría',
    se: 'Försäljning per kategori',
    no: 'Salg per kategori',
    tr: 'Kategori başına satış',
    dk: 'Salg pr. kategori',
  },
  'ZReport.TotalSales': {
    en: 'Total sales',
    es: 'Ventas acumuladas',
    se: 'Total försäljning',
    no: 'Totalt salg',
    tr: 'Toplam satış',
    dk: 'Samlet salg',
  },
  'ZReport.VatSpecification': {
    en: 'VAT specification',
    es: 'Tipos de IVA',
    se: 'Moms specifikation',
    no: 'MVA-spesifikasjon',
    tr: 'KDV spesifikasyonu',
    dk: 'momsspecifikation',
  },
  'ZReport.TotalVat': {
    en: 'Total VAT',
    es: 'Importe de IVA',
    se: 'Total moms',
    no: 'Total MVA',
    tr: 'Toplam KDV',
    dk: 'Samlet moms',
  },
  'ZReport.NetSales': {
    en: 'Net sales',
    es: 'Base imponible',
    se: 'Nettoförsäljning',
    no: 'Netto salg',
    tr: 'Net satış',
    dk: 'Nettoomsætning',
  },
  'ZReport.Receipts': {
    en: 'Receipts',
    es: 'Tickets',
    se: 'Kvitton',
    no: 'Kvitteringer',
    tr: 'Fişler',
    dk: 'Kvitteringer',
  },
  'ZReport.RegisterReceipts': {
    en: 'Register receipts',
    es: 'Tickets impresos',
    se: 'Kassakvitton',
    no: 'Salgskvitteringer',
    tr: 'Fişleri kaydet',
    dk: 'Registrer kvitteringer',
  },
  'ZReport.ReceiptCopies': {
    en: 'Receipt copies',
    es: 'Copias impresas',
    se: 'Kvittokopior',
    no: 'Kopikvitteringer',
    tr: 'Fiş kopyaları',
    dk: 'Kvittering kopier',
  },
  'ZReport.PaymentMethods': {
    en: 'Payment methods',
    es: 'Pagos del servicio',
    se: 'Betalningsmedel',
    no: 'Betalingsmidler',
    tr: 'Ödeme metodları',
    dk: 'Betalingsmetoder',
  },
  'ZReport.Tips': {
    en: 'Tips',
    es: 'Propinas',
    se: 'Dricks',
    no: 'Tips',
    tr: 'Bahşişler',
    dk: 'Tips',
  },
  'ZReport.Refunds': {
    en: 'Refunds',
    es: 'Reembolsos',
    se: 'Retur',
    no: 'Returer',
    tr: 'Geri ödemeler',
    dk: 'Tilbagebetalinger',
  },
  'ZReport.Discounts': {
    en: 'Discounts',
    es: 'Descuentos',
    se: 'Rabatter',
    no: 'Rabatter',
    tr: 'İndirimler',
    dk: 'Rabatter',
  },
  'ZReport.TotalSoldArticles': {
    en: 'Total articles sold',
    es: 'Total artículos vendidos',
    se: 'Totalt antal sålda artiklar',
    no: 'Totalt antall solgte artikler',
    tr: 'Satılan toplam ürün',
    dk: 'Samlet solgte artikler',
  },
  'ZReport.TotalRefundedArticles': {
    en: 'Total articles refunded',
    es: 'Total artículos devueltos',
    se: 'Totalt antal återbetalda artiklar',
    no: 'Totalt antall returnerte artikler',
    tr: 'İade edilen toplam ürünler',
    dk: 'Samlet artikler refunderet',
  },
  'ZReport.Sum': {
    en: 'Sum',
    es: 'Totales',
    se: 'Summa',
    no: 'Sum',
    tr: 'Toplam',
    dk: 'Sum',
  },
  'ZReport.GrandTotal': {
    en: 'Grand total sales',
    es: 'Ventas acumuladas',
    se: 'Grand total försäljning',
    no: 'Grand total salg',
    tr: 'Genel toplam satışlar',
    dk: 'Det samlede salg',
  },
  'ZReport.GrandTotalRefunds': {
    en: 'Grand total refunds',
    es: 'Reembolsos acumulados',
    se: 'Grand total retur',
    no: 'Grand total retur',
    tr: 'Genel toplam geri ödemeler',
    dk: 'Samlet refusion',
  },
  'ZReport.GrandTotalNetSales': {
    en: 'Grand total net sales',
    es: 'Base imponible acumulado',
    se: 'Grand total nettoförsäljning',
    no: 'Grand total nettosalg',
    tr: 'Genel toplam net satışlar',
    dk: 'Samlet nettoomsætning',
  },
  'ZReport.GrandTotalNetSalesSpecial': {
    en: 'Grand total net (- refunds, incl. vat)',
    es: 'Total neto acumulado (- reembolsos, incl. IVA)',
    se: 'Grand total netto (- refunds, inkl. moms)',
    no: 'Grand total netto (- refusjoner, inkl. moms)',
    tr: 'Genel toplam net (- iadeler, KDV dahil)',
    dk: 'Total netto (- restitutioner, inkl. moms)',
  },
  'ZReport.CashRegisterIn': {
    en: 'Cash register in',
    es: 'Fondo de caja inicial',
    se: 'Växelkassa in',
    no: 'Inngående vekselkasse',
    tr: 'Yazar kasa girişi',
    dk: 'Kasseapparat ind',
  },
  'ZReport.CashRegister.CashSales': {
    en: 'Cash sales',
    es: 'Ventas en efectivo',
    se: 'Kontantförsäljning',
    no: 'Kontantsalg',
    tr: 'Nakit satış',
    dk: 'Kontantsalg',
  },
  'ZReport.CashRegister.CashTips': {
    en: 'Cash tips',
    es: 'Propinas en efectivo',
    se: 'Kontantdricks',
    no: 'Kontanttips',
    tr: 'Nakit bahşişler',
    dk: 'Kontantdrikkepenge',
  },
  'ZReport.CashRegister.CashDeposits': {
    en: 'Cash deposits',
    es: 'Entradas de efectivo',
    se: 'Kontantinsättningar',
    no: 'Kontantinnskudd',
    tr: 'Nakit depozitolar',
    dk: 'Kontantindskud',
  },
  'ZReport.CashRegister.CashWithdrawals': {
    en: 'Cash withdrawals',
    es: 'Salidas de efectivo',
    se: 'Kontantuttag',
    no: 'Kontantuttak',
    tr: 'Nakit çekimler',
    dk: 'Kontantudbetalinger',
  },
  'ZReport.CashRegisterOut': {
    en: 'Cash register out',
    es: 'Fondo de caja final',
    se: 'Växelkassa ut',
    no: 'Utgående vekselkasse',
    tr: 'Yazar kasa çıkışı',
    dk: 'Kasseapparat ud',
  },
  'ZReport.OrgNr': {
    en: 'Org. number',
    es: 'CIF/NIF',
    se: 'Org. nummer',
    no: 'Org. nummer',
    tr: 'Organizasyon sayı',
    dk: 'Org. antal',
  },
  'ZReport.x': {
    en: 'x',
    es: 'x',
    se: 'st',
    no: 'stk',
    tr: 'X',
    dk: 'x',
  },
  'ZReport.TurnoverAndTax': {
    en: 'Turnover and tax calculations',
    es: 'Cálculos de facturación e impuestos',
    se: 'Omsättning och skatteberäkningar',
    no: 'Omsetning og MVA-beregning',
    tr: 'Ciro ve vergi hesaplamaları',
    dk: 'Omsætning og afgiftsberegninger',
  },
  'ZReport.TurnoverPayments': {
    en: 'Turnover payments',
    es: 'Pagos de facturación',
    se: 'Omsättning betalningar',
    no: 'Betalinger',
    tr: 'Ciro ödemeleri',
    dk: 'Omsætningsbetalinger',
  },
  'ZReport.LinesEntered': {
    en: 'Lines entered',
    es: 'Líneas ingresadas',
    se: 'Rader inmatade',
    no: 'Innslag',
    tr: 'Girilen satırlar',
    dk: 'Linjer indtastet',
  },
  'ZReport.Corrections': {
    en: 'Corrections',
    es: 'Correcciones',
    se: 'Korrigeringar',
    no: 'Linjekorreksjoner',
    tr: 'Düzeltmeler',
    dk: 'Rettelser',
  },
  'ZReport.NonCompletedCheques': {
    en: 'Removed cheques',
    es: 'Comandas anuladas',
    se: 'Borttagna notor',
    no: 'Ikke fullførte kontantsalg',
    tr: 'Kaldırılan çekler',
    dk: 'Fjernet checks',
  },
  'ZReport.Turnover': {
    en: 'Turnover',
    es: 'Facturación',
    se: 'Omsättning',
    no: 'Omsetning',
    tr: 'Devir',
    dk: 'Omsætning',
  },
  'ZReport.TrainingReceipts': {
    en: 'Training receipts',
    es: 'Tickets de formación',
    se: 'Träningskvitton',
    no: 'Treningskvitteringer',
    tr: 'Eğitim makbuzları',
    dk: 'Træningskvitteringer',
  },
  'ZReport.DeliveryReceipts': {
    en: 'Delivery receipts',
    es: 'Tickets de delivery',
    se: 'Leveranskvitton',
    no: 'Utleveringskvitteringer',
    tr: 'Teslimat makbuzları',
    dk: 'Leveringskvitteringer',
  },
  'ZReport.ProvisionalReceipts': {
    en: 'Pre-bill',
    es: 'Pre-tickets impresos',
    se: 'Förnota',
    no: 'Foreløpige kvitteringer',
    tr: 'Ön fatura',
    dk: 'Forudfakturering',
  },
  'ZReport.RefundReceipts': {
    en: 'Refund receipts',
    es: 'Reembolsos impresos',
    se: 'Returkvitton',
    no: 'Returkvitteringer',
    tr: 'Geri ödeme makbuzları',
    dk: 'Refusionskvitteringer',
  },
  'ZReport.TipRefunds': {
    en: 'Tip refunds',
    es: 'Propinas reembolsadas',
    se: 'Dricksreturer',
    no: 'Tips-returer',
    tr: 'Bahşiş iadeleri',
    dk: 'Refusion af tip',
  },
  'ZReport.Statistics': {
    en: 'Statistics',
    es: 'Estadísticas',
    se: 'Statistik',
    no: 'Statistikk',
    tr: 'İstatistik',
    dk: 'Statistik',
  },
  'ZReport.AmountPerTransaction': {
    en: 'Amount per transaction',
    es: 'Cantidad por transacción',
    se: 'Belopp per transaktion',
    no: 'Beløp per transaksjon',
    tr: 'İşlem başına tutar',
    dk: 'Beløb pr. transaktion',
  },
  'ZReport.TipPerTransaction': {
    en: 'Tip per transaction',
    es: 'Propina por transacción',
    se: 'Dricks per transaktion',
    no: 'Tips per transaksjon',
    tr: 'İşlem başına ipucu',
    dk: 'Drikkepenge pr. transaktion',
  },
  'ZReport.PriceLookUps': {
    en: 'Price look-ups',
    es: 'Buscar precio',
    se: 'Prisuppslag',
    no: 'Prisundersøkelser',
    tr: 'Fiyat aramaları',
    dk: 'Prisopslag',
  },
  'ZReport.CashDrawerOpenings': {
    en: 'Cash drawer openings',
    es: 'Aperturas de caja registradora',
    se: 'Kassalåda öppningar',
    no: 'Åpninger av kasseskuff',
    tr: 'Yazar kasa çekmecesi açıklıkları',
    dk: 'Kasseskuffeåbninger',
  },
  'ZReport.VAT': {
    en: 'VAT',
    es: 'IVA',
    se: 'Moms',
    no: 'MVA',
    tr: 'KDV',
    dk: 'moms',
  },
  'ZReport.Manufacturer': {
    en: 'Manufacturer',
    es: 'Fabricante',
    se: 'Tillverkare',
    no: 'Produsent',
    tr: 'Üretici firma',
    dk: 'Fabrikant',
  },
  'ZReport.ControlUnit': {
    en: 'Control unit',
    es: 'Nº de control',
    se: 'Kontrollenhet',
    no: 'Kontrollenhet',
    tr: 'Kontrol ünitesi',
    dk: 'Kontrolenhed',
  },
  'DemoMode.Title': {
    en: 'Welcome to Baemingo!',
    es: 'Bienvenido a Baemingo!',
    se: 'Välkommen till Baemingo!',
    no: 'Velkommen til Baemingo!',
    tr: "Baemingo'ya hoş geldiniz!",
    dk: 'Velkommen til Baemingo!',
  },
  'DemoMode.Text': {
    en:
      'This is a demo mode for you to try out the platform. When you have added your own products you will see your own product library here and be able to take your first payment.',
    es:
      'Este es un modo de demostración para que pruebes la plataforma. Cuando hayas agregado tus propios productos, verás tu propia biblioteca de productos aquí y podrás realizar tu primer pago.',
    se:
      'Detta är ett demo-läge för att du ska kunna prova plattformen. När du har lagt till dina egna produkter kommer du att se ditt eget produktbibliotek här och kunna ta din första betalning.',
    no:
      'Dette er en demoversjon, slik at du kan prøve plattformen. Når du har lagt inn dine egne produkter kommer du til å se ditt eget produktbibliotek her, og ta din første betaling.',
    tr:
      'Bu, platformu denemeniz için bir demo modudur. Kendi ürünlerinizi eklediğinizde burada kendi ürün kütüphanenizi görecek ve ilk ödemenizi alabileceksiniz.',
    dk:
      'Dette er en demotilstand, hvor du kan prøve platformen. Når du har tilføjet dine egne produkter, vil du se dit eget produktbibliotek her og være i stand til at tage din første betaling.',
  },
  'DemoMode.ExitMode': {
    en: 'Exit demo mode',
    es: 'Salir del modo de demo',
    se: 'Avsluta demo-läge',
    no: 'Avslutt demo-modus',
    tr: 'Demo modundan çık',
    dk: 'Afslut demotilstand',
  },
  'DemoMode.ExploreButton': {
    en: 'Start exploring',
    es: 'Comenzar a explorar',
    se: 'Utforska',
    no: 'Utforsk',
    tr: 'Keşfetmeye başlayın',
    dk: 'Begynd at udforske',
  },
  'DemoMode.Name': {
    en: 'Demo mode',
    es: 'Modo de demo',
    se: 'Demo-läge',
    no: 'Demo-modus',
    tr: 'Demo modu',
    dk: 'Demo-tilstand',
  },
  'DemoMode.NoPayments': {
    en:
      'You are in demo mode and can therefor not make any payments. As soon as you have set up your own product library and licenses you are ready to take your first payment',
    es:
      'Estás en modo de demostración y, por lo tanto, no puedes realizar ningún pago. Tan pronto como hayas configurado tu propia biblioteca de productos y licencias, estarás listo para realizar tu primer pago',
    se:
      'Du är i demo-läge och kan därför inte göra några betalningar. Så snart du har konfigurerat ditt eget produktbibliotek och licenser är du redo att ta din första betalning',
    no:
      'Du er i demo-modus og kan derfor ikke gjøre noen betalinger. Så snart du har konfigurert ditt eget produktbibliotek og aktivert lisenser er du kalr for å ta imot din første betaling',
    tr:
      'Demo modundasınız ve bu nedenle herhangi bir ödeme yapamazsınız. Kendi ürün kitaplığınızı ve lisanslarınızı kurduğunuzda ilk ödemenizi almaya hazırsınız',
    dk:
      'Du er i demotilstand og kan derfor ikke foretage nogen betalinger. Så snart du har oprettet dit eget produktbibliotek og licenser, er du klar til at tage din første betaling',
  },
  'DemoMode.NoPayments.Button': {
    en: 'Got it!',
    es: '¡Entendido!',
    se: 'Jag förstår!',
    no: 'Skjønner!',
    tr: 'Anladım!',
    dk: 'Forstår det!',
  },
  'DemoMode.Products.POS.Title': {
    en: 'Point of sale',
    es: 'Punto de venta',
    se: 'Kassa',
    no: 'Direktesalg',
    tr: 'Satış noktası',
    dk: 'Salgssted',
  },
  'DemoMode.Products.POS.Description': {
    en: 'Make orders and payments quickly',
    es: 'Realice pedidos y pagos rápidamente',
    se: 'Gör beställningar och betalningar snabbt',
    no: 'Gjør bestillinger og betalinger raskt',
    tr: 'Siparişleri ve ödemeleri hızlı bir şekilde yapın',
    dk: 'Foretag bestillinger og betalinger hurtigt',
  },
  'DemoMode.Products.TSR.Title': {
    en: 'Table service',
    es: 'Servicio de mesa',
    se: 'Bordservice',
    no: 'Bordservering',
    tr: 'Masa servisi',
    dk: 'Bordservice',
  },
  'DemoMode.Products.TSR.Description': {
    en: 'Order to tables, handle courses and much more',
    es: 'Ordene a las mesas, maneje los cursos y mucho más',
    se: 'Beställ till borden, hantera rätter och mycket mer',
    no: 'Bestill til bordet, håndter kjøkkenbeskjeder og mye mer',
    tr: 'Masalara sipariş verin, korsları yönetin ve çok daha fazlasını yapın',
    dk: 'Bestil til borde, varetage kurser og meget mere',
  },
  'License.Unpaid.Title': {
    en: 'You have unpaid licenses',
    es: 'Tienes licencias no pagadas',
    se: 'Du har obetalda licenser',
    no: 'Du har ubetalte lisenser',
    tr: 'Ödenmemiş lisanslarınız var',
    dk: 'Du har ubetalte licenser',
  },
  'License.Unpaid.Subtitle': {
    en: 'Please contact your sales representative or ekonomi@baemingo.com to resolve this matter.',
    es:
      'Comuníquese con su representante de ventas o ekonomi@baemingo.com para resolver este asunto.',
    se: 'Kontakta din säljrepresentant eller ekonomi@baemingo.com för att lösa detta ärende.',
    no: 'Ta kontakt med din salgsrepresentant eller ekonomi@baemingo.com for å løse denne saken.',
    tr: 'Bu konuyu çözmek için satış temsilcinizle veya ekonomi@baemingo.com ile iletişime geçin.',
    dk: 'Kontakt din salgsrepræsentant eller ekonomi@baemingo.com for at løse denne sag.',
  },
  'License.Unpaid.Confirm': {
    en: 'Understood',
    es: 'Entendido',
    se: 'Jag förstår',
    no: 'Skjønner',
    tr: 'Anladım',
    dk: 'Forstår',
  },
  'AdyenWizard.TopTitle': {
    en: 'Adyen troubleshooting guide',
    es: 'Guía de solución de problemas de Adyen',
    se: 'Adyen felsökningsguide',
    no: 'Adyen feilsøkingsguide',
    tr: 'Adyen sorun giderme kılavuzu',
    dk: 'Adyen fejlfinding guide',
  },
  'AdyenWizard.Next': {
    en: 'Next',
    es: 'Siguiente',
    se: 'Nästa',
    no: 'Neste',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'AdyenWizard.OK': {
    en: 'OK',
    es: 'OK',
    se: 'OK',
    no: 'OK',
    tr: 'TAMAM',
    dk: 'OK',
  },
  'AdyenWizard.PaymentStarted.Question': {
    en: 'Has the payment started on the terminal?',
    es: '¿Se ha iniciado el pago en la terminal?',
    se: 'Har betalningen startats på terminalen?',
    no: 'Har betalingen startet på terminalen?',
    tr: 'Ödeme terminalde başladı mı?',
    dk: 'Er betalingen startet på terminalen?',
  },
  'AdyenWizard.PaymentMade.Question': {
    en: 'Has the customer made the payment?',
    es: '¿El cliente ha realizado el pago?',
    se: 'Har kunden gjort betalningen?',
    no: 'Har kunden fullført betalingen?',
    tr: 'Müşteri ödemeyi yaptı mı?',
    dk: 'Har kunden foretaget betalingen?',
  },
  'AdyenWizard.PaymentEarlier.Question': {
    en: 'Have you made payments earlier today on this terminal?',
    es: '¿Has realizado pagos anteriormente hoy en esta terminal?',
    se: 'Har du gjort betalningar tidigare idag på denna terminal?',
    no: 'Har du mottatt betalinger tidligere i dag på denne terminalen?',
    tr: 'Bu terminalde bugün erkenden ödeme yaptınız mı?',
    dk: 'Har du foretaget betalinger tidligere i dag på denne terminal?',
  },
  'AdyenWizard.NetworkIssues': {
    en:
      'There is no internet connection on this device, check your wifi or mobile data. If a payment has been made do NOT restart the POS',
    es:
      'No hay conexión a internet en este dispositivo, comprueba tu wifi o datos móviles. Si se ha realizado un pago, NO reinicies el POS',
    se:
      'Det finns ingen internetanslutning på denna enhet, kontrollera ditt wifi eller mobildata. Om en betalning har gjorts, starta INTE om kassan',
    no:
      'Det finnes ikke nettverkstilkobling på denne enheten, vennligst kontroller wifi eller mobildata. Dersom betaling er gjennomført, IKKE restart kassen',
    tr:
      "Bu cihazda internet bağlantısı yok, kablosuz bağlantınızı veya mobil verilerinizi kontrol edin. Ödeme yapıldıysa POS'u yeniden başlatmayın",
    dk:
      'Der er ingen internetforbindelse på denne enhed, tjek din wifi eller mobildata. Hvis en betaling er foretaget, skal du IKKE genstarte POS',
  },
  'AdyenWizard.BaemingoIssues': {
    en:
      'There is an issue with the connection to Baemingo, wait a few minutes and try again or contact support',
    es:
      'Hay un problema con la conexión a Baemingo, espere unos minutos y vuelva a intentarlo o contacte con soporte',
    se:
      'Det finns ett problem med anslutningen till Baemingo, vänta några minuter och försök igen eller kontakta support',
    no:
      'Det har oppstått en feil med tilkobling til Baemingo. Vennligst vent et par minutter og prøv igjen, eller kontakt kundeservice',
    tr:
      'Baemingo bağlantısında bir sorun var, birkaç dakika bekleyip tekrar deneyin veya destek ekibiyle iletişime geçin',
    dk:
      'Der er et problem med forbindelsen til Baemingo, vent et par minutter og prøv igen eller kontakt support',
  },
  'AdyenWizard.NetworkIssues.Wait': {
    en:
      'There are currently network issues on the terminal. Please wait up to two minutes while the connection is being restored.',
    es:
      'Actualmente hay problemas de red en el terminal. Por favor, espere hasta dos minutos mientras se restablece la conexión.',
    se:
      'Det verkar vara nätverksproblem på terminalen. Vänta i upp till två minuter medan anslutningen återställs.',
    no:
      'Det er nettverksproblemer med terminalen. Vennligst vent i opp til to minutter, mens tilkoblingen starter opp igjen.',
    tr:
      'Şu anda terminalde ağ sorunları var. Bağlantı yeniden kurulurken lütfen iki dakikaya kadar bekleyin.',
    dk:
      'Der er i øjeblikket netværksproblemer på terminalen. Vent venligst op til to minutter, mens forbindelsen genoprettes.',
  },
  'AdyenWizard.NetworkIssues.Cancel': {
    en:
      'Something has gone wrong. Cancel the purchase on the terminal and then click OK and try again.',
    es:
      'Algo ha salido mal. Cancela la compra en la terminal y luego haz clic en Aceptar e inténtalo de nuevo.',
    se:
      'Något verkar ha gått fel. Avbryt köpet på terminalen och klicka sedan på OK och försök igen.',
    no: 'En feil har oppstått. Avbryt kjøpet på terminalen, klikk deretter OK og prøv igjen.',
    tr:
      "Bir şeyler ters gitti. Terminalde satın alma işlemini iptal edin ve ardından Tamam'a tıklayıp tekrar deneyin.",
    dk: 'Noget er gået galt. Annuller købet på terminalen og klik derefter på OK og prøv igen.',
  },
  'AdyenWizard.LostConnection': {
    en: 'The terminal might have lost connection',
    es: 'La terminal puede haber perdido la conexión',
    se: 'Terminalen kan ha tappat anslutningen',
    no: 'Terminalen har mistet tilkoblingen',
    tr: 'Terminalin bağlantısı kesilmiş olabilir',
    dk: 'Terminalen kan have mistet forbindelsen',
  },
  'AdyenWizard.LostConnection.Text': {
    en:
      'Try reconnecting the terminal, re-scanning, or adding it manually before attempting payment again.',
    es:
      'Intente volver a conectar la terminal, volver a escanear o agregarla manualmente antes de intentar el pago nuevamente.',
    se:
      'Försök att återansluta terminalen, skanna om eller lägg till den manuellt innan du försöker betala igen.',
    no:
      'Forsøk å koble til terminalen på nytt via scanning, eller legg den til manuelt før du forsøker en ny betaling.',
    tr:
      'Tekrar ödeme yapmayı denemeden önce terminali yeniden bağlamayı, yeniden taramayı veya manuel olarak eklemeyi deneyin.',
    dk:
      'Prøv at tilslutte terminalen igen, genscanne eller tilføje den manuelt, før du forsøger at betale igen.',
  },
  'AdyenWizard.NoTerminal': {
    en: 'No terminal has been added',
    es: 'No se ha agregado ninguna terminal',
    se: 'Ingen terminal har lagts till',
    no: 'Ingen terminal lagt til',
    tr: 'Hiçbir terminal eklenmedi',
    dk: 'Der er ikke tilføjet nogen terminal',
  },
  'AdyenWizard.NoTerminal.Text': {
    en: 'Try scanning or manually adding the terminal and then trying the payment again',
    es: 'Intente escanear o agregar manualmente la terminal y luego intente el pago nuevamente',
    se: 'Försök skanna eller lägg till terminalen manuellt och försök sedan betalningen igen',
    no: 'Forsøk å scanne eller manuelt legge til terminalen, og forsøk deretter betaling på nytt',
    tr:
      'Terminali taramayı veya manuel olarak eklemeyi ve ardından ödemeyi tekrar denemeyi deneyin',
    dk: 'Prøv at scanne eller manuelt tilføje terminalen, og prøv derefter at betale igen',
  },
  'ServiceCharge.Title': {
    en: 'Service charge',
    es: 'Cargo por servicio',
    se: 'Serviceavgift',
    no: 'Serviceavgift',
    tr: 'Servis bedeli',
    dk: 'Servicegebyr',
  },
  'Disable.Cash': {
    en: 'Disable cash',
    es: 'Deshabilitar efectivo',
    se: 'Inaktivera kontanter',
    no: 'Deaktiver kontanter',
    tr: 'Nakit parayı devre dışı bırak',
    dk: 'Deaktiver kontanter',
  },
  'Handy.DirectPayment': {
    en: 'Direct payment',
    es: 'Pago directo',
    se: 'Direktbetalning',
    no: 'Direktebetaling',
    tr: 'Doğrudan ödeme',
    dk: 'Direkte betaling',
  },
  'Handy.DirectPayment.Text': {
    en:
      'Replaces "Continue" with "Pay" in the cart to go straight to payment. Discounts, split payments and alternative payment methods are disabled.',
    es:
      'Reemplaza "Continuar" con "Pagar" en el carrito para ir directamente al pago. Los descuentos, pagos parciales y métodos de pago alternativos se desactivan.',
    se:
      'Ersätter "Fortsätt" med "Betala" i varukorgen för att gå direkt till betalning. Rabatter, delbetalningar och alternativa betalmetoder inaktiveras.',
    no:
      'Erstatter "Fortsett" med "Betal" i handlekurven for å gå direkte til betaling. Rabatter, delbetaling og alternative betalingsmetoder deaktiveres.',
    tr:
      'Sepette "Devam et" yerine "Öde" koyarak doğrudan ödemeye geçer. İndirimler, bölünmüş ödemeler ve alternatif ödeme yöntemleri devre dışı bırakılır.',
    dk:
      'Erstatter "Fortsæt" med "Betal" i kurven for at gå direkte til betaling. Rabatter, delbetalinger og alternative betalingsmetoder deaktiveres.',
  },
  'Settings.EnableInvoiceCustomerCreation': {
    en: 'Create invoice customers',
    es: 'Crear clientes de factura',
    se: 'Skapa fakturakunder',
    no: 'Opprett fakturakunder',
    tr: 'Fatura müşterisi oluştur',
    dk: 'Opret fakturakunder',
  },
  'Settings.EnableInvoiceCustomerCreation.Text': {
    en: 'Allow creating new invoice customers directly from the invoice payment flow.',
    es:
      'Permitir crear nuevos clientes de factura directamente desde el flujo de pago por factura.',
    se: 'Tillåt att skapa nya fakturakunder direkt från fakturabetalningsflödet.',
    no: 'Tillat å opprette nye fakturakunder direkte fra faktureringsbetalingsflyten.',
    tr: 'Fatura ödeme akışından doğrudan yeni fatura müşterileri oluşturmaya izin ver.',
    dk: 'Tillad oprettelse af nye fakturakunder direkte fra fakturabetalingsflowet.',
  },
  'Disable.Cash.Text': {
    en: 'Disable cash payments on this device',
    es: 'Deshabilitar pagos en efectivo en este dispositivo',
    se: 'Inaktivera kontantbetalningar på denna enhet',
    no: 'Deaktiver kontantbetalinger på denne enheten',
    tr: 'Bu cihazda nakit ödemeleri devre dışı bırak',
    dk: 'Deaktiver kontantbetalinger på denne enhed',
  },
  'History.SendOrderCopy.SelectTable': {
    en: 'Select table',
    es: 'Seleccionar mesa',
    se: 'Välj bord',
    no: 'Velg bord',
    tr: 'Masa seç',
    dk: 'Vælg bord',
  },
  'History.SendOrderCopy.Floorplan': {
    en: 'Floorplan',
    es: 'Plano',
    se: 'Planlösning',
    no: 'Bordkart',
    tr: 'Kat planı',
    dk: 'Plantegning',
  },
  'History.SendOrderCopy.Create': {
    en: 'Create cheque and go to table',
    es: 'Crear comanda e ir a la mesa',
    no: 'Opprett kvittering og gå til bord',
    se: 'Skapa nota och gå till bordet',
    tr: 'Çek oluştur ve masaya git',
    dk: 'Opret check og gå til bord',
  },
  'History.SendOrderCopy.Button': {
    en: 'Copy to table',
    es: 'Copiar a la mesa',
    no: 'Kopier til bord',
    se: 'Kopiera till bord',
    tr: 'Masaya kopyala',
    dk: 'Kopiér til bord',
  },
  'History.SendOrderCopy.Description': {
    en: 'Sends a copy of this order to a table',
    es: 'Envía una copia de este pedido a una mesa',
    no: 'Sender en kopi av denne bestillingen til et bord',
    se: 'Skickar en kopia av denna beställning till ett bord',
    tr: 'Bu siparişin bir kopyasını masaya gönderir',
    dk: 'Sender en kopi af denne ordre til et bord',
  },
  'History.SendOrderCopy.NoTable.Toast': {
    en: 'Please select a table',
    es: 'Por favor, seleccione una mesa',
    no: 'Vennligst velg et bord',
    se: 'Vänligen välj ett bord',
    tr: 'Lütfen bir masa seçin',
    dk: 'Vælg venligst et bord',
  },
  'History.SendOrderCopy.NoCheque.Toast': {
    en: 'The cheque could not be created, try again.',
    es: 'La comanda no se pudo crear, inténtelo de nuevo.',
    no: 'Kvitteringen kunne ikke opprettes, prøv igjen.',
    se: 'Notan kunde inte skapas, försök igen.',
    tr: 'Çek oluşturulamadı, tekrar deneyin.',
    dk: 'Checken kunne ikke oprettes. Prøv igen.',
  },
  'History.Legacy.Info': {
    en: 'This page have been replaced with a new history view. This page will soon be removed.',
    es:
      'Esta página ha sido reemplazada por una nueva vista de historial. Esta página pronto será eliminada.',
    no:
      'Denne siden har blitt erstattet med en ny historikkvisning. Denne siden vil snart bli fjernet.',
    se: 'Denna sida har ersatts med en ny historikvy. Denna sida kommer snart att tas bort.',
    tr: 'Bu sayfa yeni bir geçmiş görünümü ile değiştirildi. Bu sayfa yakında kaldırılacak.',
    dk:
      'Denne side er blevet erstattet med en ny historikvisning. Denne side vil snart blive fjernet.',
  },
  'History.Legacy.Info.Button': {
    en: 'Go to the new page',
    se: 'Gå till den nya sidan',
    es: 'Ir a la nueva página',
    no: 'Gå til den nye siden',
    tr: 'Yeni sayfaya git',
    dk: 'Gå til den nye side',
  },
  'Competitions.Loading': {
    en: 'Loading competitions',
    es: 'Cargando competiciones',
    se: 'Laddar tävlingar',
    no: 'Laster konkurranser',
    tr: 'Yarışmalar yükleniyor',
    dk: 'Indlæser konkurrencer',
  },
  'Competitions.Title': {
    en: 'Competitions',
    es: 'Competiciones internas',
    se: 'Tävlingar',
    no: 'Konkurranser',
    tr: 'Yarışmalar',
    dk: 'Konkurrencer',
  },
  'Competitions.Score': {
    en: 'Score',
    es: 'Puntuación',
    se: 'Poäng',
    no: 'Poeng',
    tr: 'Nokta',
    dk: 'Score',
  },
  'Competitions.Intro.Heading': {
    en: 'Get Started with Staff Competitions!',
    es: 'Comienza con las competiciones del personal!',
    se: 'Kom igång med personaltävlingar!',
    no: 'Kom i gang med ansattkonkurranser!',
    tr: 'Personel yarışmalarına başlayın!',
    dk: 'Kom godt i gang med personalekonkurrencer!',
  },
  'Competitions.Intro.Desc': {
    en: 'To get started you need to create a competition in the back office.',
    es: 'Para comenzar, debes crear una competencia en la oficina central.',
    se: 'För att komma igång måste du skapa en tävling i back office.',
    no: 'For å komme i gang må du opprette en konkurranse i back office.',
    tr: 'Başlamak için arka ofiste bir yarışma oluşturmanız gerekiyor.',
    dk: 'For at komme i gang skal du oprette en konkurrence i backoffice.',
  },
  'Competitions.Intro.Benefit.Leaderboard': {
    en: 'Track the leaderboard in real-time directly from your POS.',
    es: 'Siga la clasificación en tiempo real directamente desde su POS.',
    se: 'Följ resultatet i realtid direkt från din kassa.',
    no: 'Følg resultatlisten i sanntid direkte fra kassen din.',
    tr: 'Liderlik tablosunu POS unuzdan doğrudan gerçek zamanlı takip edin.',
    dk: 'Spor ranglisten i realtid direkte fra din POS.',
  },
  'Competitions.Intro.Benefit.Types': {
    en: 'Choose between six different competition types.',
    es: 'Elige entre seis tipos de competiciones diferentes.',
    se: 'Välj mellan sex olika tävlingstyper.',
    no: 'Velg mellom seks forskjellige konkurranseformer.',
    tr: 'Altı farklı yarışma türü arasından seçim yapın.',
    dk: 'Vælg mellem seks forskellige konkurrencetyper.',
  },
  'Competitions.Intro.Benefit.Fun': {
    en: 'A fun and engaging experience.',
    es: 'Una experiencia divertida y atractiva.',
    se: 'En rolig och engagerande upplevelse.',
    no: 'En morsom og engasjerende opplevelse.',
    tr: 'Eğlenceli ve ilgi çekici bir deneyim.',
    dk: 'En sjov og engagerende oplevelse.',
  },
  'Competitions.ScoreInfo': {
    en: 'How is the score calculated?',
    es: '¿Cómo se calcula la puntuación?',
    se: 'Hur beräknas poängen?',
    no: 'Hvordan beregnes poengsummen?',
    tr: 'Puan nasıl hesaplanır?',
    dk: 'Hvordan udregnes scoren?',
  },
  'Competitions.ScoreInfo.Desc': {
    en: 'Here is an overview of what activities add to the score and what subtract from it:',
    es:
      'Aquí tienes una descripción general de qué actividades suman a la puntuación y cuáles la restan:',
    se: 'Här är en översikt över vilka aktiviteter som lägger till poäng och vilka som drar av:',
    no:
      'Her er en oversikt over hvilke aktiviteter som legger til poeng og hvilke som trekker fra:',
    tr: 'İşte puanı artıran ve eksilten aktiviteler hakkında genel bir bakış:',
    dk:
      'Her er en oversigt over, hvilke aktiviteter der tilføjer scoren, og hvad der trækker fra den:',
  },
  'Competitions.ScoreInfo.Add.SaleInPos': {
    en: 'Sale in POS',
    es: 'Venta en POS',
    se: 'Försäljning i POS',
    no: 'Salg i POS',
    tr: 'POSta satış',
    dk: 'Salg i POS',
  },
  'Competitions.ScoreInfo.Add.ProductsToTable': {
    en: 'Adding products to a table (only the staff who opened the table gets the points)',
    es: 'Agregar productos a una mesa (solo el personal que abrió la mesa obtiene los puntos)',
    se: 'Lägga till produkter på ett bord (endast personalen som öppnade bordet får poängen)',
    no: 'Legge til produkter på et bord (bare ansatte som åpnet bordet får poengene)',
    tr: 'Tabloya ürün ekleme (Sadece tabloyu açan personel puan alır)',
    dk:
      'Tilføjelse af produkter til en tabel (kun det personale, der åbnede bordet, får pointene)',
  },
  'Competitions.ScoreInfo.Add.Tip': {
    en: 'In tip competitions, the staff who opened the table gets the points',
    es: 'En competición de propinas, el personal que abrió la mesa obtiene los puntos',
    se: 'I drickstävlingar får personalen som öppnade bordet poängen',
    no: 'I tipskonkurranser får personalet som åpnet bordet poengene',
    tr: 'İçki yarışmalarında masayı açan personel puanı alır',
    dk: 'I tipkonkurrencer får de ansatte, der åbnede bordet, pointene',
  },
  'Competitions.ScoreInfo.Remove.Refunds': {
    en: 'Refunds',
    es: 'Reembolsos',
    se: 'Återbetalningar',
    no: 'Refusjoner',
    tr: 'Geri ödemeler',
    dk: 'Tilbagebetalinger',
  },
  'Competitions.ScoreInfo.Remove.RemovedProductsTable': {
    en: 'Removing products from a table (only the staff who opened the table is affected)',
    es: 'Eliminar productos de una mesa (solo el personal que abrió la mesa se ve afectado)',
    se: 'Ta bort produkter från ett bord (endast personalen som öppnade bordet påverkas)',
    no: 'Fjerne produkter fra et bord (bare ansatte som åpnet bordet blir påvirket)',
    tr: 'Ürünleri masadan kaldırın (yalnızca masayı açan personel etkilenir)',
    dk: 'Fjernelse af produkter fra et bord (kun det personale, der åbnede bordet, er berørt)',
  },
  'Competitions.NoSales': {
    en: "The top three will be displayed here once the competition's first sale has been made.",
    es:
      'Los tres primeros se mostrarán aquí una vez que se haya realizado la primera venta de la competencia.',
    se: 'De tre bästa kommer att visas här när tävlingens första försäljning har gjorts.',
    no: 'De tre beste vil vises her når konkurransens første salg er gjort.',
    tr: 'Yarışmanın ilk satışı yapıldıktan sonra ilk üç burada sergilenecek.',
    dk: 'De tre bedste vil blive vist her, når konkurrencens første salg er gennemført.',
  },
  'Competitions.NoSales.Leaderboard': {
    en: "The leaderboard will be displayed here once the competition's first sale has been made.",
    es:
      'La clasificación se mostrará aquí una vez que se haya realizado la primera venta de la competencia.',
    se: 'Resultatet kommer att visas här när tävlingens första försäljning har gjorts.',
    no: 'Resultatlisten vil vises her når konkurransens første salg er gjort.',
    tr: 'Yarışmanın ilk satışı yapıldıktan sonra sonuç burada gösterilecektir.',
    dk: 'Leaderboardet vil blive vist her, når konkurrencens første salg er gennemført.',
  },
  'Competitions.Status.Live': {
    en: 'Live',
    es: 'En vivo',
    se: 'Live',
    no: 'Live',
    tr: 'Canlı',
    dk: 'Levende',
  },
  'Competitions.Status.NotStarted': {
    en: 'Starting in',
    es: 'Comenzando en',
    se: 'Startar om',
    no: 'Starter om',
    tr: 'Yeniden başlatılıyor',
    dk: 'Starter i',
  },
  'Competitions.Status.NoScoreYet': {
    en:
      "Your placement will be shown here once you've made a sale that counts towards a competition",
    es:
      'Tu posición se mostrará aquí una vez que hayas realizado una venta que cuente para una competición',
    se: 'Din placering kommer att visas här när du gjort en försäljning som räknas mot en tävling',
    no: 'Din plassering vil vises her når du har gjort et salg som teller i en konkurranse',
    tr: 'Bir yarışmaya dahil olan bir satış yaptığınızda sıralamanız burada gösterilecektir.',
    dk:
      'Din placering vil blive vist her, når du har foretaget et salg, der tæller med i en konkurrence',
  },
  'Competitions.Status.IsAboveYou': {
    en: 'is ahead of you with a total of',
    es: 'está por delante de ti con un total de',
    se: 'är före dig med en total på',
    no: 'er foran deg med en total på',
    tr: 'toplamda sizden önde',
    dk: 'er foran dig med i alt',
  },
  'Competitions.Status.CurrentPlacements': {
    en: 'Current placements',
    es: 'Posiciones actuales',
    se: 'Nuvarande placeringar',
    no: 'Nåværende plasseringer',
    tr: 'Mevcut yerleşimler',
    dk: 'Aktuelle placeringer',
  },
  'Competitions.Status.ViewAll': {
    en: 'View all competitions',
    es: 'Ver todas las competenciones',
    se: 'Se alla tävlingar',
    no: 'Se alle konkurranser',
    tr: 'Tüm yarışmaları gör',
    dk: 'Se alle konkurrencer',
  },
  'Competitions.Status.You': {
    en: 'You',
    es: 'Tú',
    se: 'Du',
    no: 'Du',
    tr: 'Sen',
    dk: 'Du',
  },
  'Competitions.SpecificSales.All': {
    en: 'All products included',
    es: 'Todos los productos incluidos',
    se: 'Alla produkter inkluderade',
    no: 'Alle produkter inkludert',
    tr: 'Tüm ürünler dahil',
    dk: 'Alle produkter inkluderet',
  },
  'Competitions.SpecificSales.Limited': {
    en: 'This competition is limited to:',
    es: 'Esta competencia está limitada a:',
    se: 'Denna tävling är begränsad till:',
    no: 'Denne konkurransen er begrenset til:',
    tr: 'Bu yarışma şunlarla sınırlıdır:',
    dk: 'Denne konkurrence er begrænset til:',
  },
  'Competitions.SpecificSales.Limited.Short': {
    en: 'Limited to',
    es: 'Limitado a',
    se: 'Gäller endast',
    no: 'Begrenset til',
    tr: 'Şunlarla sınırlıdır:',
    dk: 'Begrænset til',
  },
  'Competitions.SpecificSales.Product': {
    en: 'Product',
    es: 'Producto',
    se: 'Produkt',
    no: 'Produkt',
    tr: 'Ürün',
    dk: 'Produkt',
  },
  'Competitions.SpecificSales.Products': {
    en: 'Products',
    es: 'Productos',
    se: 'Produkter',
    no: 'Produkter',
    tr: 'Ürünler',
    dk: 'Produkter',
  },
  'Competitions.SpecificSales.LimitedTo': {
    en: 'Limited to',
    es: 'Limitado a',
    se: 'Gäller endast',
    no: 'Begrenset til',
    tr: 'Şunlarla sınırlıdır:',
    dk: 'Begrænset til',
  },
  'Competitions.SpecificSales.Category': {
    en: 'Category',
    es: 'Categoría',
    se: 'Kategori',
    no: 'Kategori',
    tr: 'Kategori',
    dk: 'Kategori',
  },
  'Competitions.SpecificSales.Categories': {
    en: 'Categories',
    es: 'Categorías',
    se: 'Kategorier',
    no: 'Kategorier',
    tr: 'Kategoriler',
    dk: 'Kategorier',
  },
  'Competitions.SpecificSales.Others': {
    en: 'others',
    es: 'otros',
    se: 'andra',
    no: 'andre',
    tr: 'diğerleri',
    dk: 'andre',
  },
  'Competitions.ViewLeaderboard': {
    en: 'View leaderboard',
    es: 'Ver clasificación',
    se: 'Se resultat',
    no: 'Se resultater',
    tr: 'Liderlik tablosunu gör',
    dk: 'Se leaderboard',
  },
  'Competitions.ViewInfo': {
    en: 'View competition information',
    es: 'Ver información de la competición',
    se: 'Visa tävlingsinformation',
    no: 'Vis konkurranseinformasjon',
    tr: 'Yarışma bilgilerini gör',
    dk: 'Se konkurrenceinformation',
  },
  'Competitions.Leaderboard': {
    en: 'Leaderboard',
    es: 'Clasificación',
    se: 'Resultat',
    no: 'Resultater',
    tr: 'Liderlik tablosu',
    dk: 'Leaderboard',
  },
  'Competitions.Type.SalesAmount': {
    en: 'Highest total sales',
    es: 'Monto de ventas más alto',
    se: 'Högsta totala försäljningen',
    no: 'Høyeste totale salg',
    tr: 'En yüksek toplam satış',
    dk: 'Højeste samlede salg',
  },
  'Competitions.Type.SalesCount': {
    en: 'Most sales',
    es: 'Más ventas',
    se: 'Flest försäljningar',
    no: 'Flest salg',
    tr: 'En çok satış',
    dk: 'Mest salg',
  },
  'Competitions.Type.SalesAverage': {
    en: 'Highest average sale',
    es: 'Venta promedio más alta',
    se: 'Högsta genomsnittliga försäljningen',
    no: 'Høyeste gjennomsnittlige salg',
    tr: 'En yüksek ortalama satışlar',
    dk: 'Højeste gennemsnitlige salg',
  },
  'Competitions.Type.TipsAmount': {
    en: 'Highest total tips',
    es: 'Propinas totales más altas',
    se: 'Högst total dricks',
    no: 'Høyeste totale tips',
    tr: 'Maksimum toplam bahşiş',
    dk: 'Højeste samlede tips',
  },
  'Competitions.Type.TipsCount': {
    en: 'Most tips',
    es: 'Más propinas',
    se: 'Flest dricks',
    no: 'Flest tips',
    tr: 'En çok bahşiş',
    dk: 'De fleste tips',
  },
  'Competitions.Type.TipsAverage': {
    en: 'Highest average tip',
    es: 'Propina promedio más alta',
    se: 'Högsta genomsnittliga dricks',
    no: 'Høyeste gjennomsnittlige tips',
    tr: 'En yüksek ortalama bahşiş',
    dk: 'Højeste gennemsnitlige tip',
  },
  'Competitions.Tabs.Active': {
    en: 'Active',
    es: 'Activo',
    se: 'Aktiva',
    no: 'Aktive',
    tr: 'Aktif',
    dk: 'Aktiv',
  },
  'Competitions.Tabs.Past': {
    en: 'Past',
    es: 'Pasado',
    se: 'Avslutade',
    no: 'Fullførte',
    tr: 'Geçmiş',
    dk: 'Forbi',
  },
  'Competitions.Tabs.Past.OlderThanOneMonth': {
    en: 'Looking for a competition older than one month?',
    es: '¿Buscas una competencia de más de un mes?',
    se: 'Letar du efter en tävling som är äldre än en månad?',
    no: 'Ser du etter en konkurranse som er eldre enn en måned?',
    tr: 'Bir aydan eski bir yarışma mı arıyorsunuz?',
    dk: 'Leder du efter en konkurrence ældre end en måned?',
  },
  'Competitions.Tabs.Past.OlderThanOneMonth.Desc': {
    en:
      "Here you'll only see competitions that has ended within the past month. For older competitions, please check the backoffice.",
    es:
      'Aquí solo verás competiciones que hayan finalizado en el último mes. Para competiciones más antiguas, consulta la oficina central.',
    se:
      'Här ser du bara tävlingar som har avslutats under den senaste månaden. För äldre tävlingar, kolla i backoffice.',
    no:
      'Her vil du bare se konkurranser som har endt i løpet av den siste måneden. For eldre konkurranser, sjekk backoffice.',
    tr:
      'Burada sadece son bir ay içinde biten yarışmaları göreceksiniz. Daha eski yarışmalar için lütfen arka ofise bakın.',
    dk:
      'Her vil du kun se konkurrencer, der er afsluttet inden for den seneste måned. For ældre konkurrencer, tjek venligst backoffice.',
  },
  'Competitions.Countdown.Days': {
    en: (days: number) => (days === 1 ? 'day' : 'days'),
    es: (days: number) => (days === 1 ? 'día' : 'días'),
    se: (days: number) => (days === 1 ? 'dag' : 'dagar'),
    no: (days: number) => (days === 1 ? 'dag' : 'dager'),
    tr: (days: number) => (days === 1 ? 'gün' : 'günler'),
    dk: (days: number) => (days === 1 ? 'dag' : 'dage'),
  },
  'Competitions.Countdown.DaysAgo': {
    en: (days: number) => (days === 1 ? 'day ago' : 'days ago'),
    es: (days: number) => (days === 1 ? 'día atrás' : 'días atrás'),
    se: (days: number) => (days === 1 ? 'dag sedan' : 'dagar sedan'),
    no: (days: number) => (days === 1 ? 'dag siden' : 'dager siden'),
    tr: (days: number) => (days === 1 ? 'gün önce' : 'günler önce'),
    dk: (days: number) => (days === 1 ? 'dag siden' : 'dage siden'),
  },
  'Competitions.Countdown.Ago': {
    en: 'ago',
    es: 'atrás',
    se: 'sedan',
    no: 'siden',
    tr: 'önce',
    dk: 'siden',
  },
  'Competitions.Countdown.JustNow': {
    en: 'Just now',
    es: 'Justo ahora',
    se: 'Just precis',
    no: 'Nettopp',
    tr: 'Şimdi',
    dk: 'siden',
  },
  'Competitions.Countdown.Hours': {
    en: 'hours',
    es: 'horas',
    se: 'timmar',
    no: 'timer',
    tr: 'saat',
    dk: 'timer',
  },
  'Competitions.Countdown.Minutes': {
    en: 'minutes',
    es: 'minutos',
    se: 'minuter',
    no: 'minutter',
    tr: 'dakika',
    dk: 'minutter',
  },
  'Competitions.Countdown.Seconds': {
    en: 'seconds',
    es: 'segundos',
    se: 'sekunder',
    no: 'sekunder',
    tr: 'saniye',
    dk: 'sekunder',
  },
  'Competitions.Countdown.And': {
    en: 'and',
    es: 'y',
    se: 'och',
    no: 'og',
    tr: 've',
    dk: 'og',
  },
  'Competitions.Countdown.Left': {
    en: 'left',
    es: 'restantes',
    se: 'kvar',
    no: 'igjen',
    tr: 'kaldı',
    dk: 'venstre',
  },
  'Competitions.Countdown.With': {
    en: 'with',
    es: 'con',
    se: 'med',
    no: 'med',
    tr: 'ile',
    dk: 'med',
  },
  'Competitions.Countdown.HasEnded': {
    en: 'Ended',
    es: 'Finalizó hace',
    se: 'Avslutades för',
    no: 'Endte for',
    tr: 'Bitti',
    dk: 'Afsluttet',
  },
  'Competitions.Countdown.StartDate': {
    en: 'Start date',
    es: 'Fecha de inicio',
    se: 'Startdatum',
    no: 'Startdato',
    tr: 'Başlangıç ​​tarihi',
    dk: 'Startdato',
  },
  'Competitions.Countdown.EndDate': {
    en: 'End date',
    es: 'Fecha de finalización',
    se: 'Slutdatum',
    no: 'Sluttdato',
    tr: 'Bitiş tarihi',
    dk: 'Slutdato',
  },
  'Competitions.Countdown.At': {
    en: 'at',
    es: 'a',
    se: 'kl',
    no: 'kl',
    tr: 'saat',
    dk: 'på',
  },
  'Competitions.NoCompetitions.Ongoing': {
    en: 'No ongoing competitions',
    es: 'No hay competiciones en curso',
    se: 'Inga pågående tävlingar',
    no: 'Ingen pågående konkurranser',
    tr: 'Devam eden yarışma yok',
    dk: 'Ingen løbende konkurrencer',
  },
  'Competitions.NoCompetitions.Ongoing.Desc': {
    en: 'As soon as a competition starts, they will be listed here',
    es: 'Tan pronto como comience una competencia, se listarán aquí',
    se: 'Så fort en tävling startar kommer de att listas här',
    no: 'Så snart en konkurranse starter, vil de bli listet her',
    tr: 'Bir yarışma başladığında burada listelenecek',
    dk: 'Så snart en konkurrence starter, vil de blive listet her',
  },
  'Competitions.NoCompetitions.Past': {
    en: 'No past competitions',
    es: 'No hay competiciones pasadas',
    se: 'Inga tidigare tävlingar',
    no: 'Ingen tidligere konkurranser',
    tr: 'Geçmiş yarışma yok',
    dk: 'Ingen tidligere konkurrencer',
  },
  'Competitions.NoCompetitions.Past.Desc': {
    en: 'As soon as a competition ends, they will be listed here',
    es: 'Tan pronto como una competencia termine, se listarán aquí',
    se: 'Så fort en tävling avslutas kommer de att listas här',
    no: 'Så snart en konkurranse avsluttes, vil de bli listet her',
    tr: 'Bir yarışma bittiğinde burada listelenecek',
    dk: 'Så snart en konkurrence slutter, vil de blive listet her',
  },
  'Competitions.1st': {
    en: '1st',
    es: '1ro',
    se: '1:a',
    no: '1.',
    tr: '1.',
    dk: '1.',
  },
  'Competitions.2nd': {
    en: '2nd',
    es: '2do',
    se: '2:a',
    no: '2.',
    tr: '2.',
    dk: '2.',
  },
  'Competitions.3rd': {
    en: '3rd',
    es: '3ro',
    se: '3:e',
    no: '3.',
    tr: '3.',
    dk: '3.',
  },
  'Competitions.th': {
    en: 'th',
    es: 'to',
    se: ':e',
    no: '.',
    tr: '.',
    dk: '.',
  },
  'Competitions.Place': {
    en: 'place',
    es: 'lugar',
    se: 'plats',
    no: 'plass',
    tr: 'yer',
    dk: 'placere',
  },
  'Competitions.EndDate': {
    en: 'Competition end date',
    es: 'Fin de la competencia',
    se: 'Tävlingens slutdatum',
    no: 'Konkurransens sluttdato',
    tr: 'Yarışma bitiş tarihi',
    dk: 'Konkurrencens slutdato',
  },
  'Competitions.Unknown': {
    en: 'Unknown',
    es: 'Desconocido',
    se: 'Okänd',
    no: 'Ukjent',
    tr: 'Bilinmiyor',
    dk: 'Ukendt',
  },
  'Competitions.products.count': {
    en: 'products',
    es: 'productos',
    se: 'st',
    no: 'stykker',
    tr: 'parça',
    dk: 'produkter',
  },
  'Competitions.sales.count': {
    en: 'sales',
    es: 'ventas',
    se: 'st',
    no: 'stykker',
    tr: 'parça',
    dk: 'salg',
  },
  'Competitions.tips.count': {
    en: 'tips',
    es: 'propinas',
    se: 'st',
    no: 'stykker',
    tr: 'parça',
    dk: 'tips',
  },
  'Competitions.Print.Title': {
    en: 'Print scores',
    es: 'Imprimir puntajes',
    se: 'Skriv ut resultat',
    no: 'Skriv ut resultater',
    tr: 'Sonuçları yazdır',
    dk: 'Udskriv partiturer',
  },
  'Competitions.PrintAll': {
    en: 'Print all participants',
    es: 'Imprimir todos los participantes',
    se: 'Skriv ut alla deltagare',
    no: 'Skriv ut alle deltakere',
    tr: 'Tüm katılımcıları yazdır',
    dk: 'Print alle deltagere',
  },
  'Competitions.PrintSpecific.Text': {
    en: 'Press a button below to print the score for a specific staff',
    es: 'Presione un botón a continuación para imprimir el puntaje de un empleado específico',
    se: 'Tryck på en knapp nedan för att skriva ut resultatet för en specifik deltagare',
    no: 'Trykk på en knapp under for å skrive ut resultatet for en spesifikk ansatt',
    tr: 'Belirli bir katılımcının sonucunu yazdırmak için aşağıdaki düğmeye basın',
    dk: 'Tryk på en knap nedenfor for at udskrive partituret for en bestemt medarbejder',
  },
  'Competitions.PrintSummary': {
    en: 'Print summary',
    es: 'Imprimir resumen',
    se: 'Skriv ut sammanfattning',
    no: 'Skriv ut oppsummering',
    tr: 'Özeti yazdır',
    dk: 'Udskriv oversigt',
  },
  'Competitions.Print.Button': {
    en: 'Print',
    es: 'Imprimir',
    se: 'Skriv ut',
    no: 'Skriv ut',
    tr: 'Yazdır',
    dk: 'Trykke',
  },
  'Competitions.NoPrinter': {
    en: 'No primary printer found',
    es: 'No se encontró impresora principal',
    se: 'Ingen primär skrivare hittades',
    no: 'Ingen primær skriver funnet',
    tr: 'Birincil yazıcı bulunamadı',
    dk: 'Ingen primær printer fundet',
  },
  'Competitions.FirstPlace.CompName': {
    en: (name: string) => `You just took first place in ${name}, keep it up!`,
    es: (name: string) => `¡Acabas de obtener el primer lugar en ${name}, sigue así!`,
    se: (name: string) => `Du tog precis förstaplatsen i ${name}, bra jobbat!`,
    no: (name: string) => `Du tok akkurat førsteplassen i ${name}, fortsett slik!`,
    tr: (name: string) => `Az önce birinci oldun ${name}, aferin!`,
    dk: (name: string) => `Du har lige fået førstepladsen i ${name}, fortsæt!`,
  },
  'Competitions.FirstPlace': {
    en: 'You just took first place, keep it up!',
    es: '¡Acabas de obtener el primer lugar, sigue así!',
    se: 'Du tog precis förstaplatsen, bra jobbat!',
    no: 'Du tok akkurat førsteplassen, fortsett slik!',
    tr: 'Az önce birinci oldunuz, aferin!',
    dk: 'Du har lige fået førstepladsen, fortsæt!',
  },
  'Competitions.Overtook': {
    en: (staff: string) => `You just overtook ${staff}`,
    es: (staff: string) => `Acabas de adelantar a ${staff}`,
    se: (staff: string) => `Du gick precis om ${staff}`,
    no: (staff: string) => `Du gikk nettopp forbi ${staff}`,
    tr: (staff: string) => `Az önce geçtin ${staff}`,
    dk: (staff: string) => `Du har lige overhalet ${staff}`,
  },
  'Competitions.Overtook.In': {
    en: (name: string) => ` in ${name}.`,
    es: (name: string) => ` en ${name}.`,
    se: (name: string) => ` i ${name}.`,
    no: (name: string) => ` i ${name}.`,
    tr: (name: string) => ` içinde ${name}.`,
    dk: (name: string) => ` i ${name}.`,
  },
  'DesiredTime.SetTime': {
    en: 'Set time',
    es: 'Hora',
    se: 'Välj tid',
    no: 'Velg tid',
    tr: 'Saat',
    dk: 'Vælg tid',
  },
  'DesiredTime.Title': {
    en: 'Pick-up time',
    es: 'Hora de recogida',
    se: 'Upphämtningstid',
    no: 'Hentetid',
    tr: 'Alma zamanı',
    dk: 'Afhentningstid',
  },
  'DesiredTime.Title.Choose': {
    en: 'Choose pick-up time',
    es: 'Elige hora de recogida',
    se: 'Välj upphämtningstid',
    no: 'Velg hentetid',
    tr: 'Alma zamanını seç',
    dk: 'Vælg afhentningstid',
  },
  'DesiredTime.Time': {
    en: 'Time',
    es: 'Hora',
    se: 'Tid',
    no: 'Tid',
    tr: 'Saat',
    dk: 'Tid',
  },
  'Date.PickADate': {
    en: 'Pick a date and time',
    se: 'Välj datum och tid',
    es: 'Elige una fecha y hora',
    no: 'Velg dato og tid',
    tr: 'Bir tarih ve saat seçin',
    dk: 'Vælg en dato og tid',
  },
  'Date.PickADate.OK': {
    en: 'Ok',
    se: 'Ok',
    es: 'Ok',
    no: 'Ok',
    tr: 'Tamam',
    dk: 'Okay',
  },
  'Date.Mon': {
    en: 'Mon',
    se: 'Mån',
    es: 'Lun',
    no: 'Man',
    tr: 'Pazartesi',
    dk: 'man',
  },
  'Date.Tue': {
    en: 'Tue',
    se: 'Tis',
    es: 'Mar',
    no: 'Tir',
    tr: 'Salı',
    dk: 'tir',
  },
  'Date.Wed': {
    en: 'Wed',
    se: 'Ons',
    es: 'Mie',
    no: 'Ons',
    tr: 'Çarşamba',
    dk: 'ons',
  },
  'Date.Thu': {
    en: 'Thu',
    se: 'Tor',
    es: 'Jue',
    no: 'Tor',
    tr: 'Perşembe',
    dk: 'tor',
  },
  'Date.Fri': {
    en: 'Fri',
    se: 'Fre',
    es: 'Vie',
    no: 'Fre',
    tr: 'Cuma',
    dk: 'fre',
  },
  'Date.Sat': {
    en: 'Sat',
    se: 'Lör',
    es: 'Sab',
    no: 'Lør',
    tr: 'Cumartesi',
    dk: 'lør',
  },
  'Date.Sun': {
    en: 'Sun',
    se: 'Sön',
    es: 'Dom',
    no: 'Søn',
    tr: 'Pazar',
    dk: 'søn',
  },
  'Date.Jan': {
    en: 'jan',
    se: 'jan',
    es: 'ene',
    no: 'jan',
    tr: 'Ocak',
    dk: 'jan',
  },
  'Date.Feb': {
    en: 'feb',
    se: 'feb',
    es: 'feb',
    no: 'feb',
    tr: 'Şubat',
    dk: 'feb',
  },
  'Date.Mars': {
    en: 'mar',
    se: 'mar',
    es: 'mar',
    no: 'mar',
    tr: 'Mart',
    dk: 'mar',
  },
  'Date.Apr': {
    en: 'apr',
    se: 'apr',
    es: 'abr',
    no: 'apr',
    tr: 'Nisan',
    dk: 'apr',
  },
  'Date.May': {
    en: 'may',
    se: 'maj',
    es: 'may',
    no: 'mai',
    tr: 'Mayıs',
    dk: 'maj',
  },
  'Date.June': {
    en: 'jun',
    se: 'jun',
    es: 'jun',
    no: 'jun',
    tr: 'Haziran',
    dk: 'jun',
  },
  'Date.July': {
    en: 'jul',
    se: 'jul',
    es: 'jul',
    no: 'jul',
    tr: 'Temmuz',
    dk: 'jul',
  },
  'Date.Aug': {
    en: 'aug',
    se: 'aug',
    es: 'ago',
    no: 'aug',
    tr: 'Ağustos',
    dk: 'aug',
  },
  'Date.Sep': {
    en: 'sep',
    se: 'sep',
    es: 'sep',
    no: 'sep',
    tr: 'Eylül',
    dk: 'sep',
  },
  'Date.Oct': {
    en: 'oct',
    se: 'okt',
    es: 'oct',
    no: 'okt',
    tr: 'Ekim',
    dk: 'okt',
  },
  'Date.Nov': {
    en: 'nov',
    se: 'nov',
    es: 'nov',
    no: 'nov',
    tr: 'Kasım',
    dk: 'nov',
  },
  'Date.Dec': {
    en: 'dec',
    se: 'dec',
    es: 'dic',
    no: 'des',
    tr: 'Aralık',
    dk: 'dec',
  },
  'Beeper.Title': {
    en: 'Beeper',
    es: 'Beeper',
    se: 'Puck',
    no: 'Beeper',
    tr: 'Çağrı Cihazı',
    dk: 'Bipper',
  },
  'Beeper.Title.Enter': {
    en: 'Enter beeper number',
    se: 'Ange pucknummer',
    es: 'Ingrese el número del beeper',
    no: 'Skriv inn beepernummer',
    tr: 'Beeper numarasını girin',
    dk: 'Indtast beepernummer',
  },
  // Printer troubleshooting
  'Printer.Troubleshooting': {
    en: 'Troubleshoot',
    es: 'Solución de problemas',
    se: 'Felsökning',
    no: 'Trenger du hjelp?',
    tr: 'Sorun giderme',
    dk: 'Fejlfinding',
  },
  'Printer.Troubleshooting.Yes': {
    en: 'Yes',
    es: 'Sí',
    se: 'Ja',
    no: 'Ja',
    tr: 'Evet',
    dk: 'Ja',
  },
  'Printer.Troubleshooting.No': {
    en: 'No',
    es: 'No',
    se: 'Nej',
    no: 'Nei',
    tr: 'Hayır',
    dk: 'Nej',
  },
  'Printer.Troubleshooting.OK': {
    en: 'OK',
    es: 'Aceptar',
    se: 'OK',
    no: 'OK',
    tr: 'Tamam',
    dk: 'OK',
  },
  'Printer.Troubleshooting.Close': {
    en: 'Close',
    es: 'Cerrar',
    se: 'Stäng',
    no: 'Lukk',
    tr: 'Kapat',
    dk: 'Luk',
  },
  'Printer.Troubleshooting.GoBack': {
    en: 'Go back',
    es: 'Volver',
    se: 'Gå tillbaka',
    no: 'Gå tilbake',
    tr: 'Geri dön',
    dk: 'Gå tilbage',
  },
  'Printer.Troubleshooting.Next': {
    en: 'Next',
    es: 'Siguiente',
    se: 'Nästa',
    no: 'Neste',
    tr: 'Sonraki',
    dk: 'Næste',
  },
  'Printer.Troubleshooting.Done': {
    en: 'Done',
    es: 'Hecho',
    se: 'Klar',
    no: 'Ferdig',
    tr: 'Tamamlandı',
    dk: 'Færdig',
  },
  'Printer.Troubleshooting.NeedMoreHelp': {
    en: 'I need more help',
    es: 'Necesito más ayuda',
    se: 'Jag behöver mer hjälp',
    no: 'Jeg trenger mer hjelp',
    tr: 'Daha fazla yardıma ihtiyacım var',
    dk: 'Jeg har brug for mere hjælp',
  },
  'Printer.Troubleshooting.Working': {
    en: 'It works now',
    es: 'Ahora funciona',
    se: 'Det fungerar nu',
    no: 'Det fungerer nå',
    tr: 'Şimdi çalışıyor',
    dk: 'Det virker nu',
  },
  'Printer.Troubleshooting.NotWorking': {
    en: 'Still not working',
    es: 'Sigue sin funcionar',
    se: 'Fungerar fortfarande inte',
    no: 'Fungerer fortsatt ikke',
    tr: 'Hâlâ çalışmıyor',
    dk: 'Virker stadig ikke',
  },
  'Printer.Troubleshooting.TestPrint': {
    en: 'Test print',
    es: 'Impresión de prueba',
    se: 'Testutskrift',
    no: 'Testutskrift',
    tr: 'Test baskısı',
    dk: 'Testprint',
  },
  'Printer.Troubleshooting.RetryScan': {
    en: 'Scan again',
    es: 'Escanear de nuevo',
    se: 'Skanna igen',
    no: 'Skann igjen',
    tr: 'Tekrar tarayın',
    dk: 'Scan igen',
  },
  'Printer.Troubleshooting.CoverOpen': {
    en: 'The cover is open',
    es: 'La tapa está abierta',
    se: 'Locket är öppet',
    no: 'Lokket er åpent',
    tr: 'Kapak açık',
    dk: 'Låget er åbent',
  },
  'Printer.Troubleshooting.CoverOpen.Desc': {
    en: 'The printer does not print when the cover is open. Close the cover and try again.',
    es:
      'La impresora no imprime cuando la tapa está abierta. Cierre la tapa y vuelva a intentarlo.',
    se: 'Skrivaren skriver inte ut när locket är öppet. Stäng locket och försök igen.',
    no: 'Du må stenge lokket for å kunne skrive ut.',
    tr: 'Yazıcı kapak açıkken yazdırmaz. Kapağı kapatın ve tekrar deneyin.',
    dk: 'Printeren printer ikke, når låget er åbent. Luk låget og prøv igen.',
  },
  'Printer.Troubleshooting.OutOfPaper': {
    en: 'Out of paper',
    es: 'Sin papel',
    se: 'Papper slut',
    no: 'Tomt for papir',
    tr: 'Kağıt bitti',
    dk: 'Ingen papir',
  },
  'Printer.Troubleshooting.OutOfPaper.Desc': {
    en: 'Fill with new paper and try again',
    es: 'Coloque papel nuevo y vuelva a intentarlo',
    se: 'Fyll på med nytt papper och försök igen',
    no: 'Vennligst fyll på med nytt papir og prøv igjen',
    tr: 'Yeni kağıt ekleyin ve tekrar deneyin',
    dk: 'Fyld med nyt papir og prøv igen',
  },
  'Printer.Troubleshooting.CheckingStatus': {
    en: 'Checking status...',
    es: 'Comprobando el estado...',
    se: 'Kontrollerar status...',
    no: 'Kontrollerer status...',
    tr: 'Durum kontrol ediliyor...',
    dk: 'Kontrollerer status...',
  },
  'Printer.Troubleshooting.Connection': {
    en: 'How is your printer connected?',
    es: '¿Cómo está conectada tu impresora?',
    se: 'Hur är din skrivare ansluten?',
    no: 'Hvordan er skriveren din koblet til?',
    tr: 'Hvordan er din printer tilsluttet?',
    dk: 'Yazıcınız nasıl bağlı?',
  },
  'Printer.Troubleshooting.Model': {
    en: 'What brand of printer do you have?',
    es: '¿Qué marca de impresora tienes?',
    se: 'Vilket skrivarmärke har du?',
    no: 'Hvilket skrivermerke har du?',
    tr: 'Hangi yazıcı markasına sahipsiniz?',
    dk: 'Hvilket printermærke har du?',
  },
  'Printer.Troubleshooting.Model.Desc': {
    en: 'Select your printer brand below:',
    es: 'Selecciona tu marca de impresora a continuación:',
    se: 'Välj ditt skrivarmärke nedan:',
    no: 'Velg skrivermerket ditt nedenfor:',
    tr: 'Aşağıdan yazıcı markanızı seçin:',
    dk: 'Vælg dit printermærke nedenfor:',
  },
  'Printer.TS.USB.IpadCharging': {
    en: 'Is the Ipad charging?',
    es: '¿Se está cargando el Ipad?',
    se: 'Laddas Ipaden?',
    no: 'Lader iPaden?',
    tr: 'Ipad şarj oluyor mu?',
    dk: 'Oplades Ipaden?',
  },
  'Printer.TS.USB.IpadCharging.Desc': {
    en: 'Check in the top right that the Ipad is charging',
    es: 'Comprueba en la parte superior derecha que el Ipad se está cargando',
    se: 'Kontrollera i övre högra hörnet att Ipaden laddas',
    no: 'Sjekk øverst til høyre at iPaden lader',
    tr: 'Ipad in şarj olup olmadığını sağ üstte kontrol edin',
    dk: 'Kontroller øverst til højre, at Ipaden oplades',
  },
  'Printer.TS.Toast.TicketsEnabled': {
    en: 'Kitchen tickets enabled',
    es: 'Comanandas de cocina habilitadas',
    se: 'Bongar aktiverade',
    no: 'Bonger aktivert',
    tr: 'Mutfak biletleri etkinleştirildi',
    dk: 'Køkkenbilletter aktiveret',
  },
  'Printer.TS.TicketsDisabled': {
    en: 'Kitchen ticket printing is disabled.',
    es: 'La impresión de comanda de cocina está deshabilitada.',
    se: 'Utskrift av köksbongar är inaktiverad.',
    no: 'Utskrift av bonger er deaktivert.',
    tr: 'Mutfak bileti yazdırma devre dışı bırakıldı.',
    dk: 'Udskrivning af køkkenbilletter er deaktiveret.',
  },
  'Printer.TS.TicketsDisabled.Question': {
    en: 'Do you want to enable kitchen ticket printing?',
    es: '¿Desea habilitar la impresión de comandas de cocina?',
    se: 'Vill du aktivera utskrift av köksbongar?',
    no: 'Vil du aktivere utskrift av bonger?',
    tr: 'Mutfak bileti yazdırmayı etkinleştirmek istiyor musunuz?',
    dk: 'Vil du aktivere udskrivning af køkkenbilletter?',
  },
  'Printer.TS.NoStations': {
    en: 'This printer does not have any station assigned to it.',
    es: 'Esta impresora no tiene ningún punto de elaboración asignado.',
    se: 'Denna skrivare har ingen station tilldelad.',
    no: 'Denne skriveren har ingen stasjon tildelt.',
    tr: 'Bu yazıcıya atanmış herhangi bir istasyon yok.',
    dk: 'Denne printer har ikke nogen station tildelt.',
  },
  'Printer.TS.NoStations.Desc': {
    en:
      'A station needs to be assigned to the printer to print bongs. Do you want to assign a station to this printer?',
    es:
      'Es necesario asignar una punto de elaboración a la impresora para imprimir comandas. ¿Desea asignar un punto de elaboración a esta impresora?',
    se:
      'En station måste tilldelas skrivaren för att skriva ut biljetter. Vill du tilldela en station till denna skrivare?',
    no:
      'En stasjon må tildeles skriveren for å skrive ut bonger. Vil du tildele en stasjon til denne skriveren?',
    tr:
      'Fiş yazdırmak için yazıcıya bir istasyon atanması gerekir. Bu yazıcıya bir istasyon atamak ister misiniz?',
    dk:
      'En station skal tildeles printeren for at udskrive billetter. Vil du tildele en station til denne printer?',
  },
  'Printer.TS.AssignStation': {
    en: 'Assign station',
    es: 'Asignar punto de elaboración',
    se: 'Tilldela station',
    no: 'Tildel stasjon',
    tr: 'İstasyon ata',
    dk: 'Tildel station',
  },
  'Printer.TS.CheckSettings': {
    en: 'Check your settings',
    es: 'Verifique su configuración',
    se: 'Kontrollera dina inställningar',
    no: 'Sjekk innstillingene dine',
    tr: 'Ayarlarınızı kontrol edin',
    dk: 'Kontroller dine indstillinger',
  },
  'Printer.TS.CheckSettings.Desc': {
    en:
      'Check that the correct categories/articles are included in the station settings. Check your KDS and kitchen tickets settings.',
    es:
      'Verifique que las categorías/artículos correctos estén incluidos en la configuración del punto de elaboración. Verifique la configuración de sus KDS y comandas de cocina.',
    se:
      'Kontrollera att rätt kategorier/artiklar är inkluderade i stationsinställningarna. Kontrollera dina KDS- och köksbonginställningar.',
    no:
      'Sjekk at de riktige kategoriene/artiklene er inkludert i stasjonsinnstillingene i backoffice. Sjekk kjøkkenskjerm- og bonginnstillingene dine på enheten.',
    tr:
      'İstasyon ayarlarında doğru kategori/makalelerin bulunduğundan emin olun. KDS ve mutfak bileti ayarlarınızı kontrol edin.',
    dk:
      'Sørg for, at de korrekte kategorier/artikler er inkluderet i stationsindstillingerne. Tjek dine KDS- og køkkenbilletindstillinger.',
  },
  'Printer.TS.ContactSupport': {
    en: 'Contact support',
    es: 'Contactar soporte',
    se: 'Kontakta support',
    no: 'Kontakt support',
    tr: 'Destek ile iletişime geçin',
    dk: 'Kontakt support',
  },
  'Printer.TS.ContactSupport.Text': {
    en:
      'Sorry to hear that you are having issues. Please contact our support team and we will help you further.',
    es:
      'Lamentamos que tenga problemas. Por favor, póngase en contacto con nuestro equipo de soporte y lo ayudaremos.',
    se:
      'Tråkigt att höra att du har problem. Vänligen kontakta vårt supportteam så hjälper vi dig.',
    no:
      'Beklager å høre at du har problemer. Vennligst kontakt vårt supportteam, så hjelper vi deg.',
    tr:
      'Sorun yaşadığınız için üzgünüz. Lütfen destek ekibimizle iletişime geçin, size yardımcı olalım.',
    dk: 'Beklager, at du har problemer. Kontakt venligst vores supportteam, så hjælper vi dig.',
  },
  'Printer.TS.Toast.PrimaryChange': {
    en: 'Primary printer changed',
    es: 'Impresora principal cambiada',
    se: 'Huvudskrivare ändrad',
    no: 'Primær kvitteringsskriver endret',
    tr: 'Birincil yazıcı değiştirildi',
    dk: 'Primær printer ændret',
  },
  'Printer.TS.Toast.PrintReceipts': {
    en: 'Printer changed to always print receipts',
    es: 'Impresora configurada para imprimir siempre tickets',
    se: 'Skrivaren inställd på att alltid skriva ut kvitton',
    no: 'Skriveren er endret til alltid å skrive ut kvitteringer',
    tr: 'Yazıcı her zaman fiş yazdıracak şekilde değiştirildi',
    dk: 'Printer ændret til altid at udskrive kvitteringer',
  },
  'Printer.TS.NotPrimary': {
    en: 'This is not the primary printer',
    es: 'Esta no es la impresora principal',
    se: 'Detta är inte huvudsaklig skrivare',
    no: 'Dette er ikke den primære kvitteringsskriveren',
    tr: 'Bu birincil yazıcı değil',
    dk: 'Dette er ikke den primære printer',
  },
  'Printer.TS.NotPrimary.Desc': {
    en:
      'The receipts are always printed on the primary printer. Do you want to make this printer the primary printer?',
    es:
      'Los tickets siempre se imprimen en la impresora principal. ¿Desea configurar esta impresora como principal?',
    se:
      'Kvitton skrivs alltid ut på huvudsaklig skrivare. Vill du göra denna skrivare till huvudsaklig skrivare?',
    no:
      'Kvitteringene skrives alltid ut på den primære kvitteringsskriveren. Vil du gjøre dette til den primære kvitteringsskriveren?',
    tr:
      'Fişler her zaman birincil yazıcıda yazdırılır. Bu yazıcıyı birincil yazıcı yapmak ister misiniz?',
    dk:
      'Kvitteringer udskrives altid på den primære printer. Vil du gøre denne printer til den primære printer?',
  },
  'Printer.TS.ManualPrintEnabled': {
    en: 'Manual receipt printing is enabled.',
    es: 'La impresión manual de tickets está habilitada.',
    se: 'Manuell kvittoutskrift är aktiverad.',
    no: 'Manuell kvitteringsutskrift er aktivert.',
    tr: 'Manuel fiş yazdırma etkinleştirildi.',
    dk: 'Manuel kvitteringsudskrivning er aktiveret.',
  },
  'Printer.TS.ManualPrintEnabled.Desc': {
    en: 'The receipts are not printed automatically. You need to print them manually.',
    es: 'Los tickets no se imprimen automáticamente. Debe imprimirlos manualmente.',
    se: 'Kvitton skrivs inte ut automatiskt. Du måste skriva ut dem manuellt.',
    no: 'Kvitteringene skrives ikke ut automatisk. Du må skrive dem ut manuelt.',
    tr: 'Fişler otomatik olarak yazdırılmaz. Bunları manuel olarak yazdırmanız gerekir.',
    dk: 'Kvitteringer udskrives ikke automatisk. Du skal udskrive dem manuelt.',
  },
  'Printer.TS.DoesTestPrintWork': {
    en: 'Does the test print work?',
    es: '¿Funciona la impresión de prueba?',
    se: 'Fungerar testutskriften?',
    no: 'Fungerer testutskriften?',
    tr: 'Test baskısı çalışıyor mu?',
    dk: 'Fungerer testudskriften?',
  },
  'Printer.TS.IssueWith.Question': {
    en: 'What do you have an issue with?',
    es: '¿Con qué tienes un problema?',
    se: 'Vad har du problem med?',
    no: 'Hva har du problemer med?',
    tr: 'Hangi konuda sorun yaşıyorsunuz?',
    dk: 'Hvad har du et problem med?',
  },
  'Printer.TS.IssueWith.Receipts': {
    en: 'Receipts',
    es: 'Tickets',
    se: 'Kvitton',
    no: 'Kvitteringer',
    tr: 'Fişler',
    dk: 'Kvitteringer',
  },
  'Printer.TS.IssueWith.KitchenTickets': {
    en: 'Kitchen tickets',
    es: 'Comandas de cocina',
    se: 'Bongar',
    no: 'Bonger',
    tr: 'Mutfak biletleri',
    dk: 'Køkkenbilletter',
  },
  'Printer.TS.IssueWith.Everything': {
    en: 'Nothing is printing',
    es: 'Nada se imprime',
    se: 'Inget skrivs ut',
    no: 'Ingenting skrives ut',
    tr: 'Hiçbir şey yazdırılmıyor',
    dk: 'Intet udskrives',
  },
  'Printer.TS.LightsQuestion': {
    en: 'Is the power light on the printer on?',
    es: '¿Está encendida la luz de encendido en la impresora?',
    se: 'Är strömlampan på skrivaren på?',
    no: 'Er strømlampen på skriveren på?',
    tr: 'Yazıcının güç ışığı yanıyor mu?',
    dk: 'Er strømindikatoren på printeren tændt?',
  },
  'Printer.TS.CablePluggedIn': {
    en: 'Unplug the power cable from the printer and plug it back in, press the power button',
    es:
      'Desconecte el cable de alimentación de la impresora y vuelva a conectarlo, presione el botón de encendido',
    se: 'Dra ur strömkabeln från skrivaren och sätt i den igen, tryck på ON-knappen',
    no: 'Trekk ut strømkabelen fra skriveren og sett den inn igjen, trykk på strømknappen',
    tr: 'Yazıcıdan güç kablosunu çıkarın ve tekrar takın, güç düğmesine basın',
    dk: 'Tag strømkablet ud af printeren og sæt det i igen, tryk på tænd/sluk-knappen',
  },
  'Printer.TS.CablePluggedIn.Desc': {
    en: 'Wait a minute and see if the power light turns on',
    es: 'Espera un minuto y comprueba si la luz de encendido se enciende.',
    se: 'Vänta en minut och se om strömlampan tänds.',
    no: 'Vent ett minutt og se om strømLyset slår seg på.',
    tr: 'Bir dakika bekleyin ve güç ışığının yanıp yanmadığını kontrol edin.',
    dk: 'Vent et øjeblik og se om strømLyset tænder.',
  },
  'Printer.TS.PowerWorking': {
    en: 'Is the power working?',
    es: '¿Funciona la electricidad?',
    se: 'Fungerar strömmen?',
    no: 'Fungerer strømmen?',
    tr: 'Elektrik çalışıyor mu?',
    dk: 'Virker strømmen?',
  },
  'Printer.TS.PowerWorking.Desc': {
    en:
      'Plug out the cable from the wall socket and check if there is power in the socket. For example, you can try charging your phone in the same socket to see if the power is working.',
    es:
      'Desconecte el cable del enchufe de la pared y verifique si hay electricidad en el enchufe. Por ejemplo, puede intentar cargar su teléfono en el mismo enchufe para ver si funciona.',
    se:
      'Dra ut sladden från vägguttaget och kontrollera om det finns ström i uttaget. Till exempel kan du försöka ladda din telefon i samma uttag för att se om det fungerar.',
    no:
      'Trekk ut kabelen fra stikkontakten og sjekk om det er strøm i kontakten. For eksempel kan du prøve å lade telefonen i samme kontakt for å se om det fungerer.',
    tr:
      'Kabloyu prizden çıkarın ve prizde elektrik olup olmadığını kontrol edin. Örneğin, aynı prizde telefonunuzu şarj etmeyi deneyebilirsiniz.',
    dk:
      'Træk kablet ud af stikkontakten, og kontroller, om der er strøm i stikkontakten. For eksempel kan du prøve at oplade din telefon i samme stikkontakt for at se, om det virker.',
  },
  'Printer.TS.BT.GoToSettings': {
    en: 'Go to the Ipad Bluetooth settings',
    es: 'Vaya a la configuración de Bluetooth del Ipad',
    se: 'Gå till Ipad Bluetooth-inställningar',
    no: 'Gå til iPadens Bluetooth-innstillinger',
    tr: 'Ipad Bluetooth ayarlarına gidin',
    dk: 'Gå til Ipad Bluetooth-indstillinger',
  },
  'Printer.TS.BT.GoToSettings.Desc': {
    en: 'Turn off and on Bluetooth and connect to the printer.',
    es: 'Apague y encienda Bluetooth y conéctese a la impresora.',
    se: 'Stäng av och sätt på Bluetooth och anslut till skrivaren.',
    no: 'Slå av og på Bluetooth og koble til skriveren.',
    tr: 'Bluetooth’u kapatıp açın ve yazıcıya bağlanın.',
    dk: 'Sluk og tænd Bluetooth, og opret forbindelse til printeren.',
  },
  'Printer.TS.BT.LightsOn': {
    en: 'Is the Bluetooth light shining?',
    es: '¿Está encendida la luz de Bluetooth?',
    se: 'Lyser Bluetooth-lampan?',
    no: 'Lyser Bluetooth-lampen?',
    tr: 'Bluetooth ışığı yanıyor mu?',
    dk: 'Lyser Bluetooth-lampen?',
  },
  'Printer.TS.BT.ResetPrinter': {
    en: 'Reset the printer',
    es: 'Restablecer la impresora',
    se: 'Återställ skrivaren',
    no: 'Nullstill skriveren',
    tr: 'Yazıcıyı sıfırla',
    dk: 'Nulstil printeren',
  },
  'Printer.TS.BT.ResetPrinter.Desc': {
    en:
      'Press the reset button (in the small hole) until the lights are blinking. Make sure it says "reset" next to the hole.',
    es:
      'Presione el botón de reinicio (en el pequeño agujero) hasta que las luces parpadeen. Asegúrese de que diga "reset" junto al agujero.',
    se:
      'Tryck på återställningsknappen (i det lilla hålet) tills lamporna blinkar. Se till att det står "reset" bredvid hålet.',
    no:
      'Trykk på reset-knappen (i det lille hullet) til lysene blinker. Sørg for at det står "reset" ved siden av hullet.',
    tr:
      'Işıklar yanıp sönene kadar sıfırlama düğmesine (küçük delikte) basın. Delikte "reset" yazdığından emin olun.',
    dk:
      'Tryk på reset-knappen (i det lille hul), indtil lamperne blinker. Sørg for, at der står "reset" ved siden af hullet.',
  },
  'Printer.TS.BT.Restart': {
    en: 'Try restarting the app',
    es: 'Intente reiniciar la aplicación',
    se: 'Försök starta om appen',
    no: 'Prøv å starte appen på nytt',
    tr: 'Uygulamayı yeniden başlatmayı deneyin',
    dk: 'Prøv at genstarte appen',
  },
  'Printer.TS.BT.Restart.Desc': {
    en: 'Due to issues with Bluetooth, sometimes the app needs to be restarted.',
    es: 'Debido a problemas con Bluetooth, a veces es necesario reiniciar la aplicación.',
    se: 'På grund av problem med Bluetooth måste appen ibland startas om.',
    no: 'På grunn av problemer med Bluetooth må appen noen ganger startes på nytt.',
    tr: 'Bluetooth sorunları nedeniyle bazen uygulamanın yeniden başlatılması gerekir.',
    dk: 'På grund af problemer med Bluetooth skal appen nogle gange genstartes.',
  },
  'Printer.TS.BT.PullOutCable': {
    en: 'Pull out the power cable',
    es: 'Desenchufe el cable de alimentación',
    se: 'Dra ut strömkabeln',
    no: 'Trekk ut strømkabelen',
    tr: 'Güç kablosunu çıkarın',
    dk: 'Træk strømkablet ud',
  },
  'Printer.TS.BT.PullOutCable.Desc': {
    en: 'Unplug the power cable from the printer and plug it back in, press the power button',
    es:
      'Desconecte el cable de alimentación de la impresora y vuelva a conectarlo, presione el botón de encendido',
    se: 'Dra ur strömkabeln från skrivaren och sätt i den igen, tryck på ON-knappen',
    no: 'Trekk ut strømkabelen fra skriveren og sett den inn igjen, trykk på strømknappen',
    tr: 'Yazıcıdan güç kablosunu çıkarın ve tekrar takın, güç düğmesine basın',
    dk: 'Tag strømkablet ud af printeren og sæt det i igen, tryk på tænd/sluk-knappen',
  },
  'Printer.TS.BT.CheckDistance': {
    en: 'Check the distance between the printer and the Ipad',
    es: 'Verifique la distancia entre la impresora y el Ipad',
    se: 'Kontrollera avståndet mellan skrivaren och Ipad',
    no: 'Kontroller avstanden mellom skriveren og iPaden',
    tr: 'Yazıcı ile Ipad arasındaki mesafeyi kontrol edin',
    dk: 'Kontroller afstanden mellem printeren og Ipad',
  },
  'Printer.TS.BT.CheckDistance.Desc': {
    en: 'The printer and the Ipad should be close to each other. Try moving them closer.',
    es: 'La impresora y el Ipad deben estar cerca uno del otro. Intente acercarlos.',
    se: 'Skrivaren och Ipad bör vara nära varandra. Försök att flytta dem närmare.',
    no: 'Skriveren og iPaden bør være nær hverandre. Prøv å flytte dem nærmere.',
    tr: 'Yazıcı ile Ipad birbirine yakın olmalı. Onları birbirine yaklaştırmayı deneyin.',
    dk: 'Printeren og Ipad bør være tæt på hinanden. Prøv at flytte dem tættere.',
  },
  'Printer.TS.LAN.LightStatus.Question': {
    en: 'What is the status of the ethernet light?',
    es: '¿Cuál es el estado de la luz de Ethernet?',
    se: 'Vad är statusen för Ethernet-lampan?',
    no: 'Hva er statusen for Ethernet-lampen?',
    tr: 'Ethernet ışığının durumu nedir?',
    dk: 'Hvad er status for Ethernet-lampen?',
  },
  'Printer.TS.LAN.LightStatus.On': {
    en: 'On',
    es: 'Encendida',
    se: 'På',
    no: 'På',
    tr: 'Açık',
    dk: 'Tændt',
  },
  'Printer.TS.LAN.LightStatus.Off': {
    en: 'Off',
    es: 'Apagada',
    se: 'Av',
    no: 'Av',
    tr: 'Kapalı',
    dk: 'Slukket',
  },
  'Printer.TS.LAN.LightStatus.Blinking': {
    en: 'Blinking',
    es: 'Parpadeando',
    se: 'Blinkar',
    no: 'Blinker',
    tr: 'Yanıp sönüyor',
    dk: 'Blinker',
  },
  'Printer.TS.LAN.CableConnnected.Question': {
    en: 'Is the ethernet cable connected to the printer?',
    es: '¿Está conectado el cable Ethernet a la impresora?',
    se: 'Är Ethernet-kabeln ansluten till skrivaren?',
    no: 'Er Ethernet-kabelen koblet til skriveren?',
    tr: 'Ethernet kablosu yazıcıya bağlı mı?',
    dk: 'Er Ethernet-kablet tilsluttet printeren?',
  },
  'Printer.TS.LAN.SameNetwork.Question': {
    en: (isIpad: boolean) =>
      `Is the printer and ${isIpad ? 'Ipad' : 'tablet'} on the same network?`,
    es: (isIpad: boolean) =>
      `¿La impresora y el ${isIpad ? 'Ipad' : 'tablet'} están en la misma red?`,
    se: (isIpad: boolean) => `Är skrivaren och ${isIpad ? 'Ipaden' : 'paddan'} på samma nätverk?`,
    no: (isIpad: boolean) =>
      `Er skriveren og ${isIpad ? 'iPaden' : 'tableten'} på samme nettverk?`,
    tr: (isIpad: boolean) => `Yazıcı ve ${isIpad ? 'Ipad' : 'tablet'} aynı ağda mı?`,
    dk: (isIpad: boolean) => `Er printeren og ${isIpad ? 'Ipad' : 'tablet'} på det samme netværk?`,
  },
  'Printer.TS.LAN.SameNetwork.Desc': {
    en: (isIpad: boolean) =>
      `Check in the ${
        isIpad ? 'Ipad' : 'tablet'
      } wifi settings if you are connected to the same network as the printer.`,
    es: (isIpad: boolean) =>
      `Verifique en la configuración de wifi del ${
        isIpad ? 'Ipad' : 'tablet'
      } si está conectado a la misma red que la impresora.`,
    se: (isIpad: boolean) =>
      `Kontrollera i ${
        isIpad ? 'Ipadens' : 'paddans'
      } wifi-inställningar om du är ansluten till samma nätverk som skrivaren.`,
    no: (isIpad: boolean) =>
      `Sjekk i ${
        isIpad ? 'iPadens' : 'tabletens'
      } Wi-Fi-innstillinger om du er koblet til det samme nettverket som printeren.`,
    tr: (isIpad: boolean) =>
      `Yazıcı ile aynı ağa bağlı olup olmadığınızı kontrol etmek için ${
        isIpad ? 'Ipad' : 'tablet'
      } wifi ayarlarına bakın.`,
    dk: (isIpad: boolean) =>
      `Kontroller i ${
        isIpad ? 'Ipad' : 'tablet'
      } wifi-indstillinger, om du er tilsluttet det samme netværk som printeren.`,
  },
  'Printer.TS.LAN.TryTestPrint': {
    en: 'Try sending a test print below',
    es: 'Intente enviar una impresión de prueba a continuación',
    se: 'Försök att skicka en testutskrift nedan',
    no: 'Prøv å sende en testutskrift nedenfor',
    tr: 'Aşağıdan bir test baskısı göndermeyi deneyin',
    dk: 'Prøv at sende en testudskrift nedenfor',
  },
  'Printer.TS.LAN.CheckCables': {
    en: 'Check all ethernet cables',
    es: 'Revise todos los cables Ethernet',
    se: 'Kontrollera alla Ethernet-kablar',
    no: 'Sjekk alle Ethernet-kabler',
    tr: 'Tüm ethernet kablolarını kontrol edin',
    dk: 'Kontroller alle Ethernet-kabler',
  },
  'Printer.TS.LAN.CheckCables.Desc': {
    en: 'Check both the printer and router side of the cable to see if it is connected properly.',
    es:
      'Revise tanto el lado de la impresora como el del enrutador del cable para verificar si está conectado correctamente.',
    se:
      'Kontrollera både skrivar- och routersidan av kabeln för att se om den är korrekt ansluten.',
    no: 'Sjekk både skriver- og rutersiden av kabelen for å se om den er ordentlig tilkoblet.',
    tr:
      'Kablonun yazıcı ve yönlendirici taraflarının düzgün bağlanıp bağlanmadığını kontrol edin.',
    dk:
      'Kontroller både printer- og routerenden af kablet for at sikre, at det er korrekt tilsluttet.',
  },
  'Printer.TS.LAN.TryOtherCable': {
    en: 'Try with another ethernet cable',
    es: 'Intente con otro cable Ethernet',
    se: 'Försök med en annan Ethernet-kabel',
    no: 'Prøv med en annen Ethernet-kabel',
    tr: 'Başka bir ethernet kablosu deneyin',
    dk: 'Prøv med et andet Ethernet-kabel',
  },
  'Printer.TS.LAN.TryOtherCable.Desc': {
    en: 'The cable might be broken. Try with another cable to see if that is the issue.',
    es: 'El cable podría estar dañado. Intente con otro cable para ver si ese es el problema.',
    se: 'Kabeln kan vara trasig. Försök med en annan kabel för att se om det är problemet.',
    no: 'Kabelen kan være ødelagt. Prøv med en annen kabel for å se om det er problemet.',
    tr: 'Kablo bozuk olabilir. Sorunun bu olup olmadığını anlamak için başka bir kablo deneyin.',
    dk: 'Kablet kan være defekt. Prøv med et andet kabel for at se, om det er problemet.',
  },
  'Printer.TS.LAN.RestartRouter': {
    en: 'Restart the router',
    es: 'Reinicie el enrutador',
    se: 'Starta om routern',
    no: 'Start ruteren på nytt',
    tr: 'Yönlendiriciyi yeniden başlatın',
    dk: 'Genstart routeren',
  },
  'Printer.TS.LAN.RestartRouter.Desc': {
    en: 'Unplug the power cable from the router and plug it back in after 10 seconds.',
    es:
      'Desenchufe el cable de alimentación del enrutador y vuelva a enchufarlo después de 10 segundos.',
    se: 'Dra ut strömkabeln från routern och anslut den igen efter 10 sekunder.',
    no: 'Trekk ut strømkabelen fra ruteren og sett den inn igjen etter 10 sekunder.',
    tr: 'Yönlendiricinin güç kablosunu çıkarın ve 10 saniye sonra yeniden takın.',
    dk: 'Tag strømkablet ud af routeren, og tilslut det igen efter 10 sekunder.',
  },
  'Printer.TS.LAN.NoInternet': {
    en: 'No internet connection',
    es: 'Sin conexión a internet',
    se: 'Ingen internetanslutning',
    no: 'Ingen internettforbindelse',
    tr: 'İnternet bağlantısı yok',
    dk: 'Ingen internetforbindelse',
  },
  'Printer.TS.LAN.NoInternet.Desc': {
    en: 'Please check your internet connection and try again.',
    es: 'Por favor, revise su conexión a internet y vuelva a intentarlo.',
    se: 'Kontrollera din internetanslutning och försök igen.',
    no: 'Vennligst sjekk internettforbindelsen din og prøv igjen.',
    tr: 'Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin.',
    dk: 'Kontroller venligst din internetforbindelse, og prøv igen.',
  },
  'Printer.TS.LAN.RetryScan': {
    en: 'Try scanning again',
    es: 'Intenta escanear de nuevo.',
    se: 'Testa skanna igen',
    no: 'Prøv å skanne igjen.',
    tr: 'Tekrar taramayı deneyin.',
    dk: 'Prøv at scanne igen.',
  },
  'Printer.TS.LAN.RetryScan.Desc': {
    en: 'Use the button below to go back and try scanning again.',
    es: 'Usa el botón de abajo para volver e intentar escanear de nuevo.',
    se: 'Använd knappen nedan för att gå tillbaka och testa skanna igen.',
    no: 'Bruk knappen nedenfor for å gå tilbake og prøve å skanne igjen.',
    tr: 'Geri dönüp tekrar taramayı denemek için aşağıdaki düğmeyi kullanın.',
    dk: 'Brug knappen nedenfor til at gå tilbage og prøve at scanne igen.',
  },
  'Printer.TS.LAN.CheckLights': {
    en: 'What is the Ethernet-light status?',
    es: '¿Cuál es el estado de la luz Ethernet?',
    se: 'Vad är status för Ethernet-lampan?',
    no: 'Hva er statusen til Ethernet-lyset?',
    tr: 'Ethernet ışığının durumu nedir?',
    dk: 'Hvad er status for Ethernet-lyset?',
  },
  'Printer.TS.LAN.CheckLights.Desc': {
    en: 'Check if your Ethernet-Light is now on or still continuing to blink.',
    es: 'Comprueba si la luz Ethernet está ahora encendida o sigue parpadeando.',
    se: 'Kontrollera om din Ethernet-lampa nu lyser konstant eller fortfarande blinkar.',
    no: 'Sjekk om Ethernet-lyset nå er på eller fortsatt blinker.',
    tr: 'Ethernet ışığının şu anda yanık mı yoksa hala yanıp sönüyor mu olduğunu kontrol edin.',
    dk: 'Tjek om dit Ethernet-lys nu er tændt eller fortsat blinker.',
  },
  'Printer.TS.USB.RestartPrinter': {
    en: 'Restart the printer',
    es: 'Reinicie la impresora',
    se: 'Starta om skrivaren',
    no: 'Start skriveren på nytt',
    tr: 'Yazıcıyı yeniden başlatın',
    dk: 'Genstart printeren',
  },
  'Printer.TS.USB.RestartPrinter.Desc': {
    en: 'Pull out the power cable from the printer and plug it back in.',
    es: 'Desenchufe el cable de alimentación de la impresora y vuelva a enchufarlo.',
    se: 'Dra ut strömkabeln från skrivaren och anslut den igen.',
    no: 'Trekk ut strømkabelen fra printeren og sett den inn igjen.',
    tr: 'Yazıcının güç kablosunu çıkarıp tekrar takın.',
    dk: 'Tag strømkablet ud af printeren, og tilslut det igen.',
  },
  'Printer.TS.USB.CableOutlet.Question': {
    en: 'Is the cable plugged into the USB outlet labeled "Ipad"?',
    es: '¿Está el cable conectado a la salida USB etiquetada como "Ipad"?',
    se: 'Är kabeln ansluten till USB-uttaget märkt "Ipad"?',
    no: 'Er kabelen koblet til USB-utgangen merket "iPad"?',
    tr: 'Kablo "Ipad" olarak etiketlenmiş USB çıkışına takılı mı?',
    dk: 'Er kablet sat i USB-porten mærket "Ipad"?',
  },
  'Printer.TS.USB.TryOtherCable': {
    en: 'Try with another USB cable',
    es: 'Intente con otro cable USB',
    se: 'Försök med en annan USB-kabel',
    no: 'Prøv med en annen USB-kabel',
    tr: 'Başka bir USB kablosu deneyin',
    dk: 'Prøv med et andet USB-kabel',
  },
  'Printer.TS.USB.TryOtherCable.Desc': {
    en:
      'The USB cable might be broken. Try connecting the printer and Ipad with another USB cable. Make sure it is connected in the slot labeled "Ipad" on the printer.',
    es:
      'El cable USB podría estar dañado. Intente conectar la impresora y el Ipad con otro cable USB. Asegúrese de que esté conectado en la ranura etiquetada como "Ipad" en la impresora.',
    se:
      'USB-kabeln kan vara trasig. Försök att ansluta skrivaren och Ipad med en annan USB-kabel. Kontrollera att den är ansluten i uttaget märkt "Ipad" på skrivaren.',
    no:
      'USB-kabelen kan være ødelagt. Prøv å koble skriveren og iPaden med en annen USB-kabel. Sørg for at den er koblet til i porten merket "iPad" på skriveren.',
    tr:
      'USB kablosu bozuk olabilir. Yazıcıyı ve Ipad’i başka bir USB kablosu ile bağlamayı deneyin. Yazıcının "Ipad" olarak etiketlenmiş yuvasına bağlı olduğundan emin olun.',
    dk:
      'USB-kablet kan være defekt. Prøv at forbinde printeren og Ipad med et andet USB-kabel. Sørg for, at det er tilsluttet i porten mærket "Ipad" på printeren.',
  },
  'Printer.Toast.PrinterUpdated': {
    en: 'Printer was updated',
    es: 'La impresora se actualizó',
    se: 'Skrivaren uppdaterades',
    no: 'Printeren ble oppdatert',
    tr: 'Yazıcı güncellendi',
    dk: 'Printeren blev opdateret',
  },
  'Printer.TS.LAN.Reconnecting': {
    en: 'Trying to reconnect',
    es: 'Intentando reconectar',
    se: 'Försöker att återansluta',
    no: 'Prøver å koble til på nytt',
    tr: 'Yeniden bağlanmaya çalışılıyor',
    dk: 'Prøver at genoprette forbindelsen',
  },
  'Printer.TS.LAN.Reconnecting.Desc': {
    en: 'After the reconnecting is done, try the test print again.',
    es: 'Después de que se haya reconectado, intente la impresión de prueba nuevamente.',
    se: 'Efter att återanslutningen är klar, försök testutskriften igen.',
    no: 'Etter at tilkoblingen er gjort, prøv testutskriften igjen.',
    tr: 'Yeniden bağlantı yapıldıktan sonra test baskısını tekrar deneyin.',
    dk: 'Efter genoprettelsen skal du prøve testudskriften igen.',
  },
  'Printer.TS.AnotherIssue': {
    en: 'I have another issue',
    es: 'Tengo otro problema',
    se: 'Jag har ett annat problem',
    no: 'Jeg har et annet problem',
    tr: 'Başka bir sorunum var',
    dk: 'Jeg har et andet problem',
  },
  'Printer.TS.KDSBongOnOrderStatus': {
    en: 'Kitchen tickets are printed when order reaches the status: ',
    es: 'Las comandas de cocina se imprimen cuando el pedido alcanza el estado: ',
    se: 'Bongar skrivs ut när beställningen når status: ',
    no: 'Bonger skrives ut når bestillingen når status: ',
    tr: 'Mutfak biletleri sipariş durumuna ulaştığında yazdırılır: ',
    dk: 'Billet udskrives, når ordren når status: ',
  },
  'Printer.TS.KDSBongOnOrderStatus.Desc': {
    en:
      'The regular kitchen tickets are disabled. To change this setting, go to the KDS settings.',
    es:
      'Las comandas de cocina regulares están deshabilitados. Para cambiar esta configuración, vaya a la configuración de pantalla de cocina.',
    se:
      'De vanliga bongarna är inaktiverade. För att ändra denna inställning, gå till KDS-inställningarna.',
    no:
      'De vanlige bongene er deaktivert. For å endre denne innstillingen, gå til KDS-innstillingene.',
    tr:
      'Normal mutfak biletleri devre dışı bırakıldı. Bu ayarı değiştirmek için KDS ayarlarına gidin.',
    dk:
      'De almindelige billetter er deaktiveret. For at ændre denne indstilling, gå til KDS-indstillingerne.',
  },
  'Printer.TS.KDSBongOnProgress': {
    en: 'Kitchen tickets are printed when order is progressed in the KDS',
    es: 'Las comandas de cocina se imprimen cuando el pedido avanza en el KDS',
    se: 'Bongar skrivs ut när beställningen ändrar status i KDS',
    no: 'Bonger skrives ut når bestillingen endrer status i KDS',
    tr: 'Mutfak biletleri KDS’de ilerlediğinde yazdırılır',
    dk: 'Billet udskrives, når ordren er fremskredet i KDS',
  },
  'Printer.TS.KDSBongOnProgress.Desc': {
    en: 'The regular bong prints are disabled. To change this setting, go to the KDS settings.',
    es:
      'Las impresiones regulares de bong están deshabilitadas. Para cambiar esta configuración, vaya a la configuración de pantalla de cocina.',
    se:
      'Vanliga bongutskrifter är inaktiverade. För att ändra denna inställning, gå till KDS-inställningarna.',
    no:
      'Vanlige bongutskrifter er deaktivert. For å endre denne innstillingen, gå til KDS-innstillingene.',
    tr:
      'Normal bilet yazdırmaları devre dışı bırakıldı. Bu ayarı değiştirmek için KDS ayarlarına gidin.',
    dk:
      'De almindelige billetudskrifter er deaktiveret. For at ændre denne indstilling, gå til KDS-indstillingerne.',
  },
  'Printer.TS.CheckCover': {
    en: 'Check that the cover is closed, and that the printer has paper',
    es: 'Verifique que la cubierta esté cerrada y que la impresora tenga papel',
    se: 'Kontrollera att locket är stängt och att skrivaren har papper',
    no: 'Sjekk at dekselet er lukket, og at skriveren har papir',
    tr: 'Kapağın kapalı olduğunu ve yazıcının kağıdı olduğunu kontrol edin',
    dk: 'Kontroller, at låget er lukket, og at printeren har papir',
  },
  'Bong.TAKE_AWAY': {
    en: 'Take away',
    es: 'Para llevar',
    se: 'Ta med',
    no: 'Ta med',
    tr: 'Al götür',
    dk: 'To go',
  },
  'Bong.EAT_HERE': {
    en: 'Eat here',
    es: 'Comer aquí',
    se: 'Äta här',
    no: 'Spis her',
    tr: 'Burada ye',
    dk: 'Spis her',
  },
  'Bong.DELIVERY': {
    en: 'Delivery partner',
    se: 'Leveranspartner',
    no: 'Leveringspartner',
    tr: 'Teslimat ortağı',
    dk: 'Leveringspartner',
    es: 'Socio de entrega',
  },
  'Bong.Waiter': {
    en: 'Waiter',
    es: 'Camarero',
    se: 'Servitör',
    no: 'Servitør',
    tr: 'Garson',
    dk: 'Servitrice',
  },
  'Bong.Coverage': {
    en: 'Coverage',
    es: 'Comensales',
    se: 'Antal personer',
    no: 'Antall personer',
    tr: 'Kapsam',
    dk: 'Dækning',
  },
  'Bong.EstFinishTime': {
    en: 'Est. finish time',
    es: 'Hora de finalización estimada',
    se: 'Redo till',
    no: 'Estimert ferdig tid',
    tr: 'Tahmini bitiş zamanı',
    dk: 'Est. færdig tid',
  },
  'Bong.DesiredTime': {
    en: 'Desired time',
    es: 'Hora deseada',
    se: 'upphämtningstid',
    no: 'hentetid',
    tr: 'teslim alma zamanı',
    dk: 'afhentningstid',
  },
  'Bong.DeliveryLocation': {
    en: 'Delivery location',
    es: 'Ubicación de entrega',
    se: 'Leverans',
    no: 'Levering',
    tr: 'Teslimat yeri',
    dk: 'Levering',
  },
  'Bong.Remove': {
    en: 'REMOVE',
    es: 'QUITAR',
    se: 'TA BORT',
    no: 'FJERN',
    tr: 'KALDIR',
    dk: 'FJERN',
  },
  'Bong.TestPrint': {
    en: '### TEST PRINT ###',
    es: '### IMPRESIÓN DE PRUEBA ###',
    se: '### TESTUTSKRIFT ###',
    no: '### TESTUTSKRIFT ###',
    tr: '### TEST BASKISI ###',
    dk: '### TESTUDSKRIFT ###',
  },
  'Bong.Device': {
    en: 'Device',
    es: 'Dispositivo',
    se: 'Enhet',
    no: 'Enhet',
    tr: 'Cihaz',
    dk: 'Enhed',
  },
  'Bong.Printer.Id': {
    en: 'Printer ID',
    es: 'ID de impresora',
    se: 'Skrivarens ID',
    no: 'Skriver-ID',
    tr: 'Yazıcı Kimliği',
    dk: 'Printer-ID',
  },
  'Bong.Printer.Model': {
    en: 'Printer model',
    es: 'Modelo de impresora',
    se: 'Skrivarmodell',
    no: 'Skrivermodell',
    tr: 'Yazıcı modeli',
    dk: 'Printermodel',
  },
  'Bong.Station': {
    en: 'Station',
    es: 'Punto de elaboración',
    se: 'Station',
    no: 'Stasjon',
    tr: 'İstasyon',
    dk: 'Station',
  },
  'Bong.Stations': {
    en: 'Stations',
    es: 'Estaciones',
    se: 'Stationer',
    no: 'Stasjoner',
    tr: 'İstasyonlar',
    dk: 'Stationer',
  },
  'Bong.Printer.Items': {
    en: 'Printer items',
    es: 'Elementos de impresora',
    se: 'Printer articles',
    no: 'Skriverartikler',
    tr: 'Yazıcı öğeleri',
    dk: 'Printerartikler',
  },
  'Bong.Printer.Categories': {
    en: 'Printer categories',
    es: 'Categorías de impresora',
    se: 'Skrivarkategorier',
    no: 'Skriverkategorier',
    tr: 'Yazıcı kategorileri',
    dk: 'Printerkategorier',
  },
  'ClaimDevice.RegisterDevice.Create': {
    en: 'Create a new device',
    es: 'Crear un nuevo dispositivo',
    se: 'Skapa en ny enhet',
    no: 'Opprett en ny enhet',
    tr: 'Yeni bir cihaz oluştur',
    dk: 'Opret en ny enhed',
  },
  'ClaimDevice.RegisterDevice.Claim': {
    en: 'Select a device',
    es: 'Seleccionar un dispositivo',
    se: 'Välj en enhet',
    no: 'Velg en enhet',
    tr: 'Bir cihaz seçin',
    dk: 'Vælg enhed',
  },
  'ClaimDevice.ChangeDevice': {
    en: 'Change device',
    es: 'Cambiar dispositivo',
    se: 'Byt enhet',
    no: 'Bytt enhet',
    tr: 'Cihazı değiştir',
    dk: 'Skift enhed',
  },
  'ClaimDevice.RegisterDevice': {
    en: 'No device claimed',
    es: 'Ningún dispositivo reclamado',
    se: 'Ingen enhet registrerad',
    no: 'Ingen enhet registrert',
    tr: 'Hiçbir cihaz sahiplenilmedi',
    dk: 'Ingen enhed registreret',
  },
  'ClaimDevice.RegisterDevice.CreateText': {
    en: 'Create your device by entering a name and press "Create and Use"',
    es: 'Crea tu dispositivo ingresando un nombre y presiona "Crear y reclamar"',
    se: 'Skapa din enhet genom att ange ett namn och tryck på "Skapa och använd"',
    no: 'Opprett enheten din ved å skrive inn et navn og trykke på "Opprett og aktiver"',
    tr: 'Bir ad girerek cihazınızı oluşturun ve "Oluştur ve Kullan"a basın',
    dk: 'Opret din enhed ved at indtaste et navn og trykke på "Opret og brug"',
  },
  'ClaimDevice.RegisterDevice.ClaimText': {
    en: 'A device works on one physical device at a time. Claiming it removes it from others.',
    es:
      'Un dispositivo funciona en un solo dispositivo físico a la vez. Al reclamarlo, se desvincula de otros.',
    se:
      'En enhet fungerar bara på en fysisk enhet åt gången. Att ta över den kopplar bort den från andra.',
    no: 'En enhet fungerer kun på én fysisk enhet om gangen. Å kreve den fjerner den fra andre.',
    tr:
      'Bir cihaz aynı anda yalnızca bir fiziksel cihazda çalışır. Sahiplenmek, diğerlerinden kaldırır.',
    dk: 'En enhed virker kun på én fysisk enhed ad gangen. At overtage den fjerner den fra andre.',
  },
  'ClaimDevice.Select.CreateOrSelect': {
    en: 'Would you like to create a new device or select an existing one?',
    es: '¿Le gustaría crear un nuevo dispositivo o seleccionar uno existente?',
    se: 'Vill du skapa en ny enhet eller välja en befintlig?',
    no: 'Vil du opprette en ny enhet eller velge en eksisterende?',
    tr: 'Yeni bir cihaz mı oluşturmak yoksa mevcut olanı mı seçmek istersiniz?',
    dk: 'Vil du oprette en ny enhed eller vælge en eksisterende?',
  },
  'ClaimDevice.Create.NameNotValid': {
    en: 'Name must be between 3 and 20 characters',
    es: 'El nombre debe tener entre 3 y 20 caracteres',
    se: 'Namnet måste vara mellan 3 och 20 tecken',
    no: 'Navnet må være mellom 3 og 20 tegn',
    tr: 'İsim 3 ile 20 karakter arasında olmalıdır',
    dk: 'Navnet skal være mellem 3 og 20 tegn',
  },
  'ClaimDevice.Create.NameOnlyLettersAndNumber': {
    en: 'Name can only contain letters and numbers (a-z, 0-9)',
    es: 'El nombre solo puede contener letras y números (a-z, 0-9)',
    se: 'Namnet kan bara innehålla bokstäver och siffror (a-z, 0-9)',
    no: 'Navnet kan bare inneholde bokstaver og tall (a-z, 0-9)',
    tr: 'İsim yalnızca harfler ve sayılar (a-z, 0-9) içerebilir',
    dk: 'Navnet kan kun indeholde bogstaver og tal (a-z, 0-9)',
  },
  'ClaimDevice.Create.NameAlreadyExists': {
    en: 'A device with this name already exists',
    es: 'Ya existe un dispositivo con este nombre',
    se: 'En enhet med detta namn finns redan',
    no: 'En enhet med dette navnet finnes allerede',
    tr: 'Bu isimde bir cihaz zaten var',
    dk: 'Der findes allerede en enhed med dette navn',
  },
  'ClaimDevice.Create.MissingVenueInfo': {
    en: 'The following information is required for this venue before a device can be created',
    es:
      'La siguiente información es obligatoria para este local antes de que se pueda crear un dispositivo',
    se: 'Följande information krävs för denna butik innan enheten kan skapas',
    no: 'Følgende informasjon kreves for dette stedet før enheten kan opprettes',
    tr: 'Bir cihaz oluşturulmadan önce bu mekan için gereken bilgiler',
    dk: 'Følgende oplysninger er påkrævet for dette sted, før enheden kan oprettes',
  },
  'ClaimDevice.Select.InUseByThisDevice': {
    en: 'in use by this device',
    es: 'en uso por este dispositivo',
    se: 'används av denna enhet',
    no: 'i bruk av denne enheten',
    tr: 'Bu cihaz tarafından kullanılıyor',
    dk: 'i brug af denne enhed',
  },
  'ClaimDevice.Select.InUse': {
    en: 'in use',
    es: 'en uso',
    se: 'används',
    no: 'i bruk',
    tr: 'kullanılıyor',
    dk: 'i brug',
  },
  'ClaimDevice.CreateAndUse': {
    en: 'Create and use',
    es: 'Crear y usar',
    se: 'Skapa och använd',
    no: 'Opprett og bruk',
    tr: 'Oluştur ve kullan',
    dk: 'Opret og brug',
  },
  'ClaimDevice.ClaimDevice': {
    en: 'Use this device',
    es: 'Usar este dispositivo',
    se: 'Använd denna enhet',
    no: 'Aktiver denne enheten',
    tr: 'Bu aygıtı kullan',
    dk: 'Brug denne enhed',
  },
  'ClaimDevice.Create.Placeholder': {
    en: 'e.g. pos1',
    es: 'p. ej. pos1',
    se: 't.ex. pos1',
    no: 'f.eks. pos1',
    tr: 'örn. pos1',
    dk: 'f.eks. pos1',
  },
  'ClaimDevice.Select.CreateNew': {
    en: 'Create new',
    es: 'Crear nuevo',
    se: 'Skapa ny',
    no: 'Opprett ny',
    tr: 'Yeni oluştur',
    dk: 'Opret ny',
  },
  'ClaimDevice.Select.SelectExisting': {
    en: 'Select existing',
    es: 'Seleccionar existente',
    se: 'Välj befintlig',
    no: 'Velg eksisterende',
    tr: 'Mevcut olanı seç',
    dk: 'Vælg eksisterende',
  },
  'ClaimDevice.Create.PotentialVenueError': {
    en:
      'Activation of the device to Skatteverket failed. Please verify that the venue’s information is correct and try again.',
    es:
      'La activación del dispositivo a Skatteverket falló. Verifique que la información del local sea correcta y vuelva a intentarlo.',
    se:
      'Aktivering av enheten till Skatteverket misslyckades. Kontrollera att informationen om butiken är korrekt och försök igen.',
    no:
      'Aktivering av enheten til Skatteverket mislyktes. Kontroller at informasjonen om stedet er riktig, og prøv igjen.',
    tr:
      'Cihazın Skatteverket’e etkinleştirilmesi başarısız oldu. Mekanın bilgilerinin doğru olduğunu kontrol edin ve tekrar deneyin.',
    dk:
      'Aktivering af enheden til Skatteverket mislykkedes. Kontroller, at oplysningerne om stedet er korrekte, og prøv igen.',
  },
  'ClaimDevice.Create.FailedToCreatePOSDeviceError': {
    en:
      'We couldn’t create the POS device. This might be due to a network issue—please try again.',
    es:
      'No pudimos crear el dispositivo POS. Esto puede deberse a un problema de red; inténtelo de nuevo.',
    se:
      'Vi kunde inte skapa POS-enheten. Detta kan bero på ett nätverksproblem - vänligen försök igen.',
    no:
      'Vi klarte ikke å opprette POS-enheten. Dette kan skyldes et nettverksproblem - vennligst prøv igjen.',
    tr: 'POS cihazını oluşturamadık. Bu bir ağ sorunu nedeniyle olabilir, lütfen tekrar deneyin.',
    dk:
      'Vi kunne ikke oprette POS-enheden. Dette kan skyldes et netværksproblem - prøv venligst igen.',
  },
  'ClaimDevice.Create.FailedToUpdateDevice': {
    en:
      'Something went wrong while adding compliance information to the device. It may be a temporary network issue—please try again.',
    es:
      'Algo salió mal al agregar la información de cumplimiento al dispositivo. Puede ser un problema de red temporal; inténtelo de nuevo.',
    se:
      'Något gick fel när vi lade till nödvändig information till enheten. Det kan vara ett tillfälligt nätverksproblem - försök igen.',
    no:
      'Noe gikk galt da vi la til samsvarsinformasjon til enheten. Dette kan være et midlertidig nettverksproblem - vennligst prøv igjen.',
    tr:
      'Cihaza uyumluluk bilgisi eklerken bir şeyler ters gitti. Bu geçici bir ağ sorunu olabilir, lütfen tekrar deneyin.',
    dk:
      'Noget gik galt, da vi tilføjede overensstemmelsesoplysninger til enheden. Det kan være et midlertidigt netværksproblem - prøv venligst igen.',
  },
  'ClaimDevice.Select.DeviceInUse': {
    en: (deviceName: string) =>
      `Device: "${deviceName}" was recently claimed and cannot be selected until: `,
    es: (deviceName: string) =>
      `El dispositivo: "${deviceName}" fue reclamado recientemente y no se puede seleccionar hasta: `,
    se: (deviceName: string) =>
      `Enheten: "${deviceName}" har nyligen registrerats och kan inte väljas förrän: `,
    no: (deviceName: string) =>
      `Enheten: "${deviceName}" ble nylig registrert og kan ikke velges før: `,
    tr: (deviceName: string) => `Cihaz: "${deviceName}" yakın zamanda sahiplenildi ve seçilemez: `,
    dk: (deviceName: string) =>
      `Enheden: "${deviceName}" er for nylig registreret og kan ikke vælges før `,
  },
  'ClaimDevice.Select.Licenses': {
    en: 'Licenses',
    es: 'Licencias',
    se: 'Licenser',
    no: 'Lisenser',
    tr: 'Lisanslar',
    dk: 'Licenser',
  },
  'ClaimDevice.Select.Licenses.None': {
    en: 'None',
    es: 'Ninguna',
    se: 'Inga',
    no: 'Ingen',
    tr: 'Yok',
    dk: 'Ingen',
  },
  'AccessBlocked.Frozen.Title': {
    en: 'Access frozen',
    es: 'Acceso bloqueado temporalmente',
    se: 'Åtkomsten är fryst',
    no: 'Tilgangen er midlertidig sperret',
    tr: 'Erişim geçici olarak durduruldu',
    dk: 'Adgangen er midlertidigt låst',
  },
  'AccessBlocked.Frozen.Desc': {
    en: 'Your account has outstanding invoices',
    es: 'Tu cuenta tiene facturas pendientes de pago',
    se: 'Ditt konto har obetalda fakturor',
    no: 'Kontoen din har utestående fakturaer',
    tr: 'Hesabınızda ödenmemiş faturalar var',
    dk: 'Din konto har ubetalte fakturaer',
  },
  'AccessBlocked.Expired.Title': {
    en: 'Access expired',
    es: 'Acceso caducado',
    se: 'Åtkomsten har upphört',
    no: 'Tilgangen er utløpt',
    tr: 'Erişim süresi doldu',
    dk: 'Adgangen er udløbet',
  },
  'AccessBlocked.Expired.Desc': {
    en: 'Your account’s subscription has expired',
    es: 'La suscripción de tu cuenta ha expirado',
    se: 'Prenumerationen för ditt konto har löpt ut',
    no: 'Abonnementet for kontoen din har utløpt',
    tr: 'Hesabınızın abonelik süresi sona erdi',
    dk: 'Dit abonnement er udløbet',
  },
  'AccessBlocked.DaysOverDue': {
    en: 'Days overdue',
    es: 'Días de retraso',
    se: 'Förfallodagar',
    no: 'Dager på etterskudd',
    tr: 'Geciken gün sayısı',
    dk: 'Dage for sent',
  },
  'AccessBlocked.DaysOverDue.Days': {
    en: (days: number) => (days === 1 ? 'day' : 'days'),
    es: (days: number) => (days === 1 ? 'día' : 'días'),
    se: (days: number) => (days === 1 ? 'dag' : 'dagar'),
    no: (days: number) => (days === 1 ? 'dag' : 'dager'),
    tr: (days: number) => (days === 1 ? 'gün' : 'günler'),
    dk: (days: number) => (days === 1 ? 'dag' : 'dage'),
  },
  'AccessBlocked.ContactManager': {
    en: 'Please contact your account manager to resolve the issue',
    es: 'Por favor, contacta con tu responsable de cuentas para resolver el problema',
    se: 'Kontakta din kundansvariga för att lösa problemet',
    no: 'Ta kontakt med din kundansvarlig for å løse problemet',
    tr: 'Lütfen sorunu çözmek için hesap yöneticinizle iletişime geçin',
    dk: 'Kontakt venligst din kundekontakt for at få løst problemet',
  },
  'ClaimLicense.Loading': {
    en: 'Loading available licenses...',
    es: 'Cargando licencias disponibles...',
    se: 'Laddar tillgängliga licenser...',
    no: 'Laster tilgjengelige lisenser...',
    tr: 'Mevcut lisanslar yükleniyor...',
    dk: 'Indlæser tilgængelige licenser...',
  },
  'ClaimLicense.LicenseRequired': {
    en: 'License required',
    es: 'Licencia requerida',
    se: 'Licens krävs',
    no: 'Lisens kreves',
    tr: 'Lisans gerekli',
    dk: 'Licens kræves',
  },
  'ClaimLicense.HandheldProOrOrderRequired': {
    en:
      'A "Handheld Pro" or "Handheld Order" license is required to use printers from this device.',
    es:
      'Se requiere una licencia "Handheld Pro" o "Handheld Order" para usar impresoras desde este dispositivo.',
    se:
      'En "Handheld Pro"- eller "Handheld Order"-licens krävs för att använda skrivare från den här enheten.',
    no:
      'En "Handheld Pro"- eller "Handheld Order"-lisens kreves for å bruke skrivere fra denne enheten.',
    tr:
      'Bu cihazdan yazıcıları kullanmak için "Handheld Pro" veya "Handheld Order" lisansı gereklidir.',
    dk:
      'En "Handheld Pro"- eller "Handheld Order"-licens er påkrævet for at bruge printere fra denne enhed.',
  },
  'ClaimLicense.LicenseRequired.Claim': {
    en: 'Would you like to claim a license for this device',
    es: '¿Te gustaría reclamar una licencia para este dispositivo?',
    se: 'Vill du aktivera en licens på den här enheten?',
    no: 'Vil du aktivere en lisens på denne enheten?',
    tr: 'Bu cihaz için bir lisans talep etmek ister misiniz?',
    dk: 'Vil du kræve en licens til denne enhed?',
  },
  'ClaimLicense.LicenseRequired.NoAvailableLicenses': {
    en: 'All previously available licenses have been claimed',
    es: 'Todas las licencias disponibles anteriormente han sido reclamadas',
    se: 'Alla tidigare tillgängliga licenser har aktiverats',
    no: 'Alle tidligere tilgjengelige lisenser har blitt aktivert',
    tr: 'Daha önce mevcut olan tüm lisanslar talep edildi',
    dk: 'Alle tidligere tilgængelige licenser er blevet aktiveret',
  },
  'ClaimLicense.AvailableLicenses': {
    en: (product: string) => `Available ${product} licenses`,
    es: (product: string) => `Licencias de ${product} disponibles`,
    se: (product: string) => `Tillgängliga ${product} licenser`,
    no: (product: string) => `Tilgjengelige ${product} lisenser`,
    tr: (product: string) => `Mevcut ${product} lisansları`,
    dk: (product: string) => `Tilgængelige ${product} licenser`,
  },
  'ClaimLicense.Claim': {
    en: 'Claim license',
    es: 'Reclamar licencia',
    se: 'Aktivera licens',
    no: 'Aktiver lisens',
    tr: 'Lisans talep et',
    dk: 'Krav licens',
  },
  'ClaimLicense.Register.Placeholder': {
    en: 'e.g. pos1',
    es: 'p. ej. pos1',
    se: 't.ex. pos1',
    no: 'f.eks. pos1',
    tr: 'örn. pos1',
    dk: 'f.eks. pos1',
  },
  'ClaimLicense.Error.General': {
    en: 'Something went wrong. Please try again',
    es: 'Algo salió mal. Por favor, inténtalo de nuevo',
    se: 'Något gick fel. Försök igen',
    no: 'Noe gikk galt. Vennligst prøv igjen',
    tr: 'Bir şeyler ters gitti. Lütfen tekrar deneyin',
    dk: 'Noget gik galt. Prøv venligst igen',
  },
  'ClaimLicense.Error.NoOrgNumber': {
    en: 'No "VAT No" has been configured in backoffice for this venue',
    es: 'No se ha configurado ningún NIF en la oficina de backoffice para este local',
    se: 'Inget Organisation ID har konfigurerats i backoffice för denna butik',
    no: 'Ingen organisasjonsnummer er konfigurert i backoffice for denne butikken',
    tr: 'Bu mekan için backoffice’te herhangi bir vergi numarası yapılandırılmamış',
    dk: 'Ingen CVR-nummer er konfigureret i backoffice for denne butik',
  },
  'ClaimLicense.Error.WrongDevice': {
    en: 'This device is not linked to the current venue. Please select a different device',
    es:
      'Este dispositivo no está vinculado al local actual. Por favor, seleccione un dispositivo diferente',
    se: 'Denna enhet är inte kopplad till denna butik. Vänligen välj en annan enhet',
    no: 'Denne enheten er ikke koblet til denne butikken. Vennligst velg en annen enhet',
    tr: 'Bu cihaz mevcut mekana bağlı değil. Lütfen farklı bir cihaz seçin',
    dk: 'Denne enhed er ikke knyttet til denne butik. Vælg venligst en anden enhed',
  },
  'ClaimLicense.Error.NoDeviceId': {
    en: 'No device ID found. Please re-select this device in settings',
    es:
      'No se encontró ID de dispositivo. Vuelva a seleccionar este dispositivo en la configuración',
    se: 'Ingen enhets-ID hittades. Vänligen välj denna enhet på nytt i inställningarna',
    no: 'Ingen enhets-ID ble funnet. Vennligst velg denne enheten på nytt i innstillingene',
    tr: 'Cihaz kimliği bulunamadı. Lütfen ayarlarda bu cihazı yeniden seçin',
    dk: 'Ingen enheds-ID fundet. Vælg venligst denne enhed igen i indstillingerne',
  },
  'BongHistory.Title': {
    en: 'Kitchen ticket history for this device',
    se: 'Historik över köksbongar för denna enhet',
    es: 'Historial de tickets de cocina para este dispositivo',
    no: 'Kjøkkenbonghistorikk for denne enheten',
    tr: 'Mutfak bileti geçmişi bu cihaz için',
    dk: 'Køkkenbillet historik for denne enhed',
  },
  'BongHistory.Mode': {
    en: 'Current settings will result in',
    se: 'Nuvarande inställningar kommer att resultera i',
    es: 'La configuración actual resultará en',
    no: 'Nåværende innstillinger vil resultere i',
    tr: 'Mevcut ayarlar şuna neden olacaktır',
    dk: 'Nuværende indstillinger vil resultere i',
  },
  'BongHistory.NoTickets': {
    en: "Kitchen tickets will appear here when they've been attempted to be printed",
    se: 'Köksbongar visas här när ett utskriftsförsök har gjorts',
    es: 'Los tickets de cocina aparecerán aquí cuando se hayan intentado imprimir',
    no: 'Kjøkkenbonger vil vises her når de har blitt forsøkt skrevet ut',
    tr: 'Mutfak biletleri, yazdırılmaya çalışıldığında burada görünecektir',
    dk: 'Køkkenbilletter vises her, når de er blevet forsøgt udskrevet',
  },
  'BongHistory.PrintsFor': {
    en: (count: number) => `${count} prints attempted for`,
    se: (count: number) => `${count} utskriftsförsök för`,
    es: (count: number) => `${count} intentos de impresión para`,
    no: (count: number) => `${count} utskriftsforsøk for`,
    tr: (count: number) => `${count} yazdırma denemesi içinde`,
    dk: (count: number) => `${count} udskriftsforsøg for`,
  },
  'BongHistory.By': {
    en: (name: string) => `by ${name}`,
    se: (name: string) => `av ${name}`,
    es: (name: string) => `por ${name}`,
    no: (name: string) => `av ${name}`,
    tr: (name: string) => `${name} tarafından`,
    dk: (name: string) => `af ${name}`,
  },
  'BongHistory.Reason.ServiceTypeNotIncluded': {
    en: (serviceType: string) =>
      `This printer's stations do not support the service type: ${serviceType}`,
    se: (serviceType: string) =>
      `Denna skrivares stationer stöder inte servicetypen: ${serviceType}`,
    es: (serviceType: string) =>
      `Las estaciones de esta impresora no admiten el tipo de servicio: ${serviceType}`,
    no: (serviceType: string) =>
      `Denne skriverens stasjoner støtter ikke servicetype: ${serviceType}`,
    tr: (serviceType: string) =>
      `Bu yazıcının istasyonları servis türünü desteklemiyor: ${serviceType}`,
    dk: (serviceType: string) =>
      `Denne printers stationer understøtter ikke servicetypen: ${serviceType}`,
  },
  'BongHistory.Reason.OriginNotIncluded': {
    en: (origin: string) => `This printer's stations do not support the order origin: ${origin}`,
    se: (origin: string) =>
      `Denna skrivares stationer stöder inte beställningsursprunget: ${origin}`,
    es: (origin: string) =>
      `Las estaciones de esta impresora no admiten el origen del pedido: ${origin}`,
    no: (origin: string) =>
      `Denne skriverens stasjoner støtter ikke bestillingsopprinnelse: ${origin}`,
    tr: (origin: string) => `Bu yazıcının istasyonları sipariş kaynağını desteklemiyor: ${origin}`,
    dk: (origin: string) => `Denne printers stationer understøtter ikke ordrekilden: ${origin}`,
  },
  'BongHistory.Reason.NoRelevantItems': {
    en: "None of the selected items were assigned to this printer's stations",
    se: 'Inga av de valda artiklarna var tilldelade till denna skrivares stationer',
    es:
      'Ninguno de los artículos seleccionados estaba asignado a las estaciones de esta impresora',
    no: 'Ingen av de valgte varene var tildelt denne skriverens stasjoner',
    tr: 'Seçilen öğelerin hiçbiri bu yazıcının istasyonlarına atanmadı',
    dk: 'Ingen af de valgte varer var tildelt denne printers stationer',
  },
  'BongHistory.Reason.StationNotExists': {
    en: (station: string) => `The station "${station}" no longer exists (may have been deleted)`,
    se: (station: string) => `Stationen "${station}" finns inte längre (kan ha raderats)`,
    es: (station: string) =>
      `El punto de elaboración"${station}" ya no existe (puede haber sido eliminada)`,
    no: (station: string) => `Stasjonen "${station}" finnes ikke lenger (kan ha blitt slettet)`,
    tr: (station: string) => `"${station}" istasyonu artık mevcut değil (silinmiş olabilir)`,
    dk: (station: string) =>
      `Stationen "${station}" findes ikke længere (kan være blevet slettet)`,
  },
  'BongHistory.Reason.NoCourseTypeItems': {
    en: (courseType: string) =>
      `None of the selected items with course type "${courseType}" are assigned to station`,
    se: (courseType: string) =>
      `Inga av de valda artiklarna med rätt-typ "${courseType}" är tilldelade till
stationen`,
    es: (courseType: string) =>
      `Ninguno de los artículos con tipo de curso "${courseType}" está asignado al punto de elaboración`,
    no: (courseType: string) =>
      `Ingen av de valgte varene med kurstype "${courseType}" er tildelt stasjonen`,
    tr: (courseType: string) =>
      `Kurs tipi "${courseType}" olan öğelerin hiçbiri istasyona atanmadı`,
    dk: (courseType: string) =>
      `Ingen af de valgte varer med kursustype "${courseType}" er tildelt stationen`,
  },
  'BongHistory.Reason.NoCourseTypeItems.NoType': {
    en: `None of the selected items without course type are assigned to station`,
    se: `Inga av de valda artiklarna utan rätt-typ är tilldelade till stationen`,
    es: `Ningún artículo sin tipo de curso está asignado al punto de elaboración`,
    no: `Ingen av de valgte varene uten kurstype er tildelt stasjonen`,
    tr: `Kurs tipi olmayan öğelerin hiçbiri istasyona atanmadı`,
    dk: `Ingen af de valgte varer uden kursustype er tildelt stationen`,
  },
  'BongHistory.Reason.NoCourseTypeItemsAnyStation': {
    en: (courseType: string) =>
      `None of the selected items with course type "${courseType}" were assigned to any of this printer's stations`,
    se: (courseType: string) =>
      `Inga av de valda artiklarna med rätt-typ "${courseType}" var tilldelade till någon av denna skrivares stationer`,
    es: (courseType: string) =>
      `Ningún artículo con tipo de curso "${courseType}" está asignado a ninguna de las estaciones de esta impresora`,
    no: (courseType: string) =>
      `Ingen av de valgte varene med kurstype "${courseType}" var tildelt noen av denne skriverens stasjoner`,
    tr: (courseType: string) =>
      `Kurs tipi "${courseType}" olan öğelerin hiçbiri bu yazıcının istasyonlarından hiçbirine atanmadı`,
    dk: (courseType: string) =>
      `Ingen af de valgte varer med kursustype "${courseType}" var tildelt nogen af denne printers stationer`,
  },
  'BongHistory.Reason.NoCourseTypeItemsAnyStation.NoType': {
    en: `None of the selected items without course type were assigned to any of this printer's stations`,
    se: `Inga av de valda artiklarna utan rätt-typ var tilldelade till någon av denna skrivares stationer`,
    es: `Ningún artículo sin tipo de curso está asignado a ninguna de las estaciones de esta impresora`,
    no: `Ingen av de valgte varene uten kurstype var tildelt noen av denne skriverens stasjoner`,
    tr: `Kurs tipi olmayan öğelerin hiçbiri bu yazıcının istasyonlarından hiçbirine atanmadı`,
    dk: `Ingen af de valgte varer uden kursustype var tildelt nogen af denne printers stationer`,
  },
  'BongHistory.Reason.NoItemsForStation': {
    en: (station: string) => `None of the selected items are assigned to station "${station}"`,
    se: (station: string) => `Inga av de valda artiklarna är tilldelade till station "${station}"`,
    es: (station: string) =>
      `Ninguno de los artículos está asignado al punto de elaboración "${station}"`,
    no: (station: string) => `Ingen av de valgte varene er tildelt stasjon "${station}"`,
    tr: (station: string) => `Seçilen öğelerin hiçbiri "${station}" istasyonuna atanmadı`,
    dk: (station: string) => `Ingen af de valgte varer er tildelt station "${station}"`,
  },
  'BongHistory.Reason.PrintedCourseTypeStation': {
    en: (courseType: string) =>
      `Printing was attempted for items with course type "${courseType}" on station`,
    se: (courseType: string) =>
      `Försökte skriva ut artiklar med rätt-typ "${courseType}" på station`,
    es: (courseType: string) =>
      `Se intentó imprimir artículos con tipo de curso "${courseType}" en el punto de elaboración`,
    no: (courseType: string) =>
      `Forsøkte å skrive ut varer med kurstype "${courseType}" på stasjon`,
    tr: (courseType: string) =>
      `Kurs tipi "${courseType}" olan öğelerin yazdırılması denendi istasyonda`,
    dk: (courseType: string) =>
      `Der blev forsøgt at udskrive varer med kursustype "${courseType}" på station`,
  },
  'BongHistory.Reason.PrintedCourseTypeStation.NoType': {
    en: `Printing was attempted for the selected items without course type on station`,
    se: `Försökte skriva ut de valda artiklarna utan rätt-typ på station`,
    es: `Se intentó imprimir los artículos seleccionados sin tipo de curso en el punto de elaboración`,
    no: `Forsøkte å skrive ut de valgte varene uten kurstype på stasjon`,
    tr: `Kurs tipi olmayan seçilen öğelerin yazdırılması denendi istasyonda`,
    dk: `Der blev forsøgt at udskrive de valgte varer uden kursustype på station`,
  },
  'BongHistory.Reason.PrintedCourseType': {
    en: (courseType: string) =>
      `Printing was attempted for items with course type "${courseType}"`,
    se: (courseType: string) => `Försökte skriva ut artiklar med rätt-typ "${courseType}"`,
    es: (courseType: string) => `Se intentó imprimir artículos con tipo de curso "${courseType}"`,
    no: (courseType: string) => `Forsøkte å skrive ut varer med kurstype "${courseType}"`,
    tr: (courseType: string) => `Kurs tipi "${courseType}" olan öğelerin yazdırılması denendi`,
    dk: (courseType: string) =>
      `Der blev forsøgt at udskrive varer med kursustype "${courseType}"`,
  },
  'BongHistory.Reason.PrintedCourseType.NoType': {
    en: `Printing was attempted for items without course type`,
    se: `Försökte skriva ut artiklar utan rätt-typ`,
    es: `Se intentó imprimir artículos sin tipo de curso`,
    no: `Forsøkte å skrive ut varer uten kurstype`,
    tr: `Kurs tipi olmayan öğelerin yazdırılması denendi`,
    dk: `Der blev forsøgt at udskrive varer uden kursustype`,
  },
  'BongHistory.Reason.PrintedStation': {
    en: (station: string) => `Printing was attempted for items on station "${station}"`,
    se: (station: string) => `Försökte skriva ut artiklar på station "${station}"`,
    es: (station: string) =>
      `Se intentó imprimir artículos en el punto de elaboración "${station}"`,
    no: (station: string) => `Forsøkte å skrive ut varer på stasjon "${station}"`,
    tr: (station: string) => `"${station}" istasyonundaki öğelerin yazdırılması denendi`,
    dk: (station: string) => `Der blev forsøgt at udskrive varer på station "${station}"`,
  },
  'BongHistory.Reason.PrintedCombined': {
    en: 'Printing was attempted for items on all stations combined',
    se: 'Försökte skriva ut artiklar på alla stationer kombinerat',
    es: 'Se intentó imprimir artículos en todas las estaciones combinadas',
    no: 'Forsøkte å skrive ut varer på alle stasjoner kombinert',
    tr: 'Tüm istasyonlardaki öğelerin yazdırılması denendi',
    dk: 'Der blev forsøgt at udskrive varer på alle stationer kombineret',
  },
  'BongHistory.GROUP_BY_STATION_AND_PRINT_BY_STATION': {
    en: 'Print a separate kitchen ticket for each course type at each printer station',
    se: 'Skriv ut en separat köksbong för varje rätt-typ vid varje station',
    es:
      'Imprimir un ticket de cocina separado por cada tipo de curso en cada punto de elaboración de impresora',
    no: 'Skriv ut en separat kjøkkenslipp for hver kurstype på hver stasjon',
    tr: 'Her yazıcı istasyonunda her kurs tipi için ayrı bir mutfak fişi yazdır',
    dk: 'Udskriv en separat køkkenbillet for hver kursustype på hver station',
  },
  'BongHistory.GROUP_BY_STATION_ONLY': {
    en: 'Group all printer stations and print a separate kitchen ticket for each course type',
    se: 'Gruppera alla stationer och skriv ut en separat köksbong för varje rätt-typ',
    es:
      'Agrupar todas las estaciones de impresora e imprimir un ticket de cocina separado por cada tipo de curso',
    no: 'Grupper alle stasjoner og skriv ut en separat kjøkkenslipp for hver kurstype',
    tr: 'Tüm yazıcı istasyonlarını grupla ve her kurs tipi için ayrı bir mutfak fişi yazdır',
    dk: 'Grupper alle stationer og udskriv en separat køkkenbillet for hver kursustype',
  },
  'BongHistory.PRINT_BY_STATION_ONLY': {
    en: 'Print one kitchen ticket per printer station',
    se: 'Skriv ut en köksbong per station',
    es: 'Imprimir un ticket de cocina por punto de elaboración de impresora',
    no: 'Skriv ut en kjøkkenslipp per stasjon',
    tr: 'Her yazıcı istasyonu için tek bir mutfak fişi yazdır',
    dk: 'Udskriv en køkkenbillet pr. station',
  },
  'BongHistory.DEFAULT_COMBINED': {
    en: 'Print one kitchen ticket with all printer stations combined',
    se: 'Skriv ut en köksbong med alla stationer kombinerade',
    es: 'Imprimir un ticket de cocina con todas las estaciones de impresora combinadas',
    no: 'Skriv ut en kjøkkenslipp med alle stasjoner kombinert',
    tr: 'Tüm yazıcı istasyonlarını birleştirerek tek bir mutfak fişi yazdır',
    dk: 'Udskriv en køkkenbillet med alle stationer kombineret',
  },
  'Transactions.MethodIdentifier.Search': {
    en: 'Last 4 digits of card number',
    es: 'Últimos 4 dígitos',
    se: 'Sista 4 siffror i kortnummret',
    no: 'Siste 4 siffer i kortnummer',
    tr: 'Son 4 hanesi kart numarasının',
    dk: 'Sidste 4 cifre i kortnummer',
  },
  'Transactions.ClearFilter': {
    en: 'Clear filter',
    es: 'Limpiar filtro',
    se: 'Rensa filter',
    no: 'Fjern filter',
    tr: 'Filtreyi temizle',
    dk: 'Ryd filter',
  },
  'Transactions.CreatedAt': {
    en: 'Created at',
    es: 'Creado el',
    se: 'Skapad',
    no: 'Opprettet',
    tr: 'Oluşturulma tarihi',
    dk: 'Oprettet',
  },
  'Transactions.Amount': {
    en: 'Amount',
    es: 'Cantidad',
    se: 'Belopp',
    no: 'Beløp',
    tr: 'Tutar',
    dk: 'Beløb',
  },
  'Transactions.Card': {
    en: 'Card',
    es: 'Tarjeta',
    se: 'Kort',
    no: 'Kort',
    tr: 'Kart',
    dk: 'Kort',
  },
  'Transactions.Ref': {
    en: 'Reference',
    es: 'Referencia',
    se: 'Referens',
    no: 'Referanse',
    tr: 'Referans',
    dk: 'Reference',
  },
  'Transactions.Type': {
    en: 'Type',
    es: 'Tipo',
    se: 'Typ',
    no: 'Type',
    tr: 'Tür',
    dk: 'Type',
  },
  'Transactions.purchase': {
    en: 'Purchase',
    es: 'Compra',
    se: 'Köp',
    no: 'Kjøp',
    tr: 'Alışveriş',
    dk: 'Køb',
  },
  'Transactions.refund': {
    en: 'Refund',
    es: 'Reembolso',
    se: 'Återbetalning',
    no: 'Refusjon',
    tr: 'İade',
    dk: 'Refusion',
  },
  'Transactions.refusal': {
    en: 'Refusal',
    es: 'Rechazo',
    se: 'Avslag',
    no: 'Avslag',
    tr: 'Reddedildi',
    dk: 'Afslag',
  },
  'Transactions.unknown': {
    en: 'Unknown',
    es: 'Desconocido',
    se: 'Okänd',
    no: 'Ukjent',
    tr: 'Bilinmiyor',
    dk: 'Ukendt',
  },
  'Transactions.online': {
    en: 'Online ordering',
    es: 'Pedido en línea',
    se: 'Onlinebeställning',
    no: 'Nettbestilling',
    tr: 'Çevrimiçi sipariş',
    dk: 'Online bestilling',
  },
  'Transactions.incoming': {
    en: 'Incoming',
    es: 'Entrante',
    se: 'Inkommande',
    no: 'Innkommende',
    tr: 'Gelen',
    dk: 'Indgående',
  },
  'Transactions.Reload': {
    en: 'Reload',
    es: 'Recargar',
    se: 'Ladda om',
    no: 'Last inn',
    tr: 'Yükle',
    dk: 'Genindlæs',
  },
  'FromToInput.SearchPlaceholder': {
    en: 'Search amount',
    es: 'Buscar cantidad',
    se: 'Sök belopp',
    no: 'Søk beløp',
    tr: 'Tutar ara',
    dk: 'Søg beløb',
  },
  'FromToInput.From': {
    en: 'From',
    es: 'Desde',
    se: 'Från',
    no: 'Fra',
    tr: 'Başlangıç',
    dk: 'Fra',
  },
  'FromToInput.To': {
    en: 'To',
    es: 'Hasta',
    se: 'Till',
    no: 'Til',
    tr: 'Bitiş',
    dk: 'Til',
  },
  'SplitPayment.Title': {
    en: 'Split payment',
    es: 'Pago dividido',
    se: 'Delad betalning',
    no: 'Delt betaling',
    tr: 'Bölünmüş ödeme',
    dk: 'Delt betaling',
  },
  'SplitPayment.Desc': {
    en: 'Select payment method',
    es: 'Selecciona el método de pago',
    se: 'Välj betalningsmetod',
    no: 'Velg betalingsmetode',
    tr: 'Ödeme yöntemini seçin',
    dk: 'Vælg betalingsmetode',
  },
  'SplitPayment.Desc.Next': {
    en: 'Select next payment method',
    es: 'Selecciona el siguiente método de pago',
    se: 'Välj nästa betalningsmetod',
    no: 'Velg neste betalingsmetode',
    tr: 'Sonraki ödeme yöntemini seçin',
    dk: 'Vælg næste betalingsmetode',
  },
  'SplitPayment.RefundAndCancel': {
    en: 'Refund and cancel',
    es: 'Reembolsar y cancelar',
    se: 'Återbetala och avbryt',
    no: 'Refunder og avbryt',
    tr: 'İade et ve iptal et',
    dk: 'Refunder og annullér',
  },
  'SplitPayment.OriginalTotal': {
    en: 'Original amount',
    es: 'Importe original',
    se: 'Ursprunglig summa',
    no: 'Opprinnelig beløp',
    tr: 'Orijinal tutar',
    dk: 'Oprindeligt beløb',
  },
  'SplitPayment.Remaining': {
    en: 'Remaining amount',
    es: 'Cantidad restante',
    se: 'Återstående belopp',
    no: 'Gjenstående beløp',
    tr: 'Kalan tutar',
    dk: 'Resterende beløb',
  },
  'SplitPayment.AlreadyPaid': {
    en: 'Already paid',
    es: 'Ya pagado',
    se: 'Redan betalat',
    no: 'Allerede betalt',
    tr: 'Zaten ödendi',
    dk: 'Allerede betalt',
  },
  'SplitPayment.Refund.Title': {
    en: 'Refund and cancel',
    es: 'Reembolsar y cancelar',
    se: 'Återbetala och avbryt',
    no: 'Refunder og avbryt',
    tr: 'İade et ve iptal et',
    dk: 'Refunder og annullér',
  },
  'SplitPayment.Refund.Desc': {
    en:
      'Once a split payment has started, it must be completed in full — it can’t be left unfinished after one payment.',
    es:
      'Una vez que se ha iniciado un pago dividido, debe completarse en su totalidad; no se puede dejar sin terminar después de un pago.',
    se:
      'När en delad betalning har påbörjats måste den slutföras i sin helhet – den kan inte lämnas ofullständig efter en betalning.',
    no:
      'Når en delt betaling har startet, må den fullføres i sin helhet - den kan ikke etterlates ufullstendig etter en betaling.',
    tr:
      'Bir bölünmüş ödeme başlatıldığında, tamamen tamamlanması gerekir - bir ödemenin ardından tamamlanmamış bırakılamaz.',
    dk:
      'Når en delt betaling er startet, skal den fuldføres i sin helhed - den kan ikke efterlades ufuldstændig efter en betaling.',
  },
  'SplitPayment.SelectAmount': {
    en: 'Enter partial amount to pay',
    es: 'Ingrese el monto parcial a pagar',
    se: 'Ange delbelopp att betala',
    no: 'Angi delbeløp som skal betales',
    tr: 'Ödenecek kısmi tutarı girin',
    dk: 'Indtast delbeløb til betaling',
  },
  'DidYouKnow.Title': {
    en: 'Did you know',
    es: '¿Sabías que',
    se: 'Visste du att',
    no: 'Visste du at',
    tr: 'Biliyor muydunuz',
    dk: 'Vidste du',
  },
  'DidYouKnow.Finance.ScheduledReports': {
    en:
      'You can receive sales reports daily, weekly, or monthly, delivered straight to your inbox.',
    es:
      'Puedes recibir informes de ventas diarios, semanales o mensuales, entregados directamente en tu bandeja de entrada.',
    se:
      'Du kan få försäljningsrapporter dagligen, veckovis eller månadsvis skickat till din e-post.',
    no:
      'Du kan motta salgsrapporter daglig, ukentlig eller månedlig, levert direkte til innboksen din.',
    tr:
      'Satış raporlarını günlük, haftalık veya aylık olarak alabilir ve doğrudan gelen kutunuza teslim edebilirsiniz.',
    dk:
      'Du kan modtage salgsrapporter dagligt, ugentligt eller månedligt, leveret direkte til din indbakke.',
  },
  'DidYouKnow.Finance.Loans': {
    en: 'You can get quick and affordable loans right in our back-office.',
    es:
      'Puedes obtener préstamos rápidos y asequibles directamente desde nuestra oficina administrativa.',
    se: 'Du kan få snabba och prisvärda lån direkt i backoffice.',
    no: 'Du kan få raske og rimelige lån direkte i vårt backoffice.',
    tr: 'Back-office üzerinden hızlı ve uygun krediler alabilirsiniz.',
    dk: 'Du kan få hurtige og overkommelige lån direkte i backoffice.',
  },
  'DidYouKnow.QSR.MultiQSR': {
    en: 'You can process payments for multiple orders at the same time with Multi-QSR.',
    es: 'Puedes procesar pagos de varias órdenes al mismo tidomed Multi-QSR.',
    se: 'Du kan hantera betalningar för flera beställningar samtidigt med Multi-QSR.',
    no: 'Du kan behandle betalinger for flere bestillinger samtidig med Multi-QSR.',
    tr: 'Multi-QSR ile aynı anda birden fazla siparişin ödemesini gerçekleştirebilirsiniz.',
    dk: 'Du kan behandle betalinger for flere ordrer samtidig med Multi-QSR.',
  },
  'DidYouKnow.QSR.ParkedOrders': {
    en: 'You can park orders so customers can pay later when they are ready.',
    es:
      'Puedes poner órdenes en espera para que los clientes paguen más tarde cuando estén listos.',
    se: 'Du kan parkera beställningar så att kunder kan betala senare när de är redo.',
    no: 'Du kan parkere ordre slik at kunder kan betale senere når de er klare.',
    tr: 'Müşteriler hazır olduğunda ödemelerini yapabilmesi için siparişleri bekletebilirsiniz.',
    dk: 'Du kan parkere ordrer, så kunder kan betale senere, når de er klar.',
  },
  'DidYouKnow.QSR.PreviewProduct': {
    en: 'You can press and hold on a product button to preview its image and description.',
    es:
      'Puedes presionar y mantener presionado un botón de producto para ver su imagen y descripción.',
    se:
      'Du kan trycka och hålla ned en produktknapp för att förhandsgranska bild och beskrivning.',
    no: 'Du kan trykke og holde nede en produktknapp for å forhåndsvise bilde og beskrivelse.',
    tr: 'Bir ürün butonuna basılı tutarak resmini ve açıklamasını önizleyebilirsiniz.',
    dk: 'Du kan trykke og holde på en produktknap for at se billedet og beskrivelsen.',
  },
  'DidYouKnow.QSR.Beepers': {
    en: 'You can set up beepers in backoffice to use instead of Easy IDs (e.g., #123).',
    es:
      'Puedes configurar beepers en el backoffice para usarlos en lugar de Easy IDs (por ejemplo, #123).',
    se: 'Du kan lägga till puckar i backoffice som ett alternativ till Easy IDs (t.ex. #123).',
    no: 'Du kan sette opp beepers i backoffice som et alternativ til Easy IDs (f.eks. #123).',
    tr:
      'Easy ID’ler (ör. #123) yerine kullanmak için backoffice üzerinden beeper ayarlayabilirsiniz.',
    dk: 'Du kan opsætte beepers i backoffice som et alternativ til Easy IDs (f.eks. #123).',
  },
  'DidYouKnow.QSR.ModificationGroupsGrid': {
    en:
      'Modification groups can be viewed in a grid, perfect for 10+ variations to avoid vertical scrolling.',
    es:
      'Los grupos de modificaciones se pueden ver en una cuadrícula, perfecto para más de 10 variaciones y evitar el desplazamiento vertical.',
    se:
      'Tillvalsgrupper kan visas i ett rutnät istället vilket är perfekt för 10+ variationer för att undvika att scrolla.',
    no:
      'Tillvalgrupper kan vises i et rutenett, perfekt for 10+ varianter for å unngå vertikal rulling.',
    tr:
      '10’dan fazla varyasyon için dikey kaydırmayı önlemek amacıyla, modifikasyon grupları ızgarada görüntülenebilir.',
    dk:
      'Modifikationsgrupper kan vises i et gitter, perfekt til 10+ variationer for at undgå lodret rulning.',
  },
  'DidYouKnow.QSR.BongHistory': {
    en: 'You can click the printer button in POS/KDS to check why a kitchen ticket didn’t print.',
    es:
      'Puedes hacer clic en el botón de impresora en POS/KDS para verificar por qué no se imprimió un ticket de cocina.',
    se: 'Du kan klicka på printerknappen i POS/KDS för att se varför en köksbong inte printade.',
    no:
      'Du kan klikke på printerknappen i POS/KDS for å sjekke hvorfor en kjøkkebong ikke ble skrevet ut.',
    tr:
      'POS/KDS’de yazıcı düğmesine tıklayarak mutfak fişinin neden yazdırılmadığını kontrol edebilirsiniz.',
    dk:
      'Du kan klikke på printerknappen i POS/KDS for at tjekke, hvorfor en køkkenbon ikke blev printet.',
  },
  'DidYouKnow.QSR.CustomName': {
    en:
      'You can configure to enter a custom name for a product, and it will appear in reports. Great for short-lived (seasonal) items.',
    es:
      'Puedes configurar un nombre personalizado para un producto, y aparecerá en los informes. Perfecto para productos de corta duración (temporales).',
    se:
      'Du kan ange ett eget namn för en produkt när du lägger till den, och det kommer att synas i rapporterna. Perfekt för säsongsprodukter eller öppna viner, till exempel.',
    no:
      'Du kan angi et eget navn for et produkt når du legger det til, og det vil vises i rapportene. Flott for kortvarige produkter eller åpne viner, for eksempel.',
    tr:
      'Bir ürünü eklerken özel bir isim girebilirsiniz ve bu isim raporlarda görünecektir. Kısa ömürlü ürünler veya açık şaraplar için idealdir.',
    dk:
      'Du kan angive et brugerdefineret navn for et produkt, når du tilføjer det, og det vil blive vist i rapporterne. Perfekt til kortvarige produkter eller åbne vine, for eksempel.',
  },
  'DidYouKnow.TSR.TableLayout': {
    en: 'You can customize your table layout with different shapes and sizes of tables.',
    es: 'Puedes personalizar el diseño de tu mesa con diferentes formas y tamaños de mesas.',
    se: 'Du kan redigera dina bord med olika former och storlekar.',
    no: 'Du kan tilpasse bordoppsettet ditt med forskjellige former og størrelser på bord.',
    tr: 'Farklı şekil ve boyutlarda masalarla masa düzeninizi özelleştirebilirsiniz.',
    dk: 'Du kan tilpasse dit bordlayout med forskellige former og størrelser på borde.',
  },
  'DidYouKnow.TSR.SplitBills': {
    en: 'You can split bills between multiple cards or payment methods.',
    es: 'Puedes dividir las cuentas entre varias tarjetas o métodos de pago.',
    se: 'Du kan dela upp notan mellan flera kort eller betalningsmetoder.',
    no: 'Du kan dele regninger mellom flere kort eller betalingsmetoder.',
    tr: 'Hesapları birden fazla kart veya ödeme yöntemi arasında bölebilirsiniz.',
    dk: 'Du kan dele regninger mellem flere kort eller betalingsmetoder.',
  },
  'DidYouKnow.TSR.ActivityColoring': {
    en:
      'The table that has had no activity for the longest time is red, and the second most inactive table is yellow. A good table to check if you don’t know what to do.',
    es:
      'La mesa que no ha tenido actividad durante más tiempo es roja, y la segunda mesa más inactiva es amarilla. Una buena mesa para revisar si no sabes qué hacer.',
    se:
      'Bordet som inte haft någon aktivitet längst tid är rött, och det näst mest inaktiva bordet är gult. Ett bra bord att kolla in om du inte vet vad du ska göra.',
    no:
      'Bordet som ikke har hatt aktivitet lengst tid er rødt, og det nest mest inaktive bordet er gult. Et bra bord å sjekke innom hvis du ikke vet hva du skal gjøre.',
    tr:
      'En uzun süredir etkinlik olmayan masa kırmızıdır ve ikinci en az aktif masa sarıdır. Ne yapacağınızı bilmiyorsanız kontrol etmek için iyi bir masadır.',
    dk:
      'Bordet, der ikke har haft aktivitet længst tid, er rødt, og det næstmest inaktive bord er gult. Et godt bord at tjekke, hvis du ikke ved, hvad du skal gøre.',
  },
  'DidYouKnow.OnlineOrdering.ScanQR': {
    en: 'You can let customers scan QR codes on tables to order.',
    es: 'Puedes permitir que los clientes escaneen códigos QR en las mesas para hacer pedidos.',
    se: 'Du kan låta kunder skanna QR-koder på bord för att beställa.',
    no: 'Du kan la kunder skanne QR-koder på bord for å bestille.',
    tr:
      'Müşterilerin sipariş vermesi için masalardaki QR kodlarını taramasına izin verebilirsiniz.',
    dk: 'Du kan lade kunder scanne QR-koder på borde for at bestille.',
  },
  'DidYouKnow.OnlineOrdering.Shop': {
    en:
      'You can run an online shop and offer membership discounts as well as digital stamp cards.',
    es:
      'Puedes gestionar una tienda online y ofrecer descuentos por membresía, así como tarjetas de fidelización digitales.',
    se: 'Du kan driva en onlinebutik och erbjuda medlemsrabatter samt digitala stämpelkort.',
    no: 'Du kan drive en nettbutikk og tilby medlemsrabatter samt digitale stempelkort.',
    tr:
      'Bir çevrimiçi mağaza işletebilir ve üyelik indirimleri ile dijital kartlar sunabilirsiniz.',
    dk: 'Du kan drive en online butik og tilby medlemsrabatter samt digitale stempelkort.',
  },
  'DidYouKnow.OnlineOrdering.Codes': {
    en: 'You can run promo codes, memberships, and digital stamp cards to reward loyalty.',
    es:
      'Puedes gestionar códigos promocionales, membresías y tarjetas de fidelización digitales para recompensar la lealtad.',
    se:
      'Du kan hantera kampanjkoder, medlemskap och digitala stämpelkort för att belöna lojalitet.',
    no:
      'Du kan administrere kampanjekoder, medlemskap og digitale stempelkort for å belønne lojalitet.',
    tr:
      'Sadakati ödüllendirmek için promosyon kodları, üyelikler ve dijital kartlar yönetebilirsiniz.',
    dk:
      'Du kan administrere kampagnekoder, medlemskaber og digitale stempelkort for at belønne loyalitet.',
  },
  'DidYouKnow.OnlineOrdering.Segments': {
    en: 'You can segment customers by visit frequency or spending and send targeted offers.',
    es:
      'Puedes segmentar a los clientes según la frecuencia de visitas o el gasto y enviar ofertas personalizadas.',
    se:
      'Du kan segmentera kunder efter besöksfrekvens eller köpvanor och skicka riktade erbjudanden.',
    no:
      'Du kan segmentere kunder etter besøksfrekvens eller kjøpsvaner og sende målrettede tilbud.',
    tr:
      'Müşterileri ziyaret sıklığı veya harcama alışkanlıklarına göre segmentleyebilir ve hedeflenmiş teklifler gönderebilirsiniz.',
    dk:
      'Du kan segmentere kunder efter besøgsfrekvens eller købsadfærd og sende målrettede tilbud.',
  },
  'DidYouKnow.KDS.GreenVariations': {
    en:
      'You can turn on a KDS setting to highlight added variations with green text and a + prefix.',
    es:
      'Puedes activar una configuración de KDS para resaltar las variaciones añadidas con texto verde y un prefijo +.',
    se:
      'Du kan aktivera en KDS-inställning för att markera tillagda tillval med grön text och ett + prefix.',
    no:
      'Du kan aktivere en KDS-innstilling for å markere tillegg med grønn tekst og et + prefiks.',
    tr:
      'Eklenen varyasyonları yeşil metin ve + öneki ile vurgulamak için bir KDS ayarını açabilirsiniz.',
    dk:
      'Du kan aktivere en KDS-indstilling for at fremhæve tilføjede variationer med grøn tekst og et + præfiks.',
  },
  'DidYouKnow.Settings.AutomaticEODCash': {
    en: 'You can automate end-of-day closings for cash.',
    es: 'Puedes automatizar los cierres de fin de día para efectivo.',
    se: 'Du kan automatisera dagsavslut för kontanter.',
    no: 'Du kan automatisere dagsavslutninger for kontanter.',
    tr: 'Nakit için gün sonu kapanışlarını otomatikleştirebilirsiniz.',
    dk: 'Du kan automatisere dagsafslutninger for kontanter.',
  },
  'DidYouKnow.Settings.Receipts': {
    en: 'You can add custom messages at the top and bottom of receipts.',
    es: 'Puedes agregar mensajes personalizados en la parte superior e inferior de los recibos.',
    se: 'Du kan lägga till anpassade meddelanden högst upp och längst ner på kvitton.',
    no: 'Du kan legge til egendefinerte meldinger øverst og nederst på kvitteringer.',
    tr: 'Makbuzların üstüne ve altına özel mesajlar ekleyebilirsiniz.',
    dk: 'Du kan tilføje brugerdefinerede beskeder øverst og nederst på kvitteringer.',
  },
  'DidYouKnow.Settings.TimeBasedPricing': {
    en: 'You can set happy-hour or time‑based pricing that turns on and off automatically.',
    es:
      'Puedes establecer precios de happy hour o basados en el tiempo que se activan y desactivan automáticamente.',
    se:
      'Du kan ställa in happy hour eller tidsbaserad prissättning som slås på och av automatiskt.',
    no: 'Du kan sette opp happy hour eller tidsbasert prising som slås på og av automatisk.',
    tr:
      'Otomatik olarak açılıp kapanan mutlu saat veya zamana dayalı fiyatlandırma ayarlayabilirsiniz.',
    dk:
      'Du kan indstille happy hour eller tidsbaseret prisfastsættelse, der tænder og slukker automatisk.',
  },
  'DidYouKnow.Settings.LayoutButtons': {
    en: 'You can enable images and/or prices on buttons in the POS layout settings.',
    es:
      'Puedes habilitar imágenes y/o precios en los botones desde la configuración del diseño del POS.',
    se: 'Du kan aktivera bilder och/eller priser på knappar i POS-layoutinställningarna.',
    no: 'Du kan aktivere bilder og/eller priser på knapper i POS-layoutinnstillingene.',
    tr: 'POS düzeni ayarlarından düğmelerde görselleri ve/veya fiyatları etkinleştirebilirsiniz.',
    dk: 'Du kan aktivere billeder og/eller priser på knapper i POS-layoutindstillingerne.',
  },
  'DidYouKnow.Integrations.Deliverect': {
    en: 'You can integrate Baemingo with Deliverect to offer your menu on delivery platforms.',
    es: 'Puedes integrar Baemingo con Deliverect para ofrecer tu menú en plataformas de entrega.',
    se:
      'Du kan integrera Baemingo med Deliverect för att erbjuda din meny på leveransplattformar.',
    no: 'Du kan integrere Baemingo med Deliverect for å tilby menyen din på leveringsplattformer.',
    tr:
      'Baemingo’yu Deliverect ile entegre ederek menünüzü teslimat platformlarında sunabilirsiniz.',
    dk: 'Du kan integrere Baemingo med Deliverect for at tilbyde din menu på leveringsplatforme.',
  },
  'DidYouKnow.EPOS.LimitServiceType': {
    en: 'You can limit your self service kiosk to only allow eat here or take away.',
    es: 'Puedes limitar tu quiosco de autoservicio para permitir solo comer aquí o para llevar.',
    se: 'Du kan begränsa din expresskassa till att endast tillåta äta här eller ta med.',
    no: 'Du kan begrense din selvbetjente kiosk til kun å tillate spising her eller ta med.',
    tr:
      'Self-servis kioskınızı sadece burada yemek yeme veya paket servis ile sınırlayabilirsiniz.',
    dk: 'Du kan begrænse din selvbetjeningskiosk til kun at tillade spisning her eller take away.',
  },
  'DidYouKnow.Other.StaffCompetitions': {
    en: 'You can create staff competitions to increase engagement and make work more fun.',
    es:
      'Puedes crear competiciones para el personal para aumentar la participación y hacer que el trabajo sea más divertido.',
    se: 'Du kan skapa personaltävlingar för att öka engagemanget och göra arbetet roligare.',
    no: 'Du kan lage konkurranser for ansatte for å øke engasjementet og gjøre jobben morsommere.',
    tr:
      'Çalışanların katılımını artırmak ve işi daha eğlenceli hale getirmek için personel yarışmaları oluşturabilirsiniz.',
    dk: 'Du kan oprette personale konkurrencer for at øge engagementet og gøre arbejdet sjovere.',
  },
  'DidYouKnow.Other.StaffCompetitionsFirstPlace': {
    en: 'When a staff member takes first place in the competition, confetti is triggered. 🎊',
    es:
      'Cuando un miembro del personal ocupa el primer lugar en la competición, se lanza confeti. 🎊',
    se: 'När en medarbetare tar första plats i en personaltävling firas det med konfetti. 🎊',
    no: 'Når en medarbeider tar førsteplass i en personalkonkurranse, slippes konfetti. 🎊',
    tr: 'Bir çalışan yarışmada birinci olduğunda konfeti atılır. 🎊',
    dk: 'Når en medarbejder tager førstepladsen i konkurrencen, fyres konfetti af. 🎊',
  },
  'DidYouKnow.Others.OrganizationLogin': {
    en:
      'You can use one backoffice login for multiple companies, contact us and we’ll set it up for you.',
    es:
      'Puedes usar un inicio de sesión de backoffice para varias empresas, contáctanos y lo configuraremos para ti.',
    se:
      'Du kan använda en inloggning för backoffice för flera företag, kontakta oss så ordnar vi det åt dig.',
    no:
      'Du kan bruke én backoffice-pålogging for flere selskaper, kontakt oss så ordner vi det for deg.',
    tr:
      'Birden fazla şirket için tek bir back-office girişi kullanabilirsiniz, bizimle iletişime geçin ve sizin için ayarlayalım.',
    dk:
      'Du kan bruge én backoffice-login til flere virksomheder, kontakt os, så sætter vi det op for dig.',
  },
  'DidYouKnow.Other.WasteManagement': {
    en: 'We have support for waste and food cost reports to help you control your costs.',
    es:
      'Contamos con informes de desperdicio y costes de alimentos para ayudarte a controlar tus gastos.',
    se:
      'Vi har stöd för svinn- och råvarukostnadsrapporter som hjälper dig hålla kostnaderna nere.',
    no:
      'Vi har støtte for svinn- og råvarekostnadsrapporter som hjelper deg med å kontrollere kostnadene.',
    tr:
      'Maliyetlerinizi kontrol etmenize yardımcı olacak atık ve gıda maliyeti raporları desteğimiz vardır.',
    dk:
      'Vi har støtte til spild- og råvareomkostningsrapporter, så du kan holde styr på dine omkostninger.',
  },
  'EnterSelfServiceKiosk.Title': {
    en: 'Switch to self-service kiosk mode?',
    es: '¿Cambiar al modo quiosco de autoservicio?',
    se: 'Byt till expresskassa-läge?',
    no: 'Bytt til selvbetjent kioskmodus?',
    tr: 'Self-servis kiosk moduna geçilsin mi?',
    dk: 'Skift til selvbetjeningskiosk-tilstand?',
  },
  'EnterSelfServiceKiosk.Desc': {
    en: 'To return here, tap the top left corner 5 times, then enter code 1111.',
    es: 'Para volver, toca la esquina superior izquierda 5 veces y luego ingresa el código 1111.',
    se:
      'Återvänd hit genom att trycka fem gånger i det övre vänstra hörnet och sedan ange koden 1111.',
    no:
      'For å komme tilbake hit, trykk fem ganger i øvre venstre hjørne og skriv deretter inn koden 1111.',
    tr: 'Buraya dönmek için sol üst köşeye 5 kez dokunun ve ardından 1111 kodunu girin.',
    dk:
      'For at vende tilbage hertil, tryk fem gange i øverste venstre hjørne og indtast derefter koden 1111.',
  },
  'Venues.Error': {
    en: 'An error occurred while fetching data, press the retry button',
    es: 'Se produjo un error al obtener los datos, presiona el botón de reintentar',
    se: 'Ett fel uppstod vid hämtning av data, tryck på knappen för att försöka igen',
    no: 'Det oppstod en feil under henting av data, trykk på prøv igjen-knappen',
    tr: 'Veriler alınırken bir hata oluştu, yeniden dene düğmesine basın',
    dk: 'Der opstod en fejl under hentning af data, tryk på prøv igen-knappen',
  },
  'CustomerForCheckout.Member': {
    en: 'Member',
    es: 'Miembro',
    se: 'Medlem',
    no: 'Medlem',
    tr: 'Üye',
    dk: 'Medlem',
  },
  'CustomerForCheckout.CustomerType': {
    en: 'Customer type',
    es: 'Tipo de cliente',
    se: 'Kundtyp',
    no: 'Kundetype',
    tr: 'Müşteri tipi',
    dk: 'Kundetype',
  },
  'CustomerForCheckout.CustomerType.Private': {
    en: 'Private individual',
    es: 'Particular',
    se: 'Privatperson',
    no: 'Privatperson',
    tr: 'Bireysel müşteri',
    dk: 'Privatperson',
  },
  'CustomerForCheckout.CreateAndSelect': {
    en: 'Create and select',
    es: 'Crear y seleccionar',
    se: 'Skapa och välj',
    no: 'Opprett og velg',
    tr: 'Oluştur ve seç',
    dk: 'Opret og vælg',
  },
  'CustomerForCheckout.CreateNewCustomer': {
    en: 'Create new',
    es: 'Crear nuevo',
    se: 'Skapa ny',
    no: 'Opprett ny',
    tr: 'Yeni oluştur',
    dk: 'Opret ny',
  },
  'CustomerForCheckout.NotFound': {
    en: 'No results found',
    es: 'No se han encontrado resultados',
    se: 'Inga resultat hittades',
    no: 'Ingen resultater funnet',
    tr: 'Sonuç bulunamadı',
    dk: 'Ingen resultater fundet',
  },
  'CustomerForCheckout.StartSearching': {
    en: 'Start by searching to find a member',
    es: 'Comienza buscando para encontrar un miembro',
    se: 'Börja med att söka för att hitta en medlem',
    no: 'Start med å søke for å finne et medlem',
    tr: 'Üye bulmak için arama yaparak başlayın',
    dk: 'Start med at søge for at finde et medlem',
  },
  'CustomerForCheckout.ConnectAndClose.Short': {
    en: 'Connect',
    es: 'Conectar',
    se: 'Anslut',
    no: 'Koble til',
    tr: 'Bağla',
    dk: 'Forbind',
  },
  'CustomerForCheckout.ConnectAndClose': {
    en: 'Connect member and close',
    es: 'Conectar miembro y cerrar',
    se: 'Anslut medlem och stäng',
    no: 'Koble til medlem og lukk',
    tr: 'Üyeyi bağla ve kapat',
    dk: 'Forbind medlem og luk',
  },
  'CustomerForCheckout.CustomerSince': {
    en: 'Member since',
    es: 'Miembro desde',
    se: 'Medlem sedan',
    no: 'Medlem siden',
    tr: 'Üyelik tarihi',
    dk: 'Medlem siden',
  },
  'CustomerForCheckout.CustomerSince.Short': {
    en: 'Since',
    es: 'Desde',
    se: 'Sedan',
    no: 'Siden',
    tr: 'Üyelik',
    dk: 'Siden',
  },
  'CustomerForCheckout.Points': {
    en: 'Points',
    es: 'Puntos',
    se: 'Poäng',
    no: 'Poeng',
    tr: 'Puanlar',
    dk: 'Point',
  },
  'Payment.SelectTerminal': {
    en: 'Select terminal',
    es: 'Seleccionar terminal',
    se: 'Välj terminal',
    no: 'Velg terminal',
    tr: 'Terminal seçin',
    dk: 'Vælg terminal',
  },
  'ConfirmModal.Default': {
    en: 'Please confirm this action',
    se: 'Vänligen bekräfta denna åtgärd',
    es: 'Por favor confirma esta acción',
    no: 'Vennligst bekreft denne handlingen',
    tr: 'Lütfen bu işlemi onaylayın',
    dk: 'Bekræft venligst denne handling',
  },
  'PaymentType.Cash': {
    en: 'Cash',
    es: 'Efectivo',
    se: 'Kontanter',
    no: 'Kontanter',
    tr: 'Nakit',
    dk: 'Kontanter',
  },
  'PaymentType.Card': {
    en: 'Card',
    es: 'Tarjeta',
    se: 'Kort',
    no: 'Kort',
    tr: 'Kart',
    dk: 'Kort',
  },
  'PaymentType.Invoice': {
    en: 'Invoice',
    es: 'Factura',
    se: 'Faktura',
    no: 'Faktura',
    tr: 'Fatura',
    dk: 'Faktura',
  },
  'PaymentType.PrintedInvoice': {
    en: 'Printed invoice',
    es: 'Factura impresa',
    se: 'Utskriven faktura',
    no: 'Utskrevet faktura',
    tr: 'Basılı fatura',
    dk: 'Udskrevet faktura',
  },
  'PaymentType.AdyenManuell': {
    en: 'Adyen manual',
    es: 'Adyen manual',
    se: 'Adyen manuell',
    no: 'Adyen manuell',
    tr: 'Adyen manuel',
    dk: 'Adyen manuel',
  },
  'PaymentType.GiftCard': {
    en: 'Gift card',
    es: 'Tarjeta de regalo',
    se: 'Presentkort',
    no: 'Gavekort',
    tr: 'Hediye kartı',
    dk: 'Gavekort',
  },
  'PaymentType.BaemingoGiftCard': {
    en: 'Baemingo gift card',
    es: 'Tarjeta de regalo Baemingo',
    se: 'Baemingo presentkort',
    no: 'Baemingo gavekort',
    tr: 'Baemingo hediye kartı',
    dk: 'Baemingo gavekort',
  },
  'NoDataModal.Title': {
    en: 'Just a moment',
    es: 'Un momento',
    se: 'Ett ögonblick bara',
    no: 'Vent litt',
    tr: 'Bir dakika',
    dk: 'Vent et øjeblik',
  },
  'NoDataModal.Subtitle': {
    en: 'We’re reloading the app to make sure all company data is up to date.',
    es:
      'Estamos recargando la aplicación para asegurarnos de que todos los datos de la empresa estén actualizados.',
    se: 'Vi laddar om appen för att säkerställa att all företagsdata är uppdaterad.',
    no: 'Vi laster inn appen på nytt for å sikre at all bedriftsdata er oppdatert.',
    tr: 'Tüm şirket verilerinin güncel olduğundan emin olmak için uygulamayı yeniden yüklüyoruz.',
    dk: 'Vi genindlæser appen for at sikre, at alle virksomhedsdata er opdaterede.',
  },
  'NoDataModal.Retry': {
    en: 'Reload app',
    es: 'Recargar aplicación',
    se: 'Ladda om appen',
    no: 'Last inn appen på nytt',
    tr: 'Uygulamayı yeniden yükle',
    dk: 'Genindlæs appen',
  },
  'CashCounter.Title': {
    en: 'Cash counter',
    es: 'Contador de efectivo',
    se: 'Kontant räknare',
    no: 'Kontant teller',
    tr: 'Nakit sayacı',
    dk: 'Kontant tæller',
  },
  'CashCounter.Manually': {
    en: 'Manually',
    es: 'Manualmente',
    se: 'Manuellt',
    no: 'Manuelt',
    tr: 'Manuel olarak',
    dk: 'Manuelt',
  },
  'CashCounter.NothingEntered': {
    en: 'Nothing entered yet',
    es: 'Nada ingresado todavía',
    se: 'Inget inmatat än',
    no: 'Ingenting lagt inn ennå',
    tr: 'Henüz bir şey girilmedi',
    dk: 'Intet indtastet endnu',
  },
  'CashCounter.ManualEntry': {
    en: 'Manual entry',
    es: 'Entrada manual',
    se: 'Manuell inmatning',
    no: 'Manuell inntasting',
    tr: 'Manuel giriş',
    dk: 'Manuel indtastning',
  },
  'CashCounter.EnterTotal': {
    en: 'Enter total cash amount',
    es: 'Ingrese el monto total en efectivo',
    se: 'Ange totalt kontantbelopp',
    no: 'Angi totalt kontantbeløp',
    tr: 'Toplam nakit tutarını girin',
    dk: 'Indtast samlet kontantbeløb',
  },
  'CashCounter.EnterQuantity': {
    en: 'Enter quantity for',
    es: 'Ingrese la cantidad para',
    se: 'Ange kvantitet för',
    no: 'Angi antall for',
    tr: 'Adet girin',
    dk: 'Indtast antal for',
  },
  'NewsAndUpdates.ReadMore': {
    en: 'Read more',
    es: 'Leer más',
    se: 'Läs mer',
    no: 'Les mer',
    tr: 'Daha fazla oku',
    dk: 'Læs mere',
  },
  'NewsAndUpdates.EndReached': {
    en: 'You have reached the end!',
    es: '¡Has llegado al final!',
    se: 'Du har nått slutet!',
    no: 'Du har nådd slutten!',
    tr: 'Sonuna ulaştınız!',
    dk: 'Du har nået slutningen!',
  },
  'NewsAndUpdates.ViewAllReleases': {
    en: 'View all releases',
    es: 'Ver todas las novedades',
    se: 'Visa alla releaser',
    no: 'Vis alle utgivelser',
    tr: 'Tüm yenilikleri görüntüle',
    dk: 'Se alle udgivelser',
  },
  'NewsAndUpdates.WeReleasesAFix': {
    en: 'We’ve released a potential fix as requested',
    es: 'Hemos lanzado una posible solución según lo solicitado',
    se: 'Vi har släppt en potentiell lösning som efterfrågats',
    no: 'Vi har sluppet en potensiell løsning som etterspurt',
    tr: 'Talep üzerine potansiyel bir düzeltme yayınladık',
    dk: 'Vi har udgivet en potentiel løsning som efterspurgt',
  },
  // Bookings - General
  Bookings: {
    en: 'Bookings',
    es: 'Reservas',
    se: 'Bokningar',
    no: 'Bestillinger',
    tr: 'Rezervasyonlar',
    dk: 'Reservationer',
  },
  'Bookings.Table': {
    en: 'Table',
    es: 'Mesa',
    se: 'Bord',
    no: 'Bord',
    tr: 'Masa',
    dk: 'Bord',
  },
  'Bookings.Guests': {
    en: 'guests',
    es: 'huéspedes',
    se: 'gäster',
    no: 'gjester',
    tr: 'misafirler',
    dk: 'gæster',
  },
  'Bookings.UnknownGuest': {
    en: 'Unknown Guest',
    es: 'Huésped Desconocido',
    se: 'Okänd Gäst',
    no: 'Ukjent Gjest',
    tr: 'Bilinmeyen Misafir',
    dk: 'Ukendt Gæst',
  },
  'Bookings.Today': {
    en: 'Today',
    es: 'Hoy',
    se: 'Idag',
    no: 'I dag',
    tr: 'Bugün',
    dk: 'I dag',
  },
  'Bookings.Tomorrow': {
    en: 'Tomorrow',
    es: 'Mañana',
    se: 'Imorgon',
    no: 'I morgen',
    tr: 'Yarın',
    dk: 'I morgen',
  },
  'Bookings.WalkIn': {
    en: 'Walk-in',
    es: 'Sin Reserva',
    se: 'Walk-in',
    no: 'Walk-in',
    tr: 'Rezervasyonsuz',
    dk: 'Walk-in',
  },
  // Bookings - Empty States
  'Bookings.NoTablesFound': {
    en: 'No tables found',
    es: 'No se encontraron mesas',
    se: 'Inga bord hittades',
    no: 'Ingen bord funnet',
    tr: 'Masa bulunamadı',
    dk: 'Ingen borde fundet',
  },
  'Bookings.HideEmptyTables': {
    en: 'Hide empty tables',
    es: 'Ocultar mesas vacías',
    se: 'Dölj tomma bord',
    no: 'Skjul tomme bord',
    tr: 'Boş masaları gizle',
    dk: 'Skjul tomme borde',
  },
  'Bookings.ConfigureTablesMessage': {
    en: 'Please configure tables in your venue settings',
    es: 'Por favor configure las mesas en la configuración de su local',
    se: 'Vänligen konfigurera bord i dina lokal-inställningar',
    no: 'Vennligst konfigurer bord i stedets innstillinger',
    tr: 'Lütfen mekan ayarlarınızda masaları yapılandırın',
    dk: 'Konfigurer venligst borde i dine stedsindstillinger',
  },
  'Bookings.NoAcceptedBookings': {
    en: 'No accepted bookings for this date yet!',
    es: '¡Aún no hay reservas aceptadas para esta fecha!',
    se: 'Inga accepterade bokningar för detta datum än!',
    no: 'Ingen godkjente bestillinger for denne datoen ennå!',
    tr: 'Bu tarih için henüz kabul edilmiş rezervasyon yok!',
    dk: 'Ingen accepterede reservationer for denne dato endnu!',
  },
  // Bookings - Incoming Bookings
  'Bookings.IncomingBookings': {
    en: 'Incoming bookings',
    es: 'Reservas entrantes',
    se: 'Inkommande bokningar',
    no: 'Innkommende bestillinger',
    tr: 'Gelen rezervasyonlar',
    dk: 'Indkommende reservationer',
  },
  'Bookings.LoadingBookings': {
    en: 'Loading bookings...',
    es: 'Cargando reservas...',
    se: 'Laddar bokningar...',
    no: 'Laster bestillinger...',
    tr: 'Rezervasyonlar yükleniyor...',
    dk: 'Indlæser reservationer...',
  },
  'Bookings.NoPendingBookings': {
    en: 'No pending bookings',
    es: 'No hay reservas pendientes',
    se: 'Inga väntande bokningar',
    no: 'Ingen ventende bestillinger',
    tr: 'Bekleyen rezervasyon yok',
    dk: 'Ingen afventende reservationer',
  },
  'Bookings.PercentOff': {
    en: '% off',
    es: '% de descuento',
    se: '% rabatt',
    no: '% rabatt',
    tr: '% indirim',
    dk: '% rabat',
  },
  'Bookings.Accept': {
    en: 'Accept',
    es: 'Aceptar',
    se: 'Acceptera',
    no: 'Godta',
    tr: 'Kabul Et',
    dk: 'Accepter',
  },
  'Bookings.Deny': {
    en: 'Deny',
    es: 'Rechazar',
    se: 'Neka',
    no: 'Avvis',
    tr: 'Reddet',
    dk: 'Afvis',
  },
  'Bookings.Loading': {
    en: 'Loading...',
    es: 'Cargando...',
    se: 'Laddar...',
    no: 'Laster...',
    tr: 'Yükleniyor...',
    dk: 'Indlæser...',
  },
  'Bookings.DenyConfirmation': {
    en: 'Are you sure you want to deny this booking?',
    es: '¿Estás seguro de que quieres rechazar esta reserva?',
    se: 'Är du säker på att du vill neka denna bokning?',
    no: 'Er du sikker på at du vil avvise denne bestillingen?',
    tr: 'Bu rezervasyonu reddetmek istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil afvise denne reservation?',
  },
  'Bookings.DenyBooking': {
    en: 'Deny Booking',
    es: 'Rechazar Reserva',
    se: 'Neka Bokning',
    no: 'Avvis Bestilling',
    tr: 'Rezervasyonu Reddet',
    dk: 'Afvis Reservation',
  },
  // Bookings - Booking Details
  'Bookings.BookingDetails': {
    en: 'Booking Details',
    es: 'Detalles de la Reserva',
    se: 'Bokningsdetaljer',
    no: 'Bestillingsdetaljer',
    tr: 'Rezervasyon Detayları',
    dk: 'Reservationsdetaljer',
  },
  'Bookings.GuestInformation': {
    en: 'Guest Information',
    es: 'Información del Huésped',
    se: 'Gästinformation',
    no: 'Gjesteinformasjon',
    tr: 'Misafir Bilgileri',
    dk: 'Gæsteinformation',
  },
  'Bookings.Name': {
    en: 'Name',
    es: 'Nombre',
    se: 'Namn',
    no: 'Navn',
    tr: 'Ad',
    dk: 'Navn',
  },
  'Bookings.Phone': {
    en: 'Phone',
    es: 'Teléfono',
    se: 'Telefon',
    no: 'Telefon',
    tr: 'Telefon',
    dk: 'Telefon',
  },
  'Bookings.Email': {
    en: 'Email',
    es: 'Correo electrónico',
    se: 'E-post',
    no: 'E-post',
    tr: 'E-posta',
    dk: 'Email',
  },
  'Bookings.BookingInformation': {
    en: 'Booking Information',
    es: 'Información de la Reserva',
    se: 'Bokningsinformation',
    no: 'Bestillingsinformasjon',
    tr: 'Rezervasyon Bilgileri',
    dk: 'Reservationsinformation',
  },
  'Bookings.Date': {
    en: 'Date',
    es: 'Fecha',
    se: 'Datum',
    no: 'Dato',
    tr: 'Tarih',
    dk: 'Dato',
  },
  'Bookings.Time': {
    en: 'Time',
    es: 'Hora',
    se: 'Tid',
    no: 'Tid',
    tr: 'Saat',
    dk: 'Tid',
  },
  'Bookings.PartySize': {
    en: 'Party Size',
    es: 'Tamaño del Grupo',
    se: 'Antal Gäster',
    no: 'Antall Gjester',
    tr: 'Grup Büyüklüğü',
    dk: 'Antal Gæster',
  },
  'Bookings.Discount': {
    en: 'Discount',
    es: 'Descuento',
    se: 'Rabatt',
    no: 'Rabatt',
    tr: 'İndirim',
    dk: 'Rabat',
  },
  'Bookings.NoDiscount': {
    en: 'No discount',
    es: 'Sin descuento',
    se: 'Ingen rabatt',
    no: 'Ingen rabatt',
    tr: 'İndirim yok',
    dk: 'Ingen rabat',
  },
  'Bookings.ManuallyAssignedTable': {
    en: 'This booking was manually assigned to this table',
    es: 'Esta reserva fue asignada manualmente a esta mesa',
    se: 'Denna bokning tilldelades manuellt till detta bord',
    no: 'Denne bestillingen ble manuelt tildelt dette bordet',
    tr: 'Bu rezervasyon manuel olarak bu masaya atandı',
    dk: 'Denne reservation blev manuelt tildelt dette bord',
  },
  'Bookings.ActiveCheque': {
    en: 'Active Cheque',
    es: 'Cuenta Activa',
    se: 'Aktiv Check',
    no: 'Aktiv Sjekk',
    tr: 'Aktif Hesap',
    dk: 'Aktiv Kvittering',
  },
  'Bookings.ChequeID': {
    en: 'Cheque ID',
    es: 'ID de Cuenta',
    se: 'Check-ID',
    no: 'Sjekk-ID',
    tr: 'Hesap ID',
    dk: 'Kvitterings-ID',
  },
  'Bookings.MoveToAnotherTable': {
    en: 'Move to Another Table',
    es: 'Mover a Otra Mesa',
    se: 'Flytta till Annat Bord',
    no: 'Flytt til Annet Bord',
    tr: 'Başka Masaya Taşı',
    dk: 'Flyt til Andet Bord',
  },
  'Bookings.GoToTable': {
    en: 'Go to Table',
    es: 'Ir a la Mesa',
    se: 'Gå till Bord',
    no: 'Gå til Bord',
    tr: 'Masaya Git',
    dk: 'Gå til Bord',
  },
  'Bookings.Canceling': {
    en: 'Canceling...',
    es: 'Cancelando...',
    se: 'Avbryter...',
    no: 'Avbryter...',
    tr: 'İptal Ediliyor...',
    dk: 'Annullerer...',
  },
  'Bookings.CancelBooking': {
    en: 'Cancel Booking',
    es: 'Cancelar Reserva',
    se: 'Avbryt Bokning',
    no: 'Avbryt Bestilling',
    tr: 'Rezervasyonu İptal Et',
    dk: 'Annuller Reservation',
  },
  'Bookings.CancelConfirmation': {
    en: 'Are you sure you want to cancel this booking?',
    es: '¿Estás seguro de que quieres cancelar esta reserva?',
    se: 'Är du säker på att du vill avbryta denna bokning?',
    no: 'Er du sikker på at du vil avbryte denne bestillingen?',
    tr: 'Bu rezervasyonu iptal etmek istediğinizden emin misiniz?',
    dk: 'Er du sikker på, at du vil annullere denne reservation?',
  },
  'Bookings.NoKeepBooking': {
    en: 'No, Keep Booking',
    es: 'No, Mantener Reserva',
    se: 'Nej, Behåll Bokning',
    no: 'Nei, Behold Bestilling',
    tr: 'Hayır, Rezervasyonu Tut',
    dk: 'Nej, Behold Reservation',
  },
  'Bookings.YesCancelBooking': {
    en: 'Yes, Cancel Booking',
    es: 'Sí, Cancelar Reserva',
    se: 'Ja, Avbryt Bokning',
    no: 'Ja, Avbryt Bestilling',
    tr: 'Evet, Rezervasyonu İptal Et',
    dk: 'Ja, Annuller Reservation',
  },
  // Bookings - Cheque Details
  'Bookings.ChequeDetails': {
    en: 'Cheque Details',
    es: 'Detalles de la Cuenta',
    se: 'Checkdetaljer',
    no: 'Sjekkdetaljer',
    tr: 'Hesap Detayları',
    dk: 'Kvitteringsdetaljer',
  },
  'Bookings.FromBooking': {
    en: 'From Booking',
    es: 'De Reserva',
    se: 'Från Bokning',
    no: 'Fra Bestilling',
    tr: 'Rezervasyondan',
    dk: 'Fra Reservation',
  },
  'Bookings.ChequeName': {
    en: 'Cheque name',
    es: 'Nombre de la cuenta',
    se: 'Checknamn',
    no: 'Sjekknavn',
    tr: 'Hesap adı',
    dk: 'Kvitteringsnavn',
  },
  'Bookings.SeatedAt': {
    en: 'Seated At',
    es: 'Sentado A Las',
    se: 'Satt Vid',
    no: 'Satt Ved',
    tr: 'Oturma Zamanı',
    dk: 'Sat Ved',
  },
  'Bookings.GuestName': {
    en: 'Guest name',
    es: 'Nombre del huésped',
    se: 'Gästens namn',
    no: 'Gjestenavn',
    tr: 'Misafir adı',
    dk: 'Gæstenavn',
  },
  'Bookings.ReservedTime': {
    en: 'Reserved Time',
    es: 'Hora Reservada',
    se: 'Reserverad Tid',
    no: 'Reservert Tid',
    tr: 'Rezervasyon Saati',
    dk: 'Reserveret Tid',
  },
  'Bookings.GoToTableLowercase': {
    en: 'Go to table',
    es: 'Ir a la mesa',
    se: 'Gå till bord',
    no: 'Gå til bord',
    tr: 'Masaya git',
    dk: 'Gå til bord',
  },
  'Bookings.DefaultValue': {
    en: '-',
    es: '-',
    se: '-',
    no: '-',
    tr: '-',
    dk: '-',
  },
  'Bookings.StartBooking': {
    en: 'Start Booking',
    es: 'Iniciar Reserva',
    se: 'Starta Bokning',
    no: 'Start Bestilling',
    tr: 'Rezervasyonu Başlat',
    dk: 'Start Reservation',
  },
  // Bookings - Move Table Modal
  'Bookings.Unknown': {
    en: 'Unknown',
    es: 'Desconocido',
    se: 'Okänd',
    no: 'Ukjent',
    tr: 'Bilinmeyen',
    dk: 'Ukendt',
  },
  'Bookings.SelectTableDescription': {
    en: (params: any[]) => `Select a table for this booking (Party size: ${params[0]} guests)`,
    es: (params: any[]) =>
      `Seleccione una mesa para esta reserva (Tamaño del grupo: ${params[0]} huéspedes)`,
    se: (params: any[]) => `Välj ett bord för denna bokning (Antal gäster: ${params[0]} gäster)`,
    no: (params: any[]) =>
      `Velg et bord for denne bestillingen (Antall gjester: ${params[0]} gjester)`,
    tr: (params: any[]) =>
      `Bu rezervasyon için bir masa seçin (Grup büyüklüğü: ${params[0]} misafir)`,
    dk: (params: any[]) =>
      `Vælg et bord til denne reservation (Antal gæster: ${params[0]} gæster)`,
  },
  'Bookings.CurrentlyAssignedTo': {
    en: (params: any[]) => `Currently assigned to table: ${params[0]}`,
    es: (params: any[]) => `Actualmente asignado a la mesa: ${params[0]}`,
    se: (params: any[]) => `För närvarande tilldelat till bord: ${params[0]}`,
    no: (params: any[]) => `For øyeblikket tildelt bord: ${params[0]}`,
    tr: (params: any[]) => `Şu anda atanmış masa: ${params[0]}`,
    dk: (params: any[]) => `I øjeblikket tildelt bord: ${params[0]}`,
  },
  'Bookings.ErrorLoadingTables': {
    en: 'Error loading available tables. Please try again.',
    es: 'Error al cargar las mesas disponibles. Por favor, intente de nuevo.',
    se: 'Fel vid laddning av tillgängliga bord. Vänligen försök igen.',
    no: 'Feil ved lasting av tilgjengelige bord. Vennligst prøv igjen.',
    tr: 'Mevcut masalar yüklenirken hata oluştu. Lütfen tekrar deneyin.',
    dk: 'Fejl ved indlæsning af tilgængelige borde. Prøv venligst igen.',
  },
  'Bookings.NoAvailableTables': {
    en: "No available tables found for this booking's time slot.",
    es: 'No se encontraron mesas disponibles para el horario de esta reserva.',
    se: 'Inga tillgängliga bord hittades för denna bokningens tidsperiod.',
    no: 'Ingen tilgjengelige bord funnet for denne bestillingens tidsperiode.',
    tr: 'Bu rezervasyonun zaman dilimi için uygun masa bulunamadı.',
    dk: 'Ingen ledige borde fundet for denne reservations tidsrum.',
  },
  'Bookings.Combination': {
    en: 'Combination',
    es: 'Combinación',
    se: 'Kombination',
    no: 'Kombinasjon',
    tr: 'Kombinasyon',
    dk: 'Kombination',
  },
  'Bookings.Capacity': {
    en: (params: any[]) => `Capacity: ${params[0]}`,
    es: (params: any[]) => `Capacidad: ${params[0]}`,
    se: (params: any[]) => `Kapacitet: ${params[0]}`,
    no: (params: any[]) => `Kapasitet: ${params[0]}`,
    tr: (params: any[]) => `Kapasite: ${params[0]}`,
    dk: (params: any[]) => `Kapacitet: ${params[0]}`,
  },
  'Bookings.Moving': {
    en: 'Moving...',
    es: 'Moviendo...',
    se: 'Flyttar...',
    no: 'Flytter...',
    tr: 'Taşınıyor...',
    dk: 'Flytter...',
  },
  'Bookings.MoveToSelectedTable': {
    en: 'Move to Selected Table',
    es: 'Mover a Mesa Seleccionada',
    se: 'Flytta till Valt Bord',
    no: 'Flytt til Valgt Bord',
    tr: 'Seçilen Masaya Taşı',
    dk: 'Flyt til Valgt Bord',
  },
  // Bookings - Table Row
  'Bookings.Started': {
    en: (params: any[]) => `Started: ${params[0]} • ${params[1]} guests`,
    es: (params: any[]) => `Inicio: ${params[0]} • ${params[1]} huéspedes`,
    se: (params: any[]) => `Startade: ${params[0]} • ${params[1]} gäster`,
    no: (params: any[]) => `Startet: ${params[0]} • ${params[1]} gjester`,
    tr: (params: any[]) => `Başladı: ${params[0]} • ${params[1]} misafir`,
    dk: (params: any[]) => `Startet: ${params[0]} • ${params[1]} gæster`,
  },
  // Bookings - Provider Error Messages
  'Bookings.ErrorNoBookingReturned': {
    en: 'No booking returned from updateBookingStatus mutation',
    es: 'No se devolvió ninguna reserva de la mutación updateBookingStatus',
    se: 'Ingen bokning returnerades från updateBookingStatus-mutation',
    no: 'Ingen bestilling returnert fra updateBookingStatus-mutasjon',
    tr: 'updateBookingStatus mutasyonundan rezervasyon döndürülmedi',
    dk: 'Ingen reservation returneret fra updateBookingStatus-mutation',
  },
  'Bookings.ErrorStartingBooking': {
    en: 'Something went wrong starting the booking, try again',
    es: 'Algo salió mal al iniciar la reserva, intenta de nuevo',
    se: 'Något gick fel när bokningen startades, försök igen',
    no: 'Noe gikk galt ved start av bestillingen, prøv igjen',
    tr: 'Rezervasyon başlatılırken bir şeyler yanlış gitti, tekrar deneyin',
    dk: 'Noget gik galt ved start af reservationen, prøv igen',
  },
  'Bookings.ErrorFinishingBooking': {
    en: 'Something went wrong finishing the booking',
    es: 'Algo salió mal al finalizar la reserva',
    se: 'Något gick fel när bokningen avslutades',
    no: 'Noe gikk galt ved avslutning av bestillingen',
    tr: 'Rezervasyon tamamlanırken bir şeyler yanlış gitti',
    dk: 'Noget gik galt ved afslutning af reservationen',
  },
  'Bookings.ErrorAcceptingBooking': {
    en: 'Failed to accept the booking, try again',
    es: 'No se pudo aceptar la reserva, intenta de nuevo',
    se: 'Misslyckades att acceptera bokningen, försök igen',
    no: 'Kunne ikke godta bestillingen, prøv igjen',
    tr: 'Rezervasyon kabul edilemedi, tekrar deneyin',
    dk: 'Kunne ikke acceptere reservationen, prøv igen',
  },
  'Bookings.ErrorRejectingBooking': {
    en: 'Failed to reject the booking, try again',
    es: 'No se pudo rechazar la reserva, intenta de nuevo',
    se: 'Misslyckades att neka bokningen, försök igen',
    no: 'Kunne ikke avvise bestillingen, prøv igjen',
    tr: 'Rezervasyon reddedilemedi, tekrar deneyin',
    dk: 'Kunne ikke afvise reservationen, prøv igen',
  },
  'Bookings.ErrorMovingBooking': {
    en: 'Failed to move the booking, try again',
    es: 'No se pudo mover la reserva, intenta de nuevo',
    se: 'Misslyckades att flytta bokningen, försök igen',
    no: 'Kunne ikke flytte bestillingen, prøv igjen',
    tr: 'Rezervasyon taşınamadı, tekrar deneyin',
    dk: 'Kunne ikke flytte reservationen, prøv igen',
  },
  'Bookings.ErrorCancelingBooking': {
    en: 'Failed to cancel the booking, try again',
    es: 'No se pudo cancelar la reserva, intenta de nuevo',
    se: 'Misslyckades att avbryta bokningen, försök igen',
    no: 'Kunne ikke avbryte bestillingen, prøv igjen',
    tr: 'Rezervasyon iptal edilemedi, tekrar deneyin',
    dk: 'Kunne ikke annullere reservationen, prøv igen',
  },
  'Bookings.NewBooking': {
    en: 'New booking',
    es: 'Nueva reserva',
    se: 'Ny bokning',
    no: 'Ny bestilling',
    tr: 'Yeni rezervasyon',
    dk: 'Ny reservation',
  },
  'Bookings.GuestNamePlaceholder': {
    en: 'Guest name *',
    es: 'Nombre del huésped *',
    se: 'Gästens namn *',
    no: 'Gjestens navn *',
    tr: 'Misafir adı *',
    dk: 'Gæstens navn *',
  },
  'Bookings.EmailPlaceholder': {
    en: 'Email',
    es: 'Correo electrónico',
    se: 'E-post',
    no: 'E-post',
    tr: 'E-posta',
    dk: 'E-mail',
  },
  'Bookings.PhonePlaceholder': {
    en: 'Phone (optional)',
    es: 'Teléfono (opcional)',
    se: 'Telefon (valfritt)',
    no: 'Telefon (valgfritt)',
    tr: 'Telefon (isteğe bağlı)',
    dk: 'Telefon (valgfrit)',
  },
  'Bookings.GuestsLabel': {
    en: 'Guests *',
    es: 'Huéspedes *',
    se: 'Gäster *',
    no: 'Gjester *',
    tr: 'Misafirler *',
    dk: 'Gæster *',
  },
  'Bookings.CreateBooking': {
    en: 'Create Booking',
    es: 'Crear reserva',
    se: 'Skapa bokning',
    no: 'Opprett bestilling',
    tr: 'Rezervasyon oluştur',
    dk: 'Opret reservation',
  },
  'Bookings.ErrorPartySizeTooLarge': {
    en: 'Your current booking settings do not allow this many guests per reservation.',
    es: 'La configuración actual no permite esta cantidad de huéspedes por reserva.',
    se: 'Dina nuvarande bokningsinställningar tillåter inte så många gäster per bokning.',
    no: 'Dine nåværende bestillingsinnstillinger tillater ikke så mange gjester per reservasjon.',
    tr: 'Mevcut rezervasyon ayarlarınız bu kadar misafire izin vermiyor.',
    dk: 'Dine nuværende reservationsindstillinger tillader ikke så mange gæster pr. reservation.',
  },
  'Bookings.ErrorCreatingBooking': {
    en: 'Failed to create booking',
    es: 'No se pudo crear la reserva',
    se: 'Misslyckades att skapa bokning',
    no: 'Kunne ikke opprette bestilling',
    tr: 'Rezervasyon oluşturulamadı',
    dk: 'Kunne ikke oprette reservation',
  },
  'Bookings.BookingCreatedToast': {
    en: (name: string) => `Booking for ${name} created!`,
    es: (name: string) => `¡Reserva para ${name} creada!`,
    se: (name: string) => `Bokning för ${name} skapad!`,
    no: (name: string) => `Bestilling for ${name} opprettet!`,
    tr: (name: string) => `${name} için rezervasyon oluşturuldu!`,
    dk: (name: string) => `Reservation for ${name} oprettet!`,
  },
  'Bookings.EditTime': {
    en: 'Change booking time',
    es: 'Cambiar hora de la reserva',
    se: 'Ändra bokningstid',
    no: 'Endre bestillingstid',
    tr: 'Rezervasyon saatini değiştir',
    dk: 'Ændre reservationstid',
  },
  'Bookings.StartTime': {
    en: 'Start time',
    es: 'Hora de inicio',
    se: 'Starttid',
    no: 'Starttid',
    tr: 'Başlangıç saati',
    dk: 'Starttid',
  },
  'Bookings.EndTime': {
    en: 'End time',
    es: 'Hora de fin',
    se: 'Sluttid',
    no: 'Sluttid',
    tr: 'Bitiş saati',
    dk: 'Sluttid',
  },
  'Bookings.SaveTime': {
    en: 'Save',
    es: 'Guardar',
    se: 'Spara',
    no: 'Lagre',
    tr: 'Kaydet',
    dk: 'Gem',
  },
  'Bookings.ErrorUpdatingBookingTime': {
    en: 'Failed to update booking time, try again',
    es: 'No se pudo actualizar la hora de la reserva, intenta de nuevo',
    se: 'Misslyckades att uppdatera bokningstiden, försök igen',
    no: 'Kunne ikke oppdatere bestillingstiden, prøv igjen',
    tr: 'Rezervasyon saati güncellenemedi, tekrar deneyin',
    dk: 'Kunne ikke opdatere reservationstiden, prøv igen',
  },
  'Bookings.BookingTimeUpdated': {
    en: 'Booking time updated',
    es: 'Hora de la reserva actualizada',
    se: 'Bokningstid uppdaterad',
    no: 'Bestillingstid oppdatert',
    tr: 'Rezervasyon saati güncellendi',
    dk: 'Reservationstid opdateret',
  },
  'Bookings.CommentPlaceholder': {
    en: 'Comment (optional)',
    es: 'Comentario (opcional)',
    se: 'Kommentar (valfritt)',
    no: 'Kommentar (valgfritt)',
    tr: 'Yorum (isteğe bağlı)',
    dk: 'Kommentar (valgfrit)',
  },
  'Bookings.SearchByGuestName': {
    en: 'Search by guest name...',
    es: 'Buscar por nombre de huésped...',
    se: 'Sök på gästnamn...',
    no: 'Søk etter gjestens navn...',
    tr: 'Misafir adına göre ara...',
    dk: 'Søg efter gæstenavn...',
  },
  'Bookings.EndsAt': {
    en: 'Ends at',
    es: 'Termina a las',
    se: 'Slutar',
    no: 'Slutter',
    tr: 'Bitiş',
    dk: 'Slutter',
  },
  'Bookings.ClickToViewDetails': {
    en: 'Click a booking or cheque to view details',
    es: 'Haz clic en una reserva o cuenta para ver los detalles',
    se: 'Klicka på en bokning eller nota för att se detaljer',
    no: 'Klikk på en bestilling eller regning for å se detaljer',
    tr: 'Ayrıntıları görüntülemek için bir rezervasyona veya hesaba tıklayın',
    dk: 'Klik på en reservation eller regning for at se detaljer',
  },
  'Login.UnableToLoad': {
    en: 'Unable to load your account. Please try reload or restart the app.',
    es: 'No se puede cargar su cuenta. Por favor, intente recargar o reiniciar la aplicación.',
    se: 'Kunde inte ladda ditt konto. Försök att ladda om eller starta om appen.',
    no:
      'Kunne ikke laste inn kontoen din. Vennligst prøv å laste inn på nytt eller start appen på nytt.',
    tr:
      'Hesabınızı yükleyemiyoruz. Lütfen uygulamayı yeniden yüklemeyi veya yeniden başlatmayı deneyin.',
    dk: 'Kunne ikke indlæse din konto. Prøv at genindlæse eller genstarte appen.',
  },
  'Login.EnterUsername': {
    en: 'Enter your username',
    es: 'Ingrese su nombre de usuario',
    se: 'Ange ditt användarnamn',
    no: 'Skriv inn brukernavnet ditt',
    tr: 'Kullanıcı adınızı girin',
    dk: 'Indtast dit brugernavn',
  },
  'Login.EnterPassword': {
    en: 'Enter your password',
    es: 'Ingrese su contraseña',
    se: 'Ange ditt lösenord',
    no: 'Skriv inn passordet ditt',
    tr: 'Parolanızı girin',
    dk: 'Indtast dit password',
  },
  'Login.WelcomeToBaemingo': {
    en: 'Welcome to Baemingo',
    es: 'Bienvenido a Baemingo',
    se: 'Välkommen till Baemingo',
    no: 'Velkommen til Baemingo',
    tr: "Baemingo'ya hoş geldiniz",
    dk: 'Velkommen til Baemingo',
  },
  'Login.SigninQR': {
    en: 'Sign in with QR code',
    es: 'Iniciar sesión con código QR',
    se: 'Logga in med QR-kod',
    no: 'Logg inn med QR-kode',
    tr: 'QR kod ile giriş yap',
    dk: 'Log ind med QR-kode',
  },
  'Login.LogInViaAnotherDevice': {
    en: 'Log in via another device',
    es: 'Iniciar sesión desde otro dispositivo',
    se: 'Logga in via en annan enhet',
    no: 'Logg inn via en annen enhet',
    tr: 'Başka bir cihazdan giriş yap',
    dk: 'Log ind via en anden enhed',
  },
  'Login.ScanTheQRCode': {
    en:
      'Scan the QR code with your phone and log in when prompted. You will automatically be logged in on this device.',
    es:
      'Escanea el código QR con tu teléfono e inicia sesión cuando se te solicite. Se iniciará sesión automáticamente en este dispositivo.',
    se:
      'Skanna QR-koden med din telefon och logga in när du uppmanas. Du kommer automatiskt att loggas in på denna enhet.',
    no:
      'Skann QR-koden med telefonen din og logg inn når du blir bedt om det. Du vil automatisk bli logget inn på denne enheten.',
    tr:
      'Telefonunuzla QR kodunu tarayın ve istendiğinde giriş yapın. Bu cihazda otomatik olarak giriş yapacaksınız.',
    dk:
      'Scan QR-koden med din telefon og log ind når du bliver bedt om det. Du vil automatisk blive logget ind på denne enhed.',
  },
  'Login.CreateLinkFail': {
    en: 'Could not create login link. Please try again.',
    es: 'No se pudo crear el enlace de inicio de sesión. Por favor, inténtalo de nuevo.',
    se: 'Kunde inte skapa inloggningslänk. Försök igen.',
    no: 'Kunne ikke opprette innloggingslink. Vennligst prøv igjen.',
    tr: 'Giriş bağlantısı oluşturulamadı. Lütfen tekrar deneyin.',
    dk: 'Kunne ikke oprette login-link. Prøv igen.',
  },
  'Login.OrGoTo': {
    en: 'Or go to',
    es: 'O ve a',
    se: 'Eller gå till',
    no: 'Eller gå til',
    tr: 'Veya şuraya git',
    dk: 'Eller gå til',
  },
  'Login.EnterTheCode': {
    en: 'and enter the code',
    es: 'e ingresa el código',
    se: 'och ange koden',
    no: 'og skriv inn koden',
    tr: 've kodu girin',
    dk: 'og indtast koden',
  },
  'Discount.Booking': {
    en: 'Booking discount',
    es: 'Descuento de reserva',
    se: 'Bokningsrabatt',
    no: 'Bestillingsrabatt',
    tr: 'Rezervasyon indirimi',
    dk: 'Reservationsrabat',
  },
  'Discount.Membership': {
    en: 'Membership discount',
    es: 'Descuento de membresía',
    se: 'Medlemskapsrabatt',
    no: 'Medlemskapsrabatt',
    tr: 'Üyelik indirimi',
    dk: 'Medlemskabsrabat',
  },
  'Discount.Manual': {
    en: 'Manual discount',
    es: 'Descuento manual',
    se: 'Manuell rabatt',
    no: 'Manuell rabatt',
    tr: 'Manuel indirim',
    dk: 'Manuel rabat',
  },
};

export default translations;
